var _style, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g2, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _g4, _g5, _g6, _g7, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _g8, _path176, _g9, _g10, _g11, _g12, _g13, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _g14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProperties2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 500,
    viewBox: "0, 0, 360,360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 197.51,
    cy: 50.33,
    r: 75.42,
    gradientTransform: "matrix(1 0 0 -1 0 366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77, 141, 71)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(60, 113, 64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(53, 103, 62)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 197.51,
    cy: 50.33,
    r: 75.42,
    gradientTransform: "matrix(1 0 0 -1 0 366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77, 141, 71)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(60, 113, 64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(53, 103, 62)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042010816551848108080000001942305759181148050_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1996.1783,
    x2: -81.5303,
    y2: 1996.1783,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163060899475892081950000008408497824198855296_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1994.646,
    x2: -81.5303,
    y2: 1994.646,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008870865593698780100000017429814249729433221_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1993.5743,
    x2: -81.5303,
    y2: 1993.5743,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124155660458906954420000016280556001576005807_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1960.8296,
    x2: -81.5303,
    y2: 1960.8296,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149364391259296654010000003530170401217132932_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1586.3052,
    x2: -3132.582,
    y2: 1586.3052,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181052769425583036700000002522265406821519544_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1948.8345,
    x2: -81.5303,
    y2: 1948.8345,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144309014256102371800000016948301201373127557_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1588.0828,
    x2: -3132.582,
    y2: 1588.0828,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121240277455146580210000004792500790264914109_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1963.0269,
    x2: -81.5303,
    y2: 1963.0269,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044885480850837084250000001593496410592543400_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1573.1995,
    x2: -3132.582,
    y2: 1573.1995,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143608868533996072790000016554404270332033722_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164514595113742763760000017997745748924151193_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029739109447162341350000018176890010095455125_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1664.8,
    x2: 87.17,
    y2: 1664.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024721570815073962830000006614288067243737738_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1710.9425,
    x2: 87.17,
    y2: 1710.9425,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154421535588144999800000011743261596105002670_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078037076677947106660000016145453203157266334_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1711.45,
    x2: 87.17,
    y2: 1711.45,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011719608550537266220000000111210974142197436_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1667.5575,
    x2: 87.17,
    y2: 1667.5575,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039130544260400779690000013266229306219662216_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1793.05,
    x2: 87.17,
    y2: 1793.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026126883061059541410000007722840513776853934_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8,
    y1: 1783,
    x2: 19.8,
    y2: 1783,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086660057379190350480000004983106006175553428_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1791.6982,
    x2: 87.17,
    y2: 1791.6982,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098901622897236932740000002787153897432869805_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1728.3944,
    x2: 87.17,
    y2: 1728.3944,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000930787074257856400000016090131640629647521_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039097716006320172140000010642284559214141074_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1730.1,
    x2: 87.17,
    y2: 1730.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179642899026515476030000014003638857668734849_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1756,
    x2: 87.17,
    y2: 1756,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030486097800564432530000008918914161950579350_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065773155895436534970000003582445604826263226_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1757,
    x2: 87.17,
    y2: 1757,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023254306149659424790000007084438116917023900_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1789.4124,
    x2: 91.86,
    y2: 1789.4124,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058574846320681536400000011155147357844041638_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1788,
    x2: 91.86,
    y2: 1788,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532280393150991290000018043040792068605078_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1699.2483,
    x2: 91.86,
    y2: 1699.2483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102533949883936996950000000745388254180851616_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1740.5437,
    x2: 91.86,
    y2: 1740.5437,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183218137190439396790000010528199644225813915_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1659.6604,
    x2: 91.86,
    y2: 1659.6604,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099640551746843322230000017922238269936786337_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1715.1935,
    x2: 91.86,
    y2: 1715.1935,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021798181807771047880000010754671220130711486_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181782991145093903460000016453452947331900849_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1696.05,
    x2: 91.86,
    y2: 1696.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109031443077728252460000014963914721845640373_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105392359405588435440000000272153898196980655_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1770.4,
    x2: 91.86,
    y2: 1770.4,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087407311654678336480000007510830638885346447_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9525,
    y1: 1894.3101,
    x2: 96.9525,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065045045117002439480000015978418552625924771_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.65,
    y1: 1894.3201,
    x2: 210.65,
    y2: 2007.9401,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072976955722270694640000007739506755857067166_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.9041,
    y1: 1894.3101,
    x2: 91.9041,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143616266820451442200000010261629976493827241_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.1418,
    y1: 1894.3101,
    x2: 93.1418,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065066274427333315050000016160703831854811010_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.4441,
    y1: 1894.3101,
    x2: 119.4441,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069390833366998270090000007998955406882430090_",
    gradientUnits: "userSpaceOnUse",
    x1: -3072.1802,
    y1: 1753.8755,
    x2: -2920.5798,
    y2: 1753.8755,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1527.78 -2806.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946234433940394760000015897079170284742302_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.272,
    y1: -438.086,
    x2: 563.272,
    y2: -420.866,
    gradientTransform: "matrix(0.507 0.9649 -0.9383 0.4931 -550.0696 -167.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168109852373702649950000004902788842759366057_",
    gradientUnits: "userSpaceOnUse",
    x1: -3078.5701,
    y1: 1692.0032,
    x2: -2865.3799,
    y2: 1692.0032,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1452.8201 -2858.54)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070836207816142971090000016263521108083827897_",
    cx: 196.3705,
    cy: 1907.4794,
    r: 18.0743,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139294912103822560350000005262151493287669433_",
    cx: 270.5677,
    cy: 1912.2991,
    r: 22.7578,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148620321342029457320000003743966867887378068_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.7,
    y1: 1936.8,
    x2: 260.7,
    y2: 1936.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077307610256746240680000011662169979164566460_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.7,
    y1: 1999.9,
    x2: 221.7,
    y2: 1916.2,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181789847829888253860000014952587370379039130_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6154,
    y1: 1873.24,
    x2: 320.6154,
    y2: 1751.38,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124853675744649783290000008677896324407568043_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6624,
    y1: 1843.45,
    x2: 142.6624,
    y2: 1736.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127740341217216951560000007047851351309571468_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139265169868790869420000010554492954939910335_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080904464867536717050000002770865723048467874_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097461035905135310180000002777459715441924029_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 197.51,
    cy: 50.33,
    r: 75.42,
    gradientTransform: "matrix(1 0 0 -1 0 366)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(77, 141, 71)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(60, 113, 64)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(53, 103, 62)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042010816551848108080000001942305759181148050_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1996.1783,
    x2: -81.5303,
    y2: 1996.1783,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163060899475892081950000008408497824198855296_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1994.646,
    x2: -81.5303,
    y2: 1994.646,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008870865593698780100000017429814249729433221_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1993.5743,
    x2: -81.5303,
    y2: 1993.5743,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124155660458906954420000016280556001576005807_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1960.8296,
    x2: -81.5303,
    y2: 1960.8296,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149364391259296654010000003530170401217132932_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1586.3052,
    x2: -3132.582,
    y2: 1586.3052,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181052769425583036700000002522265406821519544_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1948.8345,
    x2: -81.5303,
    y2: 1948.8345,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144309014256102371800000016948301201373127557_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1588.0828,
    x2: -3132.582,
    y2: 1588.0828,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121240277455146580210000004792500790264914109_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1963.0269,
    x2: -81.5303,
    y2: 1963.0269,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044885480850837084250000001593496410592543400_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1573.1995,
    x2: -3132.582,
    y2: 1573.1995,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143608868533996072790000016554404270332033722_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164514595113742763760000017997745748924151193_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029739109447162341350000018176890010095455125_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1664.8,
    x2: 87.17,
    y2: 1664.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024721570815073962830000006614288067243737738_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1710.9425,
    x2: 87.17,
    y2: 1710.9425,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154421535588144999800000011743261596105002670_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078037076677947106660000016145453203157266334_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1711.45,
    x2: 87.17,
    y2: 1711.45,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011719608550537266220000000111210974142197436_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1667.5575,
    x2: 87.17,
    y2: 1667.5575,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039130544260400779690000013266229306219662216_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1793.05,
    x2: 87.17,
    y2: 1793.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026126883061059541410000007722840513776853934_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8,
    y1: 1783,
    x2: 19.8,
    y2: 1783,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086660057379190350480000004983106006175553428_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1791.6982,
    x2: 87.17,
    y2: 1791.6982,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098901622897236932740000002787153897432869805_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1728.3944,
    x2: 87.17,
    y2: 1728.3944,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000930787074257856400000016090131640629647521_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039097716006320172140000010642284559214141074_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1730.1,
    x2: 87.17,
    y2: 1730.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179642899026515476030000014003638857668734849_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1756,
    x2: 87.17,
    y2: 1756,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030486097800564432530000008918914161950579350_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065773155895436534970000003582445604826263226_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1757,
    x2: 87.17,
    y2: 1757,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023254306149659424790000007084438116917023900_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1789.4124,
    x2: 91.86,
    y2: 1789.4124,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058574846320681536400000011155147357844041638_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1788,
    x2: 91.86,
    y2: 1788,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532280393150991290000018043040792068605078_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1699.2483,
    x2: 91.86,
    y2: 1699.2483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102533949883936996950000000745388254180851616_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1740.5437,
    x2: 91.86,
    y2: 1740.5437,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183218137190439396790000010528199644225813915_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1659.6604,
    x2: 91.86,
    y2: 1659.6604,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099640551746843322230000017922238269936786337_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1715.1935,
    x2: 91.86,
    y2: 1715.1935,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021798181807771047880000010754671220130711486_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181782991145093903460000016453452947331900849_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1696.05,
    x2: 91.86,
    y2: 1696.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109031443077728252460000014963914721845640373_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105392359405588435440000000272153898196980655_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1770.4,
    x2: 91.86,
    y2: 1770.4,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087407311654678336480000007510830638885346447_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9525,
    y1: 1894.3101,
    x2: 96.9525,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065045045117002439480000015978418552625924771_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.65,
    y1: 1894.3201,
    x2: 210.65,
    y2: 2007.9401,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072976955722270694640000007739506755857067166_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.9041,
    y1: 1894.3101,
    x2: 91.9041,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143616266820451442200000010261629976493827241_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.1418,
    y1: 1894.3101,
    x2: 93.1418,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065066274427333315050000016160703831854811010_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.4441,
    y1: 1894.3101,
    x2: 119.4441,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069390833366998270090000007998955406882430090_",
    gradientUnits: "userSpaceOnUse",
    x1: -3072.1802,
    y1: 1753.8755,
    x2: -2920.5798,
    y2: 1753.8755,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1527.78 -2806.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946234433940394760000015897079170284742302_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.272,
    y1: -438.086,
    x2: 563.272,
    y2: -420.866,
    gradientTransform: "matrix(0.507 0.9649 -0.9383 0.4931 -550.0696 -167.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168109852373702649950000004902788842759366057_",
    gradientUnits: "userSpaceOnUse",
    x1: -3078.5701,
    y1: 1692.0032,
    x2: -2865.3799,
    y2: 1692.0032,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1452.8201 -2858.54)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070836207816142971090000016263521108083827897_",
    cx: 196.3705,
    cy: 1907.4794,
    r: 18.0743,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139294912103822560350000005262151493287669433_",
    cx: 270.5677,
    cy: 1912.2991,
    r: 22.7578,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148620321342029457320000003743966867887378068_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.7,
    y1: 1936.8,
    x2: 260.7,
    y2: 1936.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077307610256746240680000011662169979164566460_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.7,
    y1: 1999.9,
    x2: 221.7,
    y2: 1916.2,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181789847829888253860000014952587370379039130_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6154,
    y1: 1873.24,
    x2: 320.6154,
    y2: 1751.38,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124853675744649783290000008677896324407568043_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6624,
    y1: 1843.45,
    x2: 142.6624,
    y2: 1736.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127740341217216951560000007047851351309571468_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139265169868790869420000010554492954939910335_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080904464867536717050000002770865723048467874_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097461035905135310180000002777459715441924029_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0cm{fill:url(#SVGID_1_);}\n\t.st0cm{fill:url(#SVGID_1_);}\n\t.st1cm{fill:url(#SVGID_00000147215326426197067480000009938068911698591891_);}\n\t.st2cm{fill:url(#SVGID_00000143587088323841356880000009882535810360212642_);}\n\t.st3cm{fill:url(#SVGID_00000082365674473623377720000009826085558462335873_);}\n\t.st4cm{fill:url(#SVGID_00000007410098999826481600000002475666248291445414_);}\n\t.st5cm{fill:url(#SVGID_00000177485627932316287790000018064816135864928160_);}\n\t.st6cm{fill:url(#SVGID_00000139990731691968765790000010986919652060656827_);}\n\t.st7cm{fill:url(#SVGID_00000104689855288411178210000013499757346334699906_);}\n\t.st8cm{fill:url(#SVGID_00000013176298579255165370000013371369515066139272_);}\n\t.st9cm{fill:url(#SVGID_00000007402600645843381890000014263891110465981877_);}\n\t.st1cm0{fill:#99F5FF;}\n\t.st1cm1{fill:#F3FFFD;}\n\t.st1cm2{fill:#202020;}\n\t.st1cm3{fill:#FFB0C7;}\n\t.st1cm4{fill:url(#SVGID_00000114770402490100710670000004487252132677868735_);}\n\t.st1cm5{fill:url(#SVGID_00000048482349595272404900000012325685075007606450_);}\n\t.st1cm6{fill:url(#SVGID_00000075145284691021843800000001311253880632438684_);}\n\t.st1cm7{fill:url(#SVGID_00000057866313911283639380000005879873361855215800_);}\n\t.st1cm8{fill:url(#SVGID_00000038378630343096934620000012494546872313682611_);}\n\t.st1cm9{fill:url(#SVGID_00000074416885204176570990000009845370621389852560_);}\n\t.st2cm0{fill:url(#SVGID_00000129921519121152394270000001255252346715819425_);}\n\t.st2cm1{fill:url(#SVGID_00000117650785856865872620000001500380971741078204_);}\n\t.st2cm2{fill:url(#SVGID_00000022526409326700109170000008922772645493107877_);}\n\t.st2cm3{fill:url(#SVGID_00000006671327153720880420000016653707696881347718_);}\n\t.st2cm4{fill:url(#SVGID_00000093888673877557638150000016098832550542308501_);}\n\t.st2cm5{fill:url(#SVGID_00000181084842124540542380000005259343407613201824_);}\n\t.st2cm6{fill:url(#SVGID_00000166662815811083330600000005020473146233450940_);}\n\t.st2cm7{fill:#7CFCFF;}\n\t.st2cm8{fill:url(#SVGID_00000034785957373050578780000010876182428986287013_);}\n\t.st2cm9{fill:url(#SVGID_00000083071737510860065200000003137927114003283342_);}\n\t.st3cm0{fill:url(#SVGID_00000182528292481755332180000014149291072722026930_);}\n\t.st3cm1{fill:url(#SVGID_00000073693301854012896770000001576572428795992713_);}\n\t.st3cm2{fill:url(#SVGID_00000140724075445598091820000002594003994203257518_);}\n\t.st3cm3{fill:url(#SVGID_00000148659573000509569130000014759583739944695425_);}\n\t.st3cm4{fill:url(#SVGID_00000145046832681706159120000013934672802036345235_);}\n\t.st3cm5{fill:url(#SVGID_00000037682904823278632390000008747813248549880204_);}\n\t.st3cm6{fill:url(#SVGID_00000043427622479556841320000016247712979139412660_);}\n\t.st3cm7{fill:url(#SVGID_00000176765667926497537360000004808615598989215104_);}\n\t.st3cm8{fill:url(#SVGID_00000163779081930736385790000012537949186232030085_);}\n\t.st3cm9{fill:url(#SVGID_00000031185901484914378270000011036787158357786791_);}\n\t.st4cm0{fill:url(#SVGID_00000127044789977445069860000008602452972517674175_);}\n\t.st4cm1{fill:#FFFFFF;}\n\t.st4cm2{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st4cm3{fill:none;}\n\t.st4cm4{fill:url(#SVGID_00000155106769125391382200000009929844678901535882_);}\n\t.st4cm5{fill:url(#SVGID_00000095301601750238424860000000341831833595867550_);}\n\t.st4cm6{fill:url(#SVGID_00000066497683663992734630000003382812732904403595_);}\n\t.st4cm7{fill:url(#SVGID_00000065066197840277292660000006376051234408034484_);}\n\t.st4cm8{fill:url(#SVGID_00000167397349099085119650000011441646611068062085_);}\n\t.st4cm9{fill:url(#SVGID_00000168799355507642867690000017741782027964396169_);}\n\t.st5cm0{fill:url(#SVGID_00000131348341057830483800000015553169800298411656_);}\n\t.st5cm1{fill:url(#SVGID_00000178891290937015784910000009382305696700167574_);}\n\t.st5cm2{fill:#CDD6FF;}\n\t.st5cm3{fill:#FECECF;}\n\t.st5cm4{fill:#FFFFCD;}\n\t.st5cm5{fill:#AE0D35;}\n\t.st5cm6{fill:url(#SVGID_00000036940063604589875730000014933788283015327373_);}\n\t.st5cm7{fill:url(#SVGID_00000069383578683419651300000010311301223912664491_);}\n\t.st5cm8{fill:#F7B089;}\n\t.st5cm9{fill:#F18D83;}\n\t.st6cm0{fill:url(#SVGID_00000064330656940927548450000013371187524449397400_);}\n\t.st6cm1{fill:url(#SVGID_00000176742359980087604790000004786424778428380090_);}\n\t.st6cm2{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st6cm3{fill:none;stroke:#FED5AB;stroke-miterlimit:10;}\n\t.st6cm4{fill:#FFE3A9;}\n\t.st6cm5{fill:#F9DAC0;}\n\t.st6cm6{fill:#FF7C9E;}\n\t.st6cm7{fill:#FFD2AB;}\n\t.st6cm8{fill:url(#SVGID_00000053528126013043267220000018087192740881129388_);}\n\t.st6cm9{fill:url(#SVGID_00000064329675014206787790000004139064375231706760_);}\n\t.st7cm0{fill:url(#SVGID_00000124140006130198600970000009183220451977700503_);}\n\t.st7cm1{fill:url(#SVGID_00000150097578000691389340000002494412180033227141_);}\n\t.st7cm2{fill:url(#SVGID_00000163040224064636225410000014194169697842972831_);}\n\t.st7cm3{fill:url(#SVGID_00000088827436453262013440000000619854563707048615_);}\n\t.st7cm4{fill:#FFFAFC;}\n\t.st7cm5{fill:#FFD9D6;}\n\t.st7cm6{fill:#C02C23;}\n\t.st7cm7{fill:#FFF8F8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 18,
    className: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 1,
    className: "st0cm",
    width: 359.8,
    height: 360.1,
    fill: "url(\"#SVGID_1_\")"
  }))), /*#__PURE__*/React.createElement("g", {
    id: 17,
    className: "svggstaff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jelly_warhammer_Image"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042010816551848108080000001942305759181148050_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1996.1783,
    x2: -81.5303,
    y2: 1996.1783,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.7,324.5c0,0-0.1-2.2-0.2-5.6 c-0.1-1.7-0.1-3.7-0.2-5.9c-0.1-2.2-0.1-4.6,0.1-7c0.2-2.1,0.6-4.1,1.3-6.1c0.1-0.7,0.2-1.2,0.5-2c0-0.1,0.1-0.4,0.1-0.3l0,0 c-0.1,0-0.3-0.1-0.4-0.2c-1.4-0.5-3.4-1-5.1-1.1c-1.7-0.1-3,0.1-3,0.1s-0.6,0-1.4,0.2s-2,0.4-3.1,0.9c-1.1,0.4-2.3,1-3.2,1.6 c-0.2,0.1-0.4,0.3-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0.4-0.2,0.7-0.2,1v0.1 c1.2,1.7,2.1,3.7,2.7,5.7c1.4,4.8,1.4,9.5,1.6,13c0.1,3.4,0.2,5.7,0.2,5.7s1.1,28.6,1.3,34.3c0,0.2,0,0.4,0,0.6h11.3 c0.2,0,0.5,0,0.7,0c-0.1-0.5-0.2-1-0.2-1.7C110.9,353,109.7,324.5,109.7,324.5L109.7,324.5z",
    style: {},
    fill: "url(\"#SVGID_00000042010816551848108080000001942305759181148050_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163060899475892081950000008408497824198855296_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1994.646,
    x2: -81.5303,
    y2: 1994.646,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,360.2c0,0,0,0,0-0.1s0-0.2,0-0.4 c-0.2-5.7-1.3-34.3-1.3-34.3s-0.1-2.2-0.2-5.7c-0.2-3.4-0.2-8.1-1.6-12.8c-0.7-2.3-1.7-4.6-3.2-6.5s-3.3-3.4-5.2-4.3 c-0.5-0.2-0.9-0.4-1.4-0.6h-1.3v-0.4l0,0c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.5-0.1-0.8-0.1-1.2-0.1 c-0.1,0-0.3,0-0.4,0c0.2,0.2,0.5,0.6,0.8,1.1c2,3,4.4,5.2,6,8.6c3.3,7.2,4.5,15.4,5.2,23.2c0.4,4.9,0.6,9.9,0.6,14.8 c0.1,4.8,0.7,9.9,0.3,14.7c-0.2,3-1,2.9,1.8,2.9L98.8,360.2C98.8,360.3,98.8,360.3,98.8,360.2L98.8,360.2L98.8,360.2z",
    style: {},
    fill: "url(\"#SVGID_00000163060899475892081950000008408497824198855296_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008870865593698780100000017429814249729433221_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1993.5743,
    x2: -81.5303,
    y2: 1993.5743,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,291.3c-0.1,0.1-0.2,0.1-0.3,0.2 l-0.2,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.3-0.6,0.4c-0.4,0.3-0.8,0.6-1.2,1c-1.5,1.5-2.8,3.4-3.7,5.6s-1.4,4.6-1.6,7 s-0.2,4.8-0.1,7c0.1,2.2,0.2,4.2,0.2,5.9c0.1,3.4,0.2,5.6,0.2,5.6s1.2,28.5,1.5,34.2c0,0.7,0,1.2-0.1,1.7c1.6,0.1,3.5,0.4,4.7,0 c0.2-0.1,1,0.2,1.2,0c-0.6,0.5-1.5-6.4-1.6-6.8c-0.6-5-1-10-1.5-14.9c-0.8-9.8-1.9-19.8-1.7-29.6c0.2-6.9,1.8-13.7,6.8-18.6 c-0.4,0.2-0.7,0.4-1.2,0.7C118.3,291.1,118.2,291.2,117.9,291.3L117.9,291.3z",
    style: {},
    fill: "url(\"#SVGID_00000008870865593698780100000017429814249729433221_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124155660458906954420000016280556001576005807_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1960.8296,
    x2: -81.5303,
    y2: 1960.8296,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.4,290.7c-0.5,0.5-0.9,1-1.3,1.6 c-1.3,1.7-1.7,1.9-1.4,2.4c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.8-0.1,1.2,0c0.1,0,0.3,0,0.6,0.1c0.1,0,0.2,0,0.3,0h0.1 c0.2,0,0.4,0.1,0.7,0.2c0.2,0,0.5,0.1,0.8,0.2c0.5,0.1,1,0.4,1.5,0.6c0,0,0,0,0.1,0c2,1,3.9,2.5,5.4,4.5c0.1,0.1,0.1,0.2,0.2,0.2 c0-0.2,0.1-0.4,0.2-0.7c0.1-0.1,0.2-0.3,0.4-0.5c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.3,0.7-0.5c0.9-0.6,2.1-1.2,3.3-1.7 c1.2-0.5,2.4-0.7,3.2-0.9c0.9-0.2,1.4-0.2,1.4-0.2s1.4-0.2,3.1-0.1c1.8,0.1,3.9,0.5,5.3,1.1c0.2,0.1,0.3,0.1,0.5,0.2 c0.1,0,0.2,0.1,0.4,0.1c0.9-1.6,1.9-3,3.1-4.2c0.4-0.4,0.8-0.7,1.2-1.1c0.2-0.2,0.4-0.3,0.6-0.5c0.1-0.1,0.2-0.1,0.3-0.2l0.2-0.1 c0.1-0.1,0.2-0.1,0.4-0.2s0.4-0.2,0.5-0.3c0.7-0.4,1.3-0.5,1.9-0.5c-0.1-1-4.8-3.5-7.2-5.2l0,0c-0.1,0.1-0.3,0.2-0.4,0.2 c-7.4,4.6-16.2,5.2-24.2,1.6C87,288,85.6,289.3,84.4,290.7L84.4,290.7z",
    style: {},
    fill: "url(\"#SVGID_00000124155660458906954420000016280556001576005807_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149364391259296654010000003530170401217132932_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1586.3052,
    x2: -3132.582,
    y2: 1586.3052,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,150.9c0,0.8,0.1,1.6,0.1,2.5 c0.2,5.2,0.4,10.4,0.6,15.6c0,0.6,0.1,1.2,0.1,1.7c1,25.5,2,50.9,3,76.4c0.3,8.8,0.7,17.6,1,26.5l22.4-0.9c0-0.3,0-0.6,0-0.9 c-1.6-35.7-3.2-71.4-4.8-107.1c-0.2-3.8-0.3-7.5-0.5-11.3l-0.2-4.8c-3.2,0.9-6.8,1-10.1,1.3C91.4,150.4,87.5,151,83.7,150.9 L83.7,150.9z",
    style: {},
    fill: "url(\"#SVGID_00000149364391259296654010000003530170401217132932_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181052769425583036700000002522265406821519544_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1948.8345,
    x2: -81.5303,
    y2: 1948.8345,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,277.9c0.1,1.9-0.5,5.4,0.3,7.2 c0.7,1.6,2.5,1.4,4.4,1.8c6.1,1.5,12.3,0.4,17.6-2.7c-0.1-0.4,0.1-0.8,0.4-0.8c-0.1-0.5,0-1.2-0.1-1.6c-0.1-3-0.3-6-0.4-9 l-22.4,0.9C88.5,275,88.6,276.5,88.6,277.9L88.6,277.9z",
    style: {},
    fill: "url(\"#SVGID_00000181052769425583036700000002522265406821519544_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144309014256102371800000016948301201373127557_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1588.0828,
    x2: -3132.582,
    y2: 1588.0828,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,277.9c0.1,1.9-0.5,5.4,0.3,7.2 c0.7,1.6,2.5,1.4,4.4,1.8c6.1,1.5,12.3,0.4,17.6-2.7c-0.1-0.4,0.1-0.8,0.4-0.8c-0.1-0.5,0-1.2-0.1-1.6c-0.1-3-0.3-6-0.4-9 l-22.4,0.9C88.5,275,88.6,276.5,88.6,277.9L88.6,277.9z",
    style: {},
    fill: "url(\"#SVGID_00000144309014256102371800000016948301201373127557_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121240277455146580210000004792500790264914109_",
    gradientUnits: "userSpaceOnUse",
    x1: -8.9503,
    y1: 1963.0269,
    x2: -81.5303,
    y2: 1963.0269,
    gradientTransform: "matrix(1.0491 -4.268771e-02 4.146806e-02 1.0192 60.2091 -1707.5408)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,295.6 C85.8,295.6,85.7,295.6,85.8,295.6c-0.3-0.1-0.5-0.2-0.7-0.2s-0.4-0.1-0.6-0.1v0.4L85.8,295.6L85.8,295.6z",
    style: {},
    fill: "url(\"#SVGID_00000121240277455146580210000004792500790264914109_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044885480850837084250000001593496410592543400_",
    gradientUnits: "userSpaceOnUse",
    x1: -3295.052,
    y1: 1573.1995,
    x2: -3132.582,
    y2: 1573.1995,
    gradientTransform: "matrix(-1.134442e-02 -0.9999 0.9999 -1.134442e-02 -1525.2736 -2981.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(205, 35, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "rgb(195, 52, 129)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(137, 52, 129)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.8,295.6 C85.8,295.6,85.7,295.6,85.8,295.6c-0.3-0.1-0.5-0.2-0.7-0.2s-0.4-0.1-0.6-0.1v0.4L85.8,295.6L85.8,295.6z",
    style: {},
    fill: "url(\"#SVGID_00000044885480850837084250000001593496410592543400_\")"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M109.6,294.6c-3.6-1.2-7.6-1-11.2,0.2c-2,0.7-3.6,1.8-5.3,0.1c-1.5-1.5-2.6-4.8-3.5-6.7 c-0.5-1-1.9-1.2-2.8-0.7c-2.2,1.2-3.8,2.7-5.3,4.8c-1,1.5,0.4,3.4,2,3.4c2.6,0,4.4,0.6,6.6,1.9c2.4,1.4,4.2-1.6,2.8-3.6 c-1.6-2-2.2-3.1-4.6-3.8c-0.7-0.2-1.5,0.4-1.5,1.1c0,2.7,1.1,3.6,2.9,5.8l2.8-3.6c-2.8-1.7-5.5-2.5-8.9-2.5l2,3.4 c0.8-1.5,1.9-2.8,3.4-3.6l-2.8-0.7c1.8,3,3.7,9.5,7.7,9.9c1.4,0.1,2.5-0.6,3.8-1.1c4-1.6,7.4-1.9,11.7-1.5 C111,297.6,111.2,295.1,109.6,294.6L109.6,294.6L109.6,294.6z",
    fill: "#99F5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M114.8,294.5c0.7-0.5,1.2-1.3,1.7-2s1.1-1.4,1.6-2.2c0.7-1.1,0.2-2.5-0.8-3.2c-1-0.6-2.7-0.3-3.2,0.8 c-0.7,1.7-1.6,3.7-1.7,5.5C112.3,294.9,113.9,295.2,114.8,294.5L114.8,294.5L114.8,294.5z",
    fill: "#99F5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M114.7,293.3c1.1,0,1.7-0.8,2.6-1.4s1.7-1,2.5-1.7c1.4-1.1-0.1-3.6-1.8-3.1c-1.2,0.4-2.1,1.2-3,2 c-0.9,0.9-1.8,1.8-1.5,3.1C113.6,292.9,114.2,293.3,114.7,293.3L114.7,293.3z",
    fill: "#99F5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M115.5,288.9c0.7,0.6,1.4,1.3,2.1,1.8s1.9,0.2,2.5-0.5s0.6-1.9-0.1-2.5s-1.5-1-2.3-1.5 C115.9,285.1,114,287.6,115.5,288.9L115.5,288.9L115.5,288.9z",
    fill: "#99F5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M104.9,289.8c1,1.4,3.2,0.9,4.7,0.6c0.9-0.2,1.5-1.3,1.2-2.2c-0.3-1-1.2-1.4-2.2-1.2 c-0.9,0.2-1.7,0.4-2.6,0.7C105.3,287.9,104.3,288.9,104.9,289.8L104.9,289.8L104.9,289.8z",
    fill: "#99F5FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M99.6,339.7c2.7-6.5,2-15,1.6-21.9c-0.4-6.1-0.3-15.4-3.8-20.6c-1.2-1.7-3.5-1-3.8,1 c-0.4,3.4,1,6.6,1.7,9.9c0.8,3.8,1.4,7.7,1.8,11.5c0.7,6.5,0,13.6,1.6,20C98.8,340.2,99.4,340.1,99.6,339.7L99.6,339.7 L99.6,339.7z",
    fill: "#99F5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M102.9,294.7c-6.6-0.4-8.8,7.9-6,12.9c0.8,1.5,2.8,2.1,3.2,0c0.3-1.6-0.8-3.3-0.8-4.9c0-2.3,1-4.9,3.7-5 C104.8,297.5,104.8,294.8,102.9,294.7L102.9,294.7L102.9,294.7z",
    fill: "#99F5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M98.5,325.7c-0.1,4.8,0.1,9.6,0.3,14.4l2.2-0.3c-0.2-1-0.2-1.1-1-1.7c-0.3-0.2-0.6-0.2-0.8,0.1 c-0.5,0.8-0.5,1-0.4,1.9c0.2,1.4,2.3,1.5,2.2,0c-0.2-4.8-0.6-9.6-1.1-14.4C99.9,324.7,98.5,324.7,98.5,325.7L98.5,325.7 L98.5,325.7z",
    fill: "#99F5FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M99.7,320.6c-3.1,4.8-1.8,12.6-1.8,18c0,0.7,0.4,1.6,1.1,1.9c1,0.5,1.1,0.5,2.2,0c0.7-0.3,1.1-1.2,1.1-1.9 c0.1-5.4,1.6-13.2-1.4-18C100.5,320.2,99.9,320.2,99.7,320.6L99.7,320.6z",
    fill: "#99F5FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M98.6,346.7c-0.2,3.3,0.1,6.6,0.3,10s5.4,3.3,5.2,0c-0.3-3.5-0.5-7-1.1-10.5 C102.5,343.5,98.8,344.3,98.6,346.7L98.6,346.7z",
    fill: "#99F5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M90.2,305.5c0.3,4.1,0.8,7.9,2.4,11.8c0.2,0.6,1,0.5,1.1-0.1c0.3-2.1,0.1-4.2-0.2-6.2s-1.2-3.8-2.3-5.7 C90.9,304.8,90.2,304.9,90.2,305.5L90.2,305.5L90.2,305.5z",
    fill: "#99F5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm0",
    d: "M111.3,336.2c-3.2,6.7,0.1,16.5,2.1,23.1l3.7-1.5c-1.1-2.5-1.6-4.9-1.9-7.5s-4.3-2.7-4.1,0c0.2,3,0,6,0.2,9 c0.1,2,3.3,2.8,3.8,0.5c0.6-3.2,0.5-6.3,0.2-9.5h-4.1c0.4,3.4,1.2,6.5,2.6,9.6c0.9,2.1,4.4,0.6,3.7-1.5 c-1.2-3.9-2.2-7.8-2.9-11.8c-0.6-3.4-0.8-7.1-2.5-10.2C111.8,336,111.4,335.9,111.3,336.2L111.3,336.2L111.3,336.2z",
    fill: "#99F5FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M91.9,295.8c-0.3-1.5-1.6-2.4-2.8-3.2s-2.4-1.4-3.8-1.8l1.3,5.1c0.6-0.7,1.2-1.3,1.8-2l-3.7,0.5l0.3,0.2 c3.4,2.1,6.6-3.3,3.1-5.3l-0.3-0.2c-1.1-0.6-2.9-0.5-3.7,0.5c-0.6,0.7-1.1,1.4-1.7,2c-1.4,1.7-1.1,4.5,1.3,5.1 c1.1,0.3,2.3,0.5,3.4,0.8c1.2,0.4,2.2,0.9,3.5,0.6C91.7,297.9,92.1,296.7,91.9,295.8L91.9,295.8L91.9,295.8z",
    fill: "#F3FFFD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M116.5,292.5c0.2,0,0.5,0.1,0.8,0.1c0.4,0,0.8-0.1,1.2-0.2l-1.8-0.2c0.4,0.3,1,0.4,1.5,0.4 c1-0.1,1.8-0.4,2.3-1.3c0.5-0.8,0.5-1.9,0-2.7c-1-1.7-3.6-1.8-4.6,0c-0.4,0.7-0.5,1.4-0.3,2.2l0.6-2.3c-0.4,0.5-0.8,0.9-1,1.4 c-0.1,0.2-0.1,0.5-0.2,0.7C114.7,291.6,115.5,292.4,116.5,292.5L116.5,292.5L116.5,292.5z",
    fill: "#F3FFFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M96.3,301.3l-0.2,0.1c-0.3,0.2-0.5,0.6-0.5,0.9c0,1.9,0.6,3.7,0.9,5.6c0.3,2,0.7,3.3,1.7,5.1 c0.1,0.3,0.5,0.2,0.6-0.1c1.2-3.4,0.5-8-1.2-11.2c-0.2-0.3-0.6-0.5-0.9-0.5C96.5,301.3,96.4,301.3,96.3,301.3L96.3,301.3 L96.3,301.3z",
    fill: "#F3FFFD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M98.6,319.4c-1.9,6.7,1.3,13.9,0.3,20.7c-0.4,2.5,3.4,2.2,2.8,0c-1.7-6.6,0.3-14.5-2.9-20.7 C98.7,319.3,98.6,319.4,98.6,319.4L98.6,319.4L98.6,319.4z",
    fill: "#F3FFFD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M99.3,349.5c0.1,2.1,0.1,4.2,0.3,6.3c0.2,2.4,4.1,2.4,3.8,0c-0.2-2.3-0.6-4.5-0.9-6.8 C102.2,347.3,99.2,347.7,99.3,349.5L99.3,349.5L99.3,349.5z",
    fill: "#F3FFFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm1",
    d: "M112.5,346.9c-0.2,2.5-0.4,5.1-0.1,7.6c0.2,2,0.1,4.2,1.6,5.6c0.6,0.6,1.6,0.3,1.9-0.5c0.6-2-0.5-4-1-5.9 c-0.5-2.3-1.1-4.6-1.5-6.9C113.3,346.3,112.6,346.5,112.5,346.9L112.5,346.9L112.5,346.9z",
    fill: "#F3FFFD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4,285.4c-1,1.1-2,2.2-3,3.3c-1.7,1.8-3.3,3.6-5,5.5c-0.3,0.4-0.2,0.9,0.2,1.2c9.6,7.1,11.8,20.5,12.8,31.6 c1.1,11.3,0.6,22.8,1.2,34.1c0,0.4,0.3,0.8,0.8,0.8h23.4c0.4,0,0.8-0.4,0.8-0.8c-1.4-11.8-2.6-23.7-3.3-35.6 c-0.7-11.2-3.1-25.4,5.6-34c0.1,0,0.2-0.1,0.3-0.2s0.2-0.2,0.3-0.4c0.1-0.1,0.2-0.2,0.4-0.3c0.3-0.3,0.3-0.7,0.1-0.9 c-0.1-3-8.1-4.9-8.8-6.6s-0.2-4.7-0.3-6.5c-0.1-1.3-0.1-2.6-0.2-3.9c-0.1-1.7-0.2-3.5-0.2-5.2c-0.3-7.1-0.6-14.2-1-21.3 c-1.2-26.4-2.4-52.7-3.6-79.1c0-0.8-0.1-1.6-0.1-2.4c-0.2-3.8-0.3-7.5-0.5-11.3c-0.1-1.8-0.2-3.5-0.2-5.3c0-0.3-0.1-0.4-0.3-0.6 c-0.1,0-0.1,0.1-0.2,0.1c0.3,0.1,0.3,0.5-0.1,0.7c-0.3,0.1-0.6,0.2-0.9,0.3l0.2,4.8c0.2,3.8,0.3,7.5,0.5,11.3 c1.6,35.7,3.2,71.4,4.8,107.1c0,0.3,0,0.6,0,0.9c0.1,3,0.3,6,0.4,9c0,0.4-0.1,1.2,0.1,1.6c-0.4,0.1-0.5,0.5-0.4,0.8 c-5.3,3.1-11.5,4.2-17.6,2.7c-1.9-0.5-3.7-0.3-4.4-1.8c-0.8-1.8-0.2-5.3-0.3-7.2c-0.1-1.4-0.1-2.9-0.2-4.3 c-0.3-8.8-0.7-17.6-1-26.4c-1-25.5-2-50.9-3-76.4c0-0.6-0.1-1.2-0.1-1.7c-0.2-5.2-0.4-10.4-0.6-15.6c0-0.8-0.1-1.6-0.1-2.5 c-0.4,0-0.9,0-1.4-0.1c-0.1,0-0.1,0-0.1,0c0,0.9,0.1,1.7,0.1,2.5c0.2,5.8,0.4,11.6,0.7,17.4l0.1,1.3c1.2,32.3,2.5,64.6,3.8,96.9 c0.1,1.6,0.1,3.1,0.2,4.7C87.1,277.6,87.3,281.5,87.4,285.4L87.4,285.4L87.4,285.4z M112.4,285c0.1-0.1,0.3-0.2,0.4-0.2l0,0 c2.4,1.7,7.1,4.1,7.2,5.2c0.1,0,0.3,0,0.4,0c-0.3,0.2-0.5,0.3-0.8,0.5c-5,4.9-6.7,11.6-6.8,18.6c-0.2,9.8,0.9,19.8,1.7,29.6 c0.4,5,0.9,10,1.5,14.9c0.1,0.4,1,7.4,1.6,6.8c-0.2,0.2-1-0.1-1.2,0c-1.2,0.4-3.2,0.2-4.7,0c0,0.2-0.1,0.4-0.1,0.6 c-0.1-0.2-0.1-0.4-0.2-0.6c-0.2,0-0.5,0-0.7,0H99.4c0,0.1,0,0.2,0,0.4c0,0.4,0,0.7,0,1c-0.4-0.5-0.7-1-0.9-1.3 c0.3,0.2,0.4,0.2,0.4,0.2c0-0.1,0-0.1-0.1-0.2h-2.3c-2.8,0-2,0.1-1.8-2.9c0.4-4.8-0.2-9.9-0.3-14.7c-0.1-4.9-0.2-9.9-0.6-14.8 c-0.7-7.9-1.8-16-5.2-23.2c-1.6-3.4-4-5.6-6-8.6c-0.4-0.5-0.6-0.9-0.8-1.1c-0.2,0-0.4-0.1-0.7-0.1c0.2,0,0.3-0.1,0.5-0.1 c-0.3-0.5,0.1-0.6,1.4-2.4c0.4-0.5,0.8-1.1,1.3-1.6c1.2-1.4,2.6-2.7,3.8-4C96.2,290.2,105,289.7,112.4,285L112.4,285z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M117.6,290.7c-0.1,0.1-0.2,0.1-0.4,0.2L117,291c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.3-0.6,0.5 c-0.4,0.3-0.8,0.7-1.2,1.1c-1.2,1.1-2.2,2.6-3.1,4.2c-0.1,0-0.2-0.1-0.4-0.1c-0.1-0.1-0.3-0.1-0.5-0.2c-1.4-0.6-3.5-1-5.3-1.1 s-3.1,0.1-3.1,0.1s-0.6,0-1.4,0.2c-0.9,0.2-2.1,0.4-3.2,0.9c-1.2,0.5-2.3,1.1-3.3,1.7c-0.2,0.1-0.5,0.3-0.7,0.5 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.3,0.4-0.4,0.5c-0.1,0.2-0.2,0.5-0.2,0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-1.5-2-3.4-3.5-5.4-4.5 c0,0,0,0-0.1,0c-0.5-0.2-1-0.4-1.5-0.6c-0.2-0.1-0.5-0.2-0.8-0.2c-0.2,0-0.4-0.1-0.7-0.2h-0.1c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.4-0.1-0.6-0.1c-0.5-0.1-0.9,0-1.2,0c-0.2,0-0.4,0.1-0.6,0.1s-0.3,0.1-0.5,0.1c0.2,0,0.5,0.1,0.7,0.1c0.1,0,0.3,0,0.4,0 c0.3,0.1,0.7,0.1,1.2,0.1c0.1,0,0.3,0,0.5,0.1c0.1,0,0.2,0,0.4,0.1l0,0c0.2,0,0.4,0.1,0.6,0.1s0.5,0.1,0.7,0.2l0,0 c0.5,0.1,0.9,0.4,1.4,0.6c1.9,0.9,3.8,2.4,5.2,4.3c1.5,1.9,2.5,4.1,3.2,6.5c1.4,4.6,1.4,9.4,1.6,12.8c0.1,3.4,0.2,5.7,0.2,5.7 s1.1,28.6,1.3,34.3c0,0.1,0,0.2,0,0.4c0,0.1,0,0.1,0,0.1l0,0c0,0,0,0,0,0.1c0,0,0,0.1,0.1,0.2c0,0-0.1,0-0.4-0.2 c0.2,0.3,0.5,0.8,0.9,1.3c0-0.2,0-0.6,0-1c0-0.1,0-0.2,0-0.4c0-0.2,0-0.4,0-0.6c-0.2-5.7-1.3-34.3-1.3-34.3s-0.1-2.2-0.2-5.7 c-0.2-3.4-0.2-8.2-1.6-13c-0.6-2-1.5-4-2.7-5.7v-0.1c0-0.3,0.1-0.6,0.2-1c0.1-0.1,0.1-0.2,0.3-0.4c0.1-0.1,0.2-0.2,0.2-0.2 c0.2-0.1,0.4-0.3,0.6-0.4c0.9-0.6,2-1.2,3.2-1.6c1.1-0.4,2.3-0.7,3.1-0.9c0.8-0.1,1.4-0.2,1.4-0.2s1.3-0.2,3-0.1s3.7,0.5,5.1,1.1 c0.2,0.1,0.3,0.1,0.4,0.2l0,0c0-0.1-0.1,0.2-0.1,0.3c-0.3,0.8-0.4,1.3-0.5,2c-0.7,2-1.1,4.1-1.3,6.1c-0.2,2.5-0.2,4.8-0.1,7 c0.1,2.2,0.2,4.2,0.2,5.9c0.1,3.4,0.2,5.6,0.2,5.6s1.2,28.5,1.5,34.2c0,0.7,0.1,1.2,0.2,1.7c0.1,0.2,0.1,0.4,0.2,0.6 c0-0.2,0.1-0.4,0.1-0.6c0.1-0.5,0.1-1,0.1-1.7c-0.2-5.7-1.5-34.2-1.5-34.2s-0.1-2.2-0.2-5.6c-0.1-1.7-0.1-3.7-0.2-5.9 c-0.1-2.2-0.1-4.6,0.1-7c0.2-2.4,0.7-4.8,1.6-7s2.2-4.1,3.7-5.6c0.4-0.4,0.8-0.7,1.2-1c0.2-0.1,0.4-0.3,0.6-0.4 c0.1-0.1,0.2-0.1,0.3-0.2l0.2-0.1c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.1,0.4-0.2,0.5-0.3c0.5-0.3,0.9-0.5,1.2-0.7 c0.2-0.1,0.5-0.3,0.8-0.5c-0.1,0-0.3,0-0.4,0c-0.6,0-1.1,0.2-1.9,0.5C118,290.5,117.8,290.5,117.6,290.7L117.6,290.7z",
    fill: "#202020"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M83.7,150.9c3.8,0.1,7.7-0.6,11.4-1c3.3-0.4,6.9-0.4,10.1-1.3c0.3-0.1,0.6-0.2,0.9-0.3 c0.4-0.1,0.3-0.5,0.1-0.7c-0.1,0-0.1-0.1-0.2-0.1c-4.1-0.6-8.7,0.4-12.8,0.8c-3.5,0.4-7.1,0.6-10.6,1.4c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.5,0.1-0.4,0.7,0,0.9h0.1C82.8,150.9,83.3,150.9,83.7,150.9L83.7,150.9z",
    fill: "#202020"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1cm3",
    d: "M91.7,188.1l1.3-1.7c3.2-4-4.2-7.1-4.8-2c-1.1,10-0.5,20.4-0.3,30.4c0.2,9.6-0.3,19.8,1.3,29.3 c0.7,3.8,6.2,2.6,6.3-0.9c0.6-9.7-0.8-19.7-1.1-29.4s0.2-19.7-0.7-29.4l-4.8,2c0.7,0.6,1.2,1.2,1.8,1.9 C91.1,188.5,91.5,188.3,91.7,188.1L91.7,188.1L91.7,188.1z",
    fill: "#FFB0C7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1cm3",
    d: "M91.2,255.5c-0.9,0.4-1.4,1.3-1.7,2.2s-0.2,1.6-0.1,2.5c0.2,1.2,0.8,2.2,1.7,3.1c1.4,1.5,4.3,1.2,5.3-0.7 c1.1-2.1,1-4.3,0-6.4c-0.7-1.3-2.6-2.1-4-1.6c-1.5,0.5-2.5,1.8-2.6,3.4c-0.1,1.1,0.2,1.9,0.7,2.8c1.1,2.1,4.6,2.2,5.7,0 c0.5-0.9,0.8-1.7,0.7-2.8l-6.6,1.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.2,0.1,0.1-0.2-0.4c0,0.1,0.1,0.4,0.1,0.5l-0.1-0.9 c0,0.3,0.1,0.6,0,1l0.1-0.9c0,0.3-0.1,0.5-0.2,0.7l5.6-1.5c-0.1-0.1-0.2-0.2-0.3-0.2c-0.4-0.4,0.2,0.5,0.2,0.2 c0-0.1-0.2-0.5,0,0c0.3,0.6,0-0.1,0-0.1l0.1,0.5l-0.1-0.9c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.7-0.5-1.2-0.9-1.7 C93.9,254.9,92.3,255.1,91.2,255.5L91.2,255.5L91.2,255.5z",
    fill: "#FFB0C7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000143608868533996072790000016554404270332033722_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,138.4c0.8-0.4,1.4-0.6,1.9-0.9 c0.3-0.2,0.6-0.5,1-0.8c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.2,0.4-0.6,0.7-1.2l0.2-0.5c0.1-0.2,0.2-0.4,0.2-0.6 c0.2-0.4,0.3-0.8,0.4-1.2c0.3-0.8,0.5-1.7,0.7-2.6c0.4-1.8,0.7-3.6,1-5.5c0.5-3.8,0.7-7.7,0.8-11.5c0.2-7.7-0.2-15-0.4-20.4 s-0.3-8.9-0.3-8.9s0-0.9-0.1-2.4c0-1.5-0.1-3.8-0.3-6.4c-0.1-2.7-0.4-5.9-0.4-9.4c0-1.7,0.1-3.6,0.1-5.4c0-1.8-0.1-3.7-0.5-5.6 c-0.4-1.8-0.9-3.7-1.9-5.3c-0.5-0.8-1-1.6-1.7-2.2c-0.7-0.6-1.5-1.1-2.4-1.4c-3.5-1.4-7.1-2.5-10.3-3.4c-0.8-0.2-1.6-0.5-2.4-0.7 c-0.7-0.2-1.4-0.4-2.1-0.6c-0.1,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.7-0.2-1.2-0.4-1.7-0.6l0,0 c-0.8,0.2-1.6,0.3-1.6,0.3l-2.7,0.3l-0.7,0.1c-1.3,0.1-2.7,0.2-4,0.3c-0.1,0-0.2,0-0.4,0c-2.9,0.2-5.8,0.4-8.7,0.5h-0.9 c1.2,1.1,2.2,2.3,3.1,3.5s1.6,2.5,2.3,3.8l0.2,0.4l0.1,0.2l0.2,0.5c0,0,0.2,0.4,0.3,1c0.1,0.5,0.3,1.1,0.3,1.6 c0.1,0.3,0.2,0.7,0.3,1.1c0,0.1,0.1,0.3,0.1,0.6c0,0.1,0,0.2,0.1,0.4l0.1,0.3l0.1,0.5c0,0.3,0.1,0.6,0.1,0.9 c0.1,0.6,0.1,1.2,0.2,1.9c0.5,5.2,0.7,11.3,0.9,17.2c0.4,11.7,0.6,22.3,0.6,22.3s0.2,10.7,0.5,22.4c0.1,2.9,0.1,5.9,0.2,8.8 c0,1.5,0.1,2.9,0.1,4.3c0,0.7,0,1.4,0,2.1c0,0.3-0.1,0.7-0.1,1l-0.1,0.5v0.2c0,0.8-0.1,1.7-0.5,2.8c-0.1,0.4-0.4,1-0.8,1.7 c0.6-0.2,1.2-0.3,1.8-0.4c0.5-0.1,1-0.2,1.7-0.2c0.3,0,0.8-0.1,1.8-0.1c0.3,0,0.8-0.1,1.2-0.1c3.6-0.3,9.6-0.7,9.6-0.7 s6.3-0.5,9.9-0.8C112.7,138.8,113.4,138.5,113.8,138.4L113.8,138.4z M108.8,47.9c-1.6,0-3.8,0-5.6,0c-1.8,0-3.2,0.1-3.2,0.1 s-2.4,0.1-5,0.2c-1.1,0.1-2.2,0.2-3.2,0.2c-0.2,0-0.4,0-0.6,0c-0.8,0.1-1.4,0.1-1.8,0.1c-0.9,0.1-1.5,0-2.3-0.1 c0.8-0.3,1.3-0.4,2.3-0.5c0.3,0,1-0.1,1.8-0.2c0.2,0,0.4,0,0.7,0c1-0.1,2.1-0.2,3.2-0.2c2.6-0.2,5-0.2,5-0.2s1.4,0,3.2-0.1 c1.8,0,4,0,5.6,0c0.7,0,1.2,0,1.4,0c1,0,1.5,0.1,2.3,0.4c-0.8,0.2-1.4,0.3-2.3,0.3C110,47.9,109.5,47.9,108.8,47.9L108.8,47.9z",
    style: {},
    fill: "url(\"#SVGID_00000143608868533996072790000016554404270332033722_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164514595113742763760000017997745748924151193_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.2,140.7c-2,0.2-3.6,0.3-3.6,0.3 s-6.1,0.5-9.7,0.8c-0.4,0-0.8,0.1-1.1,0.1c-1,0.1-1.5,0.1-1.8,0.1c-0.7,0.1-1.2,0.1-1.8,0c-0.7,0-1.3-0.1-2-0.2 c-0.1,0.1-0.1,0.2-0.2,0.3l-0.1,0.1v0.1c-0.1,0.1-0.2,0.2-0.2,0.4c-0.3,0.5-0.7,0.9-1.1,1.3c-0.8,0.9-1.7,1.6-2.7,2.2 c-0.4,0.3-0.9,0.5-1.3,0.7c0,0.4,0.2,0.8,0.4,1.1c0.3,0.5,0.7,0.9,1.4,1.1c0.2,0.1,0.6,0.2,1.6,0.3c0.9,0,2.2-0.1,3.5-0.2 c0.2,0,0.4,0,0.6,0c1.2-0.1,2.4-0.2,3.6-0.2c0.4,0,0.7-0.1,1.1-0.1c2.2-0.1,3.8-0.3,3.8-0.3s1.9-0.1,4.3-0.3 c1.2-0.1,2.5-0.3,3.6-0.6c1.2-0.4,2.2-0.9,2.8-1.6c0.9-0.9,1.1-1.6,1.3-2c0.3-0.8,0.4-1.4,0.4-2c0-0.5,0-1-0.2-1.6 C106.9,140.6,106,140.7,105.2,140.7L105.2,140.7z",
    style: {},
    fill: "url(\"#SVGID_00000164514595113742763760000017997745748924151193_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029739109447162341350000018176890010095455125_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1664.8,
    x2: 87.17,
    y2: 1664.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,37L26.5,37 c0.1,0.1,0.2,0.2,0.3,0.4c0,0,0,0.1,0,0.2C27.4,37.8,28,38,28,38c0.3,0.1,0.5,0.2,0.8,0.3c1.7,0.6,3.5,1,5.4,1.2 c0.5,0,1,0.1,1.5,0.1c0.1-0.7,0.2-1.3,0.5-1.9c0.4-1.1,0.9-2.1,1.3-3.2c0.9-2.1,1.9-4.2,2.9-6.2c0.3-0.6,0.6-1.2,0.9-1.8 c-0.1-0.1-0.2-0.3-0.2-0.4c0,0.1-1.2-2.7-1.2-2.7l-0.5-1.5L38.7,20c-0.2-0.6-0.5-1.3-0.8-1.6c-0.3-0.4-0.8-0.5-1.3-0.3 s-1,0.5-1.3,1c-0.4,0.5-0.7,1.1-1,1.7l-1,1.8l-4.1,7l-2,3.5c-0.7,1.2-1.5,2.4-1.2,3.3C25.8,36.6,26.2,37,26.5,37L26.5,37z",
    style: {},
    fill: "url(\"#SVGID_00000029739109447162341350000018176890010095455125_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024721570815073962830000006614288067243737738_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1710.9425,
    x2: 87.17,
    y2: 1710.9425,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.5,65.9c-0.9-0.5-1.8-1.1-2.7-1.5 C59.9,64,59,63.6,58,63.5c-0.6-0.1-1.1-0.2-1.7-0.2c-1.6-0.1-3.2,0.3-4.6,1.1c-1.4,0.8-2.7,2-3.7,3.4c-2.1,2.7-2.8,6.2-2.1,9.5 c0.3,1.6,1,3.2,2,4.6c1,1.3,2.3,2.4,3.7,3.2c1.5,0.8,3.1,1.3,4.8,1.4l0.7,0.1h0.5c0,0,0,0,0.1,0c0.2,0,0.4-0.1,0.7-0.2 c0.4-0.1,0.7-0.2,1-0.3c0.3-0.1,0.5-0.2,0.5-0.2l0.5-0.1l0.2-0.1l1.1-0.3c2-0.6,3.9-1.5,5.7-2.4c1.8-0.9,3.6-2,5.3-3.2 c0.6-0.4,1.3-0.9,1.9-1.4v-5.9l-0.3-0.2L69,69.1L63.5,65.9L63.5,65.9z",
    style: {},
    fill: "url(\"#SVGID_00000024721570815073962830000006614288067243737738_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000154421535588144999800000011743261596105002670_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,78c0.8-0.7,1.7-1.3,2.1-2.1 c0.5-0.8,0.4-1.5-0.4-2c-0.4-0.3-0.8-0.5-1.3-0.8l-1-0.6v5.9C74.9,78.3,75.1,78.1,75.3,78z",
    style: {},
    fill: "url(\"#SVGID_00000154421535588144999800000011743261596105002670_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078037076677947106660000016145453203157266334_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1711.45,
    x2: 87.17,
    y2: 1711.45,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.3,78c0.8-0.7,1.7-1.3,2.1-2.1 c0.5-0.8,0.4-1.5-0.4-2c-0.4-0.3-0.8-0.5-1.3-0.8l-1-0.6v5.9C74.9,78.3,75.1,78.1,75.3,78z",
    style: {},
    fill: "url(\"#SVGID_00000078037076677947106660000016145453203157266334_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011719608550537266220000000111210974142197436_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1667.5575,
    x2: 87.17,
    y2: 1667.5575,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,35c-0.8,2-2.1,4.2-1.5,6 c0.1,0.5,0.4,1,0.8,1.3c0,0,0,0,0,0.1v0.1c0.3,0.1,0.6,0.3,1,0.4c2.4,0.9,5,1.3,7.6,1.2c1.3,0,2.6-0.2,3.8-0.5 c0.6-0.1,1.2-0.3,1.9-0.5l1.1-0.4c0,0,0.4-0.1,0.9-0.3c0.2,0,0.4-0.1,0.6-0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0,0.6-0.4,0.9-0.9 C56,41,56,40.7,56,40.4c0-0.2,0-0.4,0-0.4c0-0.2,0-0.3,0-0.5v-0.2v-0.1L55.7,39c-0.1-0.2-0.2-0.5-0.2-0.8L52.9,32l-5.3-12.4 c-0.1-0.2-0.2-0.4-0.3-0.5S47.1,19,47,19c-0.2,0.1-0.6,0.5-0.8,0.9c-0.6,1-1.1,1.9-1.7,2.9c-1.1,2-2.1,3.9-3.1,5.9 S39.3,33,38.5,35L38.5,35z",
    style: {},
    fill: "url(\"#SVGID_00000011719608550537266220000000111210974142197436_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039130544260400779690000013266229306219662216_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1793.05,
    x2: 87.17,
    y2: 1793.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,151.6l3.7,7.8 c0.6,1.3,1.2,2.6,1.8,3.9c0.3,0.6,0.7,1.1,1.2,1.3c0.4,0.2,0.9,0.1,1.4-0.3c0.8-0.8,1.3-2.3,1.9-3.6s1.1-2.6,1.5-4 c0.5-1.3,0.9-2.7,1.3-4.1l0.2-0.7l0.2-0.5c0,0,0.2-0.4,0.4-0.9c0.2-0.4,0.5-0.8,0.8-1.1c-5.3,0.3-10.5,0.6-15.1,0.8L44.1,151.6 L44.1,151.6z",
    style: {},
    fill: "url(\"#SVGID_00000039130544260400779690000013266229306219662216_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026126883061059541410000007722840513776853934_",
    gradientUnits: "userSpaceOnUse",
    x1: 19.8,
    y1: 1783,
    x2: 19.8,
    y2: 1783,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,147L19.8,147L19.8,147L19.8,147 L19.8,147z",
    style: {},
    fill: "url(\"#SVGID_00000026126883061059541410000007722840513776853934_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086660057379190350480000004983106006175553428_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1791.6982,
    x2: 87.17,
    y2: 1791.6982,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.3,150.4L42.3,150.4 c0-0.1,0-0.2,0-0.2c-0.4,0-0.8,0-1.1,0.1c-2.4,0.1-4.7,0.2-6.8,0.2l0.8,1.4l4.7,7.6c0.4,0.6,0.8,1.3,1.2,1.6 c0.4,0.2,0.8,0.1,1.2-0.4s0.8-1.2,1.1-1.8c0.2-0.4,0.3-0.6,0.5-1c0,0,0.2-0.4,0.4-0.9c0.2-0.5,0.3-1.1,0.4-1.6l-1.5-3.2 L42.3,150.4L42.3,150.4z",
    style: {},
    fill: "url(\"#SVGID_00000086660057379190350480000004983106006175553428_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098901622897236932740000002787153897432869805_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1728.3944,
    x2: 87.17,
    y2: 1728.3944,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,130.8c-1.1,0.4-2.2,0.8-3.3,1.2 c-1.1,0.4-2.2,0.7-3.4,0.9c-0.1,0-0.3,0.1-0.4,0.1h-0.1h-0.1h-0.3h-0.6c0,0-0.5,0-1.1-0.1s-1.3-0.4-1.9-0.8 c-0.1,0-0.1-0.1-0.2-0.1l0,0l-0.3-0.1l-0.8-0.4c-1.4-0.8-2.7-1.8-3.7-3c-1.1-1.2-1.9-2.6-2.4-4.1s-0.8-3.1-0.8-4.7 c0-3.2,1.2-6.4,3.4-8.7c2.2-2.3,5.2-3.9,8.3-4.2c0.6-0.1,1.3-0.1,1.9-0.1c0,0,0,0,0.1,0s0.1,0.1,0.1,0.1c0.1,0,0.2,0,0.3,0 c1.2,0.2,2.4,0.7,3.3,1.5c0.9,0.7,1.8,1.5,2.7,2.2c0.9,0.7,1.8,1.3,2.8,1.9l2.9,1.9l1.3,0.8V79.8c-0.6,0.4-1.1,0.8-1.7,1.2 c-1.8,1.2-3.7,2.3-5.6,3.2s-3.9,1.8-6,2.4l-0.3,0.1c-0.1,0.1-0.3,0.1-0.5,0.2c0.1,0-0.7,0.2-1.4,0.4c-0.4,0.1-0.8,0.1-1.1,0.2 c-0.3,0-0.5,0-0.5,0c-0.2,0-0.4,0-0.6,0h-0.3h-0.3c-0.2,0-0.4-0.1-0.7-0.1c-1.8-0.2-3.5-0.8-5-1.7c-1.5-0.9-2.9-2.2-3.9-3.7 s-1.7-3.2-2-5s-0.3-3.6,0.2-5.3c0.4-1.8,1.2-3.4,2.3-4.8c1.1-1.4,2.4-2.7,4-3.6c1.5-0.8,3.3-1.3,5-1.2l0,0c0,0,0,0,0.1,0 s0.1,0,0.1,0c0.7,0,1.3,0.1,1.9,0.3l0,0c1,0.2,2,0.5,2.9,1c1,0.5,1.9,1.1,2.8,1.6l5.5,3.2l5,2.9v-22c-0.2-0.1-0.3-0.2-0.5-0.3 s-0.7-0.3-1.2-0.6c-1.8-0.7-4.2-0.8-6.4-0.8c-4.5,0.2-8.6,0.3-8.6,0.3s-14.6,0.6-17.5,0.7c-1,0-1.5,0-2.3-0.2 c0.8-0.2,1.3-0.4,2.3-0.4c2.9-0.1,17.5-0.7,17.5-0.7s4.1-0.2,8.6-0.3c2.2,0,4.7,0.1,6.6,0.8c0.6,0.2,1.1,0.5,1.3,0.6 c0.1,0,0.1,0.1,0.2,0.1v-7.8c-0.5-0.4-1.1-0.8-1.6-1.1c-4.7-3-10.4-4.2-15.9-3.5C56.5,36,56,36,55.6,36.1 c0.3,0.8,0.7,1.5,0.9,2.4l0.1,0.2v0.2V39v0.2c0,0.1,0,0.2,0,0.3c0,0.2,0,0.4,0,0.6c0,0,0,0.1-0.1,0.3c0,0.2-0.1,0.5-0.3,0.8 c0,0.1-0.1,0.1-0.1,0.2c0.8-0.2,0.3,0.3-0.6,0.9c0.1,0-0.6,0.4-1.3,0.8c-0.3,0.2-0.7,0.3-1,0.5c-0.3,0.1-0.5,0.2-0.5,0.2L52.2,44 c-0.2,0.1-0.3,0.1-0.7,0.2c-0.6,0.2-1.3,0.4-1.9,0.5c-1.3,0.3-2.6,0.4-4,0.5c-2.7,0.1-5.3-0.4-7.9-1.3c-0.6-0.2-1.2-0.5-1.8-0.7 c0,0,0,0-0.1-0.1c-0.1-0.2-0.2-0.4-0.1-0.6c-0.2-0.4-0.4-0.8-0.6-1.2C35,41.1,35,40.9,35,40.6c-0.5,0-1.1-0.1-1.6-0.1 c-1.9-0.2-3.8-0.7-5.6-1.3c-0.3-0.1-0.7-0.2-1-0.4c0,0-0.9-0.4-1.7-0.9c0,0.1,0,0.2,0,0.2c-0.1,0-0.2-0.1-0.4-0.2 c-0.1-0.1-0.2-0.2-0.3-0.2l-0.2-0.2l-0.1-0.1l0,0l0,0l0,0l0,0c0.1-0.1,0.2-0.2,0.2-0.3c-0.1-0.2-0.3-0.4-0.3-0.7 c0-0.2-0.1-0.4-0.1-0.5c-1.1,0.3-2.1,0.5-3.6,0.6c-0.2,0-0.5,0-0.8,0c0,2.4,0,5,0,7.7c0.1,11.3,0.2,24.7,0.2,37.4 c0.2,25.5,0.3,48.8,0.3,48.8s0,0.8,0,3.8c0,1.5,0,3.6,0,6.3c0,1.4,0,2.9,0,4.7c0,0.2,0,0.4,0,0.7v0.1c0.3,0.2,0.7,0.4,1.1,0.6 l0,0c0.2,0.1,0.3,0.2,0.7,0.4s1,0.5,2,0.8l0,0c1.4,0.5,3.6,1,6.5,1.2c2.8,0.2,6.2,0,10.1-0.2c7.7-0.4,16.8-0.9,26.1-1.4 c2.3-0.1,4.6-0.2,6.9-0.5c0.2,0,0.4-0.1,0.6-0.1V127C72.2,128.5,69.6,129.7,66.8,130.8L66.8,130.8z M31,117.5 c-0.1,3.9-0.3,7.4-0.3,7.4s-0.1,0.9-0.2,2.2c-0.1,1.4-0.2,3.2-0.5,5.1c-0.2,1.9-0.7,4-1.4,5.5c-0.3,0.6-0.5,1.1-0.7,1.3 c-0.5,0.8-1,1.2-1.8,1.6c0.6-0.9,0.8-1.3,1.2-1.9c0.1-0.2,0.4-0.6,0.7-1.2c0.7-1.5,1.1-3.5,1.4-5.4c0.2-1.9,0.3-3.8,0.5-5.1 c0.1-1.4,0.2-2.2,0.2-2.2s0.2-3.5,0.3-7.4c0-1.9,0.1-3.9,0.1-5.7c0-1,0-1.8,0-2.2c0-1,0.1-1.5,0.3-2.3c0.2,0.8,0.3,1.3,0.3,2.3 c0,0.4,0,1.2,0,2.2C31.1,113.5,31.1,115.6,31,117.5L31,117.5z M31,89.9c-0.2,2-0.5,1.2-0.6,0c0,0.1-0.2-3-0.2-3V85 c0-1.9-0.1-3.9-0.2-5.8c-0.2-3.9-0.5-7.7-1-11.6c-0.2-1.9-0.5-3.8-0.7-5.8c-0.3-1.9-0.5-3.8-1-5.7c-0.4-1.9-1-3.7-1.8-5.4 s-2-3.2-3.3-4.4c-0.4-0.4-0.9-0.7-1.4-1c0,0,0,0,0-0.1c-0.1-0.2-0.2-0.8,0.5-0.9h0.1c0.5,0.3,1.1,0.7,1.6,1.2 c3.1,2.7,4.7,6.7,5.6,10.6c0.4,2,0.7,3.9,1,5.9s0.5,3.9,0.7,5.9c0.4,3.9,0.8,7.9,1,11.8c0.1,2,0.2,3.9,0.2,5.9v1.3 C31.2,87,31.1,88.7,31,89.9L31,89.9z",
    style: {},
    fill: "url(\"#SVGID_00000098901622897236932740000002787153897432869805_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000000930787074257856400000016090131640629647521_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,143.1c0.3-0.4,0.7-0.8,1-1.2 c0.1-0.1,0.2-0.2,0.2-0.3v-0.1v-0.1c0.1-0.2,0.2-0.4,0.3-0.5c0.4-0.7,0.6-1.3,0.8-1.6c0.4-1.1,0.7-1.9,1.1-2.8v-0.3 c0-0.3,0.1-0.6,0.1-1c0-0.7,0-1.3,0-2c-0.1-1.4-0.1-2.8-0.1-4.3c-0.1-2.9-0.1-5.9-0.2-8.8c-0.2-11.7-0.5-22.3-0.5-22.3 s-0.2-10.7-0.6-22.3c-0.2-5.8-0.4-12-0.9-17.1c-0.1-0.6-0.1-1.3-0.2-1.9c0-0.3-0.1-0.6-0.1-0.9l-0.1-0.4l-0.1-0.3 c0-0.1-0.1-0.3-0.1-0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2,0-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c0,0.1-0.2-0.6-0.5-1.3S82,50.6,82,50.6 l-0.2-0.5l-0.5-1c-0.6-1.2-1.4-2.4-2.2-3.5c-1.3-1.7-2.8-3.2-4.4-4.5v7.8c0.7,0.5,1.1,0.9,1.5,1.5c-0.6-0.3-1-0.5-1.5-0.8v22 l0.5,0.3l1.4,0.8c0.4,0.3,1,0.5,1.4,1c0.5,0.4,0.9,1.1,0.8,1.8c0,0.7-0.4,1.3-0.7,1.8c-0.8,0.9-1.7,1.6-2.5,2.2 c-0.3,0.2-0.6,0.4-0.9,0.7V115l4.5,2.9c0.5,0.3,1,0.7,1.4,1.3c0.4,0.6,0.6,1.3,0.5,2s-0.4,1.3-0.8,1.8s-0.8,0.9-1.3,1.3 c-1.4,1-2.8,1.9-4.3,2.7v20.1c2-0.3,4-0.9,5.6-1.9C81.2,144.6,82,143.9,82.8,143.1L82.8,143.1z",
    style: {},
    fill: "url(\"#SVGID_00000000930787074257856400000016090131640629647521_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039097716006320172140000010642284559214141074_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1730.1,
    x2: 87.17,
    y2: 1730.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,143.1c0.3-0.4,0.7-0.8,1-1.2 c0.1-0.1,0.2-0.2,0.2-0.3v-0.1v-0.1c0.1-0.2,0.2-0.4,0.3-0.5c0.4-0.7,0.6-1.3,0.8-1.6c0.4-1.1,0.7-1.9,1.1-2.8v-0.3 c0-0.3,0.1-0.6,0.1-1c0-0.7,0-1.3,0-2c-0.1-1.4-0.1-2.8-0.1-4.3c-0.1-2.9-0.1-5.9-0.2-8.8c-0.2-11.7-0.5-22.3-0.5-22.3 s-0.2-10.7-0.6-22.3c-0.2-5.8-0.4-12-0.9-17.1c-0.1-0.6-0.1-1.3-0.2-1.9c0-0.3-0.1-0.6-0.1-0.9l-0.1-0.4l-0.1-0.3 c0-0.1-0.1-0.3-0.1-0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2,0-0.2c-0.1-0.2-0.2-0.3-0.2-0.5c0,0.1-0.2-0.6-0.5-1.3S82,50.6,82,50.6 l-0.2-0.5l-0.5-1c-0.6-1.2-1.4-2.4-2.2-3.5c-1.3-1.7-2.8-3.2-4.4-4.5v7.8c0.7,0.5,1.1,0.9,1.5,1.5c-0.6-0.3-1-0.5-1.5-0.8v22 l0.5,0.3l1.4,0.8c0.4,0.3,1,0.5,1.4,1c0.5,0.4,0.9,1.1,0.8,1.8c0,0.7-0.4,1.3-0.7,1.8c-0.8,0.9-1.7,1.6-2.5,2.2 c-0.3,0.2-0.6,0.4-0.9,0.7V115l4.5,2.9c0.5,0.3,1,0.7,1.4,1.3c0.4,0.6,0.6,1.3,0.5,2s-0.4,1.3-0.8,1.8s-0.8,0.9-1.3,1.3 c-1.4,1-2.8,1.9-4.3,2.7v20.1c2-0.3,4-0.9,5.6-1.9C81.2,144.6,82,143.9,82.8,143.1L82.8,143.1z",
    style: {},
    fill: "url(\"#SVGID_00000039097716006320172140000010642284559214141074_\")"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M178.8,53.1c-3.2-7.9-10.3-12.4-18.3-14.5c-5.1-1.3-10.4-1.7-15.6-1.5s-11.3,0-15.9,2.2 c-0.9,0.4-0.7,2,0.3,2.1c4.4,0.9,9.2-0.5,13.7-0.7c4.8-0.2,9.7-0.2,14.4,0.8c8,1.7,15.4,6,20.9,12 C178.4,53.7,178.9,53.5,178.8,53.1L178.8,53.1z",
    fill: "#7CFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179642899026515476030000014003638857668734849_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1756,
    x2: 87.17,
    y2: 1756,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.8,113.2c-0.9-0.6-1.9-1.2-2.8-1.9 c-0.9-0.7-1.8-1.5-2.6-2.1c-0.8-0.7-1.8-1.1-2.8-1.2c-0.6-0.1-1.2-0.1-1.7-0.1c-0.1,0-0.3,0-0.4,0c-2.9,0.3-5.8,1.8-7.7,4 c-2,2.2-3,5.2-3,8.2s1.1,5.9,3.2,8.1c1,1.1,2.2,2,3.6,2.6l0.3,0.1L56,131l0.2,0.1c0.2,0.1,0.3,0.1,0.5,0.2c0,0,0.4,0.2,0.9,0.4 c0.3,0.1,0.7,0.2,1,0.4c0.2,0,0.3,0,0.3,0c0.2,0,0.3,0,0.5,0h0.2h0.1h0.1H60c0.3,0,0.5-0.1,0.8-0.1c2.1-0.4,4.2-1.3,6.3-2.1 c2.1-0.8,4.1-1.8,6-2.9c0.6-0.3,1.1-0.6,1.7-1v-9.4l-2.1-1.3L69.8,113.2L69.8,113.2z",
    style: {},
    fill: "url(\"#SVGID_00000179642899026515476030000014003638857668734849_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000030486097800564432530000008918914161950579350_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,125c0.9-0.6,1.9-1.2,2.7-1.9 c0.8-0.7,1.4-1.6,1.4-2.4c0-0.9-0.8-1.5-1.8-2.1l-3.6-2.3v9.4C75.1,125.5,75.5,125.2,75.9,125z",
    style: {},
    fill: "url(\"#SVGID_00000030486097800564432530000008918914161950579350_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065773155895436534970000003582445604826263226_",
    gradientUnits: "userSpaceOnUse",
    x1: -137.98,
    y1: 1757,
    x2: 87.17,
    y2: 1757,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.9,125c0.9-0.6,1.9-1.2,2.7-1.9 c0.8-0.7,1.4-1.6,1.4-2.4c0-0.9-0.8-1.5-1.8-2.1l-3.6-2.3v9.4C75.1,125.5,75.5,125.2,75.9,125z",
    style: {},
    fill: "url(\"#SVGID_00000065773155895436534970000003582445604826263226_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023254306149659424790000007084438116917023900_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1789.4124,
    x2: 91.86,
    y2: 1789.4124,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.5,146.6l0.1,0.5 c0.7,3.2,1.7,6.4,2.9,9.5c0.3,0.8,0.6,1.5,1,2.3s0.7,1.5,1.1,2.2s1,1.2,1.6,1.3s1.2-0.1,1.7-0.7c0.5-0.6,0.9-1.2,1.2-2l1.1-2.2 l2.2-4.5l2.8-5.7c0,0,0.9-1.5,1.6-2.5c0.1-0.1,0.2-0.3,0.3-0.4c-4.6,0.8-9.4,1.4-14.3,1.9C144.7,146.4,143.6,146.5,142.5,146.6 L142.5,146.6z",
    style: {},
    fill: "url(\"#SVGID_00000023254306149659424790000007084438116917023900_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058574846320681536400000011155147357844041638_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1788,
    x2: 91.86,
    y2: 1788,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.8,152.1c-0.5-1.6-0.9-3.1-1.3-4.7 l-0.1-0.6c-2.8,0.2-5.5,0.4-8.2,0.6c0.1,0.4,0.3,0.8,0.5,1.2c1,2.5,2.3,5,3.8,7.2c0.4,0.6,0.8,1.1,1.2,1.3s0.9,0.1,1.4-0.3 c0.5-0.4,0.9-0.9,1.3-1.4c0.3-0.4,0.4-0.6,0.6-0.9c0,0,0.2-0.3,0.5-0.8c0.2-0.3,0.4-0.8,0.6-1.2 C142.9,152.4,142.8,152.2,142.8,152.1L142.8,152.1L142.8,152.1z",
    style: {},
    fill: "url(\"#SVGID_00000058574846320681536400000011155147357844041638_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169532280393150991290000018043040792068605078_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1699.2483,
    x2: 91.86,
    y2: 1699.2483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.7,73.9c1.4,0.5,2.9,0.6,4.4,0.4 l0.4-0.1c0.1,0,0.2,0,0.2-0.1l0.5-0.1c0,0,0.1,0,0.3-0.1c0.2,0,0.4-0.1,0.7-0.2h0.1c0.5-0.3,0.8-0.5,0.8-0.5l1.8-0.9 c1.9-1,3.7-2,5.6-3.1c1.8-1.1,3.6-2.2,5.3-3.5c0.9-0.6,1.8-1.2,2.5-1.9c0.4-0.3,0.7-0.7,0.8-1s0-0.7-0.2-1 c-0.5-0.6-1.6-1-2.5-1.5l-2.9-1.4l-5.8-2.8c-1.9-0.9-3.8-1.9-5.8-2.7c-1.5-0.6-3.1-1.2-4.6-1.3c-0.1,0.1-0.1,0.1-0.2,0.2H152 c-0.5-0.1-1.1-0.1-1.6,0c-1.4,0.3-2.6,1.3-3.6,2.4c-1,1.2-1.7,2.5-2.3,3.9c-1.1,2.8-1.2,6.1-0.1,8.9 C145.6,70.6,147.8,73,150.7,73.9L150.7,73.9z",
    style: {},
    fill: "url(\"#SVGID_00000169532280393150991290000018043040792068605078_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102533949883936996950000000745388254180851616_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1740.5437,
    x2: 91.86,
    y2: 1740.5437,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M176,102.9c-1.8-1.3-3.6-2.6-5.4-3.9 c-3.6-2.5-7.4-4.8-11.3-6.9L159,92c-0.1-0.1-0.3-0.1-0.4-0.1c-1.9-0.5-3.9-0.4-5.8,0.3c-1.8,0.7-3.5,1.9-4.7,3.5 c-2.5,3.1-3.9,7.2-3.5,11.2c0.3,4,2.6,7.8,6.2,9.6c1.2,0.6,2.4,0.9,3.8,1c0.2-0.1,0.8-0.2,1.3-0.3c0.7-0.2,1.5-0.4,1.5-0.4 c0.2,0,0.3-0.1,0.5-0.1l0.3-0.1l0.4-0.1c0.3-0.1,0.5-0.1,0.8-0.2c2.1-0.6,4.1-1.4,6.1-2.3s4-1.9,5.9-2.9l2.9-1.6 c1-0.5,1.9-1,2.7-1.7s1.2-1.6,1-2.4C177.7,104.3,176.8,103.6,176,102.9L176,102.9z",
    style: {},
    fill: "url(\"#SVGID_00000102533949883936996950000000745388254180851616_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183218137190439396790000010528199644225813915_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1659.6604,
    x2: 91.86,
    y2: 1659.6604,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,34.3L135.6,34.3 c0.1,0.1,0.2,0.2,0.4,0.3c0.6,0.2,1.4,0.3,2.1,0.4c0.7,0.1,1.5,0.2,2.2,0.3c1.5,0.2,3,0.2,4.4,0.2s3-0.1,4.4-0.2 c0.7-0.1,1.5-0.2,2.2-0.3c0.5-0.1,0.7-0.1,1.1-0.2c0,0,0.4,0,1-0.1c0.4,0,0.9-0.1,1.4-0.2c0.1-0.1,0.1-0.2,0.2-0.3 c0,0,0,0,0.1-0.1s0.1-0.1,0.1-0.1v-0.1c-0.1-0.2-0.1-0.3-0.2-0.5c-0.3-0.7-0.6-1.5-0.6-1.5l-0.6-1.9c-0.7-2-1.4-4-2.2-6 s-1.7-4-2.6-5.9c-0.5-1-0.9-1.9-1.4-2.9c-0.5-0.9-0.9-1.9-1.6-2.6c-0.6-0.7-1.5-1-2.2-0.6s-1.3,1.3-1.8,2.2 c-1,1.9-1.9,3.8-2.6,5.8c-1.6,4-2.7,8.1-3.4,12.3C135.9,33,135.8,33.6,135.6,34.3C135.7,34.2,135.7,34.2,135.6,34.3L135.6,34.3z",
    style: {},
    fill: "url(\"#SVGID_00000183218137190439396790000010528199644225813915_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099640551746843322230000017922238269936786337_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1715.1935,
    x2: 91.86,
    y2: 1715.1935,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.1,54.6c-0.2-0.7-0.3-1.3-0.3-1.3 l-0.3-1.7c-0.3-1.5-0.7-3-1.1-4.5c-0.9-2.9-2.2-5.7-4.1-8.1c-1.9-2.3-4.4-4.1-7.2-5.4c-2.8-1.3-5.7-2.2-8.7-3.1l-1.2-0.3l0,0 l0.4,1.3c0,0,0.1,0.4,0.2,1c0.1,0.3,0.1,0.6,0.2,0.9h0.1c0,0.1,0.1,0.2,0,0.5V34l-0.1,0.1c-0.1,0.2-0.2,0.4-0.5,0.6 c0.1,0-0.6,0.5-1.4,0.7c-0.8,0.2-1.5,0.4-1.5,0.4L152,36l-0.7,0.1c-0.7,0.1-1.5,0.2-2.2,0.3c-1.5,0.1-3,0.2-4.5,0.2 s-3-0.1-4.5-0.2c-0.7-0.1-1.5-0.2-2.2-0.3c-0.8-0.1-1.4-0.2-2.3-0.5c-0.7-0.2-1.5-0.9-1.4-1.9v-0.1c0.1-0.2,0.3-0.3,0.5-0.3 c0.1-0.4,0.1-0.7,0.2-1.1c0.2-1.5,0.6-2.9,0.9-4.3c-0.1-0.2-0.2-0.6-0.4-1c0,0.1-0.2-0.7-0.4-1.4s-0.4-1.5-0.4-1.5l-0.1-0.5 L134,22c-0.7-2.3-1.5-4.5-2.4-6.7c-0.5-1.1-0.9-2.2-1.7-2.9c-0.7-0.8-1.7-0.8-2.4-0.1c-0.4,0.3-0.7,0.8-1,1.3s-0.7,1-1,1.5 c-0.6,1-1.2,2-1.8,3.1c-1.1,2.1-2.1,4.3-2.8,6.5c-0.4,1.1-0.7,2.2-1,3.4c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.6-0.3,1.2-0.2,1.5 c0.1,0.4,0.3,0.6,0.8,0.7c0.5,0.1,1.1,0.1,1.7,0.2c1.2,0.1,2.4,0.2,3.6,0.2c2.4,0.1,4.8,0,7.1-0.1c0.6,0,1.2-0.1,1.8-0.2 c0,0,0,0,0.1,0c0.3,0.1,0.7,0.5,0.1,1h-0.1c-0.6,0.1-1.2,0.1-1.9,0.2c-2.4,0.2-4.9,0.2-7.4,0.1c-1.2,0-2.5-0.1-3.7-0.2 c-0.6-0.1-1.2-0.1-1.9-0.3c-0.4-0.1-0.7-0.3-1-0.6c-0.3-0.3-0.4-0.8-0.4-1.2c0-0.3,0-0.5,0.1-0.7l-4.7,0.2 c-2.5,0.1-5,0.3-7.4,0.5c-2.5,0.3-5,0.5-7.2,1.3c-0.7,0.3-1.4,0.6-2.1,1.1h24.9v53c0.1,1.5,0.1,3.5,0.2,5.9 c0.2,5.4,0.6,12.7,0.4,20.4c-0.1,3-0.3,6.1-0.6,9.2v20.3c1-0.6,2-1.5,2.7-2.4c0.9-1.1,1.5-2.2,1.5-2.2s0.7-1.2,1.2-2.8 s0.9-3.5,1.1-4.7c0.1-0.5,0.1-0.8,0.1-1c0.1-0.9,0.3-1.5,0.6-2.2c0.1,0.8,0.1,1.4,0,2.3c0,0.2-0.1,0.4-0.1,1 c-0.2,1.2-0.5,3.2-1.1,4.8c-0.5,1.6-1.2,2.9-1.2,2.9s-0.5,1.1-1.5,2.3c-0.9,1-2.1,2.1-3.2,2.7v3.6c1.3,0,2.6-0.1,3.9-0.1 c6.8-0.2,13.9-0.7,21.1-1.5c7.1-0.8,14.2-1.8,20.8-3.1c3.3-0.6,6.5-1.2,8.9-2.9c1.2-0.8,2.1-1.9,2.8-3.2c0.7-1.2,1.2-2.5,1.6-3.8 c0.4-1.3,0.8-2.5,1.1-3.6c0.2-0.6,0.3-1.2,0.4-1.7c0-0.2,0.1-0.4,0.1-0.6V126v-0.3l0.2-1.8c0.3-3.3,0.6-6.7,0.7-10 c0.3-6.7,0.4-13.4,0.1-20.1C182.6,80.7,180.8,67.5,178.1,54.6L178.1,54.6z M129.6,110.8c0,0.6,0,1.2,0,1.4c0,1-0.1,1.5-0.4,2.3 c-0.2-0.8-0.3-1.3-0.3-2.3c0-0.3,0-0.8,0-1.4c0.1-3.6,0.1-7.9,0.1-12c0-8.2-0.3-15.7-0.3-15.7s-0.2-7.5-0.8-15.7 c-0.3-4.1-0.6-8.4-0.9-12c-0.1-1.6-0.3-2.8-0.3-3.5c-0.1-1,0-1.5,0.1-2.3c0.3,0.8,0.4,1.3,0.5,2.3c0.1,0.6,0.2,1.9,0.3,3.5 c0.3,3.6,0.7,7.9,0.9,12c0.6,8.2,0.8,15.7,0.8,15.7s0.3,7.5,0.3,15.7C129.6,102.8,129.6,107.2,129.6,110.8L129.6,110.8z M132.2,40c-1.1,0.2-1.9,0.3-2.4,0.4c-0.9,0.2-1.5,0.2-2.3,0.1c0.8-0.3,1.3-0.6,2.2-0.8c0.4-0.1,1.3-0.2,2.4-0.4 c2.1-0.3,4.5-0.7,6.9-1c4.7-0.6,9-0.8,9-0.8s4.3-0.2,9-0.1c2.4,0,4.9,0.2,6.9,0.3c0.6,0,1.1,0.1,1.4,0.1c1,0.1,1.5,0.2,2.3,0.5 c-0.8,0.1-1.4,0.2-2.3,0.1c-0.3,0-0.8-0.1-1.4-0.1c-2-0.2-4.5-0.3-6.9-0.3c-4.7-0.1-9,0.1-9,0.1s-4.3,0.2-9,0.8 C136.7,39.3,134.3,39.7,132.2,40L132.2,40z M143.5,58.4c0.6-1.5,1.4-2.9,2.5-4.2c0.8-0.9,1.7-1.7,2.8-2.2c0-0.1,0.1-0.3,0.2-0.4 l0.1-0.1c0.6-0.2,1.3-0.3,2-0.3c2.3-0.1,4.5,0.6,6.5,1.5s3.9,1.9,5.9,2.8l5.9,2.8l2.9,1.4c0.5,0.2,1,0.5,1.5,0.8s1,0.7,1.4,1.3 c0.4,0.7,0.3,1.5-0.1,2.1c-0.4,0.6-0.8,1-1.3,1.3c-0.9,0.7-1.8,1.3-2.7,1.9c-1.8,1.2-3.6,2.4-5.5,3.5s-3.8,2.2-5.7,3.2l-1.2,0.6 c0,0-0.6,0.2-1.3,0.5c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.5,0.2-0.5,0.2l-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1 c-1.1,0.3-1.4,0.3-1.2,0.1c-1.6,0.1-3.2-0.1-4.7-0.7c-3.1-1.2-5.4-3.9-6.6-6.9C142.2,64.8,142.4,61.4,143.5,58.4L143.5,58.4z M178.5,107.3c-0.4,0.6-0.8,1-1.3,1.4c-0.9,0.8-2,1.3-3,1.8l-3,1.6c-2,1.1-4,2.1-6.1,3c-1.6,0.7-3.3,1.3-5,1.9 c-0.2,0.2-0.5,0.3-0.9,0.5c-0.7,0.4-1.5,0.6-1.5,0.6c-0.2,0.1-0.4,0.1-0.6,0.1l-0.3,0.1h-0.1h-0.1c-0.1,0-0.1,0-0.2,0 c-0.3,0-0.5,0.1-0.8,0.1c-2.1,0.2-4.4-0.3-6.2-1.4c-3.7-2.2-6-6.3-6.2-10.6c-0.2-4.2,1.2-8.5,3.9-11.8c1.4-1.6,3.1-2.9,5.2-3.7 c1.6-0.6,3.5-0.8,5.2-0.5c0.1-0.1,0.2-0.2,0.4-0.2h0.1l1.2,0.6c0.4,0.2,0.9,0.3,1.3,0.6c0,0,0,0,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2 c3.6,2,7.2,4.2,10.6,6.6c1.9,1.3,3.7,2.6,5.5,4c0.5,0.4,0.9,0.7,1.3,1.2c0.4,0.5,0.7,1.1,0.8,1.8 C179.1,106,178.9,106.7,178.5,107.3L178.5,107.3z",
    style: {},
    fill: "url(\"#SVGID_00000099640551746843322230000017922238269936786337_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000021798181807771047880000010754671220130711486_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.483,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.6,33.5c-0.3,0.2-0.6,0.5-0.8,0.7 c-0.8,0.8-1.3,1.9-1.3,3c0,0.5,0.1,1.1,0.3,1.5c0,0,0,0,0,0.1s0,0.1-0.1,0.2h0.1c0.2,0,0.6,0,1.2,0c0.1,0,0.1,0,0.2,0l0,0 l0.1,0.7c0.6,0,1.1,0.1,1.9,0.2c0.1,0,0.3,0.1,0.6,0.1c0.1,0,0.2,0.1,0.4,0.1c0.7,0.2,1.4,0.4,2.1,0.6c0.8,0.2,1.6,0.5,2.4,0.7 c3.3,1,6.8,2.1,10.4,3.5c0.9,0.4,1.8,0.9,2.5,1.5c0.8,0.7,1.3,1.5,1.8,2.4c1,1.7,1.6,3.6,2,5.5s0.5,3.8,0.5,5.7s-0.1,3.7-0.1,5.4 c0,3.4,0.2,6.6,0.4,9.3s0.3,4.9,0.3,6.5s0.1,2.4,0.1,2.4s0,1.1,0.1,3v-53H96.6V33.5z M117.2,39.6c-0.2-0.1-0.6-0.3-1.3-0.6 c-1.1-0.5-2.6-1.1-3.9-1.6c-1.3-0.5-2.3-0.8-2.3-0.8s-1.2-0.4-2.7-0.9s-3.3-0.9-4.3-1.2c-0.5-0.1-0.8-0.2-0.9-0.2 c-0.9-0.2-1.4-0.4-2.2-0.8c0.8,0,1.4,0,2.3,0.2c0.2,0,0.4,0.1,1,0.2c1.1,0.2,2.9,0.7,4.4,1.2S110,36,110,36s1,0.3,2.3,0.8 s2.9,1.2,4,1.6c0.7,0.3,1.1,0.5,1.3,0.6c0.9,0.4,1.3,0.8,1.9,1.3C118.6,40.2,118.1,40,117.2,39.6L117.2,39.6z",
    style: {},
    fill: "url(\"#SVGID_00000021798181807771047880000010754671220130711486_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181782991145093903460000016453452947331900849_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1696.05,
    x2: 91.86,
    y2: 1696.05,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96.6,33.5c-0.3,0.2-0.6,0.5-0.8,0.7 c-0.8,0.8-1.3,1.9-1.3,3c0,0.5,0.1,1.1,0.3,1.5c0,0,0,0,0,0.1s0,0.1-0.1,0.2h0.1c0.2,0,0.6,0,1.2,0c0.1,0,0.1,0,0.2,0l0,0 l0.1,0.7c0.6,0,1.1,0.1,1.9,0.2c0.1,0,0.3,0.1,0.6,0.1c0.1,0,0.2,0.1,0.4,0.1c0.7,0.2,1.4,0.4,2.1,0.6c0.8,0.2,1.6,0.5,2.4,0.7 c3.3,1,6.8,2.1,10.4,3.5c0.9,0.4,1.8,0.9,2.5,1.5c0.8,0.7,1.3,1.5,1.8,2.4c1,1.7,1.6,3.6,2,5.5s0.5,3.8,0.5,5.7s-0.1,3.7-0.1,5.4 c0,3.4,0.2,6.6,0.4,9.3s0.3,4.9,0.3,6.5s0.1,2.4,0.1,2.4s0,1.1,0.1,3v-53H96.6V33.5z M117.2,39.6c-0.2-0.1-0.6-0.3-1.3-0.6 c-1.1-0.5-2.6-1.1-3.9-1.6c-1.3-0.5-2.3-0.8-2.3-0.8s-1.2-0.4-2.7-0.9s-3.3-0.9-4.3-1.2c-0.5-0.1-0.8-0.2-0.9-0.2 c-0.9-0.2-1.4-0.4-2.2-0.8c0.8,0,1.4,0,2.3,0.2c0.2,0,0.4,0.1,1,0.2c1.1,0.2,2.9,0.7,4.4,1.2S110,36,110,36s1,0.3,2.3,0.8 s2.9,1.2,4,1.6c0.7,0.3,1.1,0.5,1.3,0.6c0.9,0.4,1.3,0.8,1.9,1.3C118.6,40.2,118.1,40,117.2,39.6L117.2,39.6z",
    style: {},
    fill: "url(\"#SVGID_00000181782991145093903460000016453452947331900849_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109031443077728252460000014963914721845640373_",
    cx: 98.09,
    cy: 1729.46,
    r: 45.48,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(129, 242, 224)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121,143.4c-0.7,0.3-1.1,0.5-1.4,0.5 c-1,0.3-1.6,0.2-2.4,0.1c1.1-0.4,1.6-0.5,2.2-0.7c0.2-0.1,0.6-0.2,1.3-0.5c0.2-0.1,0.5-0.3,0.8-0.4v-20.3 c-0.1,0.8-0.2,1.6-0.3,2.4c-0.2,1.9-0.6,3.8-1,5.6c-0.2,0.9-0.5,1.8-0.8,2.6c-0.1,0.4-0.3,0.8-0.5,1.2c-0.1,0.2-0.2,0.4-0.3,0.6 l-0.2,0.5c-0.3,0.6-0.6,1-0.7,1.2c-0.3,0.4-0.6,0.8-0.9,1c-0.1,0.3-0.3,0.6-0.6,0.9c-0.5,0.6-1.2,0.9-2,1.3 c-0.4,0.2-1.3,0.5-2.7,0.7h-0.1c0,0,0,0.2-0.1,0.4c0,0.2,0,0.6,0.1,1.1v0.1v0.1l0.1,0.5c0.2,0.6,0.5,1.2,0.9,1.8s0.9,1.1,1.4,1.4 c0.6,0.4,1.2,0.6,1.9,0.8c1.4,0.4,3,0.4,4.6,0.4c0.4,0,0.7,0,1.1,0v-3.6C121.3,143.2,121.2,143.2,121,143.4L121,143.4z",
    style: {},
    fill: "url(\"#SVGID_00000109031443077728252460000014963914721845640373_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105392359405588435440000000272153898196980655_",
    gradientUnits: "userSpaceOnUse",
    x1: 183.81,
    y1: 1770.4,
    x2: 91.86,
    y2: 1770.4,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(89, 217, 243)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(96, 242, 244)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121,143.4c-0.7,0.3-1.1,0.5-1.4,0.5 c-1,0.3-1.6,0.2-2.4,0.1c1.1-0.4,1.6-0.5,2.2-0.7c0.2-0.1,0.6-0.2,1.3-0.5c0.2-0.1,0.5-0.3,0.8-0.4v-20.3 c-0.1,0.8-0.2,1.6-0.3,2.4c-0.2,1.9-0.6,3.8-1,5.6c-0.2,0.9-0.5,1.8-0.8,2.6c-0.1,0.4-0.3,0.8-0.5,1.2c-0.1,0.2-0.2,0.4-0.3,0.6 l-0.2,0.5c-0.3,0.6-0.6,1-0.7,1.2c-0.3,0.4-0.6,0.8-0.9,1c-0.1,0.3-0.3,0.6-0.6,0.9c-0.5,0.6-1.2,0.9-2,1.3 c-0.4,0.2-1.3,0.5-2.7,0.7h-0.1c0,0,0,0.2-0.1,0.4c0,0.2,0,0.6,0.1,1.1v0.1v0.1l0.1,0.5c0.2,0.6,0.5,1.2,0.9,1.8s0.9,1.1,1.4,1.4 c0.6,0.4,1.2,0.6,1.9,0.8c1.4,0.4,3,0.4,4.6,0.4c0.4,0,0.7,0,1.1,0v-3.6C121.3,143.2,121.2,143.2,121,143.4L121,143.4z",
    style: {},
    fill: "url(\"#SVGID_00000105392359405588435440000000272153898196980655_\")"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M171.4,62.6c-2-2.2-5.1-3.2-7.8-4.5c-3.1-1.5-6.4-2.4-9.4-3.8c-7.5-3.7-10.8,8.9-2.6,9.4 c3.4,0.2,6.7,1,10.1,1.3c2.9,0.2,6.2,1,9,0C171.8,64.7,172.1,63.5,171.4,62.6L171.4,62.6L171.4,62.6z",
    fill: "#7CFCFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M174,105.4C174.1,105.4,174.1,105.4,174,105.4S173.9,105.4,174,105.4L174,105.4z",
    fill: "#7CFCFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M174.4,105.1c0.1-3.4-4.3-5.3-6.8-6.8c-3.9-2.3-7.8-4.6-12.1-6c-6.2-1.9-8.5,7.3-2.6,9.6 C155.2,102.9,174.3,109.7,174.4,105.1L174.4,105.1L174.4,105.1z",
    fill: "#7CFCFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M74.4,74.3c-1.8-2.8-4.3-4.3-7.2-5.9c-3.2-1.7-6.3-3.6-9.7-4.9c-4.7-1.9-8.1,6.1-3.5,8.3 c3.2,1.6,6.8,2.7,10.2,3.8c3.1,1.1,5.9,1.8,9.2,1.2C74.4,76.6,74.9,75.2,74.4,74.3L74.4,74.3z",
    fill: "#7CFCFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M78,119.9c-1.1-2.9-4.5-3.9-7.1-5.4c-3.3-2-6.7-3.8-10.3-5.1c-4.1-1.4-6.9,5.1-3,7 c3.2,1.6,6.8,2.8,10.2,3.7c2.8,0.7,6.4,2.8,9.2,1.6C77.6,121.3,78.3,120.7,78,119.9L78,119.9z",
    fill: "#7CFCFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M142.9,13.9c-3.2,4.2-3.8,9.6-4.7,14.7c-0.8,4.3,5.9,4.9,5.7,0.8c-0.2-5,1.3-9.9,1.2-14.8 C145.1,13.3,143.6,13,142.9,13.9L142.9,13.9L142.9,13.9z",
    fill: "#7CFCFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M126.4,14.4c-1.5,2.4-2.9,4.6-3.6,7.4c-0.7,2.6-1.8,5.1-0.5,7.6c0.6,1.1,2.3,1.6,3.4,0.9 c2.4-1.7,2.4-4.1,3-6.9c0.6-2.9,0.4-5.5,0.1-8.4C128.7,13.8,127.1,13.3,126.4,14.4L126.4,14.4z",
    fill: "#7CFCFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M45.1,24c-3.1,4.7-4.5,9.5-6.4,14.8s7.9,6.6,7.5,1C45.8,35,47,29.8,48,25.2C48.4,23.5,46.1,22.5,45.1,24 L45.1,24L45.1,24z",
    fill: "#7CFCFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M34.7,19.6c-2.7,3.3-3.8,7.8-5.3,11.8s5.9,5.8,6.2,0.8c0.2-3.9,1.7-7.6,1.9-11.4 C37.6,19.4,35.6,18.5,34.7,19.6L34.7,19.6L34.7,19.6z",
    fill: "#7CFCFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M178.1,50.5c-0.7-11.3-19.2-16.8-28.1-13c-0.6,0.2-0.6,1.3,0,1.5c4.6,2.2,9.9,1.5,14.7,3.1 c5.3,1.8,8.7,5,12.8,8.6C177.7,51,178.1,50.9,178.1,50.5L178.1,50.5z",
    fill: "#7CFCFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M143.6,38.7c5.4,0.3,10.8,0,16.2-0.3c3.4-0.2,6.8-0.5,9.2,2.3c1.3,1.5,1.6,3,3.3,4.3 c0.5,0.4,1.1,0.3,1.3-0.3c1.4-4.6-2.3-9.6-7-10.2c-3.7-0.5-7.9,0.5-11.6,0.9c-3.9,0.5-7.8,1-11.6,1.8 C142.5,37.4,142.8,38.7,143.6,38.7L143.6,38.7L143.6,38.7z",
    fill: "#7CFCFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M170.9,39.9c1,1.8,2,3.6,2.9,5.4s1.8,3.5,2.9,5.3c0.4,0.5,1.2,0.3,1.2-0.3c0-2.4-0.2-4-1.2-6.2 s-2.2-4-3.8-5.7C171.9,37.3,170.2,38.7,170.9,39.9L170.9,39.9L170.9,39.9z",
    fill: "#7CFCFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M131,80.6c-0.6-7.7-0.7-15.5-0.2-23.2c0.3-3.9,0.5-8,2.3-11.5c2.2-4.3,5.3-4.2,9-6.2 c0.4-0.2,0.5-0.8,0.1-1.1c-5.9-5.3-12.6,5.2-13.7,10c-2.5,10.4-1.6,22-0.1,32.4C128.7,82.3,131.1,82,131,80.6L131,80.6L131,80.6z ",
    fill: "#7CFCFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M128.7,74c2.3-3,1.3-8,1.1-11.6c-0.4-4.5-1.2-9.1-2.9-13.4c-1.9-4.8-6.4-13.5-12.5-13.1 c-0.5,0-0.8,0.5-0.6,1c1.2,2.7,3.9,4.3,5.7,6.6c2.3,3,4,6.4,5,10c1.2,4.1,1.6,8.4,2,12.6c0.3,3-0.2,5.5,1.7,7.9 C128.4,74.3,128.6,74.2,128.7,74L128.7,74L128.7,74z",
    fill: "#7CFCFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M114.9,37.3c5.4,4.6,19.5,6.9,25.5,2.6c0.5-0.4,0.5-1.2-0.2-1.4c-3.7-1.3-7.8-0.5-11.7-0.8 c-4.4-0.3-8.6-2-13-1.9C114.8,35.8,114.3,36.8,114.9,37.3L114.9,37.3L114.9,37.3z",
    fill: "#7CFCFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M121.7,41.7c2.1,3.4,3.3,6.4,4.1,10.3c0.6,2.7,5,2.1,4.8-0.7c-0.3-4.7-2.8-9.3-6.7-11.9 C122.6,38.4,120.9,40.3,121.7,41.7L121.7,41.7L121.7,41.7z",
    fill: "#7CFCFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M130.1,39.5c-2,0.3-3.3,2.7-3.7,4.5c-0.5,2,0.3,4,2.1,5c0.5,0.3,1.3,0,1.4-0.6c0.3-1.2,0.6-2.3,0.9-3.5 c0.2-1.3,1.1-2.2,1.4-3.4C132.7,40.2,131.4,39.2,130.1,39.5L130.1,39.5L130.1,39.5z",
    fill: "#7CFCFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M124.6,40.2c-0.4,0.6-0.6,1.4-0.4,2.2c0.2,0.9,1,1.6,1.9,1.7c1.1,0.1,2.1-0.5,2.3-1.6 c0.1-0.4,0.1-0.9,0-1.3c-0.1-0.2-0.2-0.4-0.3-0.6c0.1,0.3,0.1,0.4,0.1,0.2C127.9,39,125.5,38.8,124.6,40.2L124.6,40.2z",
    fill: "#7CFCFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M115.2,31.8c-2.1-3.2-7.9-1.9-11.1-1.5c-4.1,0.6-9,1.4-10,6.1c-0.2,0.8-0.1,1.9,0.7,2.5l0.5,0.4 c1.1,0.8,2.2,0.7,3-0.4c1.1-1.5,1.3-2.7,3.3-3.4c1.8-0.6,3.7-1.1,5.6-1.4c2.6-0.4,6.1,0.2,8-2C115.3,32,115.3,31.9,115.2,31.8 L115.2,31.8z",
    fill: "#7CFCFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M129.7,91c2.4-4,2.1-10.3,2.8-14.9c0.9-6.4,1.9-12.7,3.7-19c1.6-5.4,3.8-11.3,9.2-13.7 c2.1-0.9,5.7-1.3,5.2-4.4c-0.1-0.8-0.9-1.4-1.7-1.7c-10.1-3.4-16.5,10.8-18.5,18.2c-1.7,6.1-2.9,12.4-3.4,18.8 c-0.4,4.9-1.1,12.4,1.9,16.7C129,91.3,129.5,91.3,129.7,91L129.7,91L129.7,91z",
    fill: "#7CFCFF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M132.3,53.9c0.6-2.5,1.7-4.9,3.5-6.9c1.6-1.8,3.3-3,3.7-5.6c0.1-0.6-0.1-1.1-0.7-1.3 c-6.7-2.3-9.9,8.5-9.7,13.3C129.2,55.3,131.9,55.8,132.3,53.9L132.3,53.9z",
    fill: "#7CFCFF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M141.1,43.7c5,0.5,10.2-1.9,15.4-1.8c2.9,0,5.7,0.5,8.6,1.2c1.8,0.5,2.3,0.7,3.9-0.3 c0.2-0.1,0.3-0.4,0.3-0.6c-1.5-4.4-9.7-4.2-13.6-4.2c-5,0-11.8,0.7-15,4.9C140.4,43.2,140.8,43.6,141.1,43.7L141.1,43.7 L141.1,43.7z",
    fill: "#7CFCFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M126.9,99.8c-1.1,3.8-0.8,7.3-0.2,11.1c0.4,2.4,3.4,3.8,5.6,3.2c2.5-0.7,3.6-3.2,3.2-5.6s-0.6-5.1-0.9-7.7 c-0.2-1.9-1.3-3.6-3.4-3.8C129.3,96.8,127.5,97.9,126.9,99.8L126.9,99.8L126.9,99.8z",
    fill: "#7CFCFF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M182.2,87.2c0.3,9.2-0.1,18.2-1,27.4c-0.5,5-1.1,9.9-3.1,14.5s-5,6.2-8.1,9.5c-0.4,0.4-0.2,1.1,0.3,1.3 c8.5,2.7,11.2-10.4,11.5-16C182.6,111.6,183.4,99.6,182.2,87.2C182.4,87.1,182.2,87.1,182.2,87.2L182.2,87.2L182.2,87.2z",
    fill: "#7CFCFF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M110.1,142.3c3.5,6.2,10.2,5.8,16.5,5.4c7.7-0.5,17.4-0.3,24.4-4c0.7-0.4,0.6-1.7-0.2-1.9 c-5.8-0.9-11.7,0.5-17.4,1c-5.4,0.5-16.1,2.8-19.8-2.5C112.1,138.2,108.9,140,110.1,142.3L110.1,142.3L110.1,142.3z",
    fill: "#7CFCFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M157.4,143.4c1.2,1.3,3.4,0.6,5,0.4c1.8-0.2,3.9,0,5.3-1.2c0.6-0.5,0.5-1.7-0.3-2.1 c-1.7-0.8-3.6-0.1-5.5,0.2c-1.6,0.3-3.9,0.1-4.7,1.6C157.1,142.6,157.1,143.1,157.4,143.4L157.4,143.4L157.4,143.4z",
    fill: "#7CFCFF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M128.4,124.5c-0.4,6-2.3,12.9,1.7,18.1c2.3,3,7.3,5.3,10.8,2.6c0.7-0.6,1.8-2,0.9-3 c-0.7-0.8-1.8-0.1-2.6,0.1c-10.2,2.5-8.2-11.8-9.4-18C129.7,123.5,128.5,123.7,128.4,124.5L128.4,124.5L128.4,124.5z",
    fill: "#7CFCFF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M128.4,134.9c0.8,3.8,2.9,7.1,6.3,9c3.2,1.8,7.6,2.5,10.4-0.1c0.4-0.4,0-1-0.4-1c-3.2-0.4-6.2,0.2-9.3-1.2 s-5-3.9-6.1-7C129.1,134.1,128.2,134.3,128.4,134.9L128.4,134.9L128.4,134.9z",
    fill: "#7CFCFF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M128.6,137.1c-0.5,2.6-1.8,5.3-3.4,7.5l2.7-1.1l-0.2-0.1l1.4,1.1l-0.1-0.2c-1.5-3-6.1,0-3.8,3 c0.4,0.5,0.9,0.7,1.5,0.9c1,0.2,2.2-0.1,2.7-1.1c1.6-3.3,2-6.4,0.6-9.9C129.7,136.6,128.7,136.4,128.6,137.1L128.6,137.1 L128.6,137.1z",
    fill: "#7CFCFF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M127,137.1c-0.9,0.9-1.2,2.3-2.1,3.4c-0.9,1.1-2.2,1.7-3.1,2.7c-1.6,1.7-0.1,5,2.4,4.1 c1.9-0.7,3.4-2.3,4.3-4.1c0.8-1.4,1.8-3.8,1.2-5.4C129.4,136.7,127.9,136.2,127,137.1L127,137.1L127,137.1z",
    fill: "#7CFCFF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M128.4,130.9c-0.8,2.8-1.6,5.7-3.4,8c-2.3,2.9-4.9,3.6-8.4,3.6c-3,0-2.6,4.8,0.6,4.2 c3.5-0.6,7.5-3.3,9.7-6.1s3.2-6.3,1.9-9.6C128.7,130.7,128.4,130.7,128.4,130.9L128.4,130.9z",
    fill: "#7CFCFF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M182.5,83.5c-0.1-6.8-0.7-13.4-2-20c-1.1-5.9-1.5-14.7-5.1-19.6c-0.4-0.6-1.5-0.5-1.4,0.4 c0.4,6,4.2,11.7,5.5,17.6c1.5,7.1,2.4,14.4,2.9,21.6C182.4,83.6,182.5,83.6,182.5,83.5L182.5,83.5L182.5,83.5z",
    fill: "#7CFCFF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M172.5,46.7c1.1,2.2,2.6,4.2,4,6.3c0.2,0.3,0.8,0.2,0.8-0.2c0.2-2.9-1.4-5.8-4.2-6.9 C172.6,45.6,172.3,46.3,172.5,46.7L172.5,46.7L172.5,46.7z",
    fill: "#7CFCFF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M31.5,94.4c3.8-12.8-3.3-29.5,8.2-39.5c5.9-5.1,14.5-4,21.9-3.8c3.8,0.1,7.8,0.2,11.5,1.1 c4.3,1,5.3,3.6,8.2,6.3c0.3,0.3,0.9,0.4,1.3,0c5.3-6.1-5.9-10.7-10.4-11.4c-5-0.8-10.1-1-15.2-1c-4.8-0.1-9.7-0.2-14.2,1.4 C35.7,50,32.3,56.8,31,63.9c-1.7,9.9,0.4,20.4-0.3,30.4C30.7,94.8,31.4,94.8,31.5,94.4L31.5,94.4z",
    fill: "#7CFCFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M79.6,55c1.3,4,2.7,8,3.6,12.1c0.2,0.8,1.4,0.6,1.4-0.2c0.4-4.6-0.3-8.8-2.8-12.8 C81.2,52.9,79.1,53.6,79.6,55L79.6,55L79.6,55z",
    fill: "#7CFCFF"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M85.1,77.8c0.1-5.1,0.2-10.1-0.1-15.2c-0.3-4-0.1-8.2-1.7-11.9c-0.3-0.8-1.8-0.6-2,0.3 c-0.7,4.2,0.5,8.4,1,12.6c0.5,4.8,1.2,9.5,1.8,14.2C84.2,78.4,85.1,78.4,85.1,77.8L85.1,77.8z",
    fill: "#7CFCFF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M57,48.9c4.1,1.8,9.3,0.5,13.7,0.3c2-0.1,3.5-0.3,5.3,0.8c2,1.2,3,4.1,4.3,6c0.4,0.6,1.3,0.7,1.7,0 c2.2-4,0.6-9.4-4.6-10.3c-3.1-0.5-7.3,0.5-10.4,0.8c-3.4,0.3-7.1,0.1-10.1,2C56.9,48.5,56.8,48.8,57,48.9L57,48.9z",
    fill: "#7CFCFF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M49.1,47.4c-2.3-2.2-6.4-1.7-9.4-2c-3.3-0.3-8.1-1.6-11.4-0.4c-6.2,2.2-0.9,12.5,2.3,15 c0.5,0.4,1.3,0.3,1.5-0.4c0.7-2.5,0.4-4.5-0.3-6.9c0,0-1.2-2.9-1.1-3c0.1-0.2,4.2,0,4.5,0c3,0,6-0.1,9-0.2 c2.1-0.1,3.3,0.1,4.9-1.2C49.3,48,49.3,47.6,49.1,47.4L49.1,47.4L49.1,47.4z",
    fill: "#7CFCFF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M41.8,47.7c-3.5-1.6-8.2-2.7-11.7-0.7c-3.3,1.9-4.8,7.4-1,9.6c1.8,1.1,4.5-0.3,4.3-2.5c0-0.6-0.5-1.5-0.2-2 c0.3-0.7,1.6-0.9,2.2-1c2.4-0.5,4.6-0.1,6.6-1.8C42.5,48.9,42.4,48,41.8,47.7L41.8,47.7z",
    fill: "#7CFCFF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M41.6,49.3c-1.7-2.7-5.9-1.9-8.2-0.4c-3,1.9-4.8,5-5,8.5c-0.2,3.3,5.3,4.1,5.8,0.8c0.3-1.8,0.9-3.6,2.4-4.7 s3.4-1.3,4.8-2.6C41.8,50.5,41.9,49.8,41.6,49.3L41.6,49.3L41.6,49.3z",
    fill: "#7CFCFF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M36.6,50c-3.2-0.8-5.8,1.8-7,4.6c-1.7,4.1-0.7,7.7,1.5,11.4c0.3,0.5,1.2,0.4,1.3-0.2c0.5-2.5,0.7-5.1,1-7.6 c0.4-2.8,2-4.6,3.6-6.7C37.5,51.1,37.4,50.2,36.6,50L36.6,50L36.6,50z",
    fill: "#7CFCFF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M31.5,82.3c0.2-5.7,0.2-11.4-0.4-17c-0.5-4.9-0.7-10.5-2.2-15.1c-0.2-0.5-1.1-0.5-1,0.1 c0.6,5.3,2.2,10.5,2.7,15.9s0.6,10.7,0.5,16.1C31.1,82.5,31.5,82.5,31.5,82.3L31.5,82.3L31.5,82.3z",
    fill: "#7CFCFF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M26.8,50.7c1.7,8.2,2.3,16.6,4.1,24.7c0.1,0.3,0.5,0.2,0.5-0.1c0.1-8.3-2-16.9-4-24.8 C27.3,50.1,26.8,50.3,26.8,50.7L26.8,50.7L26.8,50.7z",
    fill: "#7CFCFF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M21.7,38.4c-1.8,0.9-0.7,3.5,0,4.8s1.4,2.7,2.7,3.3c2.5,1.2,5.1-0.8,4.5-3.5c-0.1-0.5-0.5-1.1-0.8-1.4 c-0.7-0.5-0.8-0.6-0.5-0.4c0.2,0.2,0.2,0.1,0-0.1c0.3,0.2,0.2,0.3,0-0.1c0-0.1-0.4-0.8-0.3-0.5c0.2,0.4-0.1-0.3-0.1-0.4 c-0.1-0.3-0.1-0.3,0-0.1c0,0.5,0,0.3-0.1-0.7c0-0.2-0.2-1,0-0.1c-0.1-0.7-0.2-1.2-0.5-1.8c-1.1-1.9-3.4-1.9-4.9-0.6 c-1.8,1.5-1.3,4.2-0.4,6.1c0.7,1.4,1.8,2.7,3.1,3.4L23,44.5l0,0c1.3-1.3,2.5-2.5,3.8-3.8c0.2,0,0.9,0.5,0.5,0.2 c-0.2-0.1-0.3-0.2-0.5-0.3c-0.5-0.3-0.9-0.5-1.4-0.7c-0.2-0.1-0.5-0.3-0.7-0.4c-0.1-0.1-0.7-0.5-0.3-0.2 c-0.2-0.1-0.4-0.3-0.6-0.4c-0.4-0.3,0.2,0.2,0,0s0.2,0.3,0.1,0.1c-0.1-0.1-0.2-0.3-0.3-0.4C23,38.2,22.3,38.1,21.7,38.4 L21.7,38.4L21.7,38.4z",
    fill: "#7CFCFF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M56.3,36.4c6.4,1.1,12.2,3.1,18.4,4.8c0.5,0.1,0.9-0.5,0.5-0.9c-5-4.3-12.2-6-18.7-5.6 C55.7,34.8,55.3,36.3,56.3,36.4L56.3,36.4z",
    fill: "#7CFCFF"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M76.6,41.8c2.8,1.4,6.9,0.8,10,0.7s7.2,0.6,10.1-1c0.2-0.1,0.2-0.5,0-0.6c-2.9-1.6-6.9-0.7-10.1-0.6 s-7.2-0.4-10,1.1C76.4,41.4,76.4,41.7,76.6,41.8L76.6,41.8L76.6,41.8z",
    fill: "#FFFFFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M101.3,46.7c1.6,0.4,2.7,1,4.4,1.1s3.3,0,5,0.1c3.3,0,2.9-5.1-0.6-4.6c-1.5,0.2-3,0.4-4.5,0.7 c-1.7,0.3-2.7,1-4.2,1.6C100.8,45.8,100.6,46.5,101.3,46.7L101.3,46.7z",
    fill: "#7CFCFF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M80.3,41.1c-0.3,0.4-0.7,0.3-0.8,0.8c-0.2,0.4-0.1,0.8,0,1.3c0.2,1,0.6,2,1.3,2.8c1.3,1.6,3,2.5,5,1.5 c0.3-0.2,0.3-0.6,0-0.7c-0.6-0.3-1.1-0.8-1.6-1.2c-0.6-0.4-1.2-0.7-1.7-1.3c-0.4-0.5-0.7-1.1-0.9-1.8c-0.1-0.3-0.1-0.6-0.3-0.8 c-0.2-0.2-0.5-0.3-0.6-0.6C80.5,41.1,80.4,41.1,80.3,41.1L80.3,41.1L80.3,41.1z",
    fill: "#7CFCFF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M78.8,40.8c-0.2,0.1-0.3,0.2-0.5,0.2c-0.3,0.1-0.6,0.4-0.7,0.7c-0.3,1.3,0.9,2.5,1.8,3.4s2.2,1.7,3.6,1.5 c0.5-0.1,1-0.6,0.7-1.2c-0.6-1-1.5-1.6-2.4-2.3c-0.8-0.7-1.5-2-2.5-2.2l0.7,1.2c0-0.3,0.1-0.5,0.2-0.7 C79.9,40.9,79.3,40.5,78.8,40.8L78.8,40.8L78.8,40.8z",
    fill: "#7CFCFF"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M95,47.3c-2.7-0.1-5.5-0.5-8-1.4c-1.8-0.7-3.7-3-5.6-2.7c-0.2,0-0.3,0.2-0.4,0.4c-0.5,2.4,3.4,4.1,5.3,4.8 c2.9,1.1,6.1,0.9,8.8-0.7C95.2,47.5,95.2,47.3,95,47.3L95,47.3z",
    fill: "#7CFCFF"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M89.4,41.8c-0.4-0.3-0.7-0.6-1.1-0.9c-0.4-0.3-1.1-0.5-1.6-0.5c-1.2-0.2-2.5,0.1-3.4,0.9 c-1.6,1.3-2.7,4.5-0.9,6c1.3,1.1,3.5,0.1,3-1.8c-0.2-0.7-0.5-1.2,0.3-1.8c0.5-0.3,1.2-0.6,1.7-0.8c0.7-0.3,1.3-0.7,1.9-0.9 C89.5,42,89.5,41.8,89.4,41.8L89.4,41.8L89.4,41.8z",
    fill: "#7CFCFF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M83,40.9c-2.2,0.4-4.3,3.9-2.2,5.6c0.5,0.5,1.1,0.3,1.5-0.1c-0.3,0.3,0.1-0.1,0.2-0.3c0.1-0.3,0-0.6,0-0.8 c-0.1-1-0.1-2.3,1.1-2.7C84.5,42.2,84.1,40.7,83,40.9L83,40.9L83,40.9z",
    fill: "#7CFCFF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M82.2,45.9l0.2,3c0.1,0.8,0.1,1.6,0.7,2.2c0.2,0.2,0.6,0.1,0.7-0.1c0.5-0.7,0.5-1.5,0.4-2.3L84,45.9 C84,44.7,82.2,44.7,82.2,45.9L82.2,45.9L82.2,45.9z",
    fill: "#7CFCFF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M89.4,47.6c0.3-2.4-4.8-1.4-5.8-0.7s-1.9,1.7-2.4,2.9s-0.2,2.5,0.4,3.6c0.2,0.3,0.8,0.3,0.9-0.1 c0.4-1.9,1.6-3.9,3.4-4.7c0.9-0.4,1.8-0.2,2.7-0.3C88.9,48.2,89.4,48,89.4,47.6L89.4,47.6L89.4,47.6z",
    fill: "#7CFCFF"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M85.8,46.4c-2.3,0.5-3.6,2.3-4.3,4.5s-0.3,4.2,1.1,5.9c0.3,0.4,1,0.1,0.9-0.4c0-1.5,0.3-3.3,0.7-4.7 s1.5-2.8,2.4-4C87.2,47,86.5,46.3,85.8,46.4L85.8,46.4L85.8,46.4z",
    fill: "#7CFCFF"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M119.2,86.9c-1,9-0.9,18-1.3,27.1c-0.2,4.3-0.4,8.7-0.9,13s-2.3,7.2-4.1,11c-0.3,0.6,0.2,1.4,0.9,1.2 c7.3-1.8,6.9-13.7,7.3-19.4c0.8-11.1,1.1-22-1.4-33C119.7,86.5,119.3,86.6,119.2,86.9L119.2,86.9L119.2,86.9z",
    fill: "#7CFCFF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M85.1,141.1c3,0.9,6.6-0.2,9.7-0.5c2.6-0.2,5.4,0.3,7.5-1.4c0.3-0.3,0.2-0.8-0.1-1c-2.3-1.6-6-0.6-8.7-0.4 c-2.8,0.3-6.2,0.3-8.6,2.1C84.5,140.2,84.5,140.9,85.1,141.1L85.1,141.1L85.1,141.1z",
    fill: "#7CFCFF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M105.5,138.9l3.3,0.3c1,0.1,1-1.5,0-1.6l-3.3-0.2C104.5,137.4,104.6,138.8,105.5,138.9L105.5,138.9z",
    fill: "#7CFCFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M106.3,141.6c-0.1,0.6-0.3,1.1-0.6,1.6c-0.4,0.6-1,0.9-1.3,1.5c-0.6,1.2,0.4,2.3,1.6,2.1 c2-0.3,2.9-3.1,3-4.8C109,140.5,106.6,140.1,106.3,141.6L106.3,141.6L106.3,141.6z",
    fill: "#7CFCFF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M79.2,147.9c0.6,0.9,2.3,1.4,3.1,0.4c0.7-0.9,0.3-2.1-0.9-2.1c-0.2,0-0.3,0-0.5,0l-0.3,0.1c0.1,0,0.1,0,0,0 s-0.1,0,0,0h0.1c0.1,0-0.2-0.1-0.2-0.1c-0.4-0.1-0.9,0-1.2,0.4C79,147,78.9,147.5,79.2,147.9L79.2,147.9L79.2,147.9z",
    fill: "#7CFCFF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M78.6,143.9c-3.7-1.8-8.4-0.8-12.4-0.4c-5.5,0.5-11.1,1-16.6,0.6s-10.5-2.5-15.9-3.5 c-3.9-0.7-7.2,0-10.1,2.6c-2,1.8-0.3,4.9,2.1,5c5.3,0.3,10.6,0.6,15.9,0.9l-0.8-5.7c-3.3,0.7-6.5,0.8-9.8,0.6v5.7 c7.5,0.5,15.7,1,22.2-3.4c0.6-0.4,0.6-1.4-0.2-1.6c-7.2-1.7-14.7-0.3-22-0.8c-3.7-0.3-3.6,5.4,0,5.7c3.9,0.3,7.5,0,11.3-0.7 c3.3-0.7,2.3-5.5-0.8-5.7c-5.3-0.3-10.6-0.7-15.9-1l2.1,5c4-3.6,10.8,0.4,15.3,1.1c3.9,0.7,7.8,0.8,11.8,0.7 c4.4-0.1,8.8-0.5,13.2-1.1c3.5-0.4,7.8-0.6,10.7-2.7C79.1,145.1,79.3,144.2,78.6,143.9L78.6,143.9L78.6,143.9z",
    fill: "#7CFCFF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M51,162.6c0.1-2.5-0.1-4.4-0.7-6.8s-1.6-5-2-7.6c-0.5-3.3-6.4-1.3-4.4,1.9c1.4,2.2,2.2,4.7,3.3,7 C48.2,159.2,49.3,160.8,51,162.6C50.9,162.6,51,162.6,51,162.6L51,162.6z",
    fill: "#7CFCFF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M40.1,157.8c-0.5-1.4-1-2.7-1.4-4.1c-0.3-1.2-1.2-3.5-0.7-4.7c0.6-1.7-1.4-3.1-2.8-2.5s-1.9,3-0.2,3.7 c1.3,0.6,2.3,2.6,3,3.8C38.8,155.2,39.4,156.6,40.1,157.8C40,157.9,40.1,157.8,40.1,157.8L40.1,157.8L40.1,157.8z",
    fill: "#7CFCFF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M85.3,97.9c-0.6,6.6-0.5,13.2-0.8,19.9c-0.3,7.2-1.4,14.1-2.6,21.2c-0.5,3,4.1,3.6,4.1,0.6 c0.1-6.9-0.1-13.8,0.1-20.8s0.4-13.9-0.6-20.8C85.5,97.8,85.3,97.8,85.3,97.9S85.3,98,85.3,97.9z",
    fill: "#7CFCFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M32.3,115.1c-0.7,4.9-1.6,9.9-2.2,14.9c-0.6,4.7-2.6,10.5-1.1,15.1c0.3,0.9,1.7,1.2,2.2,0.3 c2.1-3.9,1.2-9,1.5-13.4c0.3-5.6,0.3-11.2,0.4-16.7C33,114.8,32.3,114.7,32.3,115.1L32.3,115.1L32.3,115.1z",
    fill: "#7CFCFF"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M31.5,108.3c-0.6,9.1-0.8,18.2,0,27.2c0.5,5.3,1.2,11.4,7.3,12.8c1.3,0.3,2.4-0.4,2.9-1.6 c0.5-1.1-0.3-1.9-1.1-2.6c-1.9-1.8-3-1.2-3.8-4.2c-0.5-2.3-0.5-4.9-0.8-7.3c-0.9-8.2-2.3-16.3-3.8-24.4 C32.1,107.8,31.5,107.9,31.5,108.3L31.5,108.3L31.5,108.3z",
    fill: "#7CFCFF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M33.6,123.4C32.8,130,33,137,36.2,143c2,3.8,6.3,8.4,10.7,5.4c0.3-0.2,0.4-0.7,0.1-1 c-1.1-1.1-2.3-1.7-3.6-2.5c-3-1.8-4.5-4.1-5.8-7.4c-1.7-4.6-2.9-9.4-3.9-14.2C33.8,123.2,33.6,123.2,33.6,123.4L33.6,123.4 L33.6,123.4z",
    fill: "#7CFCFF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M31.6,132.7c-1,3.9-3.4,6.8-6.1,9.6l3.6,0.9l-0.2-0.4c-0.3-0.9-1.1-1.3-2-1.1l-0.5,0.1 c-3.5,0.5-0.4,6.5,2.1,3.6c3.1-3.6,4-8.1,3.4-12.7C31.9,132.5,31.6,132.5,31.6,132.7L31.6,132.7L31.6,132.7z",
    fill: "#7CFCFF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M30.1,137.8c-1.8,1.4-3.4,2.6-4.8,4.4c-0.6,0.8-0.7,1.7,0,2.5c0.2,0.2,0.5,0.3,0.8,0.4 c0.7,0.3,1.6-0.2,2-0.8c1.2-1.9,1.9-3.9,2.5-6.1C30.7,138,30.3,137.7,30.1,137.8L30.1,137.8L30.1,137.8z",
    fill: "#7CFCFF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M32.2,95.5c1.9-9.2,1.5-18.6,4.3-27.6c1.2-4,2.9-7.9,5.2-11.4c1.9-2.9,5.4-5.2,6.4-8.5c0.2-0.7-0.4-1.1-1-1 c-6.5,1-11,12.5-12.8,17.9c-3.2,9.4-4.5,20.6-3.2,30.5C31.2,95.9,32,96.2,32.2,95.5L32.2,95.5L32.2,95.5z",
    fill: "#7CFCFF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M38.9,57.2c2.1-1.9,4-4,6.5-5.4c1.2-0.7,2.6-1.3,3.9-1.7c1.1-0.3,1.9-0.3,2.8-1.1c0.3-0.2,0.2-0.8-0.1-0.9 c-2.3-1.1-6,0.9-7.9,2.2C41.5,52,39.5,54,38.6,57C38.6,57.2,38.8,57.3,38.9,57.2L38.9,57.2z",
    fill: "#7CFCFF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M34.3,70.9c-0.2-5.6,3.1-12.1,7.1-16c1.1-1.1,6.9-3.8,4.6-6c-0.4-0.4-1.1-0.6-1.6-0.4 c-4.1,1.5-7.5,5.2-9.4,9c-2.2,4.3-2.2,8.7-1.6,13.5C33.4,71.5,34.3,71.5,34.3,70.9L34.3,70.9L34.3,70.9z",
    fill: "#7CFCFF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M35.2,67.7c1.6-5.1,4-10.4,8-14c1.9-1.7,4.2-3.1,6.6-4c1.7-0.7,2.9-0.5,3.6-2.3c0.1-0.2,0.1-0.6-0.1-0.8 c-3.2-2.8-9.9,2.6-12.4,4.8c-4.7,4.2-7.2,9.9-6.7,16.2C34.3,68.1,35.1,68.3,35.2,67.7L35.2,67.7L35.2,67.7z",
    fill: "#7CFCFF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M38.9,57.7c3.1-5.5,8.4-9.2,14.7-10.2c0.2,0,0.1-0.4-0.1-0.3c-6.3,1.1-11.7,4.8-14.9,10.4 C38.5,57.7,38.8,57.9,38.9,57.7L38.9,57.7z",
    fill: "#7CFCFF"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M37.6,59.2c4.1-5.1,9.6-8.5,16-9.9c0.3-0.1,0.2-0.5-0.1-0.4C47.1,50.4,41.6,53.9,37.6,59.2 C37.4,59.2,37.5,59.3,37.6,59.2L37.6,59.2z",
    fill: "#7CFCFF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M35.4,67.8c1.9-4.7,4.5-9.7,8.7-12.7c3.9-2.8,8.8-2.7,12.6-5.3c0.6-0.4,0.6-1.2,0-1.6 c-4.9-3.2-11.8,0.6-15.7,4c-4.6,4-7.3,9.3-6.7,15.4C34.3,68.3,35.1,68.4,35.4,67.8L35.4,67.8L35.4,67.8z",
    fill: "#7CFCFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M31.9,100.3L31.9,100.3l0.3-0.1c-0.7,0.1-1.2,0.5-1.4,1.1c-0.2,0.5-0.3,0.9-0.2,1.4c0,0.2,0.1,0.3,0.2,0.5 c0.5,1.6,2.8,1.6,3.3,0c0.2-0.7,0.3-1.3,0-2c-0.3-0.6-0.7-1-1.4-1.1l0.4,0.2l-0.1-0.1C32.6,100,32.1,100,31.9,100.3L31.9,100.3 L31.9,100.3z",
    fill: "#7CFCFF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M111.9,52.8c0.3,14.2,1.5,28.1,0.4,42.3h5c-0.2-7.3-0.7-14.6-1.5-21.8s-3.1-14.5-2.9-21.7l-2,2.6l-0.4-0.1 c2.4,3.3,7.1-0.3,4.4-3.4c-1.6-1.8-3.2-2.3-5.5-1.7c-1.3,0.3-2.4,2-1.9,3.3c2.7,6.7,2.6,14.7,3.3,21.9s1.1,13.9,1.4,20.9 c0.1,3.2,4.7,3.2,5,0c1.1-14,1.9-29.1-1.5-42.8C115.1,50.2,111.8,50.6,111.9,52.8L111.9,52.8L111.9,52.8z",
    fill: "#7CFCFF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M111.9,103.2c-0.5,2.5-0.6,5.1-0.5,7.7c0,3.4,5.3,3.4,5.2,0c0-2.6-0.1-5.2-0.6-7.7 C115.6,101.2,112.3,101.1,111.9,103.2L111.9,103.2z",
    fill: "#7CFCFF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M119.3,108.5c0.3,3.3-0.5,6-2.7,8.5c-1.2,1.4-2.5,2.4-3.1,4.2c-0.4,1.4-0.1,3-0.2,4.4 c-0.1,3.6-1,6.8-2.7,10c-0.5,0.9-0.1,2.4,1.1,2.6c2,0.4,3.1-0.3,3.8-2.2c0.8-2.2,0.5-4.8,1-7.2c0.6-2.7,1.9-5.2,2.9-7.8 c1.1-2.8-4.1-4-4.3-0.6c-0.1,1.2-1.1,14.5-2.5,14.2l1.1,2.6c1.5-2.8,2.6-5.6,2.9-8.7c0.3-3-0.5-5.8,0.6-8.5 c1.8-4.2,3.7-7,2.5-11.8C119.7,108.2,119.2,108.2,119.3,108.5L119.3,108.5L119.3,108.5z",
    fill: "#7CFCFF"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M92.3,50.8c-2.1,0.1-3.4,1.4-4.3,3.2c-0.8,1.6-1.3,4.7,0.1,6.1c0.7,0.6,1.7,0.7,2.4,0.1 c0.9-0.7,0.7-1.7,0.6-2.7c-0.1-2,1-3.8,1.9-5.5C93.2,51.5,92.9,50.8,92.3,50.8L92.3,50.8L92.3,50.8z",
    fill: "#7CFCFF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M84.7,54.8c0.4-1,0.4-2.1,0.9-3s1.3-1.7,2.2-2.1c0.7-0.4,1.9-0.7,2-1.6c0.1-0.5-0.2-1-0.7-1.2 c-1.8-0.8-4,1.3-4.9,2.6c-1.1,1.5-2.1,3.9-1,5.6C83.5,55.6,84.4,55.4,84.7,54.8L84.7,54.8L84.7,54.8z",
    fill: "#7CFCFF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M159.7,57.3c-2-0.7-4-1.4-6-2.1c-3.5-1.2-5.1,4.7-1.5,5.5c2.1,0.5,4.2,0.8,6.2,1.3 C161.4,62.6,162.6,58.4,159.7,57.3L159.7,57.3z",
    fill: "#FFFFFF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M152.1,97.2c2,2.7,6.4,3.5,9.6,3.1c0.6-0.1,1.2-0.7,0.7-1.3c-0.9-1.3-2.2-2.3-3.5-3.2s-3.4-1.9-5.1-1.7 C152.6,94.3,151.1,95.8,152.1,97.2L152.1,97.2L152.1,97.2z",
    fill: "#FFFFFF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M128.5,100.2c-0.4,2.8-1.3,6.1,0.9,8.4c0.4,0.4,1,0.3,1.3,0c2.2-2,1.6-5.2,1.4-7.9 C132,98.8,128.8,98,128.5,100.2L128.5,100.2L128.5,100.2z",
    fill: "#FFFFFF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M61,110.3l-0.2-0.1l1,2.4l0.1-0.2l-4.3,1.1c3.9,3,9.5,4.8,14.3,5.4c0.6,0.1,0.9-0.7,0.6-1.1 c-2.5-4.5-7.9-8.3-13.1-8.7c-4.3-0.4-2.3,7.3,1.3,4.8c0.8-0.6,1.1-1.2,1.2-2.1C61.9,111.2,61.5,110.6,61,110.3L61,110.3z",
    fill: "#FFFFFF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M55.7,68.9c1.7,1,3.4,2,5.3,2.7s3.5,0.7,5.4,0.8c0.8,0,1.5-1,1-1.7c-1.1-1.5-2.1-2.7-3.6-3.9 s-3.4-2-5.2-2.9C55.4,62.2,52.5,67.1,55.7,68.9L55.7,68.9L55.7,68.9z",
    fill: "#FFFFFF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M124.4,19.9c-0.4,0.4-0.9,0.7-1.3,1.1c-0.5,0.5-0.8,1.1-1.1,1.7c-0.6,1.2-1,2.4-1.2,3.7 c-0.6,3.1,4,4.4,4.8,1.3v-0.1c0.3-1.3-0.4-2.5-1.6-2.9h-0.1l1.8,2.4c0-1.1,0.1-2.2,0.1-3.4c0-0.5,0.1-1,0.1-1.5 c0-0.6-0.2-1.1-0.2-1.7C125.9,19.8,124.8,19.4,124.4,19.9L124.4,19.9z",
    fill: "#FFFFFF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M141.1,18c-1.2,0.8-1.5,1.9-1.8,3.2l-1.3,4.6c-0.3,1,0.2,2,1,2.5c0.6,0.4,1.1,0.4,1.7,0.2 c0.7-0.1,1.5-0.9,1.6-1.6l0.7-4.8c0.2-1.4,0.5-2.6-0.3-3.8C142.4,17.9,141.6,17.6,141.1,18L141.1,18L141.1,18z",
    fill: "#FFFFFF"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M44.8,25.1h-0.4c-0.6-0.1-1,0.4-1.3,0.7c-2.5,3.3-3.7,8.7-3.8,12.8c-0.1,2.3,3.5,2.8,4,0.5 c0.7-3.3,1.2-6.6,2.1-9.8C45.7,28.2,46.7,25.3,44.8,25.1L44.8,25.1L44.8,25.1z",
    fill: "#FFFFFF"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M33.2,22.8c-1.7,2-2.5,4.9-3.4,7.4s3.4,3.7,3.9,1.1s1.5-5.2,1.2-7.8C34.8,22.7,33.9,22,33.2,22.8L33.2,22.8 L33.2,22.8z",
    fill: "#FFFFFF"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M44.3,152.4c0.7,2.1,1.4,4.1,3.1,5.7c0.3,0.3,1,0.2,1.1-0.3c0.4-2.2-0.1-4.2-0.7-6.4S43.6,150.2,44.3,152.4 L44.3,152.4L44.3,152.4z",
    fill: "#FFFFFF"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M127.9,137.8c-0.7,1.4-2.2,2.7-3.5,3.4c-1.4,0.8-3.3,2.5-1.7,4.1c1.8,1.8,4.7,0.1,6-1.5 c1.4-1.6,1.8-3.7,1.2-5.8C129.6,137.2,128.3,136.9,127.9,137.8L127.9,137.8L127.9,137.8z",
    fill: "#FFFFFF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M131.3,65.6c2.3-4.7,2.8-10,5.2-14.7c1.2-2.3,2.7-4.3,4.4-6.3c1.3-1.5,2.2-2.3,1.9-4.5 c-0.1-1-0.6-1.7-1.5-2c-5-1.7-8.4,5.2-9.7,9c-2,5.8-2.6,12.5-0.9,18.4C130.8,65.7,131.2,65.8,131.3,65.6L131.3,65.6L131.3,65.6z",
    fill: "#FFFFFF"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M168.8,39.4c0.8,0.5,1.4,1.1,2.1,1.8s1.4,1.2,2.1,1.9c0.4,0.4,1.1,0.3,1.3-0.3c0.6-2.8-1.4-5.1-3.8-6.1 c-0.8-0.3-1.8-0.2-2.2,0.6C167.7,37.9,168,39,168.8,39.4L168.8,39.4L168.8,39.4z",
    fill: "#FFFFFF"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M119.5,39.9c0.5,1.8,2.3,3.2,3.8,4.1c1.3,0.8,3.1,0.3,3.9-1s0.3-3.1-1-3.9c-1.5-0.9-3.7-1.7-5.5-1.2 C119.8,38.1,119.3,39,119.5,39.9L119.5,39.9z",
    fill: "#FFFFFF"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M74.6,50.2c1.3,0,2.4,0.4,3.5,1s1.7,1.7,2.7,2.5c1.3,1.1,4,0.1,3.2-1.9c-1.4-3.5-5.9-5.1-9.4-4.7 C72.7,47.3,72.6,50.1,74.6,50.2L74.6,50.2z",
    fill: "#FFFFFF"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M41.7,47.9c-4.2,0.1-7.6,2.1-9.9,5.5c-2,3.1-3,7.8,0,10.6c0.6,0.5,1.5,0.4,1.9-0.2c1.4-2.1,2-4.7,3.2-6.9 c1.2-2.4,3.3-4.5,5.6-6C43.9,50.2,43.4,47.9,41.7,47.9L41.7,47.9L41.7,47.9z",
    fill: "#FFFFFF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st2cm7",
    d: "M38.1,49.3c-5.3,3.2-11.6,13.3-4.2,17.6c0.4,0.2,0.8,0.1,1-0.3c0.5-0.7,1.1-1.1,1.5-1.9 c0.6-1.2,0.8-2.7,1.1-4c0.5-2.7,1.8-5.5,3.6-7.5S40.6,47.8,38.1,49.3L38.1,49.3z",
    fill: "#7CFCFF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm2",
    d: "M49.3,50c-5-0.6-11.9,1.3-13.1,2.5c-1.9,1.8-3.4,3.9-4,6.9",
    stroke: "#FFFFFF",
    fill: "none"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M30.7,129.9c-2,5.1-3.7,20.8,5.8,19c2.6-0.5,2.3-3.8,0.7-5c-1.3-1-1.7-1.3-2.1-3c-0.3-1.2-0.5-2.5-0.6-3.7 c-0.4-2.6-0.9-5.2-2.1-7.6C32,129,31,129.3,30.7,129.9L30.7,129.9L30.7,129.9z",
    fill: "#FFFFFF"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M40,148.9c0.6,0.3,1.1,0.5,1.8,0.4c0.6-0.1,1-0.3,1.4-0.6c0.4-0.4,0.5-1.1,0.2-1.6c-0.3-0.4-0.6-0.8-1.1-1 c-0.7-0.3-1.2-0.2-2-0.1c-0.6,0.1-1.1,0.8-1.2,1.4C39.2,147.8,39.5,148.6,40,148.9L40,148.9L40,148.9z",
    fill: "#FFFFFF"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M57.4,148c6.2,0.8,13.2,1.3,19-1.5c0.4-0.2,0.4-1-0.1-1.1c-6.2-1.2-13.1,0-18.9,2.1 C57.1,147.6,57.2,148,57.4,148L57.4,148L57.4,148z",
    fill: "#FFFFFF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M117.1,122.1c-1.1,2.6-1.8,5.2-2.4,8c-0.5,2.4-1.6,4.9-0.4,7.1c0.4,0.8,1.5,0.9,2.2,0.3 c1.8-1.7,1.4-4.1,1.7-6.4c0.3-2.9,0.5-5.8,0.2-8.7C118.2,121.8,117.3,121.4,117.1,122.1L117.1,122.1L117.1,122.1z",
    fill: "#FFFFFF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm2",
    d: "M114.3,104.9v3.9",
    stroke: "#FFFFFF",
    fill: "none"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M81.9,48.1c0.7,1,1.5,1.5,2.7,1.5c0.5,0,1.2-0.1,1.6-0.3s0.7-0.8,0.8-1.2c0.1-0.3-0.1-0.7-0.4-0.8 s-0.5-0.2-0.8-0.3c-0.3,0-0.7,0.1-1,0c-0.3,0-0.6-0.1-0.8-0.2c-0.3,0-0.6,0-0.9-0.1C82.3,46.6,81.5,47.4,81.9,48.1L81.9,48.1 L81.9,48.1z",
    fill: "#FFFFFF"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M179.8,130.2c-1.3,1.3-2.4,2.7-3.5,4.1c-1,1.2-2.3,2.2-1.9,3.9c0.1,0.2,0.2,0.4,0.4,0.4 c1.9,0.5,3-1.1,4-2.5c1.2-1.6,2.1-3.2,2.5-5.1C181.5,130.2,180.5,129.5,179.8,130.2L179.8,130.2L179.8,130.2z",
    fill: "#FFFFFF"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M144.5,153.4c0.3,2.2,1.6,9.8,5.2,7.9c0.5-0.2,0.7-0.8,0.7-1.3v-0.2c0-1.1-1.1-1.5-2-1.2 c-0.3,0.1-0.3,0.1-0.1,0l1.3,0.7c-1.2-2.1-2.4-4.2-3.2-6.5C145.9,151.6,144.3,152.1,144.5,153.4L144.5,153.4L144.5,153.4z",
    fill: "#FFFFFF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M135.6,153.1c0,0.8,0.2,1.6,0.6,2.4c0.2,0.4,0.4,0.7,0.7,1c0.4,0.5,0.9,0.7,1.5,0.8c1,0.1,1.7-1.3,1.2-2.1 c-0.4-0.6-0.9-0.7-1.4-1.2c-0.4-0.3-0.6-0.7-0.8-1.2C137.1,151.9,135.6,152.1,135.6,153.1L135.6,153.1L135.6,153.1z",
    fill: "#FFFFFF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M84.4,169c0,0.6,0.1,1.2,0.1,1.7c1,25.5,2,50.9,3,76.4c0.4,10.3,0.8,20.5,1.2,30.8c0.1,1.9-0.5,5.4,0.3,7.2 c0.7,1.6,2.5,1.4,4.4,1.8c6.1,1.5,12.3,0.4,17.6-2.7c-0.1-0.4,0.1-0.8,0.4-0.8c-0.1-0.5,0-1.2-0.1-1.6c-0.2-3.3-0.3-6.6-0.4-9.9 c-1.6-35.7-3.2-71.4-4.8-107.1c-0.2-3.8-0.3-7.5-0.5-11.3H83.9C84,158.6,84.2,163.8,84.4,169L84.4,169z",
    fill: "none"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M88.2,286.7c-1.7,1.8-3.7,3.6-5.2,5.6c-1.3,1.7-1.7,1.9-1.4,2.4c0.2-0.1,0.4-0.1,0.6-0.1 c0.4,0,0.8-0.1,1.2,0c0.1,0,0.3,0,0.6,0.1c0.1,0,0.3,0,0.4,0.1c0.2,0,0.4,0.1,0.7,0.2c0.2,0,0.5,0.1,0.8,0.2 c0.5,0.1,1,0.4,1.5,0.6c2,1,3.9,2.5,5.4,4.5c0.1,0.1,0.1,0.2,0.2,0.2c0-0.2,0.1-0.4,0.2-0.7c0.1-0.1,0.2-0.3,0.4-0.5 c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.3,0.7-0.5c0.9-0.6,2.1-1.2,3.3-1.7c1.2-0.5,2.4-0.7,3.2-0.9c0.9-0.2,1.4-0.2,1.4-0.2 s1.4-0.2,3.1-0.1c1.8,0.1,3.9,0.5,5.3,1.1c0.2,0.1,0.3,0.1,0.5,0.2c0.1,0,0.2,0.1,0.4,0.1c0.9-1.6,1.9-3,3.1-4.2 c0.4-0.4,0.8-0.7,1.2-1.1c0.2-0.2,0.4-0.3,0.6-0.5c0.1-0.1,0.2-0.1,0.3-0.2l0.2-0.1c0.1-0.1,0.2-0.1,0.4-0.2s0.4-0.2,0.5-0.3 c0.7-0.4,1.3-0.5,1.9-0.5c-0.1-1-4.8-3.5-7.2-5.2l0,0C105.3,289.7,96.4,290.3,88.2,286.7L88.2,286.7z",
    fill: "none"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M98.8,360.2c0,0,0,0,0-0.1s0-0.2,0-0.4c-0.2-5.7-1.3-34.3-1.3-34.3s-0.1-2.2-0.2-5.7 c-0.2-3.4-0.2-8.1-1.6-12.8c-0.7-2.3-1.7-4.6-3.2-6.5s-3.3-3.4-5.2-4.3c-0.5-0.2-0.9-0.4-1.4-0.6c-0.2-0.1-0.5-0.2-0.7-0.2 s-0.4-0.1-0.6-0.1c-0.1,0-0.3,0-0.4-0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.5-0.1-0.8-0.1-1.2-0.1c-0.1,0-0.3,0-0.4,0 c0.2,0.2,0.5,0.6,0.8,1.1c2,3,4.4,5.2,6,8.6c3.3,7.2,4.5,15.4,5.2,23.2c0.4,4.9,0.6,9.9,0.6,14.8c0.1,4.8,0.7,9.9,0.3,14.7 c-0.2,3-1,2.9,1.8,2.9H98.8C98.8,360.3,98.8,360.2,98.8,360.2L98.8,360.2L98.8,360.2z",
    fill: "none"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M109.7,324.5c0,0-0.1-2.2-0.2-5.6c-0.1-1.7-0.1-3.7-0.2-5.9c-0.1-2.2-0.1-4.6,0.1-7 c0.2-2.1,0.6-4.1,1.3-6.1c0.1-0.7,0.2-1.2,0.5-2c0-0.1,0.1-0.4,0.1-0.3l0,0c-0.1,0-0.3-0.1-0.4-0.2c-1.4-0.5-3.4-1-5.1-1.1 c-1.7-0.1-3,0.1-3,0.1s-0.6,0-1.4,0.2s-2,0.4-3.1,0.9c-1.1,0.4-2.3,1-3.2,1.6c-0.2,0.1-0.4,0.3-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.2 c-0.1,0.2-0.2,0.3-0.3,0.4c-0.2,0.4-0.2,0.7-0.2,1v0.1c1.2,1.7,2.1,3.7,2.7,5.7c1.4,4.8,1.4,9.5,1.6,13c0.1,3.4,0.2,5.7,0.2,5.7 s1.1,28.6,1.3,34.3c0,0.2,0,0.4,0,0.6h11.3c0.2,0,0.5,0,0.7,0c-0.1-0.5-0.2-1-0.2-1.7C110.9,353,109.7,324.5,109.7,324.5 L109.7,324.5z",
    fill: "none"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M176.9,102.3c-1.8-1.4-3.6-2.7-5.5-4c-3.4-2.4-7-4.6-10.6-6.6c0-0.1,0-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1 c-0.4-0.2-0.8-0.4-1.3-0.6l-1.2-0.6H158c-0.2,0-0.4,0.1-0.4,0.2c-1.8-0.3-3.6-0.1-5.2,0.5c-2,0.7-3.8,2.1-5.2,3.7 c-2.7,3.2-4.1,7.5-3.9,11.8c0.2,4.2,2.5,8.4,6.2,10.6c1.9,1.1,4.1,1.6,6.2,1.4c0.3,0,0.5-0.1,0.8-0.1c0.1,0,0.1,0,0.2,0h0.1h0.1 l0.3-0.1c0.2,0,0.4-0.1,0.6-0.1c0,0,0.8-0.3,1.5-0.6c0.3-0.2,0.6-0.4,0.9-0.5c1.7-0.5,3.4-1.2,5-1.9c2.1-0.9,4.1-1.9,6.1-3l3-1.6 c1-0.5,2-1.1,3-1.8c0.5-0.4,0.9-0.8,1.3-1.4c0.4-0.6,0.6-1.2,0.5-1.9c0-0.7-0.4-1.3-0.8-1.8C177.8,103,177.4,102.6,176.9,102.3 L176.9,102.3z M176.9,107.5c-0.8,0.7-1.7,1.2-2.7,1.7l-2.9,1.6c-1.9,1-3.9,2-5.9,2.9s-4.1,1.7-6.1,2.3c-0.3,0.1-0.5,0.2-0.8,0.2 l-0.4,0.1l-0.3,0.1c-0.2,0-0.3,0.1-0.5,0.1c0,0-0.7,0.2-1.5,0.4c-0.6,0.1-1.1,0.3-1.3,0.3c-1.3-0.1-2.6-0.4-3.8-1 c-3.5-1.8-5.9-5.6-6.2-9.6c-0.4-4,1-8.1,3.5-11.2c1.3-1.5,2.9-2.8,4.7-3.5s3.9-0.8,5.8-0.3c0.1,0,0.3,0.1,0.4,0.1l0.4,0.2 c3.9,2.1,7.6,4.4,11.3,6.9c1.8,1.2,3.6,2.5,5.4,3.9c0.9,0.7,1.7,1.3,1.9,2.2C178.1,106,177.6,106.8,176.9,107.5L176.9,107.5z",
    fill: "#202020"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M149.9,74.8c1.5,0.6,3.1,0.8,4.7,0.7c-0.1,0.2,0.2,0.2,1.2-0.1c0.1,0,0.2-0.1,0.3-0.1l0.4-0.1 c0,0,0.2-0.1,0.5-0.2c0.1,0,0.2-0.1,0.3-0.1c0.7-0.3,1.3-0.5,1.3-0.5l1.2-0.6c1.9-1,3.9-2,5.7-3.2c1.9-1.1,3.7-2.3,5.5-3.5 c0.9-0.6,1.8-1.2,2.7-1.9c0.4-0.3,0.9-0.7,1.3-1.3c0.4-0.6,0.5-1.4,0.1-2.1c-0.3-0.7-0.9-1-1.4-1.3s-1-0.5-1.5-0.8l-2.9-1.4 l-5.9-2.8c-2-0.9-3.9-1.9-5.9-2.8c-2-0.8-4.2-1.6-6.5-1.5c-0.7,0-1.3,0.1-2,0.3l-0.1,0.1c-0.1,0.2-0.2,0.3-0.2,0.4 c-1.1,0.5-2,1.3-2.8,2.2c-1.1,1.3-1.9,2.7-2.5,4.2c-1.2,3-1.4,6.5-0.2,9.5C144.4,71,146.8,73.6,149.9,74.8L149.9,74.8z M144.5,58.9c0.5-1.4,1.3-2.8,2.3-3.9c1-1.1,2.2-2.1,3.6-2.4c0.5-0.1,1.1-0.2,1.6,0h0.1c0.1-0.1,0.2-0.1,0.2-0.2 c1.6,0.2,3.1,0.7,4.6,1.3c1.9,0.8,3.8,1.8,5.8,2.7l5.8,2.8l2.9,1.4c0.9,0.5,2,0.9,2.5,1.5c0.3,0.3,0.3,0.6,0.2,1s-0.4,0.7-0.8,1 c-0.8,0.6-1.7,1.2-2.5,1.9c-1.7,1.2-3.5,2.4-5.3,3.5s-3.7,2.1-5.6,3.1l-1.8,0.9c0,0-0.4,0.2-0.8,0.5h-0.1 c-0.3,0.1-0.5,0.1-0.7,0.2c-0.2,0-0.3,0.1-0.3,0.1l-0.5,0.1c-0.1,0-0.2,0-0.2,0.1l-0.4,0.1c-1.5,0.2-3,0.1-4.4-0.4 c-2.8-0.9-5.1-3.3-6.2-6.1C143.4,65,143.5,61.8,144.5,58.9L144.5,58.9z",
    fill: "#202020"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M31,79.8c-0.2-3.9-0.5-7.9-1-11.8c-0.2-2-0.5-3.9-0.7-5.9c-0.3-2-0.5-3.9-1-5.9c-0.8-3.9-2.4-7.8-5.6-10.6 c-0.5-0.4-1-0.8-1.6-1.2H21c-0.8,0.1-0.6,0.7-0.5,0.9c0,0,0,0,0,0.1c0.5,0.3,1,0.7,1.4,1c1.4,1.2,2.5,2.8,3.3,4.4 s1.4,3.5,1.8,5.4c0.4,1.9,0.7,3.8,1,5.7s0.5,3.8,0.7,5.8c0.4,3.8,0.8,7.7,1,11.6c0.1,1.9,0.2,3.9,0.2,5.8V87c0,0,0.2,3.1,0.2,3 c0.1,1.2,0.4,2.1,0.6,0c0.2-1.2,0.3-2.9,0.3-2.9v-1.3C31.2,83.7,31.1,81.8,31,79.8L31,79.8z",
    fill: "#202020"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M64.2,65c-0.9-0.5-1.8-1.1-2.8-1.6c-0.9-0.5-1.9-0.8-2.9-1l0,0c-0.6-0.2-1.3-0.2-1.9-0.3 c-0.1,0-0.1,0-0.1,0s0,0-0.1,0l0,0c-1.8-0.1-3.5,0.4-5,1.2c-1.6,0.9-2.9,2.1-4,3.6c-1,1.4-1.9,3.1-2.3,4.8 c-0.4,1.8-0.4,3.6-0.2,5.3c0.3,1.8,0.9,3.5,2,5c1,1.5,2.4,2.8,3.9,3.7c1.6,0.9,3.3,1.5,5,1.7c0.2,0,0.4,0.1,0.7,0.1h0.3h0.3 c0.2,0,0.4,0,0.6,0c0,0,0.2,0,0.5,0s0.7-0.1,1.1-0.2c0.8-0.2,1.5-0.4,1.4-0.4c0.2-0.1,0.3-0.1,0.5-0.2l0.3-0.1 c2.1-0.6,4.1-1.4,6-2.4s3.8-2.1,5.6-3.2c0.6-0.4,1.1-0.8,1.7-1.2c0.3-0.2,0.6-0.4,0.9-0.7c0.8-0.7,1.7-1.3,2.5-2.2 c0.4-0.5,0.7-1.1,0.7-1.8c0.1-0.7-0.3-1.4-0.8-1.8s-1-0.7-1.4-1l-1.4-0.8l-0.5-0.3l-5-2.9L64.2,65L64.2,65z M74.7,72.5l1,0.6 c0.4,0.3,0.9,0.5,1.3,0.8c0.8,0.6,0.9,1.2,0.4,2s-1.3,1.4-2.1,2.1c-0.2,0.2-0.4,0.3-0.6,0.5c-0.6,0.5-1.2,0.9-1.9,1.4 C71.1,81,69.3,82,67.5,83c-1.8,0.9-3.8,1.8-5.7,2.4l-1.1,0.3l-0.2,0.1L60,85.9c0,0-0.2,0.1-0.5,0.2s-0.6,0.2-1,0.3 c-0.2,0.1-0.5,0.1-0.7,0.2c-0.1,0-0.1,0-0.1,0h-0.5h-0.7c-1.7-0.2-3.3-0.6-4.8-1.4S48.9,83.3,48,82c-1-1.3-1.6-2.9-2-4.6 c-0.7-3.3,0-6.8,2.1-9.5c1-1.3,2.2-2.5,3.7-3.3c1.4-0.8,3-1.2,4.6-1.1c0.6,0,1.2,0.1,1.7,0.2c1,0.2,1.9,0.5,2.8,0.9 s1.8,1,2.7,1.5l5.4,3.2l5.4,3.2H74.7L74.7,72.5z",
    fill: "#202020"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M70.5,112.3c-1-0.6-1.9-1.2-2.8-1.9c-0.9-0.7-1.7-1.4-2.7-2.2c-0.9-0.7-2.1-1.3-3.3-1.5c-0.1,0-0.2,0-0.3,0 l-0.1-0.1h-0.1c-0.7,0-1.3,0-1.9,0.1c-3.2,0.4-6.2,1.9-8.3,4.2c-2.2,2.3-3.4,5.5-3.4,8.7c0,1.6,0.2,3.2,0.8,4.7 c0.6,1.5,1.4,2.9,2.4,4.1c1.1,1.2,2.3,2.2,3.7,3l0.8,0.4l0.3,0.1l0,0c0.1,0,0.1,0.1,0.2,0.1c0.5,0.4,1.3,0.6,1.9,0.8 c0.6,0.1,1.1,0.1,1.1,0.1h0.6h0.3h0.1h0.1c0,0,0.3,0,0.4-0.1c1.2-0.2,2.3-0.5,3.4-0.9s2.2-0.8,3.3-1.2c2.7-1.1,5.4-2.4,7.9-3.8 c1.5-0.8,2.9-1.7,4.3-2.7c0.5-0.4,0.9-0.8,1.3-1.3s0.7-1.1,0.8-1.8c0.1-0.7-0.1-1.5-0.5-2c-0.4-0.6-0.9-0.9-1.4-1.3l-4.5-2.9 l-1.3-0.8L70.5,112.3L70.5,112.3z M78.3,118.6c0.9,0.6,1.7,1.2,1.8,2.1c0,0.8-0.6,1.7-1.4,2.4c-0.8,0.7-1.8,1.2-2.7,1.9 c-0.4,0.2-0.8,0.5-1.2,0.7c-0.6,0.3-1.1,0.7-1.7,1c-2,1.1-4,2-6,2.9c-2.1,0.8-4.2,1.6-6.3,2.1c-0.3,0.1-0.5,0.1-0.8,0.1h-0.2 h-0.1h-0.1h-0.2c-0.2,0-0.3,0-0.5,0c0,0-0.1,0-0.3,0c-0.3-0.1-0.7-0.2-1-0.4c-0.5-0.2-0.9-0.4-0.9-0.4c-0.2-0.1-0.3-0.1-0.5-0.2 l-0.2-0.1l-0.1-0.1l-0.3-0.1c-1.3-0.6-2.5-1.6-3.6-2.6c-2.1-2.2-3.2-5.1-3.2-8.1s1-6,3-8.2s4.8-3.7,7.7-4c0.1,0,0.3,0,0.4,0 c0.6,0,1.2,0,1.7,0.1c1,0.2,2,0.6,2.8,1.2s1.7,1.4,2.6,2.1s1.9,1.3,2.8,1.9l2.8,1.8l2.1,1.3L78.3,118.6L78.3,118.6z",
    fill: "#202020"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M184.3,94.6c-0.1-2.8-0.3-5.7-0.5-8.5c-0.8-10.8-2.4-21.7-4.7-32.3l-0.4-1.8l0,0l0,0 c-0.3-1.6-0.6-3.1-1.1-4.7c-0.9-3.1-2.2-6.1-4.2-8.7c-2-2.6-4.8-4.5-7.6-5.9c-2.9-1.4-6-2.4-9-3.2L155,29h-0.1c0,0,0,0-0.1,0 c-0.6-1.7-1.2-3.3-1.8-5c-0.8-2-1.7-4.1-2.6-6.1c-0.5-1-0.9-2-1.4-3s-0.9-2-1.7-2.9c-0.4-0.5-0.8-0.9-1.4-1.2 c-0.6-0.3-1.4-0.4-2-0.1c-0.6,0.2-1.1,0.7-1.5,1.1c-0.4,0.5-0.7,1-1,1.5c-1,2-1.9,4-2.8,6c-1,2.4-1.8,5-2.4,7.5c0,0,0-0.1,0-0.2 c-0.1-1.2-0.4-2.9-0.4-2.9l-0.4-1.4c-0.7-2.4-1.5-4.7-2.4-7c-0.2-0.6-0.5-1.1-0.8-1.7c-0.3-0.6-0.6-1.1-1-1.7 c-0.4-0.5-0.9-1.1-1.6-1.3c-0.7-0.3-1.6-0.2-2.2,0.2c-0.6,0.4-1.1,0.9-1.5,1.4s-0.7,1-1,1.6c-0.7,1-1.3,2.1-1.9,3.2 c-1.2,2.2-2.2,4.4-3,6.8c-0.4,1.2-0.8,2.3-1.1,3.5c-0.2,0.6-0.3,1.2-0.4,1.8v0.1h-0.1h-0.7l-3.8,0.2c-2.5,0.1-5.1,0.3-7.6,0.5 c-1.3,0.1-2.5,0.3-3.8,0.5s-2.6,0.4-3.8,0.8c-1.3,0.4-2.5,1.1-3.5,2.1c0,0,0,0-0.1,0.1c-0.9,1-1.5,2.3-1.6,3.7 c0,0.7,0.1,1.3,0.3,2l-1.7,0.2l-0.6,0.1c-1.4,0.1-2.7,0.2-4.1,0.3c-0.1,0-0.2,0-0.3,0c-2.9,0.2-5.9,0.4-8.8,0.5h-1.4l0,0h-0.2 v0.4c-0.6-0.5-1.1-0.9-1.7-1.3c-0.2-0.2-0.5-0.4-0.8-0.5C69,35.5,62.9,34.2,57,35c-0.6,0.1-1.1,0.2-1.6,0.3l-1.3-3l-5.4-12.6 c-0.1-0.3-0.2-0.6-0.4-0.9c-0.2-0.3-0.5-0.6-1-0.7s-1,0.1-1.3,0.3c-0.3,0.2-0.5,0.5-0.7,0.8c-0.6,1-1.2,2-1.8,3 c-0.7,1.2-1.3,2.4-2,3.6c-0.2-1.2-0.7-2.7-0.7-2.7l-0.4-1.2l-0.7-2c-0.2-0.6-0.4-1.3-0.9-2c-0.2-0.3-0.5-0.7-0.9-0.9 c-0.4-0.2-0.9-0.3-1.3-0.2c-0.9,0.1-1.6,0.6-2.1,1.1c-0.5,0.6-0.9,1.2-1.2,1.8l-1,1.8l-4.2,7.2L26,32.3c-0.3,0.6-0.7,1.2-1,1.9 c-0.2,0.5-0.4,1-0.4,1.5c-1.2-0.2-2.2-0.3-3.7-0.2c-0.3,0-0.8,0-1.3,0.1c-0.1,0-0.2,0-0.3,0H19c0,0,0,0.1,0,0.2 c0,0.2,0,0.5,0,0.8c0,2.5,0,5.1,0,7.9c0.1,11.3,0.2,24.7,0.2,37.4c0.2,25.5,0.3,48.8,0.3,48.8s0,0.8,0,3.8c0,1.5,0,3.6,0,6.3 c0,1.4,0,2.9,0,4.7c0,0.1,0,0.2,0,0.3c-0.2,0-0.3,0.1-0.5,0.2c-0.4,0.3-0.6,0.7-0.4,1.3c0,0.1,0.1,0.3,0.2,0.4 c0.1,0.1,0.1,0.1,0.1,0.1c0.1,0.1,0.1,0.1,0.2,0.1c0.3,0.1,0.6,0.1,0.8,0s0.4-0.2,0.5-0.4c0.2,0.1,0.4,0.3,0.7,0.4l0,0 c0.2,0.1,0.3,0.2,0.8,0.4c0.4,0.2,1,0.5,2.1,0.9l0,0c1.5,0.5,3.9,1.1,6.8,1.2c0.7,0.1,1.5,0.1,2.3,0.1c0,0.1,0,0.2,0,0.3v0.1 l1,1.6l4.6,7.5c0.4,0.6,0.7,1.3,1.4,1.9c0.4,0.3,0.9,0.5,1.5,0.4c0.5-0.1,0.9-0.4,1.2-0.8c0.6-0.7,0.9-1.3,1.3-1.9 c0.2-0.4,0.3-0.5,0.4-0.7l0.2-0.5c0,0,0.3-0.8,0.4-1.6v-0.1l1.5,3.1l1.8,3.8c0.3,0.6,0.8,1.4,1.5,1.8c0.8,0.5,1.9,0.4,2.6-0.1 s1.1-1.2,1.4-1.9s0.6-1.3,0.9-2c0.6-1.3,1.1-2.6,1.6-4s0.9-2.7,1.3-4.1l0.3-1l0.2-0.5c0,0,0.2-0.7,0.5-1.4s0.7-1.2,0.7-1.1 l0.1-0.1c2.6-0.1,5.2-0.3,7.8-0.4c2.3-0.1,4.6-0.2,7-0.5c0.2,0,0.3-0.1,0.4-0.1c1.5-0.2,3-0.6,4.5-1.2c-0.1,0.4-0.1,0.9,0,1.3 c0.2,0.7,0.8,1.5,1.8,1.9c0.2,0.1,0.6,0.2,1.2,0.3c0.2,0,0.5,0.1,0.8,0.1c0.2,0,0.5,0,0.7,0c0.9,0,1.9-0.1,2.9-0.2 c0.2,0,0.3,0,0.5,0c1.2-0.1,2.5-0.2,3.7-0.2c0.3,0,0.7-0.1,1-0.1c2.2-0.1,3.9-0.3,3.9-0.3s1.9-0.1,4.3-0.3 c1.2-0.1,2.6-0.3,3.9-0.7c0.5-0.1,0.9-0.3,1.3-0.5s0.8-0.4,1.2-0.7c0.3-0.2,0.5-0.4,0.8-0.7c1.1-1.1,1.4-2,1.6-2.5 c0.5-1.7,0.2-3-0.8-3.9c0.7-0.1,1.5-0.1,2.1-0.2v0.1c0,0.3-0.1,0.8,0.1,1.4v0.1v0.1v0.1l0.1,0.3c0.2,0.8,0.5,1.4,1,2.1 c0.4,0.6,1,1.2,1.6,1.8c0.7,0.5,1.4,0.9,2.2,1.1c1.6,0.5,3.2,0.6,4.8,0.6c0.5,0,1,0,1.5,0c1.1,0,2.3-0.1,3.4-0.1 c2.3-0.1,4.7-0.2,7.1-0.3c0.2,0.5,0.4,1.1,0.6,1.6c1,2.6,2.3,5,3.8,7.3c0.4,0.6,0.8,1.2,1.5,1.7c0.4,0.2,0.9,0.3,1.3,0.3 c0.4-0.1,0.8-0.2,1.2-0.4c0.7-0.4,1.1-1,1.6-1.5c0.3-0.3,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0.4-0.7,0.6-1.4 c0.4,1,0.7,2,1.1,3c0.3,0.8,0.6,1.5,1,2.3s0.7,1.5,1.1,2.3c0.5,0.7,1.1,1.5,2,1.9c1,0.4,2.2,0.1,2.9-0.6c0.7-0.7,1.1-1.4,1.5-2.2 l1.1-2.2l2.2-4.4l3-6c0,0,1.2-2.9,1.1-2.8c0.1-0.3,0.2-0.6,0.3-0.8c2-0.3,3.9-0.7,5.8-1c3.2-0.6,6.5-1.1,9.3-2.6 c1.4-0.8,2.6-1.8,3.5-3.1c0.9-1.2,1.4-2.5,1.9-3.8c0.4-1,0.7-1.9,1-2.9c0.1,0.3,0.2,0.1,0.5-1.1c0.3-1.2,0.6-2.8,0.6-2.8l0.1-0.5 l0,0c0.1-0.3,0.1-0.5,0.1-0.7c0.1-0.3,0.1-0.4,0.1-0.4s0.1-0.8,0.1-1.6c0.1-0.8,0.1-1.5,0-1.5v-0.1c0-0.5,0.1-1.1,0.1-1.6 c0.1-1.8,0.3-3.6,0.4-5.3C184.5,108.3,184.6,101.5,184.3,94.6L184.3,94.6z M19.8,147L19.8,147L19.8,147L19.8,147L19.8,147z M139.4,20c0.8-2,1.7-3.9,2.6-5.8c0.5-0.9,1-1.8,1.8-2.2c0.7-0.4,1.6-0.2,2.2,0.6c0.6,0.7,1.1,1.7,1.6,2.6c0.5,1,1,1.9,1.4,2.9 c0.9,1.9,1.8,3.9,2.6,5.9s1.6,4,2.2,6l0.6,1.9c0,0,0.3,0.7,0.6,1.5c0.1,0.2,0.1,0.3,0.2,0.5c0,0,0.1,0.1,0,0.1c0,0,0,0.1-0.1,0.1 s-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.2-0.2,0.3c-0.4,0.1-0.9,0.2-1.4,0.2c-0.6,0.1-1,0.1-1,0.1c-0.4,0.1-0.6,0.1-1.1,0.2 c-0.7,0.1-1.5,0.2-2.2,0.3c-1.5,0.1-3,0.2-4.4,0.2s-3-0.1-4.4-0.2c-0.7-0.1-1.5-0.2-2.2-0.3s-1.5-0.2-2.1-0.4 c-0.2-0.1-0.3-0.1-0.4-0.2l0,0c0,0,0,0,0-0.1c0.1-0.6,0.2-1.2,0.3-1.8C136.7,28.2,137.8,24,139.4,20L139.4,20z M44.4,23 c0.6-1,1.1-2,1.7-2.9c0.3-0.5,0.6-0.9,0.8-0.9c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.5l5.3,12.4l2.6,6.2 c0.1,0.2,0.2,0.5,0.2,0.8l0.1,0.3v0.1l0.1,0.2c0,0.2,0,0.3,0,0.5c0,0,0,0.2,0,0.4s-0.1,0.5-0.2,0.8c-0.3,0.5-1,0.9-0.9,0.9 c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.4,0.2-0.6,0.2C53.4,42.9,53,43,53,43l-1,0.2c-0.6,0.2-1.2,0.4-1.9,0.5 c-1.3,0.3-2.5,0.4-3.8,0.5c-2.6,0.1-5.2-0.3-7.6-1.2c-0.3-0.1-0.6-0.3-1-0.4v-0.1c0,0,0,0,0-0.1c-0.4-0.3-0.6-0.8-0.8-1.3 c-0.5-1.9,0.7-4,1.5-6c0.9-2,1.8-4.1,2.8-6.1C42.3,26.9,43.3,25,44.4,23L44.4,23z M27,32.9l2-3.5l4.1-7.1l1-1.8 c0.3-0.6,0.7-1.2,1-1.7c0.4-0.5,0.8-0.8,1.3-1s1,0,1.3,0.3c0.3,0.4,0.6,1,0.8,1.6l0.7,1.9l0.5,1.5c0,0,1.2,2.9,1.2,2.7 c0.1,0.2,0.2,0.3,0.2,0.4c-0.3,0.6-0.6,1.2-0.9,1.8c-1,2.1-2,4.1-2.9,6.2c-0.5,1.1-0.9,2.1-1.3,3.2c-0.2,0.6-0.4,1.2-0.5,1.9 c-0.5,0-1-0.1-1.5-0.1c-1.8-0.2-3.6-0.6-5.4-1.2c-0.3-0.1-0.5-0.2-0.8-0.3c0,0-0.5-0.2-1.2-0.4c0-0.1,0-0.1,0-0.2 c-0.1-0.2-0.2-0.3-0.3-0.4l0,0c-0.3,0-0.7-0.4-0.8-0.8C25.5,35.3,26.3,34.1,27,32.9L27,32.9z M44.2,156.9 c-0.2,0.5-0.4,0.9-0.4,0.9c-0.1,0.3-0.3,0.6-0.5,1c-0.3,0.6-0.7,1.3-1.1,1.8c-0.4,0.5-0.8,0.7-1.2,0.4s-0.8-0.9-1.2-1.6l-4.7-7.6 l-0.8-1.4c2.1,0,4.4-0.1,6.8-0.2c0.4,0,0.8,0,1.1-0.1c0,0.1,0,0.1,0,0.2v0.1l0.8,1.7l1.5,3.2C44.6,155.8,44.4,156.4,44.2,156.9 L44.2,156.9z M57.7,150.4c-0.3,0.5-0.4,0.9-0.4,0.9l-0.2,0.5l-0.2,0.7c-0.4,1.4-0.8,2.7-1.3,4.1c-0.5,1.3-1,2.7-1.5,4 c-0.6,1.3-1.1,2.8-1.9,3.6c-0.4,0.4-0.9,0.5-1.4,0.3s-0.9-0.7-1.2-1.3c-0.6-1.2-1.2-2.6-1.8-3.9l-3.7-7.8l-0.7-1.5 c4.7-0.2,9.8-0.5,15.1-0.8C58.2,149.6,57.9,150.1,57.7,150.4L57.7,150.4z M74.7,147.1c-0.2,0-0.4,0.1-0.6,0.1 c-2.2,0.3-4.6,0.4-6.9,0.5c-9.2,0.5-18.4,1-26.1,1.4c-3.8,0.2-7.2,0.4-10.1,0.2c-2.8-0.2-5-0.7-6.5-1.2l0,0c-1-0.4-1.6-0.6-2-0.8 s-0.5-0.3-0.7-0.4l0,0c-0.4-0.2-0.7-0.4-1.1-0.6v-0.1c0-0.2,0-0.4,0-0.7c0-1.8,0-3.3,0-4.7c0-2.8,0-4.8,0-6.3c0-3,0-3.8,0-3.8 s-0.1-23.2-0.3-48.8c-0.1-12.8-0.2-26.1-0.2-37.4c0-2.7,0-5.3,0-7.7c0.3,0,0.6,0,0.8,0c1.5-0.1,2.5-0.3,3.6-0.6 c0,0.2,0,0.3,0.1,0.5s0.2,0.5,0.3,0.7c-0.1,0.1-0.1,0.2-0.2,0.3l0,0l0,0l0,0l0,0l0.1,0.1l0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2 c0.2,0.1,0.3,0.2,0.4,0.2c0.1,0,0.1-0.1,0-0.2c0.8,0.5,1.7,0.9,1.7,0.9c0.3,0.1,0.7,0.2,1,0.4c1.8,0.6,3.7,1,5.6,1.3 c0.5,0.1,1.1,0.1,1.6,0.1c0,0.2,0.1,0.4,0.1,0.7c0.1,0.4,0.3,0.8,0.6,1.2c-0.1,0.2,0,0.4,0.1,0.6c0,0,0,0,0.1,0.1 c0.6,0.3,1.2,0.5,1.8,0.7c2.5,0.9,5.2,1.3,7.9,1.3c1.3,0,2.7-0.2,4-0.5c0.7-0.1,1.3-0.3,1.9-0.5c0.4-0.1,0.5-0.2,0.7-0.2l0.5-0.2 c0,0,0.2-0.1,0.5-0.2c0.3-0.1,0.6-0.3,1-0.5c0.7-0.4,1.3-0.8,1.3-0.8c0.8-0.6,1.3-1.1,0.6-0.9c0,0,0.1-0.1,0.1-0.2 c0.2-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.1-0.3,0.1-0.3c0-0.2,0-0.4,0-0.6c0-0.1,0-0.2,0-0.3v-0.2v-0.1L57.2,39l-0.1-0.2 c-0.2-0.9-0.6-1.6-0.9-2.4c0.4-0.1,0.9-0.2,1.3-0.2c5.5-0.7,11.3,0.5,15.9,3.5c0.6,0.3,1.1,0.7,1.6,1.1c1.7,1.3,3.2,2.8,4.4,4.5 c0.8,1.1,1.6,2.3,2.2,3.5l0.5,1l0.2,0.5c0,0,0.3,0.7,0.6,1.4c0.3,0.7,0.5,1.4,0.5,1.3c0.1,0.2,0.2,0.4,0.2,0.5s0,0.2,0,0.2 c0,0.1,0.1,0.3,0.1,0.5c0,0.1,0,0.2,0.1,0.4l0.1,0.3l0.1,0.4c0,0.3,0.1,0.6,0.1,0.9c0.1,0.6,0.1,1.2,0.2,1.9 c0.5,5.2,0.7,11.3,0.9,17.1c0.4,11.7,0.6,22.3,0.6,22.3s0.2,10.6,0.5,22.3c0.1,2.9,0.1,5.9,0.2,8.8c0,1.5,0.1,2.9,0.1,4.3 c0,0.7,0,1.4,0,2c0,0.3,0,0.7-0.1,1v0.3c-0.3,0.9-0.6,1.7-1.1,2.8c-0.1,0.3-0.4,1-0.8,1.6c-0.1,0.2-0.2,0.4-0.3,0.5v0.1v0.1 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.3,0.4-0.6,0.8-1,1.2c-0.7,0.8-1.5,1.4-2.4,2C78.6,146.2,76.7,146.7,74.7,147.1L74.7,147.1z M108.1,142.1c0,0.6-0.1,1.2-0.4,2c-0.1,0.4-0.4,1.1-1.3,2c-0.6,0.6-1.7,1.2-2.8,1.6c-1.2,0.4-2.4,0.5-3.6,0.6 c-2.4,0.2-4.3,0.3-4.3,0.3s-1.7,0.1-3.8,0.3c-0.3,0-0.7,0.1-1.1,0.1c-1.2,0.1-2.4,0.2-3.6,0.2c-0.2,0-0.4,0-0.6,0 c-1.4,0.1-2.7,0.2-3.5,0.2c-1,0-1.4-0.2-1.6-0.3c-0.7-0.3-1.1-0.6-1.4-1.1c-0.2-0.3-0.4-0.7-0.4-1.1c0.5-0.2,0.9-0.5,1.3-0.7 c1-0.6,1.9-1.4,2.7-2.2c0.4-0.4,0.8-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.2-0.4v-0.1l0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3 c0.7,0.1,1.3,0.2,2,0.2c0.5,0,1.1,0,1.8,0c0.3,0,0.8-0.1,1.8-0.1c0.3,0,0.7-0.1,1.1-0.1c3.6-0.3,9.7-0.8,9.7-0.8s1.6-0.1,3.6-0.3 c0.8-0.1,1.7-0.1,2.6-0.2C108.1,141,108.1,141.5,108.1,142.1L108.1,142.1z M101.5,139.8c0,0-6.1,0.5-9.6,0.7 c-0.4,0-0.8,0.1-1.2,0.1c-1,0.1-1.5,0.1-1.8,0.1c-0.6,0.1-1.2,0.1-1.7,0.2c-0.6,0.1-1.2,0.2-1.8,0.4c0.4-0.7,0.6-1.4,0.8-1.7 c0.4-1.1,0.5-1.9,0.5-2.8v-0.2l0.1-0.5c0-0.3,0.1-0.7,0.1-1c0-0.7,0-1.4,0-2.1c-0.1-1.4-0.1-2.8-0.1-4.3 c-0.1-2.9-0.1-5.9-0.2-8.8c-0.2-11.7-0.5-22.4-0.5-22.4S86,87,85.5,75.3c-0.2-5.8-0.4-12-0.9-17.2c-0.1-0.7-0.1-1.3-0.2-1.9 c0-0.3-0.1-0.6-0.1-0.9l-0.1-0.5l-0.1-0.3c0-0.1-0.1-0.3-0.1-0.4c0-0.2-0.1-0.4-0.1-0.6c-0.1-0.4-0.2-0.8-0.3-1.1 c-0.1-0.5-0.2-1.1-0.3-1.6c-0.1-0.6-0.3-1-0.3-1l-0.2-0.5l-0.1-0.2l-0.2-0.4c-0.6-1.3-1.4-2.6-2.3-3.8c-0.9-1.3-2-2.5-3.1-3.5H78 c2.9-0.1,5.8-0.2,8.7-0.5c0.1,0,0.2,0,0.4,0c1.3-0.1,2.7-0.2,4-0.3l0.7-0.1l2.7-0.3c0,0,0.8-0.2,1.6-0.3l0,0 c0.5,0.2,1,0.4,1.7,0.6c0.1,0,0.3,0.1,0.6,0.1c0.1,0,0.2,0.1,0.4,0.1c0.7,0.2,1.4,0.4,2.1,0.6c0.8,0.2,1.6,0.5,2.4,0.7 c3.2,1,6.8,2.1,10.3,3.4c0.9,0.4,1.7,0.8,2.4,1.4c0.7,0.6,1.2,1.4,1.7,2.2c0.9,1.6,1.5,3.5,1.9,5.3c0.4,1.9,0.5,3.7,0.5,5.6 c0,1.8-0.1,3.6-0.1,5.4c0,3.5,0.2,6.7,0.4,9.4c0.2,2.7,0.3,4.9,0.3,6.4c0,1.6,0.1,2.4,0.1,2.4s0.1,3.5,0.3,8.9s0.6,12.7,0.4,20.4 c-0.1,3.8-0.4,7.7-0.8,11.5c-0.2,1.9-0.5,3.7-1,5.5c-0.2,0.9-0.4,1.7-0.7,2.6c-0.1,0.4-0.3,0.8-0.4,1.2c-0.1,0.2-0.2,0.4-0.2,0.6 l-0.2,0.5c-0.3,0.6-0.6,1-0.7,1.2c-0.2,0.4-0.4,0.6-0.6,0.9c-0.3,0.3-0.6,0.6-1,0.8c-0.5,0.3-1.1,0.5-1.9,0.9 c-0.4,0.1-1.1,0.4-2.4,0.6C107.8,139.3,101.5,139.8,101.5,139.8L101.5,139.8z M142.3,153.7c-0.3,0.5-0.5,0.8-0.5,0.8 c-0.2,0.3-0.3,0.5-0.6,0.9c-0.4,0.5-0.9,1-1.3,1.4c-0.5,0.4-1,0.5-1.4,0.3s-0.8-0.7-1.2-1.3c-1.5-2.3-2.8-4.7-3.8-7.2 c-0.2-0.4-0.3-0.8-0.5-1.2c2.7-0.2,5.5-0.4,8.2-0.6l0.1,0.6c0.4,1.6,0.8,3.2,1.3,4.7v0.1c0,0.1,0.1,0.3,0.1,0.4 C142.7,152.9,142.5,153.4,142.3,153.7L142.3,153.7z M159.8,144.8c-0.7,1-1.6,2.5-1.6,2.5l-2.8,5.7l-2.2,4.5l-1.1,2.2 c-0.4,0.8-0.7,1.5-1.2,2c-0.5,0.6-1.1,0.8-1.7,0.7c-0.6-0.1-1.1-0.7-1.6-1.3c-0.4-0.6-0.7-1.4-1.1-2.2c-0.3-0.8-0.7-1.5-1-2.3 c-1.2-3.1-2.2-6.3-2.9-9.5l-0.1-0.5c1.1-0.1,2.2-0.2,3.3-0.3c4.8-0.5,9.6-1.1,14.3-1.9C159.9,144.5,159.9,144.6,159.8,144.8 L159.8,144.8z M183.1,114c-0.2,3.3-0.4,6.7-0.7,10l-0.2,1.8v0.3v0.1c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.6-0.3,1.1-0.4,1.7 c-0.3,1.2-0.7,2.4-1.1,3.6c-0.4,1.2-0.9,2.5-1.6,3.8c-0.7,1.2-1.5,2.3-2.8,3.2c-2.4,1.7-5.6,2.3-8.9,2.9 c-6.6,1.3-13.7,2.4-20.8,3.1c-7.1,0.8-14.3,1.2-21.1,1.5c-1.3,0-2.6,0.1-3.9,0.1c-0.4,0-0.7,0-1.1,0c-1.6,0-3.2,0-4.6-0.4 c-0.7-0.2-1.4-0.5-1.9-0.8c-0.6-0.4-1.1-0.9-1.4-1.4c-0.4-0.6-0.7-1.1-0.9-1.8l-0.1-0.5v-0.1v-0.1c-0.1-0.4-0.1-0.8-0.1-1.1 c0-0.2,0.1-0.4,0.1-0.4h0.1c1.4-0.2,2.3-0.5,2.7-0.7c0.8-0.4,1.5-0.7,2-1.3c0.2-0.3,0.4-0.6,0.6-0.9c0.3-0.3,0.6-0.6,0.9-1 c0.1-0.2,0.4-0.7,0.7-1.2l0.2-0.5c0.1-0.2,0.2-0.4,0.3-0.6c0.2-0.4,0.3-0.8,0.5-1.2c0.3-0.9,0.5-1.7,0.8-2.6 c0.4-1.8,0.7-3.7,1-5.6c0.1-0.8,0.2-1.6,0.3-2.4c0.3-3,0.5-6.1,0.6-9.2c0.2-7.7-0.2-15-0.4-20.4c-0.1-2.4-0.2-4.4-0.2-5.9 c-0.1-1.9-0.1-3-0.1-3s0-0.9-0.1-2.4c0-1.6-0.1-3.8-0.3-6.5c-0.1-2.7-0.4-5.9-0.4-9.3c0-1.7,0.1-3.5,0.1-5.4s-0.1-3.8-0.5-5.7 s-1-3.8-2-5.5c-0.5-0.8-1.1-1.7-1.8-2.4c-0.8-0.7-1.6-1.2-2.5-1.5c-3.6-1.4-7.1-2.5-10.4-3.5c-0.8-0.2-1.6-0.5-2.4-0.7 c-0.7-0.2-1.4-0.4-2.1-0.6c-0.1,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.4-0.1-0.6-0.1c-0.8-0.2-1.3-0.2-1.9-0.2L96.1,39l0,0 c-0.1,0-0.1,0-0.2,0c-0.6,0-1,0-1.2,0h-0.1c0-0.1,0-0.1,0.1-0.2s0,0,0-0.1c-0.2-0.5-0.3-1-0.3-1.5c0.1-1.1,0.6-2.2,1.3-3 c0.2-0.3,0.5-0.5,0.8-0.7c0.6-0.5,1.3-0.8,2.1-1.1c2.2-0.8,4.8-1,7.2-1.3c2.5-0.3,5-0.4,7.4-0.5l4.7-0.2c0,0.2-0.1,0.5-0.1,0.7 c0,0.4,0.1,0.8,0.4,1.2c0.3,0.4,0.7,0.5,1,0.6c0.7,0.2,1.3,0.2,1.9,0.3c1.2,0.1,2.4,0.2,3.7,0.2c2.5,0.1,4.9,0,7.4-0.1 c0.6,0,1.2-0.1,1.9-0.2h0.1c0.5-0.5,0.1-0.9-0.1-1H134c-0.6,0.1-1.2,0.1-1.8,0.2c-2.4,0.2-4.8,0.2-7.1,0.1 c-1.2,0-2.4-0.1-3.6-0.2c-0.6-0.1-1.2-0.1-1.7-0.2c-0.5-0.1-0.8-0.3-0.8-0.7c-0.1-0.4,0.1-1,0.2-1.5c0.1-0.6,0.3-1.1,0.4-1.7 c0.3-1.1,0.7-2.3,1-3.4c0.8-2.2,1.7-4.4,2.8-6.5c0.6-1,1.1-2.1,1.8-3.1c0.3-0.5,0.6-1,1-1.5s0.7-0.9,1-1.3 c0.8-0.7,1.7-0.6,2.4,0.1c0.8,0.7,1.2,1.8,1.7,2.9c0.9,2.2,1.8,4.4,2.4,6.7l0.4,1.5l0.1,0.5c0,0,0.2,0.7,0.4,1.5 c0.2,0.7,0.4,1.5,0.4,1.4c0.1,0.4,0.3,0.8,0.4,1c-0.4,1.4-0.7,2.9-0.9,4.3c-0.1,0.4-0.1,0.7-0.2,1.1c-0.2,0-0.4,0.1-0.5,0.3v0.1 c-0.1,1,0.7,1.7,1.4,1.9c0.9,0.3,1.5,0.3,2.3,0.5c0.7,0.1,1.5,0.2,2.2,0.3c1.5,0.2,3,0.2,4.5,0.2s3-0.1,4.5-0.2 c0.7-0.1,1.5-0.2,2.2-0.3L152,36l0.5-0.1c0,0,0.8-0.2,1.5-0.4c0.8-0.2,1.5-0.7,1.4-0.7c0.2-0.2,0.4-0.4,0.5-0.6l0.1-0.1V34 c0.1-0.2,0-0.4,0-0.5h-0.1c-0.1-0.3-0.1-0.6-0.2-0.9c-0.1-0.6-0.2-1-0.2-1l-0.4-1.3l0,0l1.2,0.3c3,0.8,5.9,1.7,8.7,3.1 c2.8,1.3,5.3,3.1,7.2,5.4c1.9,2.3,3.2,5.1,4.1,8.1c0.4,1.5,0.8,3,1.1,4.5l0.3,1.7c0,0,0.1,0.6,0.3,1.3c2.7,13,4.5,26.1,5,39.4 C183.4,100.7,183.4,107.4,183.1,114L183.1,114z",
    fill: "#202020"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M110.2,47.3c-0.2,0-0.7,0-1.4,0c-1.6,0-3.8,0-5.6,0c-1.8,0-3.2,0.1-3.2,0.1s-2.4,0.1-5,0.2 c-1.1,0.1-2.2,0.2-3.2,0.2c-0.2,0-0.4,0-0.7,0c-0.8,0.1-1.4,0.1-1.8,0.2c-1,0.1-1.5,0.2-2.3,0.5c0.8,0.1,1.4,0.2,2.3,0.1 c0.3,0,1-0.1,1.8-0.1c0.2,0,0.4,0,0.6,0c1-0.1,2.1-0.2,3.2-0.2c2.6-0.2,5-0.2,5-0.2s1.4,0,3.2-0.1c1.8,0,4,0,5.6,0 c0.7,0,1.2,0,1.4,0c1,0,1.5-0.1,2.3-0.3C111.8,47.4,111.2,47.3,110.2,47.3L110.2,47.3z",
    fill: "#202020"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M73.2,47.8c-1.9-0.7-4.3-0.9-6.6-0.8c-4.5,0.2-8.6,0.3-8.6,0.3S43.4,47.9,40.5,48c-1,0-1.5,0.2-2.3,0.4 c0.8,0.2,1.4,0.2,2.3,0.2c2.9-0.1,17.5-0.7,17.5-0.7s4.1-0.2,8.6-0.3c2.2,0,4.6,0.1,6.4,0.8c0.6,0.2,1,0.4,1.2,0.6 c0.2,0.1,0.3,0.2,0.5,0.3c0.5,0.3,0.9,0.5,1.5,0.8c-0.4-0.7-0.8-1.1-1.5-1.5c-0.1,0-0.1-0.1-0.2-0.1C74.3,48.2,73.8,48,73.2,47.8 L73.2,47.8z",
    fill: "#202020"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M157,38.1c2.3,0,4.8,0.2,6.9,0.3c0.6,0,1.1,0.1,1.4,0.1c0.9,0.1,1.5,0,2.3-0.1c-0.8-0.3-1.3-0.4-2.3-0.5 c-0.3,0-0.8-0.1-1.4-0.1c-2-0.2-4.6-0.3-6.9-0.3c-4.7-0.1-9,0.1-9,0.1s-4.3,0.2-9,0.8c-2.4,0.3-4.8,0.6-6.9,1 c-1.1,0.2-1.9,0.3-2.4,0.4c-0.9,0.2-1.5,0.4-2.2,0.8c0.8,0,1.4,0,2.3-0.1c0.4-0.1,1.3-0.2,2.4-0.4c2.1-0.3,4.5-0.7,6.8-1 c4.7-0.6,9-0.8,9-0.8S152.3,38,157,38.1L157,38.1z",
    fill: "#202020"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M119.4,143.3c-0.5,0.2-1,0.3-2.2,0.7c0.8,0.2,1.4,0.2,2.4-0.1c0.2-0.1,0.7-0.2,1.4-0.5 c0.2-0.1,0.3-0.2,0.5-0.2c1.1-0.6,2.4-1.7,3.2-2.7c1-1.2,1.5-2.3,1.5-2.3s0.7-1.3,1.2-2.9c0.5-1.6,0.9-3.6,1.1-4.8 c0.1-0.6,0.1-0.8,0.1-1c0.1-0.9,0.1-1.5,0-2.3c-0.3,0.8-0.5,1.3-0.6,2.2c0,0.2-0.1,0.4-0.1,1c-0.2,1.2-0.5,3.1-1.1,4.7 c-0.5,1.6-1.2,2.8-1.2,2.8s-0.5,1-1.5,2.2c-0.7,0.9-1.8,1.8-2.7,2.4c-0.3,0.2-0.5,0.3-0.8,0.4 C120.1,143.1,119.6,143.2,119.4,143.3L119.4,143.3z",
    fill: "#202020"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M30.7,107.3c-0.2,0.8-0.3,1.3-0.3,2.3c0,0.4,0,1.2,0,2.2c0,1.7,0,3.7-0.1,5.7c-0.1,3.9-0.3,7.4-0.3,7.4 s-0.1,0.9-0.2,2.2c-0.1,1.3-0.2,3.2-0.5,5.1c-0.2,1.9-0.7,3.9-1.4,5.4c-0.2,0.6-0.5,1-0.7,1.2c-0.4,0.6-0.7,1-1.2,1.9 c0.7-0.4,1.2-0.8,1.8-1.6c0.2-0.2,0.4-0.7,0.7-1.3c0.7-1.6,1.2-3.6,1.4-5.5s0.4-3.8,0.5-5.1c0.1-1.4,0.2-2.2,0.2-2.2 s0.2-3.5,0.3-7.4c0-1.9,0.1-4,0.1-5.7c0-1,0-1.8,0-2.2C31,108.7,30.9,108.2,30.7,107.3L30.7,107.3z",
    fill: "#202020"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M116.2,38.5c-1.1-0.5-2.7-1.2-4-1.6c-1.3-0.5-2.3-0.8-2.3-0.8s-1.2-0.4-2.7-0.9s-3.3-0.9-4.4-1.2 c-0.5-0.1-0.8-0.2-1-0.2c-0.9-0.2-1.5-0.2-2.3-0.2c0.8,0.3,1.3,0.6,2.2,0.8c0.2,0,0.4,0.1,0.9,0.2c1.1,0.2,2.8,0.7,4.3,1.2 s2.7,0.9,2.7,0.9s1,0.3,2.3,0.8s2.8,1.1,3.9,1.6c0.7,0.3,1.1,0.5,1.3,0.6c0.9,0.4,1.4,0.5,2.2,0.7c-0.6-0.5-1.1-0.9-1.9-1.3 C117.2,39,116.8,38.8,116.2,38.5L116.2,38.5z",
    fill: "#202020"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M129.3,83c0,0-0.2-7.5-0.8-15.7c-0.3-4.1-0.6-8.4-0.9-12c-0.1-1.6-0.3-2.8-0.3-3.5c-0.1-1-0.2-1.5-0.5-2.3 c-0.1,0.8-0.2,1.4-0.1,2.3c0.1,0.6,0.2,1.9,0.3,3.5c0.3,3.6,0.6,7.9,0.9,12c0.6,8.2,0.8,15.7,0.8,15.7s0.3,7.5,0.3,15.7 c0,4.1,0,8.5-0.1,12c0,0.6,0,1.2,0,1.4c0,1,0.1,1.5,0.3,2.3c0.2-0.8,0.3-1.3,0.4-2.3c0-0.3,0-0.8,0-1.4c0.1-3.6,0.1-7.9,0.1-12 C129.6,90.5,129.3,83,129.3,83L129.3,83z",
    fill: "#202020"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: 16,
    className: "svggskin"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087407311654678336480000007510830638885346447_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.9525,
    y1: 1894.3101,
    x2: 96.9525,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.1,338c-0.1,0.1-0.2,0.1-0.2,0.2 c-3.3,2.5-7.2,3.9-11.1,4.6c-2,0.3-4,0.5-6,0.5c-0.7,0-1.5-0.1-2.2-0.2c-0.5,0.5-1,1.1-1.3,1.8c-0.5,0.9-0.8,1.9-1,2.9 c-0.1,1-0.1,2.1,0.2,3.1c0.2,1,0.7,1.9,1.4,2.5c0.7,0.6,1.7,1.1,2.7,1.4c4.2,1.2,8.8,1.2,13-0.1c2.1-0.6,4.1-1.6,5.9-2.8 c1.7-1.3,3.2-2.9,3.8-4.9s0.5-4.2-0.6-5.9l-0.2-0.3l-0.1-0.1l-0.2-0.3c-0.1-0.2-0.3-0.3-0.4-0.5c0,0-0.3-0.4-0.9-0.8 c-0.5-0.4-1.3-0.8-2.1-0.9C105.4,338.1,105.2,338.1,105.1,338L105.1,338z",
    style: {},
    fill: "url(\"#SVGID_00000087407311654678336480000007510830638885346447_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065045045117002439480000015978418552625924771_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.65,
    y1: 1894.3201,
    x2: 210.65,
    y2: 2007.9401,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218,268.8l0.2-1.3c0,0,0.3-1,0.3-2.1 c0-0.1,0-0.1,0-0.2l-2.2,0.5c-8,1.8-16,4-23.8,6.6c-1.9,0.7-3.8,1.4-5.6,2.4c-1.7,1-3.3,2.2-4.7,3.7c-2.8,2.9-4.7,6.6-6.4,10.3 c-3.4,7.5-6.4,15.2-9.2,23c-1.4,3.9-2.8,7.8-4.1,11.7l-0.7,1.9c0,0-0.9,2.1-1.6,3.5c-0.1,0.1-0.1,0.3-0.2,0.4 c0.4,0.1,0.7,0.3,1,0.5c2.5,1.2,1.3,1.1-0.3,0.8c0.1,0-0.6-0.1-1.3-0.3c-0.1,0.1-0.1,0.1-0.2,0c-0.1,0-0.2,0-0.4-0.1 c-1-0.2-2-0.3-2-0.3c-0.2,0-0.5-0.1-0.7-0.1c-0.3,0-0.3-0.1-1.1-0.2c-1.3-0.2-2.6-0.2-3.9-0.2c-2.6,0-5.1,0.4-7.7,0.9 c-5.1,1-10.3,2.6-15.8,2.1c-0.9-0.1-1.7-0.2-2.5-0.5c0,0-0.1,0-0.1-0.1l-0.1-0.1c-0.7,0.8-1.5,1.5-2.4,2.2 c-1.4,1-3.1,1.8-4.9,1.9c-0.4,0-0.7,0-1.1,0c0.1,0.3,0.1,0.6,0.1,0.9c0-0.2,0.3,4,0.3,4v12.8v0.2l0.2-0.1 c0.1-0.1,0.2-0.2,0.3-0.3c0.8-0.8,1.4-1.7,1.9-2.7c0.9-2.1,0.9-4.5,0.6-6.8c-0.1-0.6-0.2-1.3-0.4-1.9l0.9-0.9l0.5,0.1 c0,0,0.1,0,0.1,0.1c0.2,0.2,0.4,0.7,0.1,1c0.1,0.4,0.2,0.9,0.3,1.3c0.4,2.5,0.4,5.2-0.7,7.7c-0.2,0.6-0.5,1.1-0.9,1.6 c0.7,0.2,1.4,0.5,2.1,0.6c11,3.1,22.6,3.2,34.1,2.4c2.9-0.2,5.8-0.4,8.5-0.8c2.8-0.4,5.3-1.6,7.6-3.2s4.2-3.7,5.7-6.1l0.6-0.9 c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0.3-0.5,0.7-1.1s0.8-1.5,1.2-2.2c0,0,0-0.1,0.1-0.1c0.6-10.3,2.1-20.6,4.6-30.6l1.2-4.9l1.4-4.8 c0.5-1.6,1-3.2,1.5-4.8l0.6-1.8l0.4-1.1c0,0,0.2-0.5,0.6-1.2c0.3-0.7,0.8-1.6,1.2-2.3c1.2-2.4,1.2-1.3,0.8,0.3 c0.1-0.1-0.2,0.9-0.5,1.9s-0.6,2-0.6,2l-0.4,1.1l-0.7,1.9c-0.3,0.8-0.5,1.5-0.8,2.3c-0.5,1.5-1,3.1-1.4,4.7l-0.7,2.3l-0.6,2.4 c-0.4,1.6-0.8,3.1-1.1,4.7c-2.9,12.7-4.3,25.6-4.3,38.6l0.1,4.9l0.2,4.3h8.9l19.6-0.1l39.1-0.2h9.4l0.8-4l1-4.8 c0.7-3.2,1.5-6.4,2.4-9.5c0.4-1.6,0.9-3.2,1.4-4.7l0.4-1.2l0.4-1.1v-0.1c0.2-0.7,0.5-1.5,0.8-2.2c0,0,0,0,0.1-0.1 c0,0,0.1,0,0.1-0.1l-1.4-4.6c0,0,0,0,0-0.1c0.1-0.4,0.5-1,1.3-0.4l0.1,0.1l1.5,5.2c2,7.1,4.1,14.2,7.3,20.7 c0.8,1.6,1.7,3.2,2.6,4.8c0.5,0.8,1,1.5,1.5,2.3l0.4,0.6v0.1l0,0h1.2c3.7,0,7.4,0,11,0l9.2-0.1h3.5l-0.5-0.9l-1-2.1 c-2.7-5.6-4.9-11.4-6.8-17.2c-4-11.7-6.8-23.7-10.1-35.5c-1.7-5.9-3.5-11.8-5.8-17.4c-1.2-2.8-2.6-5.5-4.5-7.8s-4.2-4.2-6.9-5.6 c-0.3-0.2-0.7-0.4-1-0.5s-0.7-0.3-1-0.4L265,273l-4.4-1.5c-1.5-0.5-2.9-1-4.4-1.6l-0.3-0.1l-1-0.4c0,0-0.5-0.3-1.2-0.7 c-0.7-0.4-1.5-1-2.1-1.6l-0.1-0.1c-0.1,0-0.2,0.1-0.4,0.1H251c0,0-0.3-0.4-0.5-1c-0.3-0.6-0.5-1.4-0.7-2.3 c-0.1-0.9-0.1-1.7-0.1-2.4c0.1-0.6,0.2-1.1,0.2-1.1s0.1-0.3,0.3-0.6c0.2-0.3,0.4-0.8,0.7-1l0.1-0.1c-1.7,0.5-3.4,0.9-5.1,1.3 c-4.7,1.1-9.6,1.9-14.5,2.4c-3.8,0.4-7.6,0.8-11.5,0.9c0.1,0.1,0.1,0.4,0.2,0.7c0.1,0.5,0.2,1.1,0.2,1.8 c0.1,1.3-0.3,2.6-0.3,2.6s-0.1,0.2-0.2,0.4c-0.2,0.2-0.4,0.5-0.6,0.7C218,269.9,217.9,269.3,218,268.8L218,268.8z",
    style: {},
    fill: "url(\"#SVGID_00000065045045117002439480000015978418552625924771_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072976955722270694640000007739506755857067166_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.9041,
    y1: 1894.3101,
    x2: 91.9041,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,324.3c0.1,0,0.1,0.1,0.2,0.2 c0.6-0.2,1.1-0.5,1.7-0.7c1.9-0.7,3.8-1.2,5.7-1.7c1.9-0.5,3.9-0.9,5.9-1c2-0.2,4.1-0.1,6.1,0.2c1.1,0.2,2.3,0.5,3.4,0.9l0,0 c0.2-0.4,0.3-0.9,0.4-1.3s0.2-0.6,0.2-0.6c0.1-0.2,0.2-0.4,0.2-0.6l0.1-0.3v-0.1v-0.1c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6,0.1-0.9 c0.2-2.3-0.5-4.7-1.8-6.6c-1.3-2-3.2-3.5-5.4-4.4c-2.2-0.9-4.7-1.1-7.1-1c-2.4,0.2-4.8,0.8-7.1,1.8c-2.2,1-4.3,2.3-5.9,4.1 c-0.8,0.9-1.4,1.9-1.8,3s-0.6,2.2-0.5,3.4c0.2,2.3,1.3,4.6,3.3,5.5C81.2,324.2,81.9,324.4,82.7,324.3 C82.6,324.3,82.6,324.3,82.7,324.3z",
    style: {},
    fill: "url(\"#SVGID_00000072976955722270694640000007739506755857067166_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143616266820451442200000010261629976493827241_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.1418,
    y1: 1894.3101,
    x2: 93.1418,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.2,324.2c-1.6-0.9-3.4-1.3-5.2-1.5 c-1.8-0.2-3.7-0.2-5.6,0.1c-1.9,0.2-3.7,0.6-5.6,1.1c-1.8,0.5-3.7,1-5.4,1.7c-1.7,0.7-3.4,1.6-4.7,2.8c-1.3,1.2-2.3,2.8-2.6,4.6 c-0.3,1.7,0.2,3.5,1.2,4.9c1.1,1.4,2.5,2.5,4.2,3.1c3.4,1.3,7.4,1,11.1,0.4c3.7-0.7,7.3-2,10.3-4.3c0.6-0.5,1.2-1,1.8-1.6 c0,0,0,0,0.1,0c0.1-0.1,0.1-0.1,0.1-0.1c0.2-0.2,0.3-0.3,0.5-0.5l0.2-0.2l0.4-0.5c0.3-0.4,0.6-0.7,0.8-1.1 c1-1.5,1.7-3.3,1.4-4.9C109.1,326.5,107.8,325.1,106.2,324.2L106.2,324.2z",
    style: {},
    fill: "url(\"#SVGID_00000143616266820451442200000010261629976493827241_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065066274427333315050000016160703831854811010_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.4441,
    y1: 1894.3101,
    x2: 119.4441,
    y2: 2007.9301,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,334.2c2.9-0.5,5.4-2.8,7.1-5.4 c1.7-2.6,2.8-5.6,2.7-8.7c0-1.5-0.3-3-0.8-4.5s-1.1-3-1.9-4.2c-0.8-1.3-1.9-2.3-3.3-3s-2.8-1.1-4.4-1.4 c-0.8-0.1-1.6-0.2-2.3-0.3H115l-0.1,0.8l-0.4,4.8l-0.1,1.2v0.3v0.1l0,0l0,0l0,0c-0.6,0,1.1,0-0.9,0c0,0.1-0.1,0.3-0.1,0.4 c0.1-0.1-0.3,0.9-0.6,1.8c-0.3,1-0.5,2-0.5,2c-0.1,0.2-0.1,0.5-0.2,0.7l-0.1,0.3l-0.1,0.5c-0.1,0.4-0.2,0.8-0.3,1.1 c-0.7,3.1-0.9,6.3-0.1,9.2c0.4,1.4,1.2,2.7,2.4,3.4C115.2,334.2,116.7,334.4,118.1,334.2L118.1,334.2z",
    style: {},
    fill: "url(\"#SVGID_00000065066274427333315050000016160703831854811010_\")"
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M214.7,261.5c-0.2,0.5-0.6,1-1,1.5c0.8,0,1.5,0,2.2,0c0.9,0,1.7,0,2.6,0c-0.2,0.1-0.4,0.2-0.4,0.3l0,0 c0,0,0.1,0.2,0.1,0.4l-2.3,0.5c-8,1.8-15.8,4-23.6,6.5c-1.9,0.7-3.9,1.4-5.7,2.4c-1.9,1-3.6,2.3-5.1,3.8c-3,3-5,6.7-6.7,10.4 c-3.4,7.4-6.4,15-9.2,22.7c-1.4,3.8-2.8,7.7-4.1,11.5l-1.1,3.1c0,0-1.1,4-1,3.9c0,0.2-0.1,0.3-0.1,0.5c-0.2-0.1-0.5-0.2-0.7-0.2 c-0.8-0.2-1.3-0.4-1.3-0.4l-0.7-0.1l-0.9-0.1c-1.4-0.2-2.7-0.3-4.1-0.3c-2.8,0-5.5,0.4-8.1,0.9c-5.3,1-10.5,2.6-15.6,2.1 c-0.6-0.1-1.2-0.2-1.9-0.3c0.1-0.1,0.1-0.2,0.2-0.3c2-2.8,3.3-6.1,3.4-9.6c0-1.7-0.3-3.5-0.8-5.1s-1.1-3.2-2.1-4.7 c-0.9-1.5-2.2-2.8-3.8-3.6c-1.5-0.9-3.2-1.4-4.9-1.7c-0.8-0.1-1.7-0.3-2.5-0.3l-0.9-0.1H114h-0.1c-0.1,0-0.1,0-0.1,0v0.3 l-0.1,1.8l-0.4,4.9l-0.1,1l0,0v0.1v0.4c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4,0.7-0.9,1.6-1.2,2.3s-0.5,1.2-0.5,1.2l-0.2,0.7l-0.3,1.1 c-0.5,1.8-0.8,3.7-0.9,5.6c-0.4-0.5-0.9-1-1.4-1.4c-0.4-0.3-0.9-0.6-1.3-0.8c0.1-0.2,0.2-0.4,0.3-0.5c0.2-0.4,0.3-0.7,0.4-0.8 c0.1-0.2,0.2-0.4,0.2-0.4c0.1-0.2,0.2-0.5,0.3-0.7l0.1-0.4l0.1-0.2v-0.1l0.1-0.2c0-0.1,0-0.2,0.1-0.3c0.5-2.7-0.1-5.6-1.5-7.9 c-1.3-2.3-3.5-4.3-6-5.3c-2.5-1.1-5.2-1.5-7.8-1.4c-2.7,0.1-5.2,0.8-7.7,1.8c-2.4,1-4.8,2.4-6.6,4.4c-0.9,1-1.7,2.2-2.2,3.4 c-0.5,1.3-0.7,2.7-0.7,4.1c0.1,1.4,0.4,2.8,1.2,4c0.7,1.2,1.7,2.3,3.1,2.9c0.3,0.2,0.6,0.3,1,0.4c-0.6,0.4-1.2,0.7-1.7,1.2 c-1.6,1.4-2.9,3.1-3.4,5.2c-0.6,2.1-0.1,4.5,1.1,6.2c1.2,1.8,2.9,3.2,4.8,4c0.7,0.3,1.4,0.5,2.1,0.6c-0.3,0.4-0.7,0.9-0.9,1.4 c-0.6,1.1-1,2.2-1.1,3.4c-0.1,1.2-0.1,2.4,0.2,3.6c0.2,1.2,0.8,2.4,1.8,3.3c0.9,0.9,2.1,1.4,3.2,1.7c4.4,1.4,9.2,1.4,13.6,0.1 c2.2-0.6,4.3-1.5,6.3-2.9c1.9-1.3,3.7-3,4.6-5.3c0.9-2.2,1-4.8-0.1-7.1c-0.1-0.3-0.3-0.5-0.5-0.8l-0.3-0.4l-0.2-0.3 c-0.2-0.2-0.3-0.4-0.5-0.6c0,0-0.9-0.8-1.9-1.2c-0.7-0.3-1.5-0.4-1.8-0.4c0.2-0.2,0.5-0.4,0.7-0.6c0.1-0.1,0.2-0.1,0.2-0.1 c0.2-0.2,0.4-0.4,0.5-0.5l0.3-0.3l0.1-0.1l0.1-0.1l0.4-0.5c0.9-1.1,1.6-2.3,2.1-3.7c0.4,1.1,1.1,2.1,2,2.9 c1,0.8,2.2,1.3,3.5,1.5c0,0.2-0.1,0.5-0.1,0.9c-0.2,1.6-0.4,3.9-0.4,3.9v12.7v1.4c0,0.3,0,0.6,0,0.9v0.4c0,0.1,0,0.4,0.1,0.2 c0.5-0.3,1-0.5,1.5-0.8c0.2-0.2,0.5-0.4,0.7-0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.2,0.4-0.4,0.5-0.5l0.1,0.1c0,0,0.1,0,0.1,0.1 c0.8,0.2,1.6,0.5,2.4,0.7c11.1,3.1,22.7,3.2,34,2.5c2.8-0.2,5.6-0.4,8.5-0.8c1.4-0.2,2.9-0.5,4.3-1.1c1.4-0.5,2.7-1.2,3.9-2 c2.5-1.6,4.6-3.7,6.2-6.1l0.6-0.9l0.3-0.5l0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0,0,0.1-0.2,0.3-0.6c0.1-0.2,0.2-0.4,0.3-0.7 c-0.1,2-0.1,4.1-0.2,6.2c0,3.3,0.1,6.7,0.2,10l0.1,1.6v0.6v0.1h0.1h0.3h1.1h2.5h5l20-0.1l39.9-0.2l10.2-0.1h0.3h0.1v-0.1 l0.1-0.6l0.2-0.8l0.2-1.2l0.5-2.4l1-4.8c0.7-3.2,1.5-6.3,2.3-9.5c0.4-1.6,0.9-3.1,1.4-4.7l0.4-1.2l0.4-1.1v-0.1 c0.1-0.2,0.1-0.4,0.2-0.5c1.9,6.5,3.9,13.1,6.9,19.2c0.8,1.7,1.7,3.3,2.7,4.9c0.5,0.8,1,1.6,1.5,2.4l0.4,0.6l0.1,0.2 c0.1,0.1,0.1,0.2,0.2,0.2l0.1,0.1c0.1-0.1,0,0,0.1,0l0,0h0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0h0.2h0.4h0.7 c3.7,0,7.4,0,11.1,0l9-0.1l5.3-0.1h0.6h0.1h0.1v-0.1l-0.1-0.2l-0.5-1l-0.7-1.4l-1-2c-2.6-5.4-4.7-11-6.7-16.7 c-3.9-11.3-6.7-23-9.9-34.7c-1.6-5.8-3.4-11.6-5.5-17.2c-1-2.9-2.4-5.7-4.1-8.2s-4-4.8-6.5-6.5c-0.6-0.4-1.3-0.8-2-1.2 c-0.4-0.2-0.7-0.4-1.1-0.5c-0.4-0.2-0.7-0.3-1.1-0.4l-4.3-1.4c-1.4-0.5-2.8-1-4.2-1.5l-2.1-0.8l-0.6-0.2l-1-0.4 c0,0-1-0.3-1.9-0.7c-0.8-0.3-1.5-0.8-1.6-0.8c0-0.1,0.1-0.1,0.1-0.2l0,0c0,0-0.2-0.3-0.4-0.8c-0.2-0.5-0.5-1.2-0.6-1.9 c-0.1-0.7-0.1-1.4-0.1-2c0-0.5,0.1-0.9,0.1-0.9s0-0.4,0.1-0.9s0.2-0.8,0.1-0.8c0-0.2,0-0.3,0-0.5c0-0.1,0-0.1,0-0.2 c1-0.3,2.1-0.6,3.1-0.9c-0.3-0.4-0.5-0.9-0.7-1.3c-1.8,0.6-3.6,1.1-5.5,1.5c-1.3,0.3-2.6,0.6-3.9,0.9c-8.3,1.8-17,2.8-25.8,3.2 C217.2,261.5,215.9,261.6,214.7,261.5L214.7,261.5z M80.6,323.9c-2-0.9-3.2-3.2-3.3-5.5c-0.1-1.1,0.1-2.3,0.5-3.4s1.1-2.1,1.8-3 c1.6-1.8,3.7-3.1,5.9-4.1c2.2-1,4.6-1.6,7.1-1.8c2.4-0.2,4.9,0.1,7.1,1s4.1,2.4,5.4,4.4s2.1,4.3,1.8,6.6c0,0.3-0.1,0.6-0.1,0.9 c0,0.1,0,0.1,0,0.2v0.1v0.1l-0.1,0.3c-0.1,0.2-0.1,0.4-0.2,0.6c0,0-0.1,0.2-0.2,0.6c-0.2,0.5-0.3,0.9-0.4,1.3l0,0 c-1.1-0.5-2.2-0.8-3.4-0.9c-2-0.4-4.1-0.4-6.1-0.2s-4,0.5-5.9,1s-3.8,1-5.7,1.7c-0.6,0.2-1.1,0.5-1.7,0.7 c-0.1-0.1-0.1-0.1-0.2-0.2h-0.1C81.9,324.3,81.2,324.2,80.6,323.9z M107.7,339.1c0.6,0.4,0.9,0.8,0.9,0.8 c0.1,0.1,0.3,0.3,0.4,0.5l0.2,0.3l0.1,0.1l0.2,0.3c1.1,1.7,1.2,4,0.6,5.9c-0.6,2-2.1,3.6-3.8,4.9c-1.8,1.3-3.8,2.2-5.9,2.8 c-4.2,1.3-8.8,1.3-13,0.1c-1-0.3-2-0.7-2.7-1.4c-0.7-0.6-1.2-1.5-1.4-2.5c-0.2-1-0.3-2.1-0.2-3.1c0.1-1,0.5-2,1-2.9 c0.4-0.7,0.8-1.2,1.3-1.8c0.7,0.1,1.5,0.2,2.2,0.2c2,0,4-0.2,6-0.5c3.9-0.7,7.9-2.1,11.1-4.6c0.1-0.1,0.2-0.1,0.2-0.2 c0.2,0,0.3,0,0.5,0.1C106.3,338.3,107.1,338.7,107.7,339.1L107.7,339.1z M107.8,333c-0.2,0.4-0.5,0.8-0.8,1.1l-0.4,0.5l-0.2,0.2 c-0.2,0.2-0.3,0.3-0.5,0.5c0,0,0,0-0.1,0.1h-0.1c-0.6,0.6-1.2,1.1-1.8,1.6c-3,2.3-6.6,3.6-10.3,4.3c-3.7,0.6-7.6,0.9-11.1-0.4 c-1.7-0.6-3.2-1.7-4.2-3.1c-1.1-1.4-1.5-3.2-1.2-4.9c0.3-1.7,1.3-3.3,2.6-4.6c1.3-1.2,2.9-2.1,4.7-2.8c1.7-0.7,3.6-1.2,5.4-1.7 s3.7-0.9,5.6-1.1s3.8-0.3,5.6-0.1s3.7,0.7,5.2,1.5c1.5,0.9,2.8,2.2,3,3.9C109.5,329.7,108.8,331.5,107.8,333L107.8,333z M113.9,333.5c-1.2-0.7-2-2-2.4-3.4c-0.9-2.9-0.6-6.2,0.1-9.2c0.1-0.4,0.2-0.8,0.3-1.1l0.1-0.5l0.1-0.3c0.1-0.2,0.1-0.5,0.2-0.7 c0,0,0.2-1,0.5-2s0.6-1.9,0.6-1.8c0.1-0.1,0.1-0.3,0.1-0.4c2,0.1,0.3,0,0.9,0l0,0l0,0l0,0V314v-0.3l0.1-1.2l0.4-4.8l0.1-0.8h0.2 c0.8,0.1,1.6,0.2,2.3,0.3c1.5,0.3,3,0.7,4.4,1.4c1.3,0.7,2.4,1.7,3.3,3c0.9,1.3,1.4,2.7,1.9,4.2s0.8,3,0.8,4.5 c0.1,3.1-1,6.1-2.7,8.7c-1.7,2.5-4.2,4.8-7.1,5.4C116.7,334.5,115.1,334.3,113.9,333.5L113.9,333.5z M219.3,268.4 c0.2-0.2,0.2-0.4,0.2-0.4s0.4-1.3,0.3-2.6c0-0.7-0.1-1.3-0.2-1.8c-0.1-0.3-0.2-0.5-0.2-0.7c3.9-0.1,7.7-0.5,11.5-0.9 c5-0.6,9.8-1.4,14.5-2.4c1.7-0.4,3.4-0.8,5.1-1.3l-0.1,0.1c-0.3,0.3-0.5,0.7-0.7,1s-0.3,0.6-0.3,0.6s-0.1,0.4-0.2,1.1 c-0.1,0.6-0.1,1.5,0.1,2.4c0.1,0.9,0.4,1.7,0.7,2.3c0.3,0.6,0.5,1,0.5,1h0.1c0.2,0,0.3,0,0.4-0.1l0.1,0.1 c0.6,0.6,1.4,1.2,2.1,1.6s1.2,0.7,1.2,0.7l1,0.4l0.3,0.1c1.4,0.6,2.9,1.1,4.4,1.6l4.4,1.5l2.2,0.7c0.4,0.1,0.7,0.2,1,0.4 c0.3,0.1,0.6,0.3,1,0.5c2.6,1.4,5,3.3,6.9,5.6c1.9,2.3,3.4,5,4.5,7.8c2.2,5.7,4.1,11.5,5.8,17.4c3.4,11.8,6.1,23.9,10.1,35.5 c2,5.8,4.2,11.6,6.8,17.2l1,2.1l0.5,0.9h-3.5l-9.2,0.1c-3.7,0-7.4,0.1-11,0h-1.2l0,0v-0.1l-0.4-0.6c-0.5-0.8-1-1.5-1.5-2.3 c-1-1.5-1.8-3.2-2.6-4.8c-3.3-6.5-5.3-13.6-7.3-20.7l-1.5-5.2l-0.1-0.1c-0.8-0.6-1.2,0-1.3,0.4c0,0.1,0,0.1,0,0.1l1.4,4.6 c0,0-0.1,0-0.1,0.1c0,0,0,0-0.1,0.1c-0.3,0.7-0.5,1.5-0.8,2.2v0.1l-0.4,1.1l-0.4,1.2c-0.5,1.6-0.9,3.1-1.4,4.7 c-0.9,3.2-1.6,6.4-2.4,9.5l-1,4.8l-0.8,4h-9.4l-39.1,0.2l-19.6,0.1h-8.9l-0.2-4.3l-0.1-4.9c0-13,1.4-26,4.3-38.6 c0.4-1.6,0.7-3.2,1.1-4.7l0.6-2.4l0.7-2.3c0.4-1.6,0.9-3.1,1.4-4.7c0.2-0.8,0.5-1.5,0.8-2.3l0.7-1.9l0.4-1.1c0,0,0.3-1,0.6-2 s0.6-1.9,0.5-1.9c0.4-1.6,0.5-2.8-0.8-0.3c-0.4,0.7-0.8,1.6-1.2,2.3c-0.3,0.7-0.6,1.2-0.6,1.2l-0.4,1.1l-0.6,1.8 c-0.6,1.6-1,3.2-1.5,4.8l-1.4,4.8l-1.2,4.9c-2.4,10-3.9,20.3-4.6,30.6c0,0,0,0.1-0.1,0.1c-0.4,0.7-0.8,1.5-1.2,2.2 c-0.4,0.6-0.7,1.1-0.7,1.1c-0.1,0.2-0.2,0.4-0.3,0.6l-0.6,0.9c-1.5,2.4-3.4,4.5-5.7,6.1s-4.8,2.8-7.6,3.2 c-2.8,0.5-5.7,0.6-8.5,0.8c-11.4,0.8-23.1,0.7-34.1-2.4c-0.7-0.2-1.4-0.4-2.1-0.6c0.3-0.5,0.6-1,0.9-1.6 c1.1-2.5,1.1-5.2,0.7-7.7c-0.1-0.5-0.2-0.9-0.3-1.3c0.3-0.4,0.1-0.8-0.1-1c0,0-0.1,0-0.1-0.1l-0.5-0.1l-0.9,0.9 c0.1,0.6,0.3,1.3,0.4,1.9c0.4,2.3,0.3,4.7-0.6,6.8c-0.4,1-1.1,2-1.9,2.7c-0.1,0.1-0.2,0.2-0.3,0.3l-0.2,0.1v-0.2v-12.8 c0,0-0.2-4.2-0.3-4c0-0.3-0.1-0.6-0.1-0.9c0.4,0,0.8,0,1.1,0c1.8-0.1,3.5-0.9,4.9-1.9c0.9-0.6,1.7-1.4,2.4-2.2l0.1,0.1 c0,0,0.1,0,0.1,0.1c0.8,0.2,1.7,0.3,2.5,0.5c5.5,0.5,10.7-1.1,15.8-2.1c2.6-0.5,5.1-0.9,7.7-0.9c1.3,0,2.6,0.1,3.9,0.2 c0.8,0.1,0.9,0.1,1.1,0.2c0.2,0,0.5,0.1,0.7,0.1c0,0,1,0.1,2,0.3c0.1,0,0.2,0,0.4,0.1c0,0.1,0.1,0.1,0.2,0 c0.8,0.2,1.4,0.3,1.3,0.3c1.6,0.4,2.8,0.4,0.3-0.8c-0.3-0.1-0.7-0.3-1-0.5c0.1-0.1,0.1-0.3,0.2-0.4c0.7-1.4,1.6-3.5,1.6-3.5 l0.7-1.9c1.4-3.9,2.7-7.8,4.1-11.7c2.8-7.8,5.8-15.5,9.2-23c1.7-3.7,3.6-7.4,6.4-10.3c1.4-1.5,2.9-2.7,4.7-3.7s3.6-1.7,5.6-2.4 c7.8-2.6,15.8-4.8,23.8-6.6l2.2-0.5c0,0.1,0,0.1,0,0.2c0.1,1.1-0.3,2.1-0.3,2.1l-0.2,1.3c-0.1,0.5,0,1.1,0.7,0.4 C218.9,269,219.1,268.7,219.3,268.4L219.3,268.4z",
    fill: "#202020"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069390833366998270090000007998955406882430090_",
    gradientUnits: "userSpaceOnUse",
    x1: -3072.1802,
    y1: 1753.8755,
    x2: -2920.5798,
    y2: 1753.8755,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1527.78 -2806.76)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(166, 248, 140)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(236, 255, 143)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296,203.4c-0.9-1.9-1.5-3.9-1.8-5.9 c-0.2-2.1-0.1-4.2,0.4-6.2c0.1-0.6,0.4-1.2,0.6-1.8c-0.1,0-0.3,0.1-0.5,0.1c0.1,0-1,0.1-2-0.1c-0.5-0.1-1.1-0.2-1.5-0.3 s-0.7-0.2-0.7-0.2l-0.7-0.3l-0.3-0.2l-0.3-0.1c-0.2-0.1-0.4-0.2-0.5-0.3c-1.4-0.8-2.7-1.8-3.8-3c-2.2-2.5-3.2-5.9-3-9.1 c0.2-3.2,1.4-6.5,3.8-8.8c2.1-2.1,4.8-3.5,7.6-4.3c-0.1,0-0.2-0.1-0.2-0.1c-5.8-1.8-10.9-5.6-14.4-10.6 c-1.7-2.5-3.1-5.2-3.8-8.2c-0.8-2.9-1-6-0.7-9c0.1-1,0.3-2,0.5-3c-0.2,0.2-0.3,0.4-0.5,0.6c-0.7,0.8-1.6,1.4-1.6,1.4 c-0.2,0.1-0.4,0.3-0.6,0.4c-0.2,0.1-0.4,0.2-0.8,0.4c-0.8,0.4-1.5,0.6-2.3,0.9c-1.6,0.4-3.3,0.5-4.9,0.2 c-3.3-0.6-6.2-2.5-8.1-5.2c-0.2-0.3-0.4-0.6-0.6-0.9c-1.2,2.9-3.2,5.4-5.8,7.1c-2.7,1.8-6.2,2.5-9.5,1.7 c-0.6-0.1-1.2-0.4-1.8-0.6c-0.9,3.3-2.6,6.3-4.8,8.9c-2.4,2.8-5.5,5-8.9,6.4s-7.1,2.1-10.8,2c-3.7-0.2-7.3-1.1-10.6-2.8 c-3.3-1.6-6.3-4.1-8.4-7.1c-2.1-3-3.5-6.7-3.2-10.6c0-0.3,0.1-0.6,0.1-0.9c-1.8,1.1-3.8,1.9-5.9,2.3c-4.2,0.9-8.8,0.5-12.7-1.2 c-2-0.9-3.8-2.1-5.4-3.6c-1.6-1.5-2.8-3.3-3.8-5.3c-0.8-1.6-1.3-3.4-1.6-5.1l0,0c-0.8,1.5-2,2.8-3.4,3.8s-2.9,1.7-4.4,2.2 c-1.5,0.6-3.1,1-4.8,1.3l0,0l-0.7,2c-2.7,7.7-4.8,15.7-6.2,23.8c-0.7,4-1.3,8.1-1.7,12.2c-0.1,1-0.2,2-0.3,3.1l-0.2,1.9 c0,0.1,0,0.3-0.1,0.3l-0.3,0.1c-0.1,1.5-0.2,3.1-0.3,4.6c-0.2,4.2-0.3,8.6-0.1,13.1c0.3,9,1.7,18.5,5.1,27.6 c1.7,4.6,4,9,6.8,13.1s6.4,7.8,10.2,11.1c3.9,3.3,8.2,6.1,12.7,8.7s9.1,4.9,14,6.8c4.8,1.9,9.8,3.2,14.9,4s10.2,1,15.3,0.9 c10.2-0.4,20.2-1.7,29.6-4.1s18.2-5.9,25.8-10.5c7.6-4.7,14.7-9.3,20.8-14.1c3-2.4,5.8-4.9,8.3-7.4c1.2-1.2,2.4-2.5,3.5-3.8 c0.6-0.6,1.1-1.2,1.6-1.9l0.2-0.2c0.2-0.2,0.3-0.4,0.4-0.5c0.2-0.3,0.4-0.5,0.4-0.5s0.4-0.4,0.9-1s1.2-1.2,1.8-1.8 c0.2-0.2,0.4-0.4,0.6-0.6c-2.9-0.4-5.8-1.4-8.3-2.9C300.7,210.2,297.8,207.1,296,203.4L296,203.4z",
    style: {},
    fill: "url(\"#SVGID_00000069390833366998270090000007998955406882430090_\")"
  }), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M297.5,203.1c-1.8-3.5-2.4-7.5-1.4-11.3c0.2-1,0.5-1.9,0.9-2.8c-0.4-0.5-0.7-1.1-0.8-1.7 c-0.2,0.5-0.5,0.9-0.7,1.4c-0.2,0-0.4,0-0.7-0.1c-0.8-0.1-1.7-0.3-2.4-0.6c-0.4-0.1-0.6-0.2-0.8-0.3c-0.2-0.1-0.3-0.1-0.3-0.1 l-0.6-0.3c-0.1,0-0.2-0.1-0.3-0.1l-0.5-0.2c-1.3-0.7-2.5-1.6-3.6-2.6c-2.1-2.1-3-5.1-2.9-8.1c0.1-2.9,1.2-5.9,3.2-8 s4.9-3.6,7.8-4.2c0.8-0.2,1.5-0.3,2.3-0.4l0,0c-0.2-0.5-0.3-1.1-0.4-1.7c-0.7-0.1-1.4-0.3-2.1-0.5c-2.8-0.7-5.5-2-7.9-3.7 s-4.5-3.7-6.2-6.1c-1.7-2.4-3-5-3.8-7.8s-1-5.7-0.8-8.6c0.1-1.7,0.5-3.4,1-5.1c-0.5-0.1-1-0.2-1.4-0.4c0,0.1,0,0.1-0.1,0.2 c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6,0.6-1.3,1.1-1.9,1.6c-0.6,0.4-1.1,0.7-1.1,0.7c-0.2,0.1-0.4,0.2-0.6,0.4 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7,0.4-1.4,0.6-2.1,0.8c-1.4,0.4-2.9,0.5-4.4,0.3c-2.9-0.5-5.6-2.2-7.3-4.6c-0.5-0.6-0.8-1.3-1.1-2 c0,0,0,0-0.1-0.1c0.2-0.8,0.3-1.6,0.4-2.4c-0.5,0.6-1.1,1-1.7,1.2c-0.1,0.6-0.3,1.3-0.5,1.9c-1,2.8-2.9,5.3-5.4,7 c-2.5,1.6-5.6,2.2-8.4,1.6c-0.6-0.1-1.2-0.4-1.8-0.6c0-0.1,0-0.3,0.1-0.4c-0.5,0.4-1.1,0.7-1.7,0.9c-0.7,3-2.1,5.9-4.1,8.3 c-2.2,2.7-5.1,5-8.3,6.4c-6.4,3.1-14.1,2.8-20.5-0.3c-3.2-1.5-6-3.8-8.1-6.6c-2-2.8-3.3-6.3-3-9.7c0.1-0.7,0.2-1.5,0.4-2.2 c0.2-0.1,0.4-0.3,0.5-0.4c-0.5-0.2-0.9-0.5-1.3-0.9c-1.9,1.3-3.9,2.4-6.1,3c-3.9,1.1-8.2,1-12-0.5c-3.9-1.4-7.1-4.2-9-7.9 c-1.6-2.9-2.3-6.2-2.2-9.5c-0.5-0.1-1-0.2-1.5-0.5c0,0.6,0,1.2,0,1.9c0,0,0,0-0.1,0s-0.1,0.1-0.1,0.1c-0.2,0.7-0.5,1.4-0.9,2.1 c-0.7,1.3-1.7,2.4-2.9,3.2c-1.2,0.9-2.6,1.5-4,2s-2.9,1-4.4,1.2c-0.5,0.1-1,0.1-1.4,0.1c-0.1,0.4-0.3,0.7-0.4,1.1 c-0.1,0.1-0.1,0.3-0.2,0.4c0.1,0,0.2,0,0.4,0l-0.5,1.4c-2.7,7.7-4.7,15.6-6.2,23.6c0,0.1,0,0.2-0.1,0.3h-0.1 c-0.1,0-0.1,0-0.1,0.1c-0.1,0.2-0.3,0.4-0.5,0.6c0,0.7-0.2,1.5-0.6,2.2c-0.1,0.2-0.1,0.4-0.2,0.6c0.2-0.2,0.5-0.4,0.7-0.6 c0.1-0.1,0.2-0.2,0.3-0.3c-0.5,3-0.9,6-1.2,9c-0.2,0.1-0.3,0.2-0.4,0.3c0,0,0,0.1-0.1,0.1c0,0.1-0.1,0.9-0.2,2.3 c0,0.3-0.1,0.7-0.1,1.1c-0.2,2-0.3,4.1-0.4,6.2c-0.2,4.2-0.3,8.6-0.2,13.1c0.2,9,1.5,18.5,4.8,27.7c1.7,4.6,3.8,9.2,6.6,13.4 s6.2,8.1,10,11.5c3.9,3.4,8.1,6.4,12.5,9.1c4.4,2.7,9,5.1,13.8,7.1s9.8,3.6,14.9,4.5c5.1,1,10.2,1.3,15.4,1.3 c5.1,0,10.1-0.4,15.1-1c5-0.6,9.8-1.4,14.5-2.4c9.5-2.1,18.4-5.3,26.2-9.6c3.9-2.1,7.5-4.5,11-6.8s6.8-4.5,9.9-6.8 c6.2-4.6,11.5-9.4,15.6-14.2c0.7-0.8,1.2-1.4,1.7-2c0.2-0.3,0.4-0.5,0.4-0.5s0.6-0.9,1.2-1.7s1.1-1.7,1.1-1.6 c0.2-0.4,0.5-0.8,0.6-1.1c0.1,0,0.2,0,0.3,0c0.1-0.5,0.3-1,0.5-1.4c-2.9-0.3-5.8-1.1-8.4-2.6 C302.1,209.5,299.3,206.5,297.5,203.1L297.5,203.1z M312,215.9c-0.6,0.6-1.2,1.3-1.8,1.8c-0.5,0.6-0.9,1-0.9,1s-0.1,0.2-0.4,0.5 c-0.1,0.1-0.3,0.3-0.4,0.5l-0.2,0.2c-0.5,0.6-1,1.2-1.6,1.9c-1.1,1.2-2.3,2.5-3.5,3.8c-2.5,2.5-5.3,5-8.3,7.4 c-6.1,4.8-13.2,9.4-20.8,14.1c-7.6,4.6-16.4,8.1-25.8,10.5c-9.4,2.4-19.4,3.7-29.6,4.1c-5.1,0.1-10.2-0.1-15.3-0.9 s-10.1-2.1-14.9-4c-4.8-1.9-9.5-4.2-14-6.8s-8.8-5.4-12.7-8.7s-7.4-6.9-10.2-11.1c-2.9-4.1-5.1-8.5-6.8-13.1 c-3.5-9.1-4.8-18.6-5.1-27.6c-0.2-4.5-0.1-8.9,0.1-13.1c0.1-1.6,0.2-3.1,0.3-4.6l0.3-0.1c0.1-0.1,0.1-0.2,0.1-0.3l0.2-1.9 c0.1-1,0.2-2,0.3-3.1c0.4-4.1,1-8.1,1.7-12.2c1.5-8.1,3.5-16,6.2-23.8l0.7-2l0,0c1.6-0.2,3.2-0.7,4.8-1.3 c1.5-0.6,3.1-1.2,4.4-2.2c1.4-1,2.5-2.3,3.4-3.8l0,0c0.3,1.8,0.9,3.5,1.6,5.1c0.9,1.9,2.2,3.8,3.8,5.3c1.5,1.6,3.4,2.8,5.4,3.6 c4,1.8,8.5,2.2,12.7,1.2c2.1-0.5,4.1-1.3,5.9-2.3c-0.1,0.3-0.1,0.6-0.1,0.9c-0.3,3.8,1.1,7.6,3.2,10.6c2.1,3.1,5.1,5.5,8.4,7.1 c3.3,1.6,6.9,2.6,10.6,2.8s7.4-0.5,10.8-2c3.4-1.5,6.5-3.7,8.9-6.4c2.2-2.6,3.9-5.6,4.8-8.9c0.6,0.2,1.2,0.5,1.8,0.6 c3.2,0.8,6.7,0.1,9.5-1.7c2.6-1.7,4.6-4.2,5.8-7.1c0.2,0.3,0.4,0.6,0.6,0.9c1.9,2.7,4.8,4.7,8.1,5.2c1.6,0.3,3.3,0.2,4.9-0.2 c0.8-0.2,1.6-0.5,2.3-0.9c0.4-0.2,0.6-0.3,0.8-0.4c0.2-0.1,0.4-0.2,0.6-0.4c0,0,0.9-0.6,1.6-1.4c0.2-0.2,0.4-0.4,0.5-0.6 c-0.2,1-0.4,2-0.5,3c-0.3,3,0,6.1,0.7,9c0.8,2.9,2.1,5.7,3.8,8.2c3.5,5,8.6,8.7,14.4,10.6c0.1,0,0.2,0.1,0.2,0.1 c-2.8,0.8-5.5,2.2-7.6,4.3c-2.3,2.4-3.5,5.6-3.8,8.8c-0.2,3.2,0.8,6.6,3,9.1c1.1,1.2,2.4,2.2,3.8,3c0.2,0.1,0.4,0.2,0.5,0.3 l0.3,0.1l0.3,0.2l0.7,0.3c0,0,0.3,0.1,0.7,0.2c0.4,0.1,0.9,0.2,1.5,0.3c1.1,0.1,2.1,0.1,2,0.1c0.2,0,0.3-0.1,0.5-0.1 c-0.2,0.6-0.4,1.2-0.6,1.8c-0.5,2-0.7,4.1-0.4,6.2c0.2,2.1,0.9,4.1,1.8,5.9c1.8,3.7,4.7,6.8,8.2,9c2.5,1.5,5.4,2.5,8.3,2.9 C312.4,215.4,312.2,215.6,312,215.9L312,215.9z",
    fill: "#202020"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085946234433940394760000015897079170284742302_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.272,
    y1: -438.086,
    x2: 563.272,
    y2: -420.866,
    gradientTransform: "matrix(0.507 0.9649 -0.9383 0.4931 -550.0696 -167.875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M131.8,160.6c-0.2,0.7-0.2,1.4-0.1,2.1 c0.3,1.7,1.1,3.4,2,4.9c0.2,0.4,0.5,0.7,0.8,1c0,0,0.3,0.4,0.8,0.8c0.4,0.2,0.8,0.4,1.1,0.5s0.6,0.2,0.6,0.2 c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.2,0,0.3,0.1h0.1c0,0,0.2,0,0.3,0c0.2,0,0.4,0,0.6,0l0,0v-0.3l0.1-1.5l0.3-3 c0.3-3.1,0.7-6.1,1.2-9.1c-0.1,0.1-0.2,0.2-0.3,0.3C137.8,158.7,134.8,160.1,131.8,160.6L131.8,160.6z",
    style: {},
    fill: "url(\"#SVGID_00000085946234433940394760000015897079170284742302_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168109852373702649950000004902788842759366057_",
    gradientUnits: "userSpaceOnUse",
    x1: -3078.5701,
    y1: 1692.0032,
    x2: -2865.3799,
    y2: 1692.0032,
    gradientTransform: "matrix(6.123234e-17 -1 1 6.123234e-17 -1452.8201 -2858.54)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(45, 198, 246)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(100, 252, 249)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M360.5,143.1c0.2,0,0.7,0.2,1.5,0 c-0.1,0,0.8-0.1,1.5-0.7c0.8-0.5,1.5-1.2,1.5-1.2c0.2-0.1,0.3-0.3,0.5-0.5c0,0,0-0.1,0.1-0.1c0-0.1,0-0.2,0.1-0.1l0,0l0.2-0.2 c0.1-0.1,0.2-0.3,0.3-0.4c0.8-1.2,1.4-2.6,1.8-4.1c0.7-2.9,0.5-6.1-0.4-8.9c-0.9-2.9-2.6-5.6-5.1-7.1c-2.5-1.6-5.6-1.5-8.6-0.9 c-0.5,0.1-1.1,0.2-1.6,0.4l0,0c-0.9,0.3-1.7,0.4-2.5,0.5c0,0,0,0-0.1,0c-0.4-0.2-0.9-0.7-0.2-1.4l0.1-0.1 c0.5-0.1,1.1-0.2,1.6-0.3l0,0c0.2-0.1,0.5-0.1,0.7-0.2c1.1-0.3,1.9-0.9,2.6-1.9s1.4-2,1.9-3.1c1.1-2.2,1.7-4.5,1.7-6.9 c0-4.8-2-9.6-5-13.4s-7.3-6.7-12-7.6c-2.4-0.5-4.8-0.4-7.2,0.1l-0.6,0.2c-0.1,0-0.2,0.1-0.3,0.1l-0.7,0.2c0,0-0.5,0.1-1.2,0.4 c-0.7,0.2-1.6,0.6-2.3,0.9c-1.2,0.6-1.6,0.8-1.6,0.5c0-0.2,0.5-0.8,1.2-1.3c-0.1,0,0.7-0.6,1.7-1.1c0.9-0.5,2-0.9,2-0.9l0.7-0.2 c0.1,0,0.2-0.1,0.4-0.1l0.5-0.1c0.2-0.1,0.4-0.1,0.5-0.1c0.3-0.2,0.6-0.5,1-0.8c0.7-0.7,1.2-1.5,1.2-1.5 c0.1-0.2,0.2-0.4,0.4-0.6c0.1-0.2,0.2-0.2,0.5-1c0.6-1.2,1-2.4,1.3-3.7c0.5-2.6,0.4-5.3-0.6-7.8c-0.9-2.4-2.8-4.5-5-5.8 c-1.1-0.7-2.4-1.1-3.6-1.3c-1.3-0.2-2.6-0.2-3.7,0.2c-0.6,0.2-1.1,0.5-1.5,1c-0.1,0.5-0.3,0.9-0.4,1.4l-0.1,0.3l-0.1,0.2v0.1 l-0.1,0.2l-0.1,0.3l-0.3,0.7c0,0-0.3,0.5-0.8,1.2c-0.5,0.6-1.2,1.4-1.9,1.9c-1.1,0.9-1.6,0.9-1.5,0.7c0-0.2,0.5-0.7,1-1.3 c-0.1,0.1,0.6-0.7,1.1-1.5s0.9-1.8,0.9-1.8c0.1-0.2,0.2-0.4,0.3-0.6l0.1-0.3v-0.1l0.1-0.4c0.1-0.3,0.2-0.7,0.3-1 c0-0.2,0.1-0.4,0.1-0.5c0,0,0,0,0-0.1c0.6-2.5,0.6-5.1,0-7.7c-1.2-5.5-4.3-10.7-8.7-14.1c-2.2-1.7-4.8-2.9-7.6-3.3 c-2.8-0.4-5.6,0-8.2,0.9c-2.6,1-5,2.6-6.8,4.7c-0.7,0.8-1.3,1.8-1.9,2.7c-0.1,0.2-0.2,0.5-0.3,0.8c0,0,0,0-0.1,0.1 c-0.5,1.2-0.9,2.5-1,3.9c-0.1,0.8,0,1.5,0.1,2.3c0,0,0,0,0,0.1c-0.1,0.3-0.6,1-1.4,0.3l-0.1-0.1c-0.2-0.9-0.2-1.8-0.1-2.7 c0.1-1.8,0.7-3.6,1.5-5.2c0.2-0.5,0.4-1,0.6-1.5c0.3-1,0.5-2,0.5-3V38c0-0.5-0.1-1-0.1-1.6c-0.2-2.1-0.6-4.2-1.3-6.2 c-0.7-2-1.6-3.9-2.7-5.7c-1.1-1.8-2.4-3.5-3.8-5.1c-2.9-3.1-6.3-5.7-10.2-7.5c-3.8-1.8-8-2.9-12.2-3.4c-2.1-0.2-4.2-0.3-6.4-0.2 c-2.1,0.1-4.2,0.3-6.4,0.7c-2.1,0.3-4.2,0.9-6.3,1.4c-2.1,0.6-4.1,1.2-6.1,2c-1.9,0.8-3.8,1.9-5.3,3.2s-2.9,3-4,4.8l-0.7,1.1 c-0.1,0.2-0.2,0.4-0.3,0.6c0,0-0.2,0.4-0.5,1.1c-0.2,0.5-0.5,1.2-0.6,1.8c0.2,0.3,0.4,0.5,0.6,0.8c2.6,3.7,4,8.4,3.3,13 c-0.1,0.9-0.4,1.7-0.6,2.5c0,0,0,0-0.1,0.1c-0.3,0.3-1,0.5-1.3-0.5v-0.1c0.3-0.7,0.4-1.5,0.6-2.3c0.6-4-0.5-8.1-2.8-11.5l0,0 c-0.1,0-0.3-0.3-0.4-0.6c-2.5-3.5-6.1-6.2-10.1-8s-8.4-2.5-12.8-2.3c-4.4,0.3-8.6,1.5-12.5,3.6c-3.9,2-7.3,4.9-10.1,8.2 c-2.8,3.4-4.9,7.3-5.7,11.6c-0.8,4.2-0.6,8.8,1.3,12.7l0.2,0.4l0.1,0.2v0.1l0.1,0.2l0.2,0.3l0.4,0.6c0,0,0.3,0.5,0.7,1.1 s1,1.3,1.5,1.9c0.9,0.9,1.2,1.2,1.1,1.3c-0.2,0-0.9-0.2-1.6-0.7c0.1,0.1-0.8-0.5-1.6-1.3s-1.4-1.7-1.4-1.7 c-0.1-0.2-0.3-0.4-0.4-0.6l-0.2-0.3l-0.1-0.1l-0.1-0.2c-0.1-0.1-0.1-0.3-0.2-0.4c-0.2-0.4-0.4-0.8-0.6-1.3 c-0.8,0.2-1.5,0.5-2.2,0.8c-3.5,1.5-6.7,3.7-9.4,6.4c-1.3,1.4-2.5,2.8-3.6,4.5c-0.3,0.4-0.5,0.8-0.7,1.2 c-0.2,0.4-0.5,0.8-0.7,1.3l-0.4,0.7c-0.1,0.2-0.2,0.4-0.3,0.6c0,0-0.2,0.5-0.6,1.2c-0.3,0.7-0.7,1.5-1.1,2.3 c0,0.1-0.1,0.1-0.1,0.2c0.9,0.5,1.8,1.1,2.6,1.8c1.8,1.5,3.4,3.4,4.3,5.6l0.2,0.4L158,79v0.1l0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.4 c0.1,0.2,0.2,0.5,0.2,0.7c0,0,0.1,0.6,0.2,1.4c0.1,0.8,0,1.8-0.2,2.6c-0.1,0.7-0.3,1.1-0.4,1.3c-0.1,0.2-0.2,0.3-0.3,0.2 c-0.1-0.2-0.1-0.8-0.1-1.7c0,0.1,0-0.9-0.2-1.8c-0.2-1-0.5-1.9-0.5-1.9l-0.2-0.6c0-0.1-0.1-0.2-0.1-0.3v-0.1l-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.4c-0.2-0.5-0.4-0.9-0.7-1.4c-1.3-2.2-3.3-4-5.6-5.3c0,0-0.1,0-0.1-0.1c-1.4-0.8-2.9-1.4-4.4-1.9 c-8.2-2.6-17.7-0.9-24.7,4.1c-7.1,4.9-11.5,13.6-10.9,22.2c0.3,4.3,1.9,8.5,4.6,11.8c1.3,1.7,2.9,3.2,4.7,4.3 c1.8,1.1,3.8,1.6,5.9,1.4l0.2-0.1h0.2l0.4-0.1c0.2-0.1,0.5-0.1,0.8-0.1c0,0,0.6-0.1,1.4,0c0.8,0,1.8,0.2,2.6,0.4 c0.7,0.2,1.1,0.4,1.3,0.6s0.2,0.2,0.2,0.3c-0.2,0.1-0.9,0-1.7-0.1c0.1,0-0.9-0.1-1.9,0c-0.2,0-0.4,0-0.6,0.1c0,0,0,0.1-0.1,0.1 l-0.1,0.1c-0.8,0.2-1.6,0.3-2.5,0.4l-0.2,0.1c-0.4,0.1-0.8,0.2-1.1,0.4c-3,1.2-5.4,3.4-7.3,6.1c-1.9,2.7-3.3,5.7-4.2,8.8 s-1.4,6.4-0.9,9.6c0.5,3.2,1.7,6.3,3.4,9.1s3.9,5.3,6.6,7.1c1.3,0.9,2.8,1.6,4.3,2.1c1.5,0.4,3.1,0.5,4.7,0.4 c3.2-0.3,6.3-1.6,8.7-3.7c0.3-0.3,0.6-0.5,0.8-0.8c0.3-0.3,0.5-0.6,0.7-0.9c0,0,0,0,0.1-0.1h0.1c0-0.1,0-0.2,0.1-0.3 c1.5-8,3.5-15.9,6.2-23.6l0.5-1.4c-0.3,0-0.6,0-0.9,0c-0.6,0-1.1-0.1-1.6-0.2c0,0-0.6-0.1-1.3-0.4s-1.6-0.7-2.4-1.1 c-0.3-0.2-0.6-0.3-0.8-0.4h-0.1v-0.1c0,0,0,0-0.1,0l0.1-0.4c0,0,0,0,0.1,0v-0.1c0.1,0,0.1,0,0.2,0l0,0c0.1-0.1,0.1-0.1,0.2-0.1 l0.1,0.1c0.2,0.1,0.4,0.1,0.6,0.2c-0.1-0.1,0.9,0.3,1.8,0.5c1,0.2,1.9,0.3,1.9,0.3c0.2,0,0.4,0.1,0.7,0.1c0.2,0,0.4,0,0.8,0.1 c0.7,0,1.5-0.1,2.2-0.2c1.5-0.2,2.9-0.7,4.4-1.2c1.4-0.5,2.8-1.2,4-2s2.2-2,2.9-3.2c0.4-0.7,0.7-1.4,0.9-2.1c0,0,0,0,0.1-0.1 c0,0,0,0,0.1,0c-0.1-1.5,0-3.1,0.3-4.6c0.7-4.3,2.7-8.2,5.4-11.6c1.8-2.1,3.9-4,6.3-5.5c-2.4-0.6-4.4-2.2-5.7-4.2 c-1.4-2.2-1.9-4.9-1.6-7.5c0.4-2.6,1.4-5,3-6.9c0.8-1,1.8-1.9,2.8-2.6l0.2-0.1l0.1-0.1l0.2-0.1l0.3-0.2c0.2-0.1,0.5-0.2,0.7-0.4 c0,0,0.6-0.2,1.4-0.4c0.8-0.2,1.9-0.2,2.7-0.1c0.7,0.1,1.1,0.3,1.4,0.4c0.2,0.1,0.3,0.2,0.2,0.3c-0.2,0.1-0.9,0.1-1.6,0.2 c0.1,0-0.9,0.1-1.8,0.3c-0.9,0.3-1.8,0.8-1.8,0.8c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.2-0.9,0.6c-0.9,0.7-1.7,1.4-2.4,2.3 c-1.4,1.8-2.3,3.9-2.5,6.2c-0.3,2.2,0.2,4.5,1.4,6.3s3.1,3.2,5.2,3.6l0.6,0.1c0.2,0,0.3,0,0.5,0c0.3,0,0.6-0.2,0.6-0.2l0,0 c0,0,0.1,0,0.2,0c0.5-0.2,0.9-0.4,1.4-0.6c4.1-1.4,8.9-1.2,12.7,1.2c0.8,0.4,1.4,1,2.1,1.6c0,0,0,0,0.1,0.1c0.1,0.4,0,1.1-1,1 h-0.1c-0.6-0.5-1.2-1-1.8-1.4c-3.4-2.1-7.8-2.3-11.6-1c-3.9,1.3-7.2,4-9.8,7.2s-4.4,7.1-5,11.1c-0.6,4.1,0.1,8.3,2,11.9 s5.1,6.5,9,7.9c3.8,1.4,8.1,1.6,12,0.5s7.4-3.6,10.1-6.7l0.8-1l0.4-0.6c0,0,0.4-0.4,0.8-1c0.5-0.6,1-1.4,1.4-2 c1.4-2.3,1.3-1.2,0.7,0.4c0.1-0.1-0.3,0.9-0.8,1.8c-0.2,0.5-0.5,0.9-0.7,1.3c-0.2,0.3-0.4,0.6-0.4,0.6c-0.1,0.2-0.3,0.4-0.4,0.6 l-0.2,0.3l-0.5,0.6c-0.4,0.4-0.7,0.8-1.1,1.2c-1,1.1-2.2,2-3.4,2.9c-0.2,0.7-0.4,1.4-0.4,2.2c-0.3,3.4,1,6.9,3,9.7 c2,2.9,4.9,5.1,8.1,6.6c6.4,3.1,14.1,3.4,20.5,0.3c3.2-1.5,6.1-3.7,8.3-6.4s3.8-6,4.3-9.5c0.6-3.5,0.1-7.1-1.5-10.2l-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.2v-0.1l-0.1-0.2l-0.2-0.3c-0.1-0.2-0.2-0.4-0.4-0.6c0,0-0.3-0.5-0.7-1.1s-1-1.3-1.5-2 c-0.9-1-1.2-1.3-1-1.4c0.2,0,0.9,0.3,1.6,0.8c-0.1-0.1,0.8,0.6,1.5,1.3c0.8,0.8,1.4,1.7,1.4,1.7c0.1,0.2,0.3,0.4,0.4,0.6 l0.2,0.3v0.1l0,0c0,0.1,0.1,0.1,0.1,0.2l0.2,0.3c0.2,0.4,0.4,0.8,0.6,1.3c1.4,3.3,1.6,7,1,10.4c0.6,0.3,1.2,0.5,1.8,0.6 c2.9,0.7,6,0.1,8.4-1.6c2.5-1.6,4.4-4.1,5.4-7c1-2.8,1.1-6,0-8.7c-0.6-1.3-1.5-2.5-2.6-3.5l-0.4-0.3c-0.1-0.1-0.2-0.1-0.3-0.2 c-0.2-0.1-0.4-0.3-0.6-0.4c0,0-0.4-0.3-1.1-0.6c-0.6-0.3-1.5-0.7-2.2-0.8c-0.6-0.1-1.1-0.2-1.3-0.2c-0.3-0.1-0.3-0.1-0.3-0.2 c0.1-0.2,0.8-0.4,1.7-0.4c-0.1,0,1,0,2,0.3c1.1,0.3,2.1,0.8,2.1,0.8l0.6,0.4c0.1,0.1,0.2,0.2,0.3,0.2l0.3,0.2 c0.2,0.1,0.3,0.3,0.5,0.4c1.2,1.1,2.2,2.5,2.8,4.1c1,2.6,1,5.4,0.3,8c0,0,0,0,0.1,0.1c0.3,0.7,0.6,1.4,1.1,2 c1.7,2.4,4.4,4.2,7.3,4.6c1.5,0.2,3,0.1,4.4-0.3c0.7-0.2,1.4-0.5,2.1-0.8c0.3-0.1,0.4-0.2,0.6-0.4c0.2-0.1,0.4-0.2,0.6-0.4 c0,0,0.5-0.3,1.1-0.7s1.3-1,1.9-1.6c0.1-0.2,0.3-0.3,0.4-0.4c1.2-4.2,3.3-8.2,6.3-11.4c0.3-0.3,0.6-0.6,0.9-0.9l1-0.8 c0,0,0,0,0.1,0c0.4-0.1,1.1,0,0.9,1.1v0.1l-0.9,0.8c-0.3,0.3-0.6,0.6-0.8,0.9c-2,2.1-3.6,4.6-4.8,7.2c-1.1,2.7-1.9,5.5-2.1,8.4 c-0.2,2.9,0,5.8,0.8,8.6s2.1,5.4,3.8,7.8c1.7,2.4,3.9,4.4,6.2,6.1c2.4,1.7,5,2.9,7.9,3.7c0.7,0.2,1.4,0.4,2.1,0.5 s1.4,0.2,2.1,0.3c1.4,0.1,2.9,0,4.3-0.3l0.7-0.2c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.1,0.6-0.2c0,0,0.5-0.1,1.2-0.4 c0.7-0.3,1.5-0.7,2.1-1.2c0.5-0.4,0.8-0.7,1-0.9s0.3-0.2,0.3-0.1c0,0.2-0.2,0.9-0.8,1.6c0.1-0.1-0.6,0.8-1.5,1.4 c-0.9,0.6-1.9,1.1-1.9,1.1l-0.7,0.2c-0.1,0-0.2,0.1-0.4,0.1l-0.5,0.1c-0.4,0.1-0.8,0.2-1.1,0.2c-1.8,0.2-3.5,0.2-5.2-0.1l0,0 l-0.1,0.1c-0.8,0.1-1.6,0.2-2.3,0.4c-2.9,0.7-5.7,2.1-7.8,4.2c-2,2.1-3.1,5.1-3.2,8s0.9,6,2.9,8.1c1,1.1,2.2,2,3.6,2.6l0.5,0.2 c0.1,0.1,0.2,0.1,0.3,0.1l0.6,0.3c0,0,0.1,0.1,0.3,0.1c0.2,0.1,0.5,0.2,0.8,0.3c0.7,0.3,1.6,0.4,2.4,0.6c0.3,0,0.5,0.1,0.7,0.1 c1.2-3,3.3-5.7,6-7.6c0.7-0.5,1.5-0.9,2.2-1.3c0,0,0,0,0.1,0c0.4,0,1,0.4,0.6,1.3c0,0,0,0.1-0.1,0.1c-0.7,0.3-1.4,0.7-2,1.2 c-3.2,2.2-5.4,5.7-6.2,9.4c-1,3.8-0.3,7.8,1.4,11.3c1.8,3.4,4.6,6.4,8,8.3c3.4,1.9,7.4,2.8,11.3,2.7s7.8-1.1,11.3-2.9 c3.5-1.8,6.6-4.4,8.6-7.7c2.1-3.3,2.9-7.3,2.1-11.1c0-0.1,0-0.2-0.1-0.4l-0.1-0.2v-0.1v-0.2l-0.1-0.3l-0.2-0.7 c0,0,0-0.1-0.1-0.4c-0.1-0.2-0.2-0.5-0.3-0.9c-0.2-0.7-0.6-1.6-1-2.2c-0.7-1.1-0.9-1.5-0.6-1.5c0.2,0,0.8,0.4,1.4,1.1 c0-0.1,0.6,0.7,1.2,1.6c0.3,0.4,0.5,0.9,0.7,1.3c0.6,0.1,1.3,0,2-0.2c3.6-1.1,6.8-3.9,8.5-7.4c0.9-1.7,1.3-3.6,1.2-5.6 c0-1-0.2-1.9-0.4-2.8l-0.1-0.4l-0.1-0.3c-0.1-0.2-0.1-0.4-0.2-0.6c0,0-0.2-0.5-0.4-1.2c-0.3-0.7-0.7-1.5-1.1-2.1 c-0.8-1.1-1-1.4-0.8-1.4s0.8,0.3,1.5,0.9c0-0.1,0.7,0.7,1.3,1.6c0.6,0.9,1.1,1.9,1.1,1.9l0.2,0.7l0,0c0.7-0.2,1.4-0.5,2.1-0.8 c5.3-2.3,9.6-6.6,11.8-12c1.1-2.7,1.6-5.5,1.6-8.4c0-1.4-0.2-2.9-0.5-4.3l-0.1-0.5c0-0.1,0-0.2-0.1-0.3l-0.2-0.7 c0,0,0-0.1-0.1-0.4c0-0.2-0.1-0.5-0.2-0.9c-0.2-0.7-0.4-1.5-0.6-2.2l-0.1,0.1c0,0-0.5,0.4-1.2,0.8c-0.4,0.2-0.8,0.4-1.2,0.6 c-0.5,0.1-1,0.2-1.4,0.2c-0.8,0-1.2-0.3-1.4-0.5C360.4,143.2,360.4,143.1,360.5,143.1L360.5,143.1z",
    style: {},
    fill: "url(\"#SVGID_00000168109852373702649950000004902788842759366057_\")"
  }), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M367.1,141.1c1.1-1.4,1.8-2.9,2.2-4.6c0.9-3.3,0.7-6.7-0.2-9.9c-0.9-3.2-2.8-6.3-5.6-8.2 c-1.5-1-3.2-1.5-4.9-1.6c-1.1-0.1-2.1,0-3.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.8-1,1.5-2.1,2.1-3.2c1.2-2.3,1.9-4.9,1.9-7.4 c0.1-5.2-2-10.2-5-14.2c-3.1-4-7.4-7.2-12.5-8.4c-1.9-0.4-3.9-0.6-5.8-0.5c0.6-0.5,1-1,1-1c0.2-0.2,0.3-0.4,0.4-0.6l0.2-0.3 l0.3-0.5c0.7-1.3,1.2-2.7,1.6-4.1c0.7-2.9,0.6-6-0.5-8.8c-1-2.8-3-5.2-5.6-6.8c-1.3-0.8-2.7-1.3-4.2-1.6s-3.1-0.2-4.6,0.3 c-0.2,0.1-0.4,0.2-0.6,0.2c0.2-1.9,0.2-3.8-0.1-5.6c-0.5-3-1.6-5.9-3.1-8.5s-3.5-5-5.9-7c-2.4-1.9-5.2-3.3-8.3-3.8 c-1.5-0.3-3.1-0.3-4.6-0.2s-3.1,0.5-4.5,1c-1.5,0.5-2.8,1.2-4.1,2.1c-1.1,0.8-2.2,1.7-3.1,2.7c0-0.3,0-0.5,0-0.8 c0-1.1,0-2.2-0.1-3.3c-0.2-2.2-0.6-4.4-1.3-6.4c-0.7-2.1-1.6-4.1-2.7-6s-2.4-3.6-3.8-5.3c-1.5-1.6-3.1-3.1-4.8-4.4 c-1.7-1.3-3.6-2.4-5.6-3.4c-3.9-1.9-8.1-3.1-12.4-3.7c-1.6-0.2-3.2-0.3-4.8-0.4c-0.6,0-1.1,0-1.7,0c-2.2,0-4.3,0.2-6.5,0.5 c-2.1,0.3-4.3,0.8-6.3,1.3c-2.1,0.5-4.1,1.1-6.2,1.9c-2,0.8-4,1.8-5.8,3.1s-3.3,2.9-4.6,4.7l-0.9,1.4l-0.4,0.6l-0.2,0.3 l-0.4,0.6c0,0-0.4,1.1-0.6,2.1c-0.1,0.2-0.1,0.4-0.1,0.6c-2.5-2.9-5.6-5.1-9-6.7c-4.1-1.9-8.7-2.8-13.2-2.6 c-4.5,0.1-9,1.4-13,3.4s-7.6,4.8-10.6,8.2s-5.3,7.3-6.5,11.8c-1,4-1.1,8.3,0.1,12.3c-0.8,0.2-1.6,0.5-2.3,0.8 c-1.8,0.8-3.6,1.7-5.2,2.8c-1.6,1.1-3.2,2.4-4.5,3.8c-1.4,1.4-2.6,2.9-3.7,4.6c-0.3,0.4-0.5,0.8-0.8,1.2s-0.5,0.8-0.7,1.3 l-0.8,1.6c0,0-0.4,1-0.7,2s-0.5,2-0.5,1.9c0,0,0,0,0,0.1c-0.9-0.5-1.8-0.9-2.7-1.2c-8.8-3.2-18.9-1.8-26.6,3.3 C113,77.8,108,87,108.5,96.4c0.3,4.7,1.9,9.2,4.8,12.9c1.4,1.8,3.1,3.5,5.1,4.8c1,0.6,2.1,1.1,3.3,1.4c0.1,0,0.2,0,0.3,0.1 c-2.3,1.2-4.2,3-5.8,5c-2.1,2.8-3.7,6-4.8,9.2c-1.1,3.3-1.7,6.9-1.3,10.4s1.7,6.9,3.4,9.9s4.1,5.8,7,7.8c1.5,1,3,1.8,4.8,2.4 c1.6,0.5,3.4,0.6,5,0.5c0,0.1,0,0.2,0,0.3c-0.1,0.6-0.1,1.3,0,1.9c0.1,1,0.5,2,0.9,2.9s0.8,1.8,1.4,2.6c0.2,0.4,0.5,0.7,0.8,1 c0,0,0.2,0.2,0.5,0.5s0.8,0.6,1.3,0.9c0,0,0.1,0,0.1,0.1c0.6,0.4,1.1,0.6,1.1,0.6c0.2,0.1,0.4,0.1,0.6,0.2c0.1,0,0.1,0,0.2,0.1 c0.1,0,0.3,0.1,0.4,0.1h0.2h0.1c0,0,0.3,0.1,0.4,0c0.3,0,0.6,0,0.9,0c0.2,0,0.5-0.1,0.7-0.1l0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.3 l0.1-1.5v-0.4c0.1-1,0.2-2,0.3-3.1c0.4-3.9,0.9-7.8,1.6-11.6c0-0.2,0.1-0.4,0.1-0.6c1.5-8.1,3.5-16,6.2-23.8l0.7-2l0,0 c1.6-0.2,3.2-0.7,4.8-1.3c1.5-0.6,3.1-1.2,4.4-2.2c1.4-1,2.5-2.3,3.4-3.8l0,0c0.3,1.8,0.9,3.5,1.6,5.1c0.9,1.9,2.2,3.8,3.8,5.3 c1.5,1.6,3.4,2.8,5.4,3.6c4,1.8,8.5,2.2,12.7,1.2c2.1-0.5,4.1-1.3,5.9-2.3c-0.1,0.3-0.1,0.6-0.1,0.9c-0.3,3.8,1.1,7.6,3.2,10.6 c2.1,3.1,5.1,5.5,8.4,7.1c3.3,1.6,6.9,2.6,10.6,2.8s7.4-0.5,10.8-2c3.4-1.5,6.5-3.7,8.9-6.4c2.2-2.6,3.9-5.6,4.8-8.9 c0.6,0.2,1.2,0.5,1.8,0.6c3.2,0.8,6.7,0.1,9.5-1.7c2.6-1.7,4.6-4.2,5.8-7.1c0.2,0.3,0.4,0.6,0.6,0.9c1.9,2.7,4.8,4.7,8.1,5.2 c1.6,0.3,3.3,0.2,4.9-0.2c0.8-0.2,1.6-0.5,2.3-0.9c0.4-0.2,0.6-0.3,0.8-0.4c0.2-0.1,0.4-0.2,0.6-0.4c0,0,0.9-0.6,1.6-1.4 c0.2-0.2,0.4-0.4,0.5-0.6c-0.2,1-0.4,2-0.5,3c-0.3,3,0,6.1,0.7,9c0.8,2.9,2.1,5.7,3.8,8.2c3.5,5,8.6,8.7,14.4,10.6 c0.1,0,0.2,0.1,0.2,0.1c-2.8,0.8-5.5,2.2-7.6,4.3c-2.3,2.4-3.5,5.6-3.8,8.8c-0.2,3.2,0.8,6.6,3,9.1c1.1,1.2,2.4,2.2,3.8,3 c0.2,0.1,0.4,0.2,0.5,0.3l0.3,0.1l0.3,0.2l0.7,0.3c0,0,0.3,0.1,0.7,0.2c0.4,0.1,0.9,0.2,1.5,0.3c1.1,0.1,2.1,0.1,2,0.1 c0.2,0,0.3-0.1,0.5-0.1c-0.2,0.6-0.4,1.2-0.6,1.8c-0.5,2-0.7,4.1-0.4,6.2c0.2,2.1,0.9,4.1,1.8,5.9c1.8,3.7,4.7,6.8,8.2,9 c3.5,2.1,7.7,3.2,11.8,3.2c4.1,0,8.2-0.9,11.9-2.6c3.7-1.7,7.1-4.3,9.5-7.7c1.2-1.7,2.1-3.6,2.7-5.6s0.8-4.1,0.5-6.2 c0-0.5-0.1-1-0.2-1.6c0-0.1,0-0.3-0.1-0.4l-0.1-0.2v-0.1v-0.2c0.6,0,1.3-0.1,1.9-0.2c1.1-0.3,2-0.8,2.9-1.3s1.8-1.1,2.6-1.8 c1.6-1.4,2.9-3,3.9-4.9s1.5-4,1.5-6.1c0-0.9-0.1-1.8-0.3-2.7c0.8-0.2,1.6-0.5,2.4-0.9c5.5-2.4,10.1-6.9,12.5-12.5 c1.1-2.8,1.8-5.8,1.8-8.8c0-1.5-0.1-3-0.4-4.5l-0.2-1.2l-0.2-0.7c0,0-0.1-0.3-0.2-0.6c-0.1-0.4-0.3-0.9-0.5-1.4 c-0.4-1-0.9-1.9-0.9-1.8c0-0.1-0.1-0.1-0.1-0.2l0.1-0.1L367.1,141.1L367.1,141.1z M139.3,165.5l-0.3,3l-0.1,1.5v0.3l0,0 c-0.2,0-0.4,0-0.6,0c-0.1,0-0.3,0-0.3,0h-0.1c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.4-0.1-0.6-0.2c0,0-0.2-0.1-0.6-0.2 c-0.3-0.1-0.7-0.3-1.1-0.5c-0.5-0.4-0.8-0.8-0.8-0.8c-0.3-0.3-0.5-0.6-0.8-1c-0.9-1.5-1.8-3.2-2-4.9c-0.1-0.7-0.1-1.4,0.1-2.1 c3.1-0.5,6.1-1.9,8.4-4c0.1-0.1,0.2-0.2,0.3-0.3C140,159.4,139.6,162.5,139.3,165.5L139.3,165.5z M360.6,143.4 c0.2,0.2,0.6,0.5,1.4,0.5c0.5,0,0.9-0.1,1.4-0.2c0.5-0.2,0.9-0.4,1.2-0.6c0.7-0.4,1.2-0.8,1.2-0.8l0.1-0.1 c0.2,0.7,0.5,1.6,0.6,2.2c0.1,0.4,0.2,0.7,0.2,0.9s0.1,0.4,0.1,0.4l0.2,0.7c0,0.1,0.1,0.2,0.1,0.3l0.1,0.5 c0.3,1.4,0.4,2.8,0.5,4.3c0,2.9-0.5,5.8-1.6,8.4c-2.2,5.3-6.5,9.7-11.8,12c-0.7,0.3-1.4,0.6-2.1,0.8l0,0L352,172 c0,0-0.5-1-1.1-1.9s-1.4-1.6-1.3-1.6c-0.6-0.6-1.3-0.9-1.5-0.9s0,0.4,0.8,1.4c0.4,0.7,0.9,1.5,1.1,2.1c0.3,0.7,0.4,1.2,0.4,1.2 c0.1,0.2,0.2,0.4,0.2,0.6l0.1,0.3l0.1,0.4c0.2,0.9,0.4,1.9,0.4,2.8c0.1,1.9-0.4,3.8-1.2,5.6c-1.7,3.4-4.9,6.2-8.5,7.4 c-0.7,0.2-1.4,0.2-2,0.2c-0.2-0.4-0.4-0.9-0.7-1.3c-0.5-0.9-1.2-1.7-1.2-1.6c-0.6-0.7-1.2-1.1-1.4-1.1c-0.2,0,0,0.4,0.6,1.5 c0.4,0.7,0.7,1.6,1,2.2c0.1,0.4,0.2,0.6,0.3,0.9c0.1,0.2,0.1,0.4,0.1,0.4l0.2,0.7l0.1,0.3v0.2v0.1l0.1,0.2c0,0.1,0,0.2,0.1,0.4 c0.7,3.8-0.1,7.8-2.1,11.1c-2.1,3.3-5.2,5.9-8.6,7.7c-3.5,1.8-7.4,2.8-11.3,2.9c-3.9,0.1-7.9-0.8-11.3-2.7s-6.2-4.8-8-8.3 s-2.4-7.5-1.4-11.3c0.9-3.8,3.1-7.2,6.2-9.4c0.6-0.4,1.3-0.9,2-1.2l0.1-0.1c0.4-0.9-0.2-1.2-0.6-1.3c-0.1,0-0.1,0-0.1,0 c-0.8,0.4-1.5,0.8-2.2,1.3c-2.7,1.9-4.7,4.6-6,7.6c-0.2,0-0.4,0-0.7-0.1c-0.8-0.1-1.7-0.3-2.4-0.6c-0.4-0.1-0.6-0.2-0.8-0.3 c-0.2-0.1-0.3-0.1-0.3-0.1l-0.6-0.3c-0.1,0-0.2-0.1-0.3-0.1l-0.5-0.2c-1.3-0.7-2.5-1.6-3.6-2.6c-2.1-2.1-3-5.1-2.9-8.1 c0.1-2.9,1.2-5.9,3.2-8s4.9-3.6,7.8-4.2c0.8-0.2,1.5-0.3,2.3-0.4l0.1-0.1l0,0c1.7,0.2,3.5,0.3,5.2,0.1c0.4,0,0.8-0.1,1.1-0.2 l0.5-0.1c0.1,0,0.2-0.1,0.4-0.1l0.7-0.2c0,0,1-0.4,1.9-1.1c0.9-0.6,1.6-1.4,1.5-1.4c0.6-0.7,0.9-1.4,0.8-1.6 c0-0.1-0.1-0.1-0.3,0.1c-0.2,0.2-0.5,0.5-1,0.9c-0.6,0.5-1.4,0.9-2.1,1.2s-1.2,0.4-1.2,0.4c-0.2,0.1-0.4,0.1-0.6,0.2 c-0.1,0-0.2,0.1-0.3,0.1l-0.7,0.2c-1.4,0.3-2.8,0.4-4.3,0.3c-0.7,0-1.4-0.1-2.1-0.3c-0.7-0.1-1.4-0.3-2.1-0.5 c-2.8-0.7-5.5-2-7.9-3.7s-4.5-3.7-6.2-6.1c-1.7-2.4-3-5-3.8-7.8s-1-5.7-0.8-8.6c0.2-2.9,1-5.8,2.1-8.4c1.1-2.7,2.8-5.2,4.8-7.2 c0.3-0.3,0.5-0.6,0.8-0.9l0.9-0.8v-0.1c0.2-1-0.5-1.1-0.9-1.1c-0.1,0-0.1,0-0.1,0l-1,0.8c-0.3,0.3-0.6,0.6-0.9,0.9 c-3,3.2-5.2,7.1-6.3,11.4c-0.1,0.1-0.2,0.3-0.4,0.4c-0.6,0.6-1.3,1.1-1.9,1.6c-0.6,0.4-1.1,0.7-1.1,0.7 c-0.2,0.1-0.4,0.2-0.6,0.4c-0.2,0.1-0.4,0.2-0.6,0.4c-0.7,0.4-1.4,0.6-2.1,0.8c-1.4,0.4-2.9,0.5-4.4,0.3 c-2.9-0.5-5.6-2.2-7.3-4.6c-0.5-0.6-0.8-1.3-1.1-2c0,0,0,0-0.1-0.1c0.7-2.6,0.7-5.4-0.3-8c-0.6-1.6-1.5-3-2.8-4.1 c-0.2-0.1-0.3-0.3-0.5-0.4l-0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2l-0.6-0.4c0,0-1-0.6-2.1-0.8c-1.1-0.3-2.1-0.3-2-0.3 c-0.9,0-1.6,0.2-1.7,0.4c-0.1,0.1,0,0.2,0.3,0.2c0.2,0.1,0.7,0.1,1.3,0.2c0.8,0.2,1.6,0.5,2.2,0.8s1.1,0.6,1.1,0.6 c0.2,0.1,0.4,0.2,0.6,0.4c0.1,0.1,0.2,0.1,0.3,0.2l0.4,0.3c1.1,0.9,2,2.1,2.6,3.5c1.1,2.7,1,5.9,0,8.7c-1,2.8-2.9,5.3-5.4,7 c-2.5,1.6-5.6,2.2-8.4,1.6c-0.6-0.1-1.2-0.4-1.8-0.6c0.7-3.4,0.4-7.1-1-10.4c-0.2-0.4-0.4-0.9-0.6-1.3l-0.2-0.3 c0-0.1,0-0.1-0.1-0.2l0,0v-0.1l-0.2-0.3c-0.1-0.2-0.3-0.4-0.4-0.6c0,0-0.6-0.9-1.4-1.7c-0.8-0.8-1.6-1.4-1.5-1.3 c-0.7-0.5-1.4-0.8-1.6-0.8c-0.2,0.1,0.1,0.4,1,1.4c0.5,0.6,1.1,1.3,1.5,2s0.7,1.1,0.7,1.1c0.1,0.2,0.3,0.4,0.4,0.6l0.2,0.3 l0.1,0.2v0.1c0,0,0.1,0.1,0.1,0.2l0.1,0.3c1.6,3.1,2.1,6.7,1.5,10.2s-2.1,6.8-4.3,9.5s-5.1,5-8.3,6.4 c-6.4,3.1-14.1,2.8-20.5-0.3c-3.2-1.5-6-3.8-8.1-6.6c-2-2.8-3.3-6.3-3-9.7c0.1-0.7,0.2-1.5,0.4-2.2c1.2-0.9,2.3-1.8,3.4-2.9 c0.4-0.4,0.7-0.8,1.1-1.2l0.5-0.6l0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0,0,0.1-0.2,0.4-0.6c0.2-0.3,0.5-0.8,0.7-1.3 c0.5-0.9,0.9-1.9,0.8-1.8c0.6-1.6,0.7-2.7-0.7-0.4c-0.4,0.7-1,1.4-1.4,2s-0.8,1-0.8,1l-0.4,0.6l-0.8,1 c-2.7,3.1-6.2,5.6-10.1,6.7c-3.9,1.1-8.2,1-12-0.5c-3.9-1.4-7.1-4.2-9-7.9c-1.9-3.6-2.6-7.8-2-11.9s2.4-7.9,5-11.1 s5.9-5.9,9.8-7.2c3.8-1.4,8.2-1.1,11.6,1c0.7,0.4,1.3,0.9,1.8,1.4h0.1c1,0.1,1.1-0.6,1-1c0-0.1,0-0.1-0.1-0.1 c-0.6-0.6-1.3-1.2-2.1-1.6c-3.8-2.3-8.6-2.6-12.7-1.2c-0.5,0.2-0.9,0.3-1.4,0.6c-0.1,0-0.2,0-0.2,0l0,0c0,0.1-0.3,0.2-0.6,0.2 c-0.2,0-0.3,0-0.5,0l-0.6-0.1c-2.1-0.4-4-1.8-5.2-3.6c-1.2-1.8-1.7-4.1-1.4-6.3c0.2-2.2,1.2-4.4,2.5-6.2 c0.7-0.9,1.5-1.7,2.4-2.3c0.6-0.4,0.6-0.4,0.9-0.6c0.2-0.1,0.4-0.2,0.6-0.3c0,0,0.8-0.5,1.8-0.8c0.9-0.3,1.9-0.3,1.8-0.3 c0.8-0.1,1.4,0,1.6-0.2c0.1-0.1,0.1-0.1-0.2-0.3c-0.2-0.1-0.7-0.3-1.4-0.4c-0.8-0.2-1.9-0.1-2.7,0.1s-1.4,0.4-1.4,0.4 c-0.2,0.1-0.5,0.2-0.7,0.4l-0.3,0.2l-0.2,0.1l-0.1,0.1l-0.2,0.1c-1.1,0.7-2,1.6-2.8,2.6c-1.6,2-2.7,4.4-3,6.9 c-0.4,2.5,0.1,5.3,1.6,7.5c1.3,2,3.3,3.6,5.7,4.2c-2.4,1.5-4.5,3.4-6.3,5.5c-2.7,3.3-4.7,7.3-5.4,11.6c-0.3,1.5-0.4,3.1-0.3,4.6 c0,0,0,0-0.1,0s-0.1,0.1-0.1,0.1c-0.2,0.7-0.5,1.4-0.9,2.1c-0.7,1.3-1.7,2.4-2.9,3.2c-1.2,0.9-2.6,1.5-4,2s-2.9,1-4.4,1.2 c-0.7,0.1-1.5,0.2-2.2,0.2c-0.4,0-0.6,0-0.8-0.1c-0.2,0-0.4-0.1-0.7-0.1c0,0-1-0.1-1.9-0.3c-1-0.2-1.9-0.6-1.8-0.5 c-0.2-0.1-0.4-0.1-0.6-0.2c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.2,0.1l0,0c-0.1,0-0.1,0-0.2,0v0.1c0,0,0,0-0.1,0l-0.1,0.4 c0,0,0,0,0.1,0v0.1h0.1c0.2,0.1,0.4,0.3,0.8,0.4c0.7,0.4,1.6,0.8,2.4,1.1c0.8,0.3,1.3,0.4,1.3,0.4c0.5,0.1,1,0.2,1.6,0.2 c0.3,0,0.6,0,0.9,0l-0.5,1.4c-2.7,7.7-4.7,15.6-6.2,23.6c0,0.1,0,0.2-0.1,0.3h-0.1c-0.1,0-0.1,0-0.1,0.1 c-0.2,0.3-0.5,0.6-0.7,0.9c-0.2,0.3-0.5,0.6-0.8,0.8c-2.4,2.1-5.5,3.4-8.7,3.7c-1.6,0.2-3.2,0.1-4.7-0.4c-1.5-0.4-3-1.2-4.3-2.1 c-2.7-1.8-4.9-4.3-6.6-7.1c-1.6-2.8-2.9-5.9-3.4-9.1c-0.5-3.2-0.1-6.5,0.9-9.6c1-3.1,2.4-6.2,4.2-8.8c1.9-2.6,4.3-4.9,7.3-6.1 c0.4-0.2,0.8-0.3,1.1-0.4l0.2-0.1c0.8-0.1,1.7-0.2,2.5-0.4l0.1-0.1c0,0,0-0.1,0.1-0.1c0.2,0,0.4-0.1,0.6-0.1c1-0.1,1.9,0,1.9,0 c0.8,0.1,1.5,0.2,1.7,0.1c0.1-0.1,0.1-0.1-0.2-0.3c-0.2-0.2-0.6-0.4-1.3-0.6c-0.8-0.3-1.8-0.4-2.6-0.4s-1.4,0-1.4,0 c-0.2,0-0.5,0.1-0.8,0.1l-0.4,0.1h-0.2l-0.2,0.1c-2.1,0.1-4.1-0.3-5.9-1.4c-1.8-1.1-3.4-2.6-4.7-4.3c-2.6-3.4-4.2-7.6-4.6-11.8 c-0.6-8.6,3.8-17.3,10.9-22.2c7-5,16.5-6.7,24.7-4.1c1.5,0.5,3,1.1,4.4,1.9l0.1,0.1c2.3,1.3,4.3,3.1,5.6,5.3 c0.3,0.4,0.5,0.9,0.7,1.4c0.1,0.1,0.1,0.2,0.1,0.4l0.1,0.2V80c0,0.1,0.1,0.2,0.1,0.3l0.2,0.6c0,0,0.3,0.9,0.5,1.9 s0.2,1.9,0.2,1.8c0,0.8,0,1.5,0.1,1.7c0.1,0.1,0.1,0,0.3-0.2s0.3-0.7,0.4-1.3c0.2-0.8,0.2-1.8,0.2-2.6c-0.1-0.8-0.2-1.4-0.2-1.4 c-0.1-0.2-0.1-0.5-0.2-0.7c0-0.1-0.1-0.2-0.1-0.4l-0.1-0.2v-0.1l-0.1-0.3l-0.2-0.4c-1-2.2-2.5-4.1-4.3-5.6 c-0.8-0.7-1.7-1.3-2.6-1.8c0-0.1,0-0.1,0.1-0.2c0.3-0.7,0.7-1.6,1.1-2.3c0.4-0.7,0.6-1.2,0.6-1.2c0.1-0.2,0.2-0.4,0.3-0.6 l0.4-0.7c0.2-0.4,0.4-0.8,0.7-1.2c0.2-0.4,0.5-0.8,0.7-1.2c1-1.6,2.2-3.1,3.6-4.5c2.6-2.7,5.9-5,9.4-6.4 c0.7-0.3,1.5-0.6,2.2-0.8c0.2,0.4,0.4,0.9,0.6,1.3c0.1,0.1,0.1,0.3,0.2,0.4l0.1,0.2l0.1,0.1l0.2,0.3c0.1,0.2,0.3,0.4,0.4,0.6 c0,0,0.6,0.9,1.4,1.7s1.6,1.4,1.6,1.3c0.7,0.5,1.4,0.7,1.6,0.7c0.2-0.1-0.1-0.4-1.1-1.3c-0.5-0.6-1.1-1.3-1.5-1.9 c-0.4-0.6-0.7-1.1-0.7-1.1l-0.4-0.6l-0.2-0.3l-0.1-0.2v-0.1l-0.1-0.2l-0.2-0.4c-1.9-3.9-2.1-8.4-1.3-12.7s3-8.2,5.7-11.6 c2.8-3.4,6.2-6.2,10.1-8.2c3.9-2.1,8.1-3.3,12.5-3.6c4.4-0.2,8.8,0.5,12.8,2.3c4,1.7,7.6,4.5,10.1,8c0.1,0.4,0.3,0.6,0.4,0.6 l0,0c2.3,3.4,3.4,7.5,2.8,11.5c-0.1,0.8-0.3,1.5-0.6,2.3v0.1c0.3,0.9,1,0.7,1.3,0.5c0.1,0,0.1,0,0.1-0.1 c0.3-0.8,0.5-1.7,0.6-2.5c0.8-4.6-0.6-9.3-3.3-13c-0.2-0.3-0.4-0.5-0.6-0.8c0.2-0.6,0.4-1.3,0.6-1.8c0.3-0.7,0.5-1.1,0.5-1.1 c0.1-0.2,0.2-0.4,0.3-0.6l0.7-1.1c1.1-1.8,2.4-3.4,4-4.8c1.6-1.4,3.4-2.4,5.3-3.2c1.9-0.8,4-1.4,6.1-2c2.1-0.6,4.1-1.1,6.3-1.4 c2.1-0.3,4.2-0.6,6.4-0.7c2.1-0.1,4.3,0,6.4,0.2c4.2,0.5,8.4,1.5,12.2,3.4c3.9,1.8,7.3,4.3,10.2,7.5c1.4,1.6,2.7,3.3,3.8,5.1 c1.1,1.8,2,3.7,2.7,5.7s1.1,4.1,1.3,6.2c0,0.5,0.1,1,0.1,1.6v1.6c0,1-0.2,2-0.5,3c-0.2,0.5-0.4,1-0.6,1.5 c-0.8,1.6-1.4,3.3-1.5,5.2c-0.1,0.9,0,1.8,0.1,2.7l0.1,0.1c0.8,0.7,1.2,0,1.4-0.3v-0.1c-0.1-0.7-0.2-1.5-0.1-2.3 c0.1-1.3,0.5-2.7,1-3.9c0,0,0,0,0.1-0.1c0.1-0.2,0.2-0.5,0.3-0.8c0.5-1,1.1-1.9,1.9-2.7c1.8-2.1,4.2-3.7,6.8-4.7 c2.6-1,5.5-1.3,8.2-0.9c2.8,0.4,5.4,1.6,7.6,3.3c4.5,3.4,7.5,8.6,8.7,14.1c0.5,2.5,0.6,5.2,0,7.7c0,0,0,0,0,0.1 c0,0.2-0.1,0.4-0.1,0.5c-0.1,0.3-0.2,0.7-0.3,1l-0.1,0.4V64l-0.1,0.3c-0.1,0.2-0.2,0.4-0.3,0.6c0,0-0.4,0.9-0.9,1.8 c-0.5,0.8-1.1,1.6-1.1,1.5c-0.5,0.6-1,1.1-1,1.3c0,0.2,0.4,0.1,1.5-0.7c0.7-0.5,1.4-1.2,1.9-1.9s0.8-1.2,0.8-1.2l0.3-0.7 l0.1-0.3l0.1-0.2v-0.1l0.1-0.2l0.1-0.3c0.2-0.5,0.3-0.9,0.4-1.4c0.4-0.4,0.9-0.8,1.5-1c1.1-0.4,2.5-0.5,3.7-0.2 c1.3,0.2,2.5,0.7,3.6,1.3c2.2,1.3,4.1,3.4,5,5.8c1,2.4,1.1,5.2,0.6,7.8c-0.3,1.3-0.7,2.6-1.3,3.7c-0.4,0.8-0.4,0.8-0.5,1 s-0.2,0.4-0.4,0.6c0,0-0.5,0.8-1.2,1.5c-0.3,0.3-0.7,0.6-1,0.8c-0.2,0-0.4,0.1-0.5,0.1l-0.5,0.1c-0.1,0-0.2,0.1-0.4,0.1 l-0.7,0.2c0,0-1,0.4-2,0.9c-0.9,0.5-1.8,1.1-1.7,1.1c-0.7,0.5-1.1,1.1-1.2,1.3c0,0.2,0.4,0.1,1.6-0.5c0.7-0.3,1.6-0.7,2.3-0.9 c0.7-0.2,1.2-0.4,1.2-0.4l0.7-0.2c0.1,0,0.2-0.1,0.3-0.1l0.6-0.2c2.4-0.5,4.8-0.6,7.2-0.1c4.8,0.9,9,3.8,12,7.6s5,8.6,5,13.4 c0,2.4-0.6,4.8-1.7,6.9c-0.5,1.1-1.2,2.1-1.9,3.1c-0.7,1-1.5,1.5-2.6,1.9c-0.2,0.1-0.5,0.1-0.7,0.2l0,0c-0.5,0.1-1,0.2-1.6,0.3 l-0.1,0.1c-0.7,0.7-0.2,1.2,0.2,1.4h0.1c0.8-0.1,1.7-0.2,2.5-0.5l0,0c0.5-0.1,1.1-0.3,1.6-0.4c3-0.6,6.2-0.7,8.6,0.9 c2.5,1.6,4.2,4.3,5.1,7.1c0.9,2.9,1.1,6,0.4,8.9c-0.3,1.5-0.9,2.9-1.8,4.1c-0.1,0.2-0.2,0.3-0.3,0.4l-0.2,0.2l0,0 c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1-0.1,0.1c-0.1,0.2-0.3,0.3-0.5,0.5c0,0-0.6,0.7-1.5,1.2c-0.8,0.6-1.6,0.7-1.5,0.7 c-0.7,0.2-1.3,0-1.5,0C360.5,143.1,360.5,143.2,360.6,143.4L360.6,143.4z",
    fill: "#202020"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5cm2",
    d: "M278.5,78.5c-0.3-0.3-0.6-0.6-1-0.8c-0.2-0.1-0.4-0.2-0.6-0.3c0,0-0.3-0.1-0.5-0.2c0,0-0.1,0-0.1-0.1v-0.2 l0.1-0.3c0.2-0.9,0.4-1.7,0.5-2.6c0-0.4,0.1-0.9,0.1-1.2c0-0.3-0.2-0.4-0.5-0.4s-0.7,0.2-1,0.4s-0.7,0.4-1,0.6s-0.6,0.4-0.9,0.7 l-0.2,0.2c-0.4,0.3-0.7,0.6-0.7,0.6l0,0c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.3-0.1-0.5-0.2c0,0-0.4-0.1-0.8-0.2s-0.8-0.2-0.8-0.2 s-0.1,0-0.2-0.1h-0.1c-0.1,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.2-0.2-1.7,0c-0.3,0.1-0.4,0.2-0.5,0.4c-0.1,0.2,0,0.5,0.1,0.8 c0.2,0.7,0.6,1.3,1,1.9c0.1,0.2,0.2,0.3,0.4,0.5l0.4,0.4l0.1,0.1l-0.1,0.1l-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2l-0.1,0.1l-0.2,0.2 c-0.1,0.1-0.3,0.2-0.4,0.4c-0.6,0.5-1,1.2-1.3,2c-0.1,0.4-0.2,0.8,0,1c0.1,0.2,0.5,0.3,0.9,0.2c0.9-0.1,1.8-0.2,2.6-0.5l0.5-0.2 c0,0,0.1-0.1,0.2,0l0.1,0.2l0.2,0.3c0.1,0.2,0.2,0.4,0.4,0.6c0.2,0.4,0.5,0.8,0.8,1.1c0.3,0.4,0.6,0.7,0.9,1s0.7,0.5,0.9,0.4 c0.3-0.1,0.5-0.6,0.7-1s0.4-0.8,0.5-1.3c0.1-0.4,0.2-0.9,0.3-1.4v-0.4v-0.4c0,0,0-0.2,0-0.1h0.2h0.5h0.4 c0.9-0.1,1.9-0.2,2.7-0.5c0.2-0.1,0.2-0.1,0.2-0.2s-0.1-0.3-0.2-0.5C279.1,79.1,278.8,78.8,278.5,78.5L278.5,78.5z",
    fill: "#CDD6FF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M279.2,78.3c-0.3-0.4-0.7-0.7-1.1-1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1-0.1-0.2-0.1-0.3-0.2h-0.1l0.1-0.4 c0.1-0.2,0.1-0.4,0.2-0.7c0.1-0.4,0.2-0.9,0.2-1.4s0.1-0.9,0.1-1.3c0-0.2,0-0.5-0.2-0.8s-0.5-0.4-0.8-0.4c-0.5,0-1,0.2-1.3,0.4 c-0.4,0.2-0.7,0.4-1.1,0.6c-0.3,0.2-0.7,0.5-1,0.7c-0.1,0.1-0.2,0.2-0.3,0.2c-0.4,0.4-0.7,0.7-0.7,0.7v0.1l0,0 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.6-0.4-1.5-0.7-1.5-0.7s-0.1,0-0.2-0.1c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4-0.1-0.5-0.1 c-0.3,0-0.6-0.1-1-0.1s-0.8,0-1.1,0.2c-0.4,0.2-0.7,0.7-0.6,1.2c0,0.4,0.2,0.8,0.3,1.2c0.1,0.4,0.3,0.7,0.5,1.1 c0.2,0.3,0.4,0.7,0.7,1c0,0.1,0.1,0.1,0.1,0.1l0,0c0.1-0.1-0.2,0.1-0.4,0.2c-0.7,0.5-1.3,1.2-1.7,2.1c-0.2,0.4-0.4,0.8-0.4,1.4 c0,0.3,0,0.6,0.2,0.8s0.5,0.4,0.8,0.4c0.5,0.1,1,0,1.5-0.1s0.9-0.2,1.4-0.3c0.2-0.1,0.5-0.1,0.7-0.2l0,0l0.1,0.2 c0.2,0.4,0.5,0.8,0.8,1.2c0.3,0.4,0.6,0.8,1,1.1c0.4,0.3,0.7,0.8,1.3,0.9c0.3,0.1,0.7,0,0.9-0.2c0.2-0.2,0.4-0.4,0.5-0.7 c0.2-0.4,0.5-0.9,0.6-1.4c0.2-0.5,0.3-1,0.4-1.5c0-0.2,0.1-0.5,0.1-0.8l0,0h0.2c1,0,2-0.2,2.9-0.4c0.2-0.1,0.5-0.1,0.8-0.4 s0.2-0.8,0.1-1C279.8,79.1,279.5,78.7,279.2,78.3L279.2,78.3z M279.2,80.3c-0.8,0.2-1.8,0.4-2.7,0.5h-0.4h-0.5h-0.2 c-0.1,0,0,0.1,0,0.1v0.4v0.4c0,0.5-0.1,0.9-0.3,1.4c-0.1,0.4-0.3,0.9-0.5,1.3s-0.4,0.8-0.7,1c-0.2,0.1-0.6-0.1-0.9-0.4 s-0.6-0.7-0.9-1c-0.3-0.4-0.6-0.7-0.8-1.1c-0.1-0.2-0.2-0.4-0.4-0.6l-0.2-0.3l-0.1-0.2c0,0-0.1,0-0.2,0l-0.5,0.2 c-0.9,0.3-1.8,0.4-2.6,0.5c-0.4,0.1-0.8,0-0.9-0.2s-0.1-0.6,0-1c0.3-0.8,0.7-1.5,1.3-2c0.1-0.1,0.3-0.3,0.4-0.4l0.2-0.2l0.1-0.1 c0.1-0.1,0.2-0.1,0.3-0.2l0.3-0.2l0.1-0.1L269,78l-0.4-0.4c-0.2-0.2-0.2-0.3-0.4-0.5c-0.4-0.6-0.8-1.3-1-1.9 c-0.1-0.3-0.2-0.6-0.1-0.8s0.2-0.4,0.5-0.4c0.5-0.2,1.1,0,1.7,0c0.2,0,0.3,0.1,0.5,0.1h0.1c0.1,0,0.2,0.1,0.2,0.1 s0.4,0.1,0.8,0.2s0.8,0.2,0.8,0.2c0.3,0.1,0.4,0.1,0.5,0.2s0.2,0.1,0.4,0.1l0,0c0,0,0.3-0.3,0.7-0.6l0.2-0.2 c0.3-0.2,0.6-0.5,0.9-0.7s0.6-0.4,1-0.6s0.7-0.4,1-0.4c0.4,0,0.5,0.1,0.5,0.4c0,0.4,0,0.8-0.1,1.2c-0.1,0.9-0.2,1.7-0.5,2.6 l-0.1,0.3v0.2c0,0.1,0.1,0.1,0.1,0.1c0.2,0.1,0.5,0.2,0.5,0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.4,0.2,0.7,0.5,1,0.8s0.6,0.7,0.8,1.1 c0.1,0.2,0.2,0.4,0.2,0.5C279.4,80.1,279.4,80.2,279.2,80.3L279.2,80.3z",
    fill: "#202020"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5cm3",
    d: "M329.8,160.9c-0.3-0.4-0.7-0.8-1.1-1.1c-0.2-0.2-0.4-0.3-0.7-0.4c0,0-0.4-0.2-0.6-0.3l0.3-0.6 c0.4-1,0.7-2,0.9-3.1c0.1-0.5,0.2-1.1,0.2-1.5s-0.3-0.5-0.8-0.5c-0.4,0.1-0.9,0.3-1.3,0.4c-0.4,0.2-0.9,0.4-1.3,0.6 c-0.4,0.2-0.8,0.5-1.2,0.7l-0.2,0.2c-0.4,0.3-0.7,0.5-0.7,0.6l0,0c-0.1,0-0.3,0-0.4-0.2c-0.1-0.1-0.2-0.1-0.5-0.2 c0.1,0-1.5-0.6-1.5-0.6s-0.1,0-0.2-0.1h-0.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.6-0.2-1.4-0.4-2.1-0.4c-0.4,0-0.7,0.1-0.9,0.2 s-0.3,0.5-0.2,0.9c0.1,0.8,0.4,1.7,0.8,2.5c0.1,0.2,0.2,0.4,0.3,0.6c0.1,0.2,0.2,0.3,0.5,0.8l0.1,0.1c0,0,0.1,0.1,0,0.1 l-0.3,0.1c-0.1,0-0.3,0.1-0.3,0.1l-0.2,0.1c-0.2,0.1-0.4,0.2-0.6,0.4c-0.8,0.5-1.5,1.3-1.9,2.1c-0.2,0.4-0.4,0.9-0.4,1.3 c0,0.4,0.4,0.6,0.9,0.6c1,0.1,2.1,0,3.2-0.2l0.4-0.1l0.3-0.1c0.1,0,0.3-0.1,0.3,0.1l0.2,0.6l0.2,0.4c0.2,0.5,0.5,1,0.8,1.5 s0.6,0.9,1,1.4c0.3,0.4,0.8,0.8,1.1,0.8c0.4,0,0.7-0.5,1-1s0.6-1,0.8-1.5s0.4-1.1,0.5-1.6l0.1-0.4l0.1-0.3v-0.2v-0.1h0.1 l0.7,0.1h0.4c1.1,0.1,2.3,0,3.4-0.2c0.2-0.1,0.3-0.1,0.4-0.3c0-0.2,0-0.4-0.1-0.7C330.3,161.8,330.1,161.3,329.8,160.9 L329.8,160.9z",
    fill: "#FECECF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M330.5,160.9c-0.3-0.5-0.8-0.9-1.2-1.3c-0.2-0.2-0.5-0.4-0.7-0.5c-0.1-0.1-0.2-0.1-0.4-0.2c-0.1,0,0,0,0,0 l0.2-0.6l0.3-0.8c0.2-0.5,0.3-1.1,0.4-1.6s0.2-1.1,0.3-1.6c0-0.3,0-0.7-0.2-1s-0.6-0.4-0.9-0.4c-0.6,0-1.1,0.2-1.6,0.4 s-0.9,0.4-1.4,0.6c-0.4,0.2-0.9,0.5-1.2,0.7c-0.1,0.1-0.2,0.2-0.4,0.3c-0.5,0.3-0.8,0.6-0.8,0.6s0,0,0,0.1 c-0.1-0.1-0.1-0.1-0.3-0.2c-0.5-0.4-1.4-0.9-1.4-0.9s-0.1,0-0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1h-0.1c-0.2-0.1-0.4-0.1-0.5-0.2 c-0.4-0.1-0.8-0.2-1.2-0.3c-0.4-0.1-0.9-0.2-1.3-0.1c-0.5,0-1.1,0.3-1.3,0.8c-0.2,0.5-0.1,1.1,0,1.5c0.1,0.5,0.3,0.9,0.4,1.4 s0.4,0.9,0.7,1.4l0.2,0.3l0.1,0.2l0,0l-0.1,0.1c-1,0.5-1.8,1.2-2.5,2.1c-0.3,0.5-0.6,0.9-0.8,1.5c-0.1,0.3-0.1,0.6-0.1,1 c0.1,0.4,0.3,0.7,0.6,0.8c0.6,0.3,1.2,0.2,1.8,0.2c0.6,0,1.1-0.1,1.7-0.1c0.3,0,0.6-0.1,0.9-0.1l0.3-0.1l0,0 c0.2,0.5,0.5,1.1,0.8,1.6s0.6,1,1,1.5s0.7,1,1.3,1.3c0.3,0.2,0.8,0.2,1.1,0c0.3-0.2,0.6-0.4,0.8-0.7c0.4-0.5,0.7-1,1-1.6 s0.5-1.1,0.7-1.7c0.1-0.3,0.2-0.6,0.2-0.9v-0.1h0.2c1.2,0.1,2.4,0.1,3.6-0.1c0.3-0.1,0.6-0.1,1-0.4c0.4-0.3,0.3-0.8,0.2-1.1 C331.1,161.9,330.8,161.4,330.5,160.9L330.5,160.9z M330.4,163.3c-1.1,0.2-2.2,0.3-3.4,0.2h-0.4l-0.7-0.1h-0.1v0.1v0.2l-0.1,0.3 l-0.1,0.4c-0.1,0.6-0.3,1.1-0.5,1.6s-0.5,1-0.8,1.5s-0.7,0.9-1,1c-0.4,0.1-0.8-0.3-1.1-0.8c-0.4-0.4-0.7-0.9-1-1.4 s-0.6-1-0.8-1.5l-0.2-0.4l-0.2-0.6c0-0.2-0.2-0.1-0.3-0.1l-0.3,0.1l-0.4,0.1c-1.1,0.2-2.2,0.3-3.2,0.2c-0.5,0-0.9-0.2-0.9-0.6 c0-0.4,0.2-0.9,0.4-1.3c0.5-0.9,1.1-1.6,1.9-2.1c0.2-0.1,0.4-0.2,0.6-0.4l0.2-0.1c0,0,0.2-0.1,0.3-0.1l0.3-0.1 c0.1,0,0-0.1,0-0.1l-0.1-0.1c-0.4-0.5-0.4-0.5-0.5-0.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.8-0.7-1.7-0.8-2.5 c-0.1-0.4,0-0.7,0.2-0.9s0.6-0.3,0.9-0.2c0.7,0,1.5,0.3,2.1,0.4c0.2,0.1,0.4,0.1,0.5,0.2h0.1c0.1,0.1,0.2,0.1,0.2,0.1 s1.6,0.6,1.5,0.6c0.2,0.1,0.4,0.2,0.5,0.2c0.1,0.1,0.2,0.2,0.4,0.2l0,0c0,0,0.3-0.2,0.7-0.6l0.2-0.2c0.4-0.2,0.8-0.5,1.2-0.7 s0.8-0.4,1.3-0.6c0.5-0.2,0.9-0.4,1.3-0.4c0.5-0.1,0.8,0.1,0.8,0.5s-0.1,1-0.2,1.5c-0.2,1-0.5,2.1-0.9,3.1l-0.3,0.6 c0.2,0.1,0.6,0.3,0.6,0.3c0.2,0.1,0.5,0.3,0.7,0.4c0.4,0.3,0.8,0.7,1.1,1.1c0.3,0.4,0.6,0.9,0.8,1.4c0.1,0.2,0.2,0.5,0.1,0.7 C330.7,163.1,330.6,163.2,330.4,163.3L330.4,163.3z",
    fill: "#202020"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5cm4",
    d: "M153.4,104.5c-0.4-0.8-1.1-1.5-1.9-1.9l-0.2-0.1l-0.3-0.2c0-0.2,0.2-0.5,0.2-0.6c0.1-0.2,0.2-0.4,0.3-0.7 c0.2-0.4,0.3-0.9,0.4-1.4c1.2-2.8-1.9-1.1-3.3-0.3c-0.3,0.2-0.6,0.4-0.8,0.6l0,0c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.3-0.1-0.5-0.2 c0,0-0.3-0.2-0.7-0.3c-0.4-0.1-0.8-0.2-0.8-0.2l-0.3-0.1h-0.1l-0.3-0.1c-0.2-0.1-0.5-0.1-0.7-0.2c-0.4-0.1-0.9-0.1-1.2,0.1 s-0.2,0.6-0.1,1c0.1,0.4,0.3,0.9,0.5,1.3c0.1,0.2,0.2,0.4,0.4,0.6c0.1,0.1,0.1,0.1,0.3,0.4l0.2,0.3l0.1,0.2c0,0-0.1,0.1-0.2,0.1 l-0.4,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.1-0.4,0.2-0.6,0.4c-0.4,0.3-0.7,0.6-0.9,1s-0.5,0.8-0.5,1.2 c0,0.3,0.3,0.4,0.8,0.5c0.9,0,1.9,0,2.9-0.2l0.4-0.1h0.1v0.1l0.1,0.2l0.2,0.4c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.4,0.5,0.8,0.8,1.2 c0.3,0.4,0.6,0.8,0.9,1c0.3,0.2,0.6,0.1,0.9-0.3c0.6-0.7,1-1.6,1.2-2.5l0.1-0.3l0.1-0.6c0.2,0,0.6,0,0.6,0h0.4c0.5,0,1,0,1.4,0 c0.2,0,0.5,0,0.7-0.1c0.2,0,0.5-0.1,0.6-0.1c0.1-0.1,0.1-0.1,0.1-0.2C153.6,104.9,153.5,104.6,153.4,104.5L153.4,104.5z",
    fill: "#FFFFCD"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M151.9,102.1c-0.2-0.1-0.2-0.1-0.2-0.1l0,0l0.1-0.3l0.1-0.4c0.2-0.5,0.3-1,0.4-1.5 c0.1-0.2,0.1-0.5,0.1-0.8s0.1-0.5,0.1-0.8c0-0.4-0.4-0.7-0.7-0.8c-0.3-0.1-0.6,0-0.9,0c-1,0.3-1.9,0.7-2.8,1.3 c-0.3,0.2-0.6,0.4-0.9,0.6c0,0,0,0,0,0.1c0,0,0,0,0,0.1c-0.1-0.1-0.2-0.2-0.3-0.2c-0.5-0.4-1.4-0.8-1.4-0.8l-0.3-0.1h-0.1 l-0.4-0.1c-0.5-0.1-1-0.3-1.6-0.2c-0.3,0-0.6,0.1-0.9,0.3s-0.4,0.6-0.4,0.9c0,0.6,0.2,1.1,0.4,1.6s0.4,0.9,0.7,1.4l0.1,0.1l0,0 l-0.2,0.1c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.3-0.9,0.6-1.2,1c-0.4,0.4-0.6,0.9-0.8,1.4c-0.1,0.3-0.2,0.6-0.1,0.9 c0.1,0.4,0.4,0.6,0.7,0.7c0.6,0.2,1.1,0.1,1.6,0.1s1-0.1,1.5-0.1l0.4-0.1h0.1l0,0l0.1,0.2l0.2,0.3c0.2,0.5,0.5,0.9,0.8,1.3 s0.6,0.8,1,1.2c0.2,0.2,0.5,0.4,0.8,0.4s0.7-0.1,0.9-0.3c0.8-0.8,1.2-1.7,1.6-2.7c0.1-0.2,0.1-0.5,0.2-0.8l0,0h0.2 c0.5,0.1,1,0.1,1.5,0c0.5,0,1-0.1,1.5-0.1c0.1,0,0.3-0.1,0.5-0.2s0.3-0.3,0.3-0.5c0.1-0.4-0.1-0.7-0.2-0.9 C153.6,103.4,152.8,102.6,151.9,102.1L151.9,102.1z M153.5,105.3c-0.1,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.5,0.1-0.7,0.1 c-0.5,0-1,0-1.4,0h-0.4c-0.1,0-0.5-0.1-0.6,0l-0.1,0.6l-0.1,0.3c-0.2,0.9-0.7,1.8-1.2,2.5c-0.3,0.4-0.6,0.5-0.9,0.3 c-0.3-0.2-0.6-0.6-0.9-1c-0.3-0.4-0.6-0.8-0.8-1.2c-0.1-0.2-0.2-0.4-0.3-0.6l-0.2-0.4l-0.1-0.2v-0.1h-0.1l-0.4,0.1 c-1,0.2-1.9,0.2-2.9,0.2c-0.5,0-0.8-0.2-0.8-0.5s0.2-0.8,0.5-1.2c0.2-0.4,0.6-0.7,0.9-1c0.2-0.1,0.4-0.3,0.6-0.4 c0.1-0.1,0.2-0.1,0.3-0.2c0,0,0.1-0.1,0.3-0.1l0.4-0.1c0.1,0,0.1,0,0.2-0.1l-0.1-0.2l-0.2-0.3c-0.2-0.2-0.2-0.3-0.3-0.4 c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.4-0.4-0.9-0.5-1.3c-0.1-0.5-0.2-0.9,0.1-1c0.3-0.2,0.8-0.2,1.2-0.1c0.2,0.1,0.5,0.1,0.7,0.2 l0.3,0.1h0.1l0.3,0.1c0,0,0.4,0.1,0.8,0.2s0.8,0.3,0.7,0.3c0.3,0.1,0.4,0.2,0.5,0.2c0.1,0.1,0.2,0.2,0.3,0.1l0,0 c0.3-0.2,0.6-0.4,0.8-0.6c1.4-0.8,4.4-2.5,3.3,0.3c-0.1,0.5-0.2,0.9-0.4,1.4c-0.1,0.2-0.2,0.4-0.3,0.7c0,0.1-0.2,0.4-0.2,0.6 l0.3,0.2l0.2,0.1c0.8,0.4,1.5,1.1,1.9,1.9c0.1,0.2,0.2,0.4,0.2,0.6C153.6,105.3,153.6,105.3,153.5,105.3L153.5,105.3z",
    fill: "#202020"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M179,42.3c0,0,0,0.1-0.2,0.1c-0.5,0.2-1.3,0.4-2.3,0.4s-2.2-0.3-3.4-1.3c0,0-0.2-0.2-0.2-0.3s0.3-2,1.2-4.5 c0.9-2.6,2.8-5.8,5.2-8.4c2.5-2.6,5.6-4.6,8.1-5.6c1.2-0.5,2.3-0.9,3.1-1.1s1.2-0.3,1.2-0.3s1.2-0.1,2.8,0s3.5,0.5,5,1.1 c1.3,0.5,2,1,2.4,1.4s0.4,0.8,0.2,1c-0.4,0.5-1.6,0.8-3,1c0.1,0.1-1.5,0.2-3.1,0.6c-0.8,0.2-1.6,0.5-2.2,0.6 c-0.6,0.2-0.9,0.4-0.9,0.4s-0.3,0.1-0.9,0.2c-0.6,0.2-1.4,0.4-2.2,0.8c-1.8,0.8-4.1,2.2-5.9,4.2c-1.8,2-3.2,4.3-3.9,6.2 C179.2,40.8,179.1,42.2,179,42.3L179,42.3z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M232.9,24.5c-0.1,0.1-0.1,0.1-0.4,0.1c-0.7,0.1-1.8,0.2-2.8-0.3c-0.9-0.5-1.7-1.5-1.4-3.7 c0-0.1,0.1-0.4,0.2-0.5c2.7-2.7,5.8-4.9,9.2-6.5c5.3-2.6,11.4-3.9,17.3-3.5c2,0.1,4.1,0.4,6.1,0.8c0,0,2.5,0.6,5.6,1.9 c3.2,1.3,6.9,3.5,9.5,6c2.2,2,3.2,3.7,3.6,4.8c0.4,1,0.3,1.4-0.1,1.4s-1.1-0.6-2.1-1.2c-1-0.7-2.2-1.5-3.6-2.3 c0.1,0.1-0.6-0.3-1.9-1c-1.3-0.6-3.1-1.4-5-2s-3.9-1-5.4-1.3c-0.8-0.1-1.4-0.2-1.8-0.3c-0.4-0.1-0.7-0.1-0.7-0.1 c-1.5-0.2-3-0.4-4.6-0.5c-4.9-0.3-9.8,0.7-14.2,2.8C237.6,20.5,235.1,22.3,232.9,24.5L232.9,24.5z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M118.1,95.2c0,0.1,0,0.2-0.2,0.3c-0.5,0.6-1.3,1.3-2.3,1.6c-1,0.2-2.3,0.1-3.5-1.9c0-0.1-0.2-0.4-0.2-0.6 c0.2-2,0.6-3.9,1.2-5.7c0.6-1.8,1.4-3.6,2.4-5.3c2.2-3.6,5.2-6.7,8.8-8.9c1.9-1.1,3.9-2,6-2.6c0,0,0.7-0.1,1.8-0.3 c0.6-0.1,1.2-0.1,2-0.2c0.8,0,1.6-0.1,2.5,0c3.6,0.1,7.9,1.4,10.9,3.3c2.6,1.5,3.9,3,4.6,3.9c0.6,0.9,0.6,1.3,0.2,1.4 c-0.9,0.1-3.2-1.3-6.3-2.2c0.1,0.1-0.7-0.2-2.1-0.5c-1.4-0.3-3.3-0.6-5.2-0.6s-3.8,0.3-5.2,0.7c-0.7,0.2-1.2,0.4-1.6,0.5 c-0.4,0.2-0.6,0.2-0.6,0.2c-0.7,0.2-1.3,0.5-2,0.8c-0.6,0.3-1.3,0.6-1.9,1c-2.7,1.6-5,4-6.7,6.8c-0.8,1.3-1.4,2.7-1.9,4.1 C118.6,92.2,118.3,93.7,118.1,95.2L118.1,95.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M181.1,97.2c0.2,0,0.2,0,0.5,0.1c0.9,0.3,1.9,1.1,2.2,2.1s-0.2,2.2-1.3,3.7c0,0.1-0.2,0.3-0.3,0.3 c-2.6,0.4-5.2,1.9-7.2,3.9c-0.6,0.7-1.2,1.4-1.7,2.2c-0.8,1.3-1.4,2.8-1.6,4.2c0,0-0.1,0.4-0.2,1.2c-0.1,0.4-0.1,0.9-0.1,1.4 s0,1.2,0.1,1.8c0.2,1.3,0.6,2.8,1.2,4.3s1.6,2.8,2.6,4c1.8,1.9,3.3,2.8,4.1,3.5c0.9,0.6,1.1,1,0.7,1.2c-0.4,0.2-1.3,0.3-2.7-0.1 c-1.3-0.3-3-1-4.6-2.2c0.1,0.1-0.1,0-0.5-0.3s-0.9-0.7-1.5-1.3c-1.2-1.2-2.7-3.2-3.7-5.4c-1.1-2.2-1.5-4.8-1.6-6.8 c0-1,0-1.8,0.1-2.4s0.1-0.9,0.1-0.9c0.4-2,1.2-3.8,2.3-5.5c0.7-1.2,1.6-2.2,2.5-3.2C173.2,100,176.9,97.9,181.1,97.2L181.1,97.2z ",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M125.1,147.9c0.1,0.1,0.1,0.1,0.1,0.4c0.1,0.7,0.1,1.8-0.4,2.7s-1.4,1.8-3.7,1.4c-0.1,0-0.4-0.1-0.6-0.2 c-2.7-2.9-4.6-6.5-5.6-10.4v-0.2c-0.5-2.1-0.7-4.4-0.6-6.6c0,0,0-0.2,0.1-0.5c0-0.3,0.1-0.8,0.2-1.3c0.2-1.1,0.7-2.7,1.4-4.3 c0.7-1.7,1.8-3.4,3.1-4.9c1.3-1.6,2.8-2.9,4.3-3.8c2.5-1.7,4.5-2.2,5.6-2.4c1.1-0.1,1.5,0.1,1.3,0.5s-0.8,0.9-1.7,1.7 c-0.9,0.8-2,1.7-3.1,2.9c0.1-0.1-0.5,0.5-1.3,1.6c-0.9,1.1-1.9,2.7-2.6,4.4c-0.7,1.7-1.1,3.6-1.2,4.9c-0.1,0.7-0.1,1.2-0.1,1.6 c0,0.2,0,0.4,0,0.5s0,0.2,0,0.2c0,1.4,0.1,2.8,0.5,4.1v0.1C121.7,143.1,123.2,145.8,125.1,147.9L125.1,147.9z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M352.5,115.7c0,0.1-0.1,0.1-0.2,0.1c-0.6,0-1.4-0.2-2.2-0.7c-0.9-0.6-1.7-1.5-2.5-2.7c0,0-0.1-0.2-0.1-0.3 c0,0,0.2-0.3,0.5-0.7c0.3-0.4,0.6-1.1,0.9-1.9c0.6-1.6,1.1-4,0.7-6.3c-0.3-2.3-1.4-4.3-2.6-5.6c-0.6-0.7-1.1-1.2-1.5-1.5 s-0.6-0.5-0.6-0.5s-0.5-0.6-1.3-1.3c-0.8-0.8-1.9-1.6-3-2.3c-0.9-0.5-1.6-0.9-2-1.3c-0.4-0.3-0.5-0.7-0.4-1 c0.2-0.6,1.5-1.1,3.1-1.1c-0.1-0.1,1.8,0,3.7,0.6c1,0.3,1.9,0.7,2.6,1c0.7,0.4,1.1,0.6,1.1,0.6s0.3,0.3,0.9,0.7 c0.6,0.5,1.4,1.2,2.2,2.2c0.8,1,1.7,2.3,2.4,3.8s1.2,3.2,1.4,4.9c0.5,3.4-0.1,6.9-1.1,9.3c-0.5,1.2-1,2.2-1.4,2.9 C352.8,115.3,352.6,115.7,352.5,115.7L352.5,115.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M354.2,169.4c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.6-0.7-0.9-2.2c0,0,0.1-0.1,0.1-0.2c0.3-0.1,0.6-0.2,0.9-0.4 l0.8-0.4c0.6-0.3,1.1-0.7,1.6-1c3-2.2,5.2-5.4,6.4-8.9c0.3-0.7,0.4-1.4,0.6-2.1c0,0,0.1-0.2,0.1-0.6s0.2-0.9,0.3-1.5 c0.2-1.2,0.4-2.7,0.3-4c0-1.1-0.2-1.8-0.1-2.2c0-0.4,0.1-0.6,0.2-0.5s0.4,0.4,0.6,0.8c0.1,0.2,0.2,0.5,0.4,0.8 c0.1,0.3,0.2,0.6,0.3,1c0-0.1,0.1,0.3,0.2,0.9c0.1,0.6,0.3,1.5,0.2,2.4c0.1,1.8-0.2,3.6-0.2,3.6c-0.1,0.7-0.3,1.4-0.6,2 c-1.3,4-3.9,7.6-7.3,10.1c-0.6,0.4-1.2,0.9-1.9,1.2l-1,0.5C354.9,169.1,354.5,169.2,354.2,169.4L354.2,169.4z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M317.2,213.1c-0.1,0-0.1,0-0.2-0.2c-0.3-0.4-0.6-1.2-0.6-2.2s0.2-2.2,0.7-3.6c0-0.1,0.1-0.2,0.1-0.2 s0.3,0,0.8,0s1.2-0.1,2-0.3c1.6-0.3,3.7-1.1,5.4-2.4c1.7-1.3,3-3,3.7-4.5c0.7-1.4,1-2.5,1-2.5s0.4-0.6,0.8-1.6 c0.4-0.9,0.9-2.2,1.2-3.3c0.2-0.9,0.4-1.6,0.7-2.1s0.5-0.6,0.8-0.6c0.6,0.1,1.4,1,1.9,2.4c0.1-0.2,0.5,1.5,0.6,3.3 s-0.2,3.7-0.2,3.7s-0.1,0.4-0.3,1c-0.2,0.6-0.6,1.5-1.1,2.6c-1,2.1-3,4.6-5.5,6.5s-5.5,3-7.8,3.5 C319,213.1,317.3,213,317.2,213.1L317.2,213.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M296.4,48.6c0,0,0,0-0.2,0c-0.5,0-1.2-0.2-2.2-0.5s-2.1-0.8-3.1-1.8c0,0-0.2-0.2-0.2-0.3 c0,0,0.2-0.3,0.4-0.9c0.3-0.5,0.7-1.2,1.3-2c1.1-1.5,3-3.3,5.3-4.3c2.2-1.1,4.9-1.5,6.7-1.4c0.9,0,1.7,0.2,2.2,0.3 s0.8,0.2,0.8,0.2s0.8,0.3,1.6,1c0.9,0.6,1.9,1.6,2.4,2.6c0.5,0.8,0.7,1.4,0.7,1.8c0,0.4-0.2,0.7-0.5,0.9 c-0.5,0.3-1.4,0.2-2.2,0.1c0,0.1-0.9-0.2-1.8-0.3s-1.8-0.1-1.8-0.1s-0.2,0-0.5-0.1c-0.3,0-0.8-0.1-1.3-0.1 c-1.1,0-2.4,0.2-3.7,0.8c-1.3,0.6-2.4,1.6-3,2.5C296.7,47.9,296.4,48.6,296.4,48.6L296.4,48.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M143.6,100.1L143.6,100.1c-0.1-0.2-0.3-0.7,0.1-1.2c0,0,0,0,0.1-0.1c0,0,0.4,0,1,0.2s1.3,0.4,1.9,0.8 c0.2,0.1,0.3,0.2,0.5,0.3l0.1,0.1l0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.3,0.8-0.5,0.8-0.5s0.9-0.3,1.6-0.4c1.1-0.2,0.8,0.3,0.2,0.6 c0.1,0-1.3,0.9-1.2,0.9c0,0-0.3,0.2-0.7,0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.3l-0.1,0.1h-0.1l-0.2-0.2 c-0.1-0.1-0.2-0.2-0.4-0.3l-0.2-0.1l-0.1-0.1c-0.1-0.1-0.2-0.2-0.4-0.2c-0.5-0.3-1.1-0.5-1.6-0.6 C143.9,100.1,143.6,100.1,143.6,100.1L143.6,100.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M268.8,75.1L268.8,75.1c-0.3-0.2-0.7-0.8,0.1-1.2h0.1c0.7,0.1,1.4,0.3,2.1,0.6c0.4,0.2,0.9,0.4,1.2,0.7 l0.1,0.1l0,0l0,0c0.1-0.1,0.3-0.4,0.5-0.7c0.5-0.5,1.1-1.1,1.7-1.4c1-0.6,1.4-0.5,1.4-0.4c0,0.2-0.5,0.5-1,0.9 c0.1,0-0.5,0.5-1,1.1c-0.2,0.3-0.5,0.7-0.6,0.9c-0.3,0.5-0.5,1-0.5,0.9l-0.2,0.3l-0.7-0.5c-0.2-0.2-0.5-0.3-0.5-0.4 c-0.4-0.2-0.7-0.4-1.1-0.6C270.1,75.4,269.5,75.3,268.8,75.1L268.8,75.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M318.4,155.8L318.4,155.8c-0.3-0.3-0.6-0.8,0.2-1.2h0.1c0.7,0.2,1.4,0.4,2,0.7c0.5,0.2,1,0.4,1.4,0.7 c0.2,0.1,0.5,0.3,0.7,0.4l0,0l0.2-0.2l0.4-0.4c0,0,0.4-0.3,0.9-0.7s1.2-0.8,1.9-1.1c1-0.5,1.4-0.5,1.4-0.4c0,0.2-0.5,0.5-1,1 c0.1,0-0.6,0.5-1.2,1c-0.6,0.6-1.2,1.2-1.2,1.2l-0.4,0.3l-0.5,0.5c-0.3,0.7-0.8,0-1.2-0.2c-0.2-0.1-0.4-0.2-0.6-0.4 c-0.4-0.2-0.9-0.4-1.3-0.6C319.7,156.1,319,155.9,318.4,155.8L318.4,155.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M284.2,119.7c0.1-0.1,0.1-0.1,0.2-0.1c0.5-0.1,1.2-0.2,1.7,0.2c0.5,0.3,0.9,1,0.8,2.2c0,0,0,0.2-0.1,0.3 c-1.3,1.4-2.4,2.9-3.2,4.6c-1.4,2.9-2.2,6.1-2.1,9.3c0,1.1,0.1,2.1,0.3,3.1c0,0,0.1,1.3,0.5,3s1.2,3.9,2.1,5.6 c0.8,1.4,1.4,2.3,1.7,2.9c0.3,0.6,0.3,0.8,0,0.8c-0.5,0-2-1-3.5-2.7c0.1,0.2-1.6-1.8-2.8-4.3c-1.3-2.4-1.9-5.3-1.9-5.3 c-0.2-1.1-0.3-2.1-0.3-3.2c-0.1-3.8,0.8-7.6,2.5-11C281.3,123.2,282.6,121.4,284.2,119.7L284.2,119.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M299.3,219.8c0.1-0.1,0.1-0.1,0.2-0.1c0.9-0.2,2.8-0.1,2.5,2.4c0,0.1,0,0.2-0.1,0.3c-1.5,1.5-3,2.9-4.6,4.3 c-5.6,5-11.7,9.6-18.1,13.5c-3.2,2-6.5,3.8-9.9,5.5l-2.5,1.2l-2.6,1.2l-0.9,0.4c-0.3,0.1-0.6,0.2-0.9,0.4l-1.7,0.7 c0,0-0.3,0.1-0.9,0.3s-1.4,0.4-2.3,0.7c-1.9,0.6-4.3,1.1-6.2,1.5c-6.7,1.2-4.3-0.4-0.5-2c-0.2,0,2.1-0.9,4.4-1.9 c1.1-0.5,2.3-1,3.2-1.5c0.9-0.4,1.4-0.7,1.4-0.7l1.6-0.7l1.9-0.9c1.6-0.7,3.2-1.5,4.9-2.3c3.2-1.6,6.4-3.4,9.4-5.3 c6.1-3.8,11.9-8.1,17.2-12.9C296.3,222.6,297.8,221.3,299.3,219.8L299.3,219.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M142.6,184.6c0-0.1,0-0.1,0.1-0.2c0.6-0.8,2.1-1.8,3.5,0.3c0,0,0.1,0.2,0.1,0.3c-0.1,1-0.2,2-0.2,3 s-0.1,2-0.1,3c0,4.9,0.6,9.7,1.7,14.4c1.1,4.7,2.8,9.3,4.9,13.7c0.5,1,1.1,2,1.6,3c0,0,0.1,0.3,0.4,0.8c0.3,0.5,0.6,1.2,1.1,2.1 s1,1.8,1.5,2.7s1.1,1.9,1.6,2.7c0.1,0.2,0.2,0.3,0.3,0.5l-1.3,1.1c-3.1-4.9-1.2-3.8,1.5-1.2l-1.7,1.4c-0.2-0.2-0.3-0.3-0.5-0.5 c0.1,0.2-1.6-1.7-3.2-3.8c-0.8-1-1.5-2.1-2.1-3c-0.3-0.4-0.5-0.8-0.7-1s-0.2-0.4-0.2-0.4c-0.5-0.9-1-1.8-1.4-2.7 c-2.3-4.6-4-9.5-5.2-14.5s-1.8-10.1-1.8-15.3c0-1.1,0-2.1,0.1-3.2C142.4,186.8,142.5,185.7,142.6,184.6L142.6,184.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M143.1,166.8L143.1,166.8c0.6-0.2,2-0.3,3.6,0.2l0.1,0.1c0,0.1-0.5,7.2-0.5,7.2s-0.5,1.1-1.1,1.9 c-0.9,1.3-1.7,0.7-2.1-0.2c-0.1,0.1-0.6-2.1-0.6-2.1S143.1,166.9,143.1,166.8L143.1,166.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M174.8,293.4c0-0.1,0-0.1,0.2-0.2c0.8-0.6,2.5-1.2,3.3,1.2c0,0,0.1,0.2,0,0.3l-2.2,5.8l-3.7,9.8l-1.2,3.2 c0,0-2.4,5.2-4.3,8.7c-3.1,6-2.9,3.2-1.9-0.9c-0.2,0.4,2.9-9.6,2.9-9.6l1.1-2.8l3.7-9.8L174.8,293.4L174.8,293.4z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M147.6,334C147.6,334,147.5,334,147.6,334c-0.4-0.5-1.2-1.7-1.3-3.4c0,0,0-0.1,0-0.2c0,0,0.6-0.2,1.6-0.5 c0.9-0.2,2.2-0.5,3.4-0.5s2.5,0,3.4,0.2c0.9,0.1,1.5,0.3,1.5,0.3s0.4,0.2,0.8,0.5c0.5,0.3,1,0.8,1.4,1.2c1.3,1.5,0.2,1.9-0.8,1.9 c0,0.1-0.6,0-1.2,0c-0.3,0-0.6,0-0.8,0s-0.4,0-0.4,0s-0.5-0.1-1.2-0.2s-1.7-0.2-2.7-0.1c-1,0-1.9,0.2-2.6,0.4 S147.6,333.9,147.6,334L147.6,334z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M84.6,309.2L84.6,309.2c0.3,0.3,0.6,0.7,0.8,1.3c0.2,0.6,0.3,1.3,0.4,2.1c0,0,0,0.1,0,0.2 c0,0-0.4,0.1-0.9,0.4s-1.1,0.8-1.5,1.5s-0.7,1.5-0.9,2c-0.1,0.6-0.1,1-0.1,1s-0.1,0.2-0.2,0.6s-0.3,0.9-0.4,1.4 c-0.1,0.8-0.3,1.2-0.7,1.4c-0.3,0.1-0.9-0.1-1.3-0.6c0,0.1-0.5-0.5-0.7-1.3c-0.1-0.4-0.2-0.8-0.3-1.1c-0.1-0.3-0.1-0.5-0.1-0.5 s0-0.2,0-0.5s0.1-0.7,0.2-1.2c0.2-1,0.7-2.2,1.4-3.3c0.7-1.1,1.8-2,2.7-2.6C83.8,309.4,84.6,309.2,84.6,309.2L84.6,309.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M83.3,328L83.3,328c0.3,0.3,0.5,0.8,0.6,1.4s0.1,1.4,0.1,2.2v0.1c0,0-0.1,0-0.2,0s-0.3,0.1-0.4,0.2 c-0.3,0.2-0.8,0.5-1,1c-0.2,0.4-0.3,0.9-0.3,1.3c0.1,0.4,0.2,0.6,0.2,0.6s0,0.2-0.1,0.5c0,0.3,0,0.7,0.1,1.1 c0.2,0.6,0.2,1.1,0,1.4s-0.8,0.4-1.3,0.1c0,0.1-0.6-0.2-1.2-0.8c-0.6-0.5-1-1.2-1-1.2s-0.1-0.1-0.1-0.4c-0.1-0.3-0.2-0.7-0.2-1.1 c-0.1-1,0.1-2.4,0.8-3.5c0.7-1.1,1.7-2,2.6-2.4c0.4-0.2,0.8-0.4,1.1-0.4C83.1,328,83.3,328,83.3,328L83.3,328z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M87.5,345.1L87.5,345.1c0.3,0.2,0.6,0.6,0.8,1.2c0.2,0.5,0.4,1.3,0.8,2l0.1,0.1c0,0,0,0-0.1,0 s-0.2,0.2-0.2,0.4c0,0.2,0,0.5,0,0.7c0.1,0.2,0.1,0.2,0.1,0.2s-0.1,0.1-0.1,0.3c-0.1,0.2-0.1,0.4-0.2,0.8c0,0.5,0.1,0.9,0,1.2 c-0.1,0.3-0.5,0.6-1,0.5c0,0.1-0.5,0-1-0.3c-0.2-0.1-0.5-0.3-0.7-0.5c-0.2-0.1-0.3-0.2-0.3-0.2s-0.2-0.4-0.4-1 c-0.2-0.6-0.3-1.5-0.1-2.4c0.1-0.9,0.6-1.8,1.2-2.4c0.3-0.3,0.6-0.5,0.8-0.6C87.3,345.2,87.5,345.1,87.5,345.1L87.5,345.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M279.5,305.2c0-0.1,0-0.1,0-0.3c0.2-1,1.2-2.5,3.3-1.1c0,0,0.2,0.1,0.2,0.2l1.9,5.9l8.6,26.6l1.1,3.3 c0,0,1.4,5.5,2.1,9.5c1.3,6.7-0.3,4.4-2,0.5c0.1,0.4-3.8-9.3-3.8-9.3l-0.9-2.8l-8.6-26.6L279.5,305.2L279.5,305.2z",
    fill: "#FFFFFF"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: 13,
    className: "svggclothes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  }, /*#__PURE__*/React.createElement("g", null, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M253.7,272.4c0,0,0.1,0.1,0.3,0.2c0.2,0.1,0.6,0.3,1,0.4c0.8,0.2,1.6,0.3,1.9,0.3c0.2,0,0.3,0,0.5,0.1 c-0.1-0.1-0.1-0.2-0.2-0.2c-0.3-0.4-0.7-0.6-0.7-0.6s-0.3-0.3-0.7-0.5c-0.3-0.2-0.7-0.4-0.9-0.5h-0.1c-0.1,0-0.4-0.1-0.6,0 c-0.2,0-0.5,0.2-0.6,0.4c-0.1,0.2-0.1,0.3,0,0.4C253.5,272.3,253.7,272.4,253.7,272.4L253.7,272.4z",
    fill: "#AE0D35"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M269.2,268.6c0.1,0.1,0.1,0.1,0.1,0.2c0.4-0.4,1-0.7,1.6-1.1c0.3-0.1,0.8-0.4,1.8-0.7l0,0 c-0.3,0-0.5-0.1-0.7-0.2s-0.9-0.5-1.5-0.5c-0.3,0-0.6,0.1-0.8,0.1c-0.2,0.1-0.3,0.1-0.3,0.1s-0.1,0.1-0.3,0.2s-0.3,0.4-0.4,0.6 s0,0.5,0,0.7S269.1,268.5,269.2,268.6L269.2,268.6z",
    fill: "#AE0D35"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000070836207816142971090000016263521108083827897_",
    cx: 196.3705,
    cy: 1907.4794,
    r: 18.0743,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,263.2c-0.7-0.3-1.6-0.4-2.5-0.4 c-1,0-1.9,0-2.9-0.1c-0.7,0-1.4-0.1-2.1-0.1c0,0.2,0,0.5-0.1,0.7c-0.1,0.3-0.2,0.6-0.2,0.6s-0.1,0.3-0.2,0.6 c-0.1,0.3-0.3,0.6-0.4,0.8c-0.1,0.2-0.3,0.2-0.6,0.2c-0.1-0.3-0.1-0.5,0-0.6c0.1-0.2,0.6-1.2,0.5-1.2c0,0,0.2-0.9,0.2-1.2 c-0.9-0.1-1.9-0.2-2.8-0.3c-0.6-0.1-1.1-0.1-1.7-0.2c0.2,0.9,0.1,1.8-0.7,2.8c-0.1,0.2-0.4,0.5-1,0.9c-0.4,0.2-1,0.5-1.6,0.5 c-0.3,0-0.6,0-0.8,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1,0-0.1,0s-0.2,0-0.5-0.1c-0.1,0-0.3-0.1-0.5-0.1c-0.1,0-0.2-0.1-0.3-0.1 c0-0.1,0.1-0.1,0.2-0.2c0.1-0.2,0.3-0.3,0.5-0.5l0.4-0.4c0.2-0.2,0.4-0.4,0.5-0.5c0.7-0.6,1.2-1,1.4-1.1c0.9-0.6,1.6-0.9,2.4-1.1 c-3.1-0.4-6-1-8.7-1.7c-0.8-0.2-1.6-0.4-2.4-0.7c-0.4-0.1-0.8-0.2-1.1-0.4c-0.3-0.1-0.6-0.2-1-0.3c-0.2-0.1-0.5-0.2-0.7-0.2 c-0.4-0.1-0.8-0.3-1-0.4c-1.2-0.4-2-0.9-2.8-1.4c-1.1,0.7-1.9,1.3-3.2,2.1c-0.4,0.3-1.2,0.8-2,1.6l-0.2,0.1 c-0.1,0.1-0.1,0.1-0.2,0.2l-0.4,0.4c-0.3,0.3-0.6,0.6-0.8,0.9c-0.5,0.6-1,1.3-1.5,2.1c-0.9,1.5-1.6,3.2-1.9,4.9 c-0.7,3.5-0.1,7.4,1.6,10.6c0.8,1.6,1.9,3.1,3.2,4.2c0.6,0.6,1.3,1.1,2.1,1.3s1.5,0.3,2.3,0.2c1.6-0.2,3.1-0.9,4.6-1.3 c1.6-0.4,3.1-0.5,4.4-0.5c2.7,0,4.8,0.2,6.3,0c1.5-0.1,2.2-0.4,2.2-0.4s0.8-0.2,2.1-0.8s3.1-1.7,5-3.5s3.9-4.2,5.4-7.1 c0.8-1.5,1.5-3.1,1.9-4.8C217.2,265.9,218.1,263.7,216.6,263.2L216.6,263.2z M203.4,269.9c-0.3,0.1-0.8,0.3-1.8,0.5 c-1.8,0.4-4.3,0.5-6.3,0.6c-1,0.1-1.9,0.2-2.5,0.4c-0.6,0.1-1,0.2-1,0.2s-0.4,0.1-1.2,0.3c-0.7,0.2-1.7,0.5-2.8,0.9 c-2.2,0.8-4.8,1.5-6.4,1.7c-0.7,0.1-1,0.1-1.2,0.1c-1.2,0-1.9-0.2-2.9-0.7c1-0.1,1.7-0.1,2.9-0.1c0.2,0,0.5,0,1.2-0.1 c1.6-0.1,4.1-0.9,6.3-1.6c1.1-0.4,2.1-0.7,2.8-0.9s1.2-0.3,1.2-0.3s0.4-0.1,1-0.2s1.6-0.3,2.6-0.4c2.1-0.2,4.5-0.2,6.2-0.6 c0.9-0.2,1.4-0.4,1.6-0.5c1.1-0.5,1.6-0.7,2.6-1.2C205.1,268.8,204.5,269.4,203.4,269.9L203.4,269.9z",
    style: {},
    fill: "url(\"#SVGID_00000070836207816142971090000016263521108083827897_\")"
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M200.3,265c-0.2,0.2-0.4,0.4-0.6,0.6l0,0c0,0,0.1,0,0.2,0c0.2,0,0.4,0,0.6,0c0.5,0,1-0.3,1.3-0.4 c0.5-0.3,0.7-0.6,0.8-0.7c0.6-0.8,1-1.4,1.2-2.3l0,0c-0.7,0.6-1.2,1.1-2.1,1.7C201.4,264.1,201,264.4,200.3,265L200.3,265z",
    fill: "#AE0D35"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139294912103822560350000005262151493287669433_",
    cx: 270.5677,
    cy: 1912.2991,
    r: 22.7578,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M297,275c0,0-0.2-1.2-0.9-3 c-0.7-1.8-2.1-4-3.9-6.1c-0.9-1-1.9-2.1-2.8-3c-0.5-0.4-1-0.7-1.6-1c-0.6-0.2-1.1-0.3-1.7-0.4s-1.2,0-1.7,0c-0.3,0-0.5,0-0.7,0 c-0.5,0-0.8,0-1.1,0c-1,0-1.9-0.2-2.5-0.7c-0.8-0.3-1.6-0.6-2.7-1.1c-0.4-0.2-1.3-0.6-2.4-0.9c-2.5-0.8-5.8-1.2-8.6-0.4 c-2.9,0.7-5.1,2.7-6.7,4.1c-1.6,1.5-2.9,2.3-2.9,2.3s-0.3,0.2-0.9,0.5s-1.5,0.8-2.5,1.1c-1.1,0.3-2.4,0.6-3.7,1 c-1.3,0.4-2.6,1-3.6,2s-1.6,2.4-1.9,3.9c-0.3,1.4-0.2,2.9,0.1,4.1c0.1,0.6,0.4,1.3,0.5,1.8c0.1,0.2,0.2,0.5,0.3,0.7 c0.2,0.4,0.3,0.7,0.4,0.9c0.3,0.6,0.5,1.1,0.8,1.5c0.3,0.3,0.6,0.6,0.9,0.9c0.2,0.1,0.4,0.4,0.8,0.6c0.2,0.1,0.4,0.2,0.6,0.4 c0.4,0.2,0.9,0.5,1.4,0.7c2.1,0.8,4.9,1.3,7.4,2.2c2.5,0.8,4.9,1.8,6.6,2.5s2.9,1.1,2.9,1.1s0.7,0.3,1.8,0.7 c1.1,0.4,2.6,1,4.4,1.5s3.7,0.9,5.6,1.1s3.8,0.2,5.4,0c0.7-0.1,1.3-0.2,1.7-0.3c1-0.4,1.8-0.7,2.9-1.2c0.4-0.2,1.2-0.6,2.1-1.4 c1.8-1.5,3.3-3.9,4.4-6.4c0.5-1.2,1-2.5,1.4-3.7c0.2-0.4,0.2-0.8,0.3-1.2c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4,0.3-0.8,0.5-0.8,0.5 s-0.4,0.2-0.9,0.5c-0.5,0.2-1,0.5-1.2,0.5c-0.3,0.1-0.6,0-0.9-0.1c0.2-0.3,0.3-0.5,0.6-0.6c0.2-0.1,0.7-0.3,1.1-0.5 s0.8-0.5,0.8-0.5s0.4-0.2,0.8-0.5s0.8-0.6,0.9-0.8c0,0,0.1-0.1,0.2-0.1c0-0.3,0.1-0.5,0.1-0.8c0.1-0.9,0-1.7,0-2.2 C297,275.3,297,275,297,275L297,275z M252.4,271.1c0.3-0.5,0.9-0.9,1.4-1s0.9,0,1,0s0.2,0,0.3,0.1c0.2,0.1,0.7,0.4,1.1,0.7 c0.5,0.3,0.8,0.6,0.8,0.6s0.4,0.3,0.8,0.7c0.4,0.4,0.7,0.9,0.9,1c0.2,0.3,0.1,0.6,0,1c-0.4,0-0.7-0.1-0.9-0.3 c-0.3,0.2-0.6,0.4-1.1,0.4c-0.3,0-1.4-0.1-2.2-0.4c-0.5-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.5-0.3-0.5-0.3s-0.2-0.1-0.5-0.5 c-0.1-0.2-0.2-0.4-0.3-0.8C252.2,271.8,252.2,271.4,252.4,271.1L252.4,271.1z M256.6,277.3c-0.3,0-0.9,0-1.8-0.2 c-0.6-0.1-1.4-0.2-2.1-0.4s-1.2-0.3-1.2-0.3s-0.6-0.2-1.4-0.4c-0.8-0.2-1.6-0.6-2.1-1c-0.6-0.4-0.9-0.7-1-0.9 c-0.8-1-0.9-2-0.5-2.9c0,0.5,0.1,0.9,0.3,1.3c0.2,0.4,0.4,0.7,0.7,1.1c0.1,0.1,0.3,0.4,0.8,0.7c0.4,0.3,1.2,0.6,1.9,0.9 s1.3,0.4,1.3,0.4s0.5,0.1,1.2,0.3s1.5,0.3,2,0.4c0.9,0.1,1.5,0.2,1.7,0.2c1.2,0.1,1.8,0.2,2.9,0.4 C258.5,277.3,257.8,277.4,256.6,277.3L256.6,277.3z M281.1,264.9c0.2-0.1,0.9-0.2,1.6-0.3c0.6-0.1,1.2,0,1.2,0s0.6,0,1.2,0.1 s1.3,0.3,1.5,0.3c0.4,0.1,0.6,0.4,0.8,0.9c-0.5,0.2-0.7,0.3-1.1,0.2c-0.2-0.1-0.8-0.2-1.4-0.3c-0.6-0.1-1.1-0.1-1.1-0.1 s-0.5,0-1.1,0s-1.2,0.2-1.4,0.2c-0.4,0.1-0.6,0-1.1-0.3C280.6,265.3,280.7,265,281.1,264.9L281.1,264.9z M267.8,267.1 c0.1-0.5,0.5-0.9,0.7-1.1c0.3-0.2,0.4-0.3,0.4-0.3s0.7-0.5,1.7-0.5s1.8,0.5,2.1,0.6c0.4,0.3,0.6,0.6,0.6,1.1c0.1,0,0.1,0,0.2,0 c0.3,0,0.5-0.1,0.5-0.1s0.7-0.1,1.1-0.1c1.5-0.1,2.3,0.1,2.8,0.2c1.9,0.4,2.8,1,3.9,2.1c-1.5-0.5-2.4-0.6-4.1-1 c-0.4-0.1-1.2-0.2-2.5-0.1c-0.4,0-1,0.1-1,0.1s-0.8,0.1-1.1,0.2c-0.9,0.3-1.4,0.5-1.6,0.6c-1.5,0.8-2.4,1.2-3.7,2 c0.3-0.4,0.5-0.8,0.8-1.2c-0.1,0-0.1-0.1-0.2-0.2C268.1,269.2,267.4,268.2,267.8,267.1L267.8,267.1z M285.4,284 c-0.3,0.1-0.9,0.1-1.8,0.2c-1.4,0.1-3.4,0.2-5.1,0.1c-0.8,0-1.5-0.1-2.1-0.2c-0.5-0.1-0.8-0.1-0.8-0.1s-1.5-0.2-3.3-0.6 s-3.9-1.1-5.1-1.6c-0.6-0.3-1-0.4-1.1-0.5c-1.1-0.5-1.6-1-2.4-1.7c1,0.3,1.6,0.5,2.7,1c0.2,0.1,0.5,0.2,1.1,0.5 c1.2,0.5,3.2,1.2,5,1.6s3.3,0.6,3.3,0.6s0.3,0,0.8,0.1s1.2,0.1,2,0.2c1.6,0.1,3.5,0,4.9-0.1c0.9-0.1,1.5-0.2,1.7-0.2 c1.2-0.2,1.9-0.2,2.9-0.2C287.2,283.5,286.6,283.8,285.4,284L285.4,284z M295.5,272.3c-0.4,0-0.6,0.1-0.7,0 c0-0.1-0.2-0.2-0.4-0.4c-0.2-0.1-0.4-0.2-0.4-0.2s-0.2-0.1-0.4-0.1c-0.2-0.1-0.4-0.1-0.5-0.1c0,0.1,0,0.1,0,0.2 c-0.1,0.6-0.3,1.2-0.4,1.4c-0.1,0.4-0.5,0.5-0.9,0.6c-0.2-0.5-0.3-0.7-0.2-1c0.1-0.2,0.2-0.6,0.3-1.1c0.1-0.5,0-0.9,0-0.9 s0-0.4-0.1-0.9s-0.3-1-0.4-1.1c-0.1-0.3,0-0.5,0.1-1c0.5,0,0.8,0.1,1,0.5c0.1,0.2,0.3,0.8,0.5,1.4c0.1,0.3,0.1,0.6,0.1,0.9l0,0 c0.1,0,0.5,0,0.8,0.1s0.6,0.2,0.6,0.2s0.3,0.1,0.5,0.3c0.3,0.2,0.5,0.5,0.6,0.6C295.8,271.7,295.7,272,295.5,272.3L295.5,272.3z",
    style: {},
    fill: "url(\"#SVGID_00000139294912103822560350000005262151493287669433_\")"
  }), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M298.2,274.8c0,0-0.2-1.3-1-3.2c-0.8-1.9-2.2-4.2-4-6.4c-0.9-1.1-1.9-2.1-3-3.1c-0.6-0.5-1.2-0.9-1.9-1.2 c-0.7-0.2-1.4-0.4-2-0.5s-1.3,0-1.8,0c-0.3,0-0.5,0-0.7,0c-0.4,0-0.8,0-1,0c-0.9,0-1.5-0.1-2.1-0.2c-0.2,0-0.3-0.1-0.5-0.1 c-0.6-0.5-1.2-0.9-2.2-1.3c-0.5-0.2-1.4-0.6-2.5-1c-2.6-0.9-6.1-1.3-9.3-0.5c-1.6,0.4-3,1.1-4.2,2c-1.2,0.8-2.2,1.7-3,2.4 c-1.6,1.5-2.8,2.2-2.8,2.2s-0.3,0.2-0.8,0.5s-1.3,0.7-2.3,1s-2.3,0.6-3.7,1c-1.4,0.4-3,1.1-4.1,2.3c-1.2,1.2-1.9,2.8-2.2,4.4 c-0.3,1.6-0.2,3.2,0.1,4.6c0.1,0.7,0.4,1.4,0.6,1.9c0.1,0.3,0.2,0.5,0.3,0.7c0.2,0.4,0.4,0.8,0.5,1c0.2,0.4,0.5,0.8,0.7,1.1 c0.3,0.6,0.7,1.1,1.3,1.7c0.2,0.2,0.5,0.4,0.9,0.7c0.2,0.1,0.4,0.3,0.7,0.4c0.4,0.2,1,0.5,1.6,0.7c2.3,0.9,5,1.3,7.5,2.2 c2.5,0.8,4.8,1.8,6.6,2.5s2.9,1.1,2.9,1.1s0.7,0.3,1.8,0.7c1.1,0.4,2.7,1,4.5,1.5s3.8,1,5.8,1.2s4,0.2,5.6,0 c1.4-0.2,2.3-0.4,2.7-0.5c1.5-0.4,2.3-0.9,3.2-1.6c0.4-0.3,0.9-0.6,1.4-1c1-0.8,1.9-1.9,2.7-3.1c0.8-1.2,1.5-2.5,2-3.8 c0.6-1.3,1-2.6,1.5-3.8c0.2-0.6,0.3-1.2,0.5-1.8c0.1-0.6,0.2-1.1,0.2-1.6c0.1-1,0-1.9-0.1-2.5 C298.2,275.2,298.2,274.8,298.2,274.8L298.2,274.8z M297.2,278.1c0,0.3,0,0.5-0.1,0.8c0,0-0.1,0.1-0.2,0.1 c-0.1,0.1-0.5,0.5-0.9,0.8s-0.8,0.5-0.8,0.5s-0.4,0.2-0.8,0.5s-0.9,0.4-1.1,0.5c-0.3,0.1-0.4,0.3-0.6,0.6 c0.3,0.1,0.6,0.2,0.9,0.1c0.2-0.1,0.7-0.3,1.2-0.5s0.9-0.5,0.9-0.5s0.4-0.2,0.8-0.5c0.1-0.1,0.3-0.2,0.4-0.3 c-0.1,0.4-0.2,0.8-0.3,1.2c-0.4,1.2-0.9,2.5-1.4,3.7c-1.1,2.5-2.6,5-4.4,6.4c-0.9,0.8-1.7,1.2-2.1,1.4c-1.2,0.5-2,0.9-2.9,1.2 c-0.4,0.1-1,0.2-1.7,0.3c-1.5,0.2-3.4,0.2-5.4,0c-1.9-0.2-3.9-0.6-5.6-1.1s-3.3-1.1-4.4-1.5s-1.8-0.7-1.8-0.7s-1.1-0.5-2.9-1.1 c-1.7-0.7-4.1-1.7-6.6-2.5c-2.5-0.9-5.4-1.4-7.4-2.2c-0.5-0.2-1-0.5-1.4-0.7c-0.2-0.1-0.4-0.2-0.6-0.4c-0.4-0.2-0.6-0.5-0.8-0.6 c-0.4-0.3-0.7-0.6-0.9-0.9c-0.2-0.5-0.5-1-0.8-1.5c-0.1-0.2-0.3-0.5-0.4-0.9c-0.1-0.2-0.2-0.4-0.3-0.7c-0.2-0.5-0.4-1.1-0.5-1.8 c-0.3-1.3-0.4-2.7-0.1-4.1s0.9-2.8,1.9-3.9c1-1,2.3-1.6,3.6-2c1.3-0.4,2.6-0.6,3.7-1c1.1-0.3,2-0.7,2.5-1.1 c0.6-0.3,0.9-0.5,0.9-0.5s1.2-0.8,2.9-2.3c1.6-1.5,3.8-3.5,6.7-4.1c2.9-0.8,6.2-0.4,8.6,0.4c1.1,0.4,2,0.7,2.4,0.9 c1.1,0.5,1.9,0.8,2.7,1.1c0.7,0.4,1.5,0.6,2.5,0.7c0.3,0,0.6,0,1.1,0c0.2,0,0.5,0,0.7,0c0.5,0,1.1,0,1.7,0s1.1,0.2,1.7,0.4 c0.5,0.2,1.1,0.5,1.6,1c1,0.9,2,1.9,2.8,3c1.8,2.1,3.2,4.3,3.9,6.1c0.7,1.8,0.9,3,0.9,3s0,0.3,0.1,0.8 C297.2,276.4,297.3,277.2,297.2,278.1L297.2,278.1z",
    fill: "#202020"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M268.6,269.6c-0.3,0.4-0.5,0.8-0.8,1.2c1.3-0.8,2.2-1.2,3.7-2c0.3-0.1,0.7-0.3,1.6-0.6 c0.3-0.1,1.1-0.2,1.1-0.2s0.6-0.1,1-0.1c1.3-0.1,2.1,0.1,2.5,0.1c1.7,0.3,2.6,0.5,4.1,1c-1.1-1.1-2-1.8-3.9-2.1 c-0.5-0.1-1.4-0.2-2.8-0.2c-0.4,0-1.1,0.1-1.1,0.1s-0.2,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.1-0.5-0.2-0.8-0.6-1.1 c-0.2-0.2-1.1-0.6-2.1-0.6s-1.7,0.5-1.7,0.5s-0.2,0.1-0.4,0.3c-0.2,0.2-0.6,0.6-0.7,1.1c-0.3,1,0.3,2.1,0.6,2.3 C268.5,269.5,268.5,269.5,268.6,269.6L268.6,269.6z M268.9,267.4c0.1-0.2,0.2-0.5,0.4-0.6c0.1-0.1,0.3-0.2,0.3-0.2 s0.1-0.1,0.3-0.1c0.2-0.1,0.5-0.1,0.8-0.1c0.6,0,1.3,0.3,1.5,0.5c0.2,0.1,0.5,0.2,0.7,0.2l0,0c-1,0.3-1.5,0.5-1.8,0.7 c-0.7,0.3-1.2,0.7-1.6,1.1c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.2-0.2-0.3-0.4C268.9,267.9,268.8,267.6,268.9,267.4L268.9,267.4z",
    fill: "#202020"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M295.1,271c-0.3-0.2-0.5-0.3-0.5-0.3s-0.3-0.1-0.6-0.2c-0.3-0.1-0.7-0.1-0.8-0.1l0,0c0-0.2,0-0.5-0.1-0.9 c-0.1-0.6-0.4-1.2-0.5-1.4c-0.2-0.4-0.5-0.5-1-0.5c-0.1,0.5-0.2,0.7-0.1,1c0.1,0.2,0.3,0.6,0.4,1.1s0.1,0.9,0.1,0.9s0,0.4,0,0.9 c-0.1,0.5-0.2,1-0.3,1.1c-0.1,0.3,0,0.5,0.2,1c0.5-0.1,0.8-0.2,0.9-0.6c0.1-0.2,0.3-0.8,0.4-1.4c0-0.1,0-0.1,0-0.2 c0.1,0,0.3,0,0.5,0.1s0.4,0.1,0.4,0.1s0.2,0.1,0.4,0.2c0.2,0.1,0.3,0.3,0.4,0.4s0.3,0,0.7,0c0.2-0.3,0.3-0.5,0.2-0.7 C295.6,271.4,295.4,271.2,295.1,271L295.1,271z",
    fill: "#202020"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M281.4,266c0.2,0,0.8-0.2,1.4-0.2c0.6-0.1,1.1,0,1.1,0s0.5,0,1.1,0.1s1.2,0.2,1.4,0.3 c0.4,0.1,0.6,0,1.1-0.2c-0.2-0.5-0.4-0.8-0.8-0.9c-0.2-0.1-0.9-0.2-1.5-0.3c-0.6-0.1-1.2-0.1-1.2-0.1s-0.6,0-1.2,0 c-0.6,0.1-1.3,0.2-1.6,0.3c-0.4,0.1-0.6,0.4-0.8,0.9C280.8,266,281,266.1,281.4,266L281.4,266z",
    fill: "#202020"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M252.9,273.3c0,0,0.2,0.2,0.5,0.3c0.3,0.2,0.7,0.3,1.1,0.5c0.9,0.3,1.9,0.4,2.2,0.4c0.5,0,0.8-0.1,1.1-0.4 c0.2,0.2,0.4,0.2,0.9,0.3c0.2-0.4,0.2-0.7,0-1c-0.1-0.2-0.5-0.6-0.9-1s-0.8-0.7-0.8-0.7s-0.4-0.3-0.8-0.6s-1-0.6-1.1-0.7 c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.5-0.1-1,0s-1.1,0.4-1.4,1c-0.2,0.3-0.2,0.6-0.2,0.9s0.1,0.6,0.3,0.8 C252.7,273.2,252.9,273.3,252.9,273.3L252.9,273.3z M253.4,271.7c0.1-0.2,0.4-0.4,0.6-0.4s0.5,0,0.6,0h0.1 c0.2,0.1,0.6,0.3,0.9,0.5c0.4,0.3,0.7,0.5,0.7,0.5s0.3,0.3,0.7,0.6c0.1,0.1,0.1,0.1,0.2,0.2c-0.1,0-0.3-0.1-0.5-0.1 c-0.3,0-1.1-0.1-1.9-0.3c-0.4-0.1-0.7-0.3-1-0.4c-0.2-0.1-0.3-0.2-0.3-0.2s-0.1-0.1-0.2-0.2C253.3,272,253.3,271.9,253.4,271.7 L253.4,271.7z",
    fill: "#202020"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M217.2,262.2c-1.1-0.5-2.1-0.5-3.1-0.5c-0.9,0-1.9,0-2.8-0.1c-1.9-0.1-3.8-0.2-5.6-0.4 c-3.7-0.4-7.2-1.1-10.4-2c-0.8-0.2-1.6-0.4-2.3-0.7c-0.4-0.1-0.8-0.2-1.1-0.3c-0.3-0.1-0.6-0.2-1-0.3c-0.2-0.1-0.5-0.2-0.7-0.2 c-0.4-0.1-0.8-0.3-1-0.4c-1.7-0.6-2.7-0.8-4.2-1c0.3,0.2,0.5,0.4,0.8,0.6c-1.2,0.1-2.2,0.5-3.6,1.3c-0.4,0.3-1.3,0.8-2.2,1.7 l-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2l-0.5,0.5c-0.3,0.3-0.6,0.7-0.9,1c-0.6,0.7-1.1,1.4-1.6,2.2c-1,1.6-1.7,3.4-2.1,5.3 c-0.8,3.8-0.1,8,1.7,11.4c0.9,1.7,2.1,3.3,3.5,4.6c0.7,0.6,1.5,1.2,2.4,1.6s1.9,0.4,2.9,0.3c1.8-0.3,3.3-1,4.8-1.3 c1.4-0.3,2.8-0.4,4.1-0.4c2.6,0,4.8,0.2,6.4,0c1.6-0.1,2.4-0.4,2.4-0.4s0.2,0,0.6-0.2c0.4-0.1,1-0.3,1.7-0.7 c1.4-0.6,3.4-1.9,5.3-3.8c1.9-1.9,4-4.4,5.6-7.4c0.8-1.5,1.5-3.2,2-5c0.2-0.9,0.5-1.8,0.6-2.8c0.1-0.5,0.1-1.1-0.2-1.7 C218.2,262.9,217.7,262.4,217.2,262.2L217.2,262.2z M203.8,262.1c-0.2,0.9-0.6,1.5-1.2,2.3c-0.1,0.1-0.3,0.4-0.8,0.7 c-0.3,0.2-0.8,0.4-1.3,0.4c-0.2,0-0.5,0-0.6,0s-0.2,0-0.2,0l0,0c0.2-0.2,0.5-0.4,0.6-0.6c0.7-0.6,1.1-0.9,1.4-1.1 C202.5,263.2,203,262.7,203.8,262.1C203.7,262.1,203.8,262.1,203.8,262.1L203.8,262.1z M216.9,267.6c-0.5,1.7-1.1,3.3-1.9,4.8 c-1.6,2.9-3.6,5.3-5.4,7.1c-1.9,1.8-3.7,3-5,3.5c-1.3,0.6-2.1,0.8-2.1,0.8s-0.8,0.2-2.2,0.4c-1.5,0.1-3.6,0-6.3,0 c-1.4,0-2.9,0.1-4.4,0.5c-1.6,0.4-3.1,1.1-4.6,1.3c-0.8,0.1-1.6,0.1-2.3-0.2s-1.4-0.8-2.1-1.3c-1.3-1.2-2.4-2.6-3.2-4.2 c-1.7-3.2-2.3-7.1-1.6-10.6c0.4-1.8,1-3.4,1.9-4.9c0.4-0.8,0.9-1.4,1.5-2.1c0.3-0.3,0.5-0.6,0.8-0.9l0.4-0.4 c0.1-0.1,0.1-0.1,0.2-0.2l0.2-0.1c0.8-0.8,1.6-1.3,2-1.6c1.3-0.9,2.1-1.4,3.2-2.1c0.8,0.5,1.6,1,2.8,1.4c0.2,0.1,0.6,0.2,1,0.4 c0.2,0.1,0.4,0.1,0.7,0.2s0.6,0.2,1,0.3c0.4,0.1,0.8,0.2,1.1,0.4c0.8,0.2,1.6,0.5,2.4,0.7c2.7,0.7,5.6,1.3,8.7,1.7 c-0.9,0.2-1.5,0.5-2.4,1.1c-0.2,0.2-0.7,0.5-1.4,1.1c-0.2,0.1-0.3,0.3-0.5,0.5l-0.4,0.4c-0.2,0.2-0.3,0.3-0.5,0.5 c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.3,0.1,0.5,0.1c0.3,0.1,0.5,0.1,0.5,0.1h0.1c0.1,0,0.1,0,0.2,0 c0.2,0,0.5,0,0.8,0c0.6-0.1,1.2-0.3,1.6-0.5c0.6-0.4,0.9-0.7,1-0.9c0.8-1,0.9-1.9,0.7-2.8c0.6,0.1,1.1,0.2,1.7,0.2 c0.9,0.1,1.9,0.2,2.8,0.3c0,0.3-0.2,1.2-0.2,1.2s-0.4,1-0.5,1.2s-0.1,0.3,0,0.6c0.3,0,0.5,0,0.6-0.2c0.1-0.1,0.3-0.4,0.4-0.8 c0.1-0.3,0.2-0.6,0.2-0.6s0.1-0.3,0.2-0.6c0.1-0.3,0.1-0.6,0.1-0.7c0.7,0,1.4,0.1,2.1,0.1c1,0,1.9,0,2.9,0.1c0.9,0,1.9,0,2.5,0.4 C218,263.8,217.2,266,216.9,267.6L216.9,267.6z",
    fill: "#202020"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M201.4,269.7c-1.7,0.4-4.1,0.4-6.2,0.6c-1,0.1-1.9,0.3-2.6,0.4c-0.6,0.1-1,0.2-1,0.2s-0.5,0.1-1.2,0.3 c-0.7,0.2-1.7,0.5-2.8,0.9c-2.2,0.8-4.7,1.5-6.3,1.6c-0.7,0.1-1,0.1-1.2,0.1c-1.2,0-1.8,0-2.9,0.1c0.9,0.4,1.6,0.7,2.9,0.7 c0.2,0,0.6,0,1.2-0.1c1.6-0.1,4.3-0.9,6.4-1.7c1.1-0.4,2.1-0.7,2.8-0.9c0.7-0.2,1.2-0.3,1.2-0.3s0.4-0.1,1-0.2s1.5-0.3,2.5-0.4 c2-0.2,4.5-0.2,6.3-0.6c0.9-0.2,1.5-0.4,1.8-0.5c1.1-0.5,1.7-1,2.3-1.9c-0.9,0.5-1.5,0.7-2.6,1.2 C202.8,269.3,202.3,269.5,201.4,269.7L201.4,269.7z",
    fill: "#202020"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M254.9,276.4c-0.6-0.1-1.4-0.2-2-0.4c-0.7-0.1-1.2-0.3-1.2-0.3s-0.6-0.2-1.3-0.4s-1.5-0.6-1.9-0.9 c-0.5-0.4-0.7-0.6-0.8-0.7c-0.4-0.4-0.6-0.8-0.7-1.1c-0.2-0.4-0.3-0.8-0.3-1.3c-0.5,0.9-0.4,1.9,0.5,2.9c0.1,0.2,0.4,0.5,1,0.9 c0.5,0.3,1.4,0.7,2.1,1c0.8,0.2,1.4,0.4,1.4,0.4s0.5,0.1,1.2,0.3c0.7,0.2,1.5,0.3,2.1,0.4c0.9,0.1,1.5,0.2,1.8,0.2 c1.2,0.1,1.9-0.1,2.9-0.4c-1-0.2-1.7-0.3-2.9-0.4C256.3,276.5,255.8,276.4,254.9,276.4L254.9,276.4z",
    fill: "#202020"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M285.2,283.2c-0.3,0.1-0.9,0.1-1.7,0.2c-1.4,0.1-3.3,0.2-4.9,0.1c-0.8,0-1.5-0.1-2-0.2s-0.8-0.1-0.8-0.1 s-1.5-0.2-3.3-0.6s-3.8-1.1-5-1.6c-0.6-0.3-0.9-0.4-1.1-0.5c-1.1-0.5-1.7-0.7-2.7-1c0.8,0.7,1.3,1.1,2.4,1.7 c0.2,0.1,0.5,0.2,1.1,0.5c1.2,0.5,3.3,1.2,5.1,1.6c1.8,0.4,3.3,0.6,3.3,0.6s0.3,0,0.8,0.1s1.2,0.1,2.1,0.2c1.6,0.1,3.6,0,5.1-0.1 c0.9-0.1,1.5-0.2,1.8-0.2c1.2-0.2,1.8-0.5,2.8-1C287.1,283,286.4,283,285.2,283.2L285.2,283.2z",
    fill: "#202020"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M259.8,263.9c0.5-0.9,1.1-1.5,1.9-1.9c0.4-0.2,0.7-0.5,1.2-0.6c0.2-0.1,0.4-0.2,0.7-0.3 c0.2-0.1,0.5-0.2,0.8-0.3c0.2-0.1,0.4-0.2,0.8-0.3c0.2,0,0.4-0.1,0.6-0.2s0.5-0.1,0.8-0.2c0.2,0,0.5-0.1,0.8-0.2 c0.3,0,0.5-0.1,0.5-0.1s0.2,0,0.5-0.1c0.3,0,0.6,0,0.8-0.1c0.4,0,0.8,0,1.2,0c0.4,0,0.7,0,1,0c0.6,0,1,0,1.2,0.1 c0.6,0.1,1.1,0.1,1.5,0.2c0.2,0,0.5,0.1,0.7,0.1s0.4,0.1,0.6,0.1c0.9,0.2,1.6,0.5,2.4,1.2c-1.5-1.3-2.7-2.3-5.1-2.9 c-0.3-0.1-0.8-0.1-1.4-0.2c-0.3,0-0.6,0-1-0.1c-0.4,0-0.8,0-1.3,0c-0.2,0-0.6,0-0.9,0.1c-0.3,0-0.5,0.1-0.5,0.1s-0.3,0-0.6,0.1 c-0.3,0-0.7,0.2-0.9,0.2c-0.4,0.1-0.6,0.2-0.9,0.3c-0.3,0.1-0.5,0.2-0.7,0.3c-0.4,0.1-0.6,0.3-0.8,0.4 C261.5,260.8,260.7,262.2,259.8,263.9L259.8,263.9z",
    fill: "#FFFFFF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M282.4,262.8c0.2-0.1,0.5,0,0.7,0.1c0.1,0,0.2,0,0.4,0.1c0.2,0,0.4,0.1,0.6,0.1c0.4,0.1,0.8,0.1,0.8,0.1 s0.4,0,0.9,0c0.2,0,0.5-0.1,0.7-0.2s0.4-0.2,0.5-0.2c0.3-0.2,0.4-0.5,0.6-0.6c-0.2,0.1-0.5-0.1-0.7-0.2c-0.1,0-0.6-0.2-1-0.3 c-0.4-0.1-0.8-0.1-0.8-0.1s-0.4,0-0.9,0c-0.5,0.1-1,0.3-1.2,0.5C282.6,262.3,282.5,262.6,282.4,262.8L282.4,262.8z",
    fill: "#FFFFFF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M282.9,266.7c0.3,0,0.5,0.1,0.9,0.2c0.3,0.1,2,0.5,2,0.5s0.4,0.1,0.9,0.2s1,0.2,1.2,0.3c0.4,0,0.7,0,0.9,0.1 c-0.2-0.2-0.3-0.5-0.5-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.2-0.2-0.4-0.4-0.7-0.5c-0.5-0.3-1-0.4-1-0.4s-0.5-0.1-1.1-0.1 c-0.3,0-0.6,0.1-0.9,0.1c-0.2,0.1-0.5,0.2-0.5,0.2C283.4,266.4,283.2,266.6,282.9,266.7L282.9,266.7z",
    fill: "#FFFFFF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M269.1,271c0.3-0.2,0.6-0.2,1.1-0.4c0.1,0,0.3-0.1,0.6-0.2c0.3-0.1,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,1.1-0.2 s2.3-0.4,2.8-0.5s0.7-0.3,1.1-0.2c-0.4-0.1-0.6-0.4-1-0.6c-0.1,0-0.4-0.1-0.7-0.2c-0.3-0.1-0.7-0.1-1.1-0.1 c-0.7,0-1.4,0.1-1.4,0.1s-0.7,0.1-1.3,0.4c-0.3,0.1-0.7,0.4-0.9,0.6c-0.3,0.2-0.4,0.4-0.5,0.5C269.4,270.3,269.4,270.7,269.1,271 L269.1,271z",
    fill: "#FFFFFF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M246.6,270.7c0.5-0.3,0.9-0.4,1.5-0.7c0.3-0.2,1.3-0.7,2.2-1c0.9-0.4,1.7-0.6,1.7-0.6s0.2,0,0.5-0.1 s0.8-0.1,1.2-0.2c0.5-0.1,1-0.1,1.5-0.2s0.8-0.1,1-0.2c0.7-0.2,1.1-0.5,1.6-0.6c-0.6,0.1-1,0-1.6-0.2c-0.4,0-1.5-0.2-2.5-0.2 c-0.5,0-1,0-1.5,0.1c-0.4,0.1-0.6,0.1-0.6,0.1s-1,0.2-1.9,0.8c-0.5,0.3-0.9,0.6-1.3,0.9s-0.6,0.6-0.7,0.7 C247.2,269.9,247,270.3,246.6,270.7L246.6,270.7z",
    fill: "#FFFFFF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M295.9,274c0.1,0.3-0.1,0.6-0.2,1c0,0.1,0,0.3-0.1,0.5c0,0.2-0.1,0.5-0.1,0.8c-0.1,0.5-0.1,1-0.1,1 s0,0.1-0.1,0.3c0,0.2-0.1,0.4-0.1,0.6c-0.1,0.2-0.1,0.5-0.2,0.6c-0.1,0.2-0.2,0.4-0.2,0.4c-0.1,0.3-0.2,0.6-0.5,0.7 c0.3-0.1,0.6,0.1,1.1-0.1c0.1-0.1,0.4-0.1,0.6-0.4c0.2-0.2,0.5-0.5,0.6-0.8c0.2-0.3,0.3-0.6,0.3-0.8c0.1-0.2,0.1-0.4,0.1-0.4 s0.1-0.6,0-1.2c0-0.3-0.1-0.6-0.2-0.9s-0.2-0.5-0.2-0.6C296.3,274.5,296,274.4,295.9,274L295.9,274z",
    fill: "#FFFFFF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M294.5,284.8c-0.5,0.9-1.1,1.5-1.7,2.1s-1.3,1.2-2.2,2c-0.1,0.1-0.4,0.3-0.6,0.5c-0.1,0.1-0.3,0.2-0.5,0.4 c-0.2,0.1-0.4,0.3-0.7,0.5c-0.1,0-0.2,0.1-0.2,0.1s0,0-0.1,0.1c0,0-0.1,0-0.1,0.1c-1.3,0.8-2.4,1.2-3,1.5 c-1.1,0.4-1.9,0.7-2.8,0.9c-0.9,0.2-1.7,0.4-2.7,0.3c2,0.2,3.4,0.7,5.9,0.1c0.6-0.2,2-0.6,3.4-1.5c0,0,0.1,0,0.1-0.1 c0.1,0,0.1-0.1,0.1-0.1s0.2-0.1,0.2-0.2c0.3-0.2,0.5-0.4,0.8-0.6c0.2-0.2,0.4-0.3,0.5-0.5c0.3-0.3,0.5-0.5,0.6-0.6 C293.2,288,293.6,286.5,294.5,284.8L294.5,284.8z",
    fill: "#FFFFFF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M245.2,277.1c0.1,0.5,0,1,0.1,1.7c0,0.2,0.1,0.6,0.3,1c0.2,0.5,0.4,1,0.7,1.5c0.6,1,1.4,1.6,1.4,1.6 s0.2,0.2,0.5,0.4c0.3,0.2,0.8,0.5,1.2,0.7c0.5,0.2,1,0.4,1.5,0.5s0.8,0.2,1,0.2c0.7,0.1,1.1,0,1.7,0.1c-0.5-0.2-0.8-0.5-1.4-0.9 c-0.3-0.2-1.3-0.8-2.1-1.3c-0.4-0.3-0.8-0.5-1-0.7s-0.4-0.3-0.4-0.3s-0.6-0.5-1.2-1.3c-0.6-0.7-1.2-1.6-1.4-1.9 C245.7,278,245.3,277.7,245.2,277.1L245.2,277.1z",
    fill: "#FFFFFF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M184.7,259.1c-0.3,0.2-0.7,0.3-1,0.5c-0.3,0.1-0.7,0.3-1.1,0.6c-0.2,0.2-0.7,0.4-1.2,0.9 c-0.3,0.2-0.5,0.5-0.8,0.7c-0.3,0.3-0.5,0.5-0.8,0.8c-0.5,0.6-0.9,1.2-1.2,1.6c-0.3,0.5-0.4,0.8-0.4,0.8s-0.2,0.3-0.4,0.8 s-0.5,1.1-0.8,1.8c-0.2,0.7-0.4,1.5-0.6,2.1c-0.1,0.6-0.2,1.2-0.2,1.5c-0.1,1,0.1,1.6,0,2.4c0.1-0.8,0.4-1.3,0.8-2.2 c0.1-0.2,0.3-0.7,0.5-1.3c0.2-0.6,0.5-1.3,0.8-1.9c0.6-1.3,1.2-2.4,1.2-2.4s0.2-0.3,0.4-0.7s0.6-1,1-1.5c0.4-0.6,0.8-1.1,1.2-1.6 s0.8-0.9,0.9-1C183.7,260.1,184,259.6,184.7,259.1L184.7,259.1z",
    fill: "#FFFFFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M178.5,278c0.2,0.5,0.1,1,0.3,1.7c0.1,0.2,0.2,0.6,0.4,1s0.5,0.9,0.8,1.4s0.7,0.9,0.9,1.1s0.5,0.4,0.5,0.4 s0.2,0.2,0.5,0.4c0.3,0.2,0.8,0.5,1.4,0.7c0.3,0.1,0.6,0.2,0.9,0.2c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.3,0,0.5-0.1,0.7-0.2 s0.3-0.1,0.4-0.2c0.3-0.2,0.6-0.4,0.8-0.6s0.3-0.4,0.6-0.6c-0.2,0.2-0.5,0.2-0.7,0.3c-0.2,0-0.5,0-0.8,0.1c-0.2,0-0.5,0.1-0.9,0 c-0.1,0-0.2,0-0.3,0s-0.2-0.1-0.3-0.1c-0.2,0-0.4-0.1-0.6-0.2c-0.4-0.2-0.8-0.4-1-0.6c-0.3-0.2-0.4-0.3-0.4-0.3s-0.2-0.1-0.4-0.4 c-0.2-0.2-0.6-0.5-0.9-0.9c-0.3-0.4-0.7-0.7-0.9-1.1s-0.5-0.6-0.6-0.8C179.1,278.8,178.7,278.5,178.5,278L178.5,278z",
    fill: "#FFFFFF"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M214.5,270.7c-1.1,1.7-2.2,2.6-3.8,4.3c-0.1,0.1-0.3,0.3-0.6,0.6c-0.3,0.3-0.6,0.6-1.1,1.1 c-0.1,0.1-0.4,0.4-0.4,0.4s-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-1.1,1-2.2,1.7-2.7,2c-1,0.6-1.8,1.1-2.5,1.5 c-0.8,0.4-1.6,0.8-2.5,1c1.9-0.4,3.4-0.3,5.7-1.4c0.6-0.3,1.8-0.9,3.1-2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2 s0.3-0.3,0.4-0.4c0.5-0.5,0.9-0.9,1.1-1.2s0.4-0.5,0.6-0.7C213.2,273.8,213.5,272.4,214.5,270.7L214.5,270.7z",
    fill: "#FFFFFF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M205.5,270.1c-0.4,0.2-0.7,0.2-1.2,0.3c-0.1,0-0.4,0.1-0.7,0.2s-0.7,0.1-1,0.2c-0.7,0.1-1.3,0.2-1.3,0.2 s-0.6,0.1-1.3,0.2s-1.5,0.3-1.8,0.4c-0.5,0.2-0.8,0.4-1.2,0.4c0.4,0,0.7,0.2,1.2,0.4c0.1,0,0.4,0.1,0.8,0.1c0.3,0,0.7,0.1,1.1,0.1 c0.8,0,1.5-0.1,1.5-0.1s0.7-0.1,1.4-0.4c0.4-0.1,0.7-0.3,1-0.5s0.5-0.4,0.6-0.5C205.1,270.7,205.2,270.4,205.5,270.1L205.5,270.1z ",
    fill: "#FFFFFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5cm8",
    d: "M256.2,353.7c0,0.3-0.1,0.9-0.2,1.8c0,0.2-0.1,0.5-0.1,0.7c0.2-0.2,0.4-0.3,0.7-0.3c0.6,0,1.1,0.4,1.5,0.9 c0.1,0.2,0.3,0.5,0.7,1c0.1,0.1,0.3,0.3,0.3,0.3s0.2,0.1,0.3,0.2c0.6,0.2,1-0.3,1.1-0.5c0.4-0.4,0.8-0.8,1.4-0.9 c0.2,0,0.4,0,0.5,0c0-0.1,0-0.2,0-0.2s0,0,0,0.1c0-1,0-1.7,0.2-2.9c0.1-0.3,0.2-1,0.4-1.7c0.4-1.5,0.9-3.3,1.4-5h-0.1 c0,0-0.2,0.1-0.5,0.1s-0.6,0-0.7,0s-0.2-0.1-0.3-0.2c-0.4,0-0.8-0.1-1.2-0.4c-0.3-0.2-0.8-0.6-1.4-1.2l0,0l0,0l0,0 c-0.5-0.5-0.7-0.6-0.9-0.8c-0.4-0.3-0.8-0.5-1.2-0.5c-0.2,0-0.3-0.1-0.5-0.1c-0.2,1.2-0.4,2.1-0.4,2.1s-0.2,1.3-0.5,3 c-0.2,1.2-0.4,2.5-0.6,3.6C256.3,353,256.3,353.3,256.2,353.7L256.2,353.7z",
    fill: "#F7B089"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M258.3,343.5c0.5,0,1,0.1,1.6,0.5c0.2,0.1,0.5,0.4,1,0.8l0,0l0,0l0,0c0.6,0.6,1,1,1.2,1.1 c0.4,0.3,0.8,0.4,1.2,0.5c0.1,0,0.2,0,0.3,0h0.1c0.2,0,0.4-0.1,0.4-0.1s0.2-0.1,0.3-0.2c0.2-0.1,0.3-0.2,0.4-0.3 c0.3-1.1,0.7-2.1,1-3c-0.2,0-0.5,0-0.5,0s-0.5,0-0.6,0c0,0-0.1-0.1-0.1-0.2c-0.8-0.2-2.7-0.8-2.7-0.8s-2.5-0.7-3-0.9 c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2,0.9-0.4,2-0.6,2.9l0,0C258,343.5,258.1,343.5,258.3,343.5L258.3,343.5z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M259.1,337.5c-0.1,0.3-0.2,0.8-0.4,1.7c-0.1,0.3-0.1,0.6-0.2,1c0.2,0,0.4,0,0.7,0.1c0.5,0.1,3,0.9,3,0.9 s2.5,0.7,3,0.9c0.1,0,0.1,0,0.2,0.1l0,0c0,0,0.5,0,0.6,0c0,0,0.1,0,0.1,0.1c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.4-1.2,0.5-1.6 s0.2-0.6,0.2-0.6s0.1-0.2,0.2-0.6c0-0.2,0.1-0.4,0.1-0.7c0-0.1,0-0.3,0.1-0.4c0-0.1,0-0.3,0-0.5c0-0.6-0.2-1.3-0.8-1.8 c-0.6-0.5-1.6-0.7-2.5-0.9c-1-0.2-2-0.5-2.9-0.9c-0.2-0.1-0.5-0.2-0.7-0.3c-0.2-0.1-0.5-0.2-0.6-0.4l0,0 c-0.2,1.1-0.3,1.9-0.4,2.4c0,0.2-0.1,0.3-0.1,0.5C259.3,336.3,259.2,336.8,259.1,337.5L259.1,337.5z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M256.2,361c0.7,0,1.2-0.1,1.7-0.1c0.9-0.1,1.3-0.1,1.3-0.1s0.2,0,0.5,0s0.8,0,1.3-0.1s1-0.2,1.2-0.8 c0.2-0.6,0.1-1.4,0.2-2.2c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0.1c-0.3,0.2-0.5,0.5-1,0.9c-0.1,0.1-0.3,0.3-0.6,0.5 c-0.3,0.2-0.8,0.4-1.4,0.2c-0.2-0.1-0.5-0.3-0.5-0.3s-0.3-0.2-0.4-0.4c-0.5-0.6-0.6-0.9-0.7-1c-0.3-0.5-0.6-0.7-0.9-0.8 c-0.2,0-0.5,0-0.7,0.1c-0.2,1.5-0.5,3.2-0.8,4.3c0,0.2-0.1,0.2,0,0.2C255.5,361,255.8,361,256.2,361L256.2,361z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm8",
    d: "M259.8,298.3c0,0,0.1-0.2,0.3-0.5c0.1-0.4,0.3-0.9,0.4-1.4c0-0.2,0.1-0.5,0.2-1.1c0-0.3,0.1-0.9,0.1-0.9 s0-0.5,0-0.9c-0.1-0.9,0-1.6,0-1.9c0.1-0.7,0.6-1.1,1-1.4c0.3-0.1,0.6-0.2,0.9-0.2c-0.1,0-0.1,0-0.2-0.1 c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.2-1.3-0.4-2-0.6c-1.4-0.4-2.8-0.8-4.3-1.2c-0.8-0.2-1.6-0.5-2.3-0.7l0,0 c-0.1,0.1-0.2,0.4-0.4,0.6c-0.1,0.3-0.2,0.5-0.2,0.5s-0.1,0.3-0.1,0.6s-0.1,0.6-0.1,0.7s-0.1,0.2-0.2,0.3c0,0.2,0,0.3,0,0.3 s0,0.3,0,0.6c0,0,0,0,0,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.2,0.2,0.3,0.5,0.5,0.7c1.1,1.8,1.5,2.5,1.5,2.5s0.1,0.1,0.5,0.8 c0.2,0.3,0.5,0.8,0.9,1.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.1,0.1,0.2,0.2,0.2l0,0c0.5,0,1.1,0.1,1.8,0.3c0.3,0.1,0.8,0.3,1.3,0.8 C259.7,298.5,259.9,298.3,259.8,298.3L259.8,298.3z",
    fill: "#F7B089"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M273.8,293.9L273.8,293.9C273.9,293.8,273.9,293.9,273.8,293.9z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M263.2,290.3c-0.4,0-0.7,0.2-1,0.5s-0.5,0.6-0.6,1.1c-0.1,0.2-0.1,0.8,0,1.7c0,0.3,0,0.9,0,0.9s0,0.7-0.1,1 c-0.1,0.7-0.2,1-0.3,1.2c-0.1,0.2-0.2,0.5-0.3,0.7c0,0.1,0.1,0.2,0,0.3c0,0.2-0.6,1.2-0.6,1.1c0,0-0.2,0.2-0.4,0.5 c0.2,0.2,0.4,0.4,0.5,0.7c0.2,0.4,0.4,0.8,0.7,1.2c0.1,0.1,0.1,0.2,0.2,0.3l0,0c0.3,0,0.6,0.1,0.9,0.3c0.3,0.2,0.6,0.4,0.8,0.8 c0.2,0.3,0.3,0.6,0.4,1l0.1,0.2l0,0c0,0,0.2,0,0.2-0.1c0.4-0.1,0.9-0.1,1.4,0.1l0,0c0.1,0,0.3,0.1,0.4,0.2l0,0 c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.9,0.7-1.5c0.8-1.6,2-3.4,3.5-5.2c0.7-0.9,1.6-1.7,2.4-2.5l0.5-0.4l0,0l0,0l-0.4-0.1 l-0.8-0.3c-0.7-0.3-1.3-0.5-1.9-0.7c-0.3-0.1-0.6-0.2-0.8-0.3c-1.1-0.5-1.7-0.9-2.5-1.4c-1-0.1-1.7-0.2-2.8-0.7 C263.6,290.5,263.4,290.4,263.2,290.3L263.2,290.3z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5cm9",
    d: "M251.2,289.6c0-0.1,0.1-0.2,0.2-0.2c0-0.2,0-0.4,0.1-0.6c0.1-0.4,0.2-0.6,0.2-0.6s0.1-0.3,0.3-0.6 c0.1-0.2,0.2-0.4,0.3-0.5c-1.8-0.6-3.6-1.3-5.2-2.1c-0.3-0.1-0.6-0.3-0.8-0.4s-0.4,0-0.6,0.1c-0.3,0.2-0.6,0.8-0.8,1.3 c-0.1,0.3-0.2,0.5-0.4,0.8c-0.1,0.1-0.1,0.2-0.2,0.4c-0.1,0.1-0.1,0.1-0.1,0.1l0,0c1.1,0.3,2.2,0.7,3.2,1 c0.2,0.1,0.5,0.2,0.7,0.3l0.1,0.1h0.1h0.4c0.5,0.1,1,0.2,1.4,0.4C250.6,289.1,250.9,289.3,251.2,289.6L251.2,289.6L251.2,289.6z",
    fill: "#F18D83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M273.8,293.8l-0.1-0.2l0,0c0,0,0,0,0.1-0.1h-0.1h-0.2c-0.2,0-0.2-0.1-0.3-0.1l-0.2-0.1l-1-0.3 c-0.7-0.3-1.3-0.5-1.9-0.7c-0.3-0.1-0.6-0.2-0.8-0.3c-1.1-0.4-1.8-0.6-2.8-0.7c0.9,0.6,1.4,1,2.5,1.4c0.2,0.1,0.4,0.2,0.8,0.3 c0.5,0.2,1.2,0.5,1.9,0.7l0.8,0.3l0.4,0.1l0,0l0,0l-0.5,0.4c-0.9,0.8-1.7,1.7-2.4,2.5c-1.5,1.8-2.7,3.6-3.5,5.2 c-0.3,0.6-0.5,1-0.7,1.5c0,0.1-0.1,0.1-0.1,0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.2l0,0c-0.5-0.2-0.9-0.2-1.4-0.1 c-0.1,0-0.2,0.1-0.2,0.1l0,0l-0.1-0.2c-0.1-0.3-0.3-0.6-0.4-1c-0.2-0.4-0.5-0.6-0.8-0.8s-0.6-0.3-0.9-0.3l0,0 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2-0.4-0.4-0.8-0.7-1.2c-0.2-0.3-0.4-0.5-0.5-0.7c0.2-0.2,0.4-0.4,0.4-0.5c0,0,0.6-0.9,0.6-1.1 c0-0.1,0-0.2,0-0.3c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.2,0.2-0.5,0.3-1.2c0.1-0.3,0.1-1,0.1-1s0-0.6,0-0.9c-0.1-0.9,0-1.4,0-1.7 c0.1-0.5,0.3-0.8,0.6-1.1c0.2-0.2,0.5-0.5,1-0.5c0.2,0.1,0.5,0.2,0.6,0.3c1.1,0.5,1.8,0.6,2.8,0.7c-0.9-0.5-1.4-0.9-2.5-1.4 c-0.2-0.1-0.6-0.2-1-0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.3-0.1-0.6-0.3-1-0.4c-0.7-0.2-1.4-0.4-2-0.6c-1.4-0.4-2.8-0.8-4.3-1.2 c-2.9-0.8-5.8-1.8-8.1-3c-0.3-0.1-0.6-0.3-1-0.4s-0.9,0-1.2,0.2c-0.7,0.5-0.8,1.1-1,1.6c-0.1,0.2-0.2,0.5-0.3,0.7 c-0.1,0.1-0.1,0.2-0.2,0.3c0,0-0.1,0.1-0.2,0.2s-0.2,0.1-0.4,0.2c-0.2,0.1-0.4,0.2-0.6,0.2l-0.3,0.1h-0.1l0,0 c0.2,0.1,0.4,0.1,0.6,0.2c0.4,0.1,0.8,0.2,1.2,0.4c1.2,0.4,2.3,0.7,3.2,1c0.2,0.1,0.5,0.2,0.7,0.3l0.2,0.1c0,0,0.1,0,0.2,0h0.1 h0.3c0.4,0.1,0.8,0.2,1.2,0.3c0.3,0.2,0.7,0.4,0.9,0.6c0.2,0.2,0.3,0.5,0.5,0.9c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.2,0.2,0.3,0.5,0.5,0.7c1.1,1.7,1.5,2.5,1.5,2.5s0.1,0.1,0.5,0.8 c0.2,0.3,0.5,0.8,0.9,1.5c0.1,0.2,0.2,0.3,0.4,0.5c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.1 c0.5,0,1,0.1,1.6,0.3c0.4,0.1,1.2,0.4,2,1.7c0.2,0.3,0.4,0.7,0.6,1.1c0.1,0.1,0.1,0.2,0.2,0.3l0.2,0.3c0.1,0.1,0.2,0,0.4,0 c0.3,0,0.5,0.1,0.7,0.2s0.4,0.3,0.5,0.5c0.1,0.3,0.2,0.6,0.4,0.9l0.1,0.3c0.1,0.2,0.1,0.3,0.3,0.4c0.3,0.2,0.7-0.1,0.8-0.1 c0.3-0.1,0.6,0,0.9,0.1l0,0c0.1,0,0.1,0,0.3,0.2l0,0c0.1,0.1,0.3,0.2,0.4,0.3l0.2,0.2c0,0.1,0,0,0.1-0.1l0.1-0.1 c0.1-0.3,0.3-0.6,0.4-0.9c0.2-0.4,0.4-0.9,0.7-1.4c0.8-1.5,2-3.3,3.4-5c0.7-0.9,1.5-1.7,2.4-2.5l0.3-0.3l0.5-0.4 c0.1-0.1,0.3-0.2,0.3-0.3l0.1-0.2v-0.1l0,0l0,0l0,0c-0.2,0.1-0.3,0.1-0.4,0.1L273.8,293.8L273.8,293.8z M250.1,288.9 c-0.4-0.2-0.9-0.3-1.4-0.4h-0.4h-0.1l-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.3c-1-0.4-2.1-0.7-3.2-1l0,0c0,0,0,0,0.1-0.1 s0.2-0.2,0.2-0.4c0.1-0.2,0.3-0.5,0.4-0.8c0.2-0.5,0.4-1.1,0.8-1.3c0.2-0.1,0.4-0.2,0.6-0.1c0.2,0,0.5,0.2,0.8,0.4 c1.5,0.8,3.3,1.5,5.2,2.1c-0.1,0.1-0.2,0.3-0.3,0.5c-0.2,0.3-0.3,0.6-0.3,0.6s-0.1,0.3-0.2,0.6c0,0.2-0.1,0.4-0.1,0.6 c-0.1,0.1-0.2,0.1-0.2,0.2l0,0C250.9,289.3,250.5,289.1,250.1,288.9L250.1,288.9z M256.4,297.6L256.4,297.6 c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.5c-0.4-0.7-0.7-1.1-0.9-1.5c-0.4-0.7-0.5-0.8-0.5-0.8s-0.4-0.7-1.5-2.5 c-0.1-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.2-0.3-0.3-0.4c0,0,0,0,0-0.1c0-0.2,0-0.6,0-0.6s0-0.2,0-0.3c0.1-0.1,0.2-0.2,0.2-0.3 c0-0.1,0-0.4,0.1-0.7c0.1-0.3,0.1-0.6,0.1-0.6s0.1-0.3,0.2-0.5s0.3-0.5,0.4-0.6l0,0c0.8,0.2,1.6,0.5,2.3,0.7 c1.5,0.4,2.9,0.8,4.3,1.2c0.7,0.2,1.4,0.4,2,0.6c0.3,0.1,0.6,0.2,0.9,0.4c0.1,0,0.1,0,0.2,0.1c-0.3,0-0.6,0-0.9,0.2 c-0.4,0.2-0.9,0.7-1,1.4c-0.1,0.3-0.1,1,0,1.9c0,0.3,0,0.9,0,0.9s0,0.7-0.1,0.9c-0.1,0.6-0.2,1-0.2,1.1c-0.2,0.5-0.3,1-0.4,1.4 c-0.1,0.2-0.3,0.5-0.3,0.5s-0.1,0.2-0.3,0.4c-0.5-0.5-1-0.7-1.3-0.8C257.6,297.7,257,297.7,256.4,297.6L256.4,297.6z M273.8,293.9L273.8,293.9C273.8,293.9,273.9,293.9,273.8,293.9z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M254.2,361.9h0.3c0.2,0,0.4,0,0.6,0c0.4,0,0.8,0,1.1-0.1c0.7,0,1.2-0.1,1.7-0.1c0.9-0.1,1.3-0.1,1.3-0.1 s0.2,0,0.5,0s0.8,0,1.4-0.1c0.3,0,0.7-0.1,1-0.3c0.4-0.2,0.7-0.6,0.8-1c0.2-0.9,0.1-1.6,0.2-2.4c0.1-1.6,0.4-3.2,0.7-4.6 c0.1-0.3,0.2-0.7,0.2-1c0-0.2,0.1-0.3,0.1-0.5c0.1-0.3,0.1-0.5,0.2-0.7c0.2-0.8,0.3-1.3,0.4-1.9c0-0.1,0-0.2,0-0.3 c0.2-0.7,0.4-1.4,0.6-2c0.6-1.9,1.2-3.6,1.6-5c0.2-0.6,0.4-1.2,0.5-1.6s0.2-0.6,0.2-0.6s0.1-0.2,0.2-0.6c0-0.2,0.1-0.5,0.1-0.7 c0-0.1,0.1-0.3,0.1-0.5s0-0.4,0-0.5c0-0.4-0.1-0.8-0.2-1.2c-0.1-0.2-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.4-0.5-0.5 c-0.8-0.6-1.8-0.8-2.8-1s-1.9-0.4-2.8-0.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.2-0.1-0.4-0.2-0.6-0.4c-0.4-0.3-0.7-0.5-1-0.8 c-0.1,0.3-0.2,0.9-0.2,1.3c-0.2,1.1-0.3,2-0.4,2.4c-0.1,0.5-0.1,0.9-0.1,1.3c-0.1,0.2-0.1,0.5-0.2,0.7c-0.1,0.3-0.2,0.8-0.4,1.7 c-0.3,1.2-0.6,3-0.9,4.4s-0.5,2.5-0.5,2.5s-0.2,1.3-0.5,3c-0.3,1.6-0.5,3.5-0.7,4.7c-0.1,0.7-0.1,1-0.2,1.2 c-0.1,0.7-0.1,1.2-0.1,1.7c-0.2,1.4-0.5,3.1-0.8,4.2c-0.1,0.4-0.2,0.8-0.3,1.1v0.1L254.2,361.9L254.2,361.9z M259.8,333 L259.8,333c0.2,0.2,0.5,0.3,0.7,0.4s0.5,0.2,0.7,0.3c0.9,0.4,2,0.6,2.9,0.9c1,0.2,1.9,0.4,2.5,0.9c0.6,0.4,0.8,1.1,0.8,1.8 c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c0,0.3-0.1,0.5-0.1,0.7c-0.1,0.4-0.2,0.6-0.2,0.6s-0.1,0.2-0.2,0.6s-0.3,0.9-0.5,1.6 c-0.1,0.2-0.1,0.4-0.2,0.7c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.6,0-0.6,0l0,0c-0.1,0-0.1,0-0.2-0.1c-0.5-0.1-3-0.9-3-0.9 s-2.5-0.7-3-0.9c-0.3-0.1-0.5-0.1-0.7-0.1c0.1-0.4,0.1-0.7,0.2-1c0.2-0.9,0.3-1.5,0.4-1.7c0.1-0.6,0.2-1.1,0.2-1.6 c0-0.1,0.1-0.3,0.1-0.5C259.5,334.9,259.7,334.1,259.8,333L259.8,333z M258.4,340.7c0.2,0.1,0.3,0.2,0.6,0.3c0.5,0.1,3,0.9,3,0.9 s1.8,0.5,2.7,0.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.6,0,0.6,0s0.4,0,0.5,0c-0.3,0.9-0.6,1.9-1,3c0,0-0.2,0.2-0.4,0.3 c-0.2,0.1-0.3,0.2-0.3,0.2s-0.2,0.1-0.4,0.1h-0.1c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.8-0.2-1.2-0.5c-0.2-0.1-0.7-0.5-1.2-1.1l0,0l0,0 l0,0c-0.5-0.5-0.8-0.7-1-0.8c-0.6-0.4-1.1-0.5-1.6-0.5c-0.2,0-0.3,0-0.5,0.1l0,0C258,342.7,258.2,341.7,258.4,340.7L258.4,340.7z M256.8,349c0.3-1.6,0.5-3,0.5-3s0.2-0.9,0.4-2.1c0.2,0,0.4,0,0.5,0.1c0.4,0.1,0.8,0.2,1.2,0.5c0.1,0.1,0.4,0.3,0.9,0.8l0,0l0,0 l0,0c0.5,0.6,1.1,1,1.4,1.2c0.4,0.3,0.8,0.4,1.2,0.4c0.1,0.1,0.1,0.2,0.3,0.2c0.1,0,0.4,0,0.7,0c0.3,0,0.5-0.1,0.5-0.1s0,0,0.1,0 c-0.5,1.7-1,3.5-1.4,5c-0.2,0.8-0.4,1.4-0.4,1.7c-0.3,1.2-0.3,1.9-0.2,2.9c0,0,0,0,0-0.1c0,0.1,0,0.2,0,0.2c-0.2,0-0.3-0.1-0.5,0 c-0.6,0.1-1,0.5-1.4,0.9c-0.2,0.2-0.6,0.7-1.1,0.5c-0.1,0-0.3-0.2-0.3-0.2s-0.2-0.2-0.3-0.3c-0.4-0.5-0.5-0.8-0.7-1 c-0.4-0.5-0.9-1-1.5-0.9c-0.3,0-0.5,0.1-0.7,0.3c0-0.3,0.1-0.5,0.1-0.7c0.1-0.9,0.2-1.5,0.2-1.8c0-0.4,0-0.7,0-1 C256.4,351.6,256.6,350.2,256.8,349L256.8,349z M255.1,360.9c0.2-1.1,0.6-2.8,0.8-4.3c0.2-0.2,0.5-0.2,0.7-0.1 c0.3,0.1,0.6,0.3,0.9,0.8c0.1,0.1,0.2,0.4,0.7,1c0.1,0.1,0.4,0.4,0.4,0.4s0.3,0.2,0.5,0.3c0.6,0.2,1.1,0,1.4-0.2s0.5-0.4,0.6-0.5 c0.4-0.5,0.7-0.8,1-0.9c0.1,0,0.2-0.1,0.3-0.1c0,0.1,0,0.2,0,0.4c-0.1,0.8,0,1.6-0.2,2.2s-0.6,0.7-1.2,0.8 c-0.5,0.1-1,0.1-1.3,0.1s-0.5,0-0.5,0s-0.4,0-1.3,0.1c-0.4,0-1,0.1-1.7,0.1c-0.3,0-0.7,0-1.1,0.1 C255,361.1,255.1,361.1,255.1,360.9L255.1,360.9z",
    fill: "#202020"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148620321342029457320000003743966867887378068_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.7,
    y1: 1936.8,
    x2: 260.7,
    y2: 1936.8,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "260.7,300.8 260.7,300.8  260.7,300.8  ",
    style: {},
    fill: "url(\"#SVGID_00000148620321342029457320000003743966867887378068_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077307610256746240680000011662169979164566460_",
    gradientUnits: "userSpaceOnUse",
    x1: 221.7,
    y1: 1999.9,
    x2: 221.7,
    y2: 1916.2,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(243, 173, 125)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(243, 181, 117)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.8,360.5c0,0,9.4,0,19.7,0.1 c5.1,0,10.5,0,15,0.1c1.2,0,2.1,0,2.5,0s0.7-0.1,1-0.3c0.2-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.3-0.5,0.4-0.7c0-0.2,0-0.4,0-0.6 c0-0.1-0.1-0.2-0.1-0.3l0.1,0.1c0-0.3,0-0.7,0.1-1c0.1-0.5,0.2-1.5,0.3-2.6c0.3-2.7,0.8-6.1,1.2-9.2c0.9-6.3,2.1-11.9,2.1-11.9 s1.1-5.7,2.6-11.8c0.7-3.1,1.6-6.3,2.3-9c0.5-1.6,0.8-3,1-3.6c0.3-1.1,0.7-1.9,1.1-2.7c0-0.2,0-0.4,0-0.6s-0.1-0.4-0.2-0.6 c-0.2-0.2-0.5-0.5-1-0.4c0,0,0,0-0.1,0c0,0.2,0,0.3-0.1,0.5c0,0.1-0.1,0.3-0.1,0.4l-0.1,0.2l0,0l0,0l0,0l0,0 c-2.2-0.1-0.6,0-1.1-0.1l0,0v-0.1c-0.1-0.3-0.1-0.6,0-1l0,0c0-0.2,0.2-0.4,0.3-0.6c0-0.1,0-0.2,0-0.3c-0.2-0.8-0.7-1.4-1.3-1.6 c-0.3-0.2-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.2,0h-0.2c-0.3,0-0.6,0.1-0.8,0.1c0-0.5,0-0.9,0-1.1v-0.1l0,0 c0,0,0,0,0-0.1l0,0c0,0.1,0.2-2-2-2.1c-0.2,0-0.5,0-0.8,0h-0.6c-0.1-0.1-0.2-0.2-0.3-0.2l-0.2-0.1c-0.5-0.4-1-0.8-1.4-1.2 c-0.8-0.8-1.5-1.7-1.9-2.4c-0.6-0.9-0.8-1.3-1-1.6c-0.7-1.1-1-2-1.2-3c-0.5-0.2-1-0.4-1.6-0.6c-0.5-0.1-1.4-0.4-2.5-0.7 c-1.9-0.5-3.9-1-6-1.6c-1-0.2-2.1-0.4-3-0.2c-0.5,0.1-0.8,0.3-1.3,0.6c-0.2,0.2-0.5,0.3-0.9,0.5c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.2,0-0.3,0-0.5,0s-0.4,0-0.6-0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.2-0.2-0.4-0.4-0.6-0.5c-0.3-0.3-0.8-0.5-1.2-0.7 c-0.9-0.3-1.9-0.5-2.9-0.6c-1.9-0.2-3.7-0.1-5.3-0.1c-3.1,0-5.1,0-5.1,0s-2,0-5.1,0s-7.3,0.2-11.7,0.3c-2.2,0.1-4.5,0.1-6.6,0.2 c-2.2,0.1-4.3,0-6.1,0.5c-0.9,0.2-1.8,0.6-2.3,1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.3,0.3-0.5,0.5-0.7,0.7c-0.4,0.5-0.7,1-0.9,1.4 c0.1,0.9,0,1.8-0.1,3.1c-0.1,1.1-0.5,3.4-0.8,5.9c-0.3,2.1-0.6,4.3-0.9,6.4c-0.1,1-0.3,2-0.4,2.9c0,0.2-0.1,0.5-0.1,0.7 c0,0,0,0,0,0.1c0,0,0.1,0,0.3,0c0.9,0.2,1.4,0.9,1.8,1.6c0.1,0.4,0.2,0.8,0.2,1.1c0,0.4-0.1,0.7-0.2,1c-0.5,1.2-1.2,2-1.6,2.8 c-0.8,1.7-0.9,3.3-1,4.6c-0.2,2.7-0.3,4-0.3,4s-2,26.5-2.4,31.8c-0.1,1.3-0.3,2.2-0.6,3.2c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3 v0.1l0,0C183.6,360.3,215.8,360.5,215.8,360.5L215.8,360.5z",
    style: {},
    fill: "url(\"#SVGID_00000077307610256746240680000011662169979164566460_\")"
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M181,361.6c4.6,0,9.9,0,15.1,0.1c10.3,0,19.6,0.1,19.6,0.1s9.4,0,19.6,0.1c5.1,0,10.5,0,15,0.1 c1.2,0,2.2,0,2.7-0.1s1-0.2,1.3-0.5c0.2-0.2,0.4-0.4,0.6-0.6c0.1,0,0.2,0.1,0.3,0l0.2-0.2c0.3-1,0.5-1.9,0.7-3.2 c0.1-0.5,0.2-1.5,0.3-2.6c0.3-2.7,0.8-6,1.2-9.1c0.9-6.2,2.1-11.9,2.1-11.9s1.1-5.6,2.6-11.8c0.7-3.1,1.6-6.3,2.3-9 c0.5-1.6,0.8-3,1-3.6c0.1-0.4,0.2-0.7,0.3-1c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0.1-0.1,0.1-0.2c0.3-0.6,0.6-1.2,0.5-2.3 c0-0.3-0.1-0.7-0.5-1.2c0,0,0,0-0.1-0.1c-0.4-0.4-1-0.9-2-0.8l0,0l0,0c-0.3-1.1-1.1-2-2-2.4c-0.4-0.2-0.9-0.3-1.3-0.3 c-0.1,0-0.2,0-0.3,0l0,0c0-0.1,0-0.2,0-0.2s0-0.1,0-0.4c0-0.2-0.1-0.6-0.2-1c-0.2-0.4-0.5-0.9-1-1.3s-1.2-0.5-1.8-0.5 c-0.3,0-0.6,0-0.9,0h-0.2c-0.1,0,0,0,0,0l-0.2-0.1c-0.4-0.3-0.9-0.7-1.2-1.1c-0.8-0.8-1.4-1.6-1.8-2.2c-0.6-0.8-0.8-1.2-1-1.5 c-0.2-0.4-0.5-0.8-0.7-1.1c0.1-0.7-0.3-1.4-0.8-1.8c-0.5-0.5-1.2-0.9-2.1-1.2c-0.5-0.1-1.4-0.4-2.6-0.7c-1.9-0.5-3.9-1-6-1.6 c-1.1-0.3-2.3-0.5-3.6-0.2c-0.6,0.1-1.2,0.5-1.7,0.8c-0.2,0.1-0.4,0.3-0.6,0.3c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.3,0 c-0.2,0-0.2,0-0.4-0.2s-0.4-0.4-0.6-0.6c-0.5-0.4-1.1-0.6-1.6-0.9c-1.1-0.4-2.1-0.6-3.1-0.7c-2-0.2-3.9-0.1-5.4-0.1 c-3.1,0-5.1,0-5.1,0s-2,0-5.1,0s-7.3,0.2-11.7,0.3c-2.2,0.1-4.5,0.1-6.6,0.2c-2.2,0.1-4.4,0-6.4,0.6c-0.5,0.1-1,0.3-1.4,0.5 c-0.2,0.1-0.4,0.2-0.7,0.3l-0.3,0.2l-0.2,0.2c-0.2,0.2-0.5,0.3-0.6,0.5c-0.4,0.3-0.6,0.6-0.8,0.8c-0.9,1.1-1.2,2.3-1,3.3 c-0.1,0.5-0.2,1.1-0.3,1.7c-0.1,1.1-0.5,3.4-0.9,5.9c-0.3,2.1-0.6,4.3-0.9,6.4c-0.1,1-0.3,2-0.4,2.9c-0.1,0.7-0.2,1.3-0.3,1.9 c0,0.2-0.1,0.4-0.1,0.6v0.2v0.1c0,0,0,0.1,0,0l0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6c0.1-0.1,0.2,0,0.2,0h0.1c0.4,0.1,0.8,0.5,0.9,0.9 c0.1,0.2,0.1,0.4,0.1,0.6s-0.1,0.5-0.2,0.7c-0.4,0.9-1.1,1.8-1.5,2.8c-0.9,1.9-1,3.7-1.1,5c-0.2,2.7-0.3,4-0.3,4 s-2,26.5-2.4,31.8c0,0.4,0,0.8-0.1,1.1v0.1c-0.1,0.3-0.1,0.5-0.2,0.8c-0.1,0.3-0.1,0.7-0.2,1c0,0.2-0.1,0.4-0.1,0.6 c0,0.3-0.1,0.5-0.1,0.8c0,0.2-0.1,0.5-0.1,0.9c0.2,0,0.4,0,0.7,0c0.2,0,0.4,0,0.6,0C178.1,361.6,179.5,361.6,181,361.6L181,361.6 z M260.7,300.8L260.7,300.8L260.7,300.8L260.7,300.8L260.7,300.8z M177.1,360.3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4 c0.3-1,0.5-1.9,0.6-3.2c0.4-5.3,2.4-31.8,2.4-31.8s0.1-1.4,0.3-4c0.1-1.3,0.2-3,1-4.6c0.4-0.8,1.1-1.6,1.6-2.8 c0.1-0.3,0.2-0.6,0.2-1s0-0.8-0.2-1.1c-0.3-0.7-0.8-1.4-1.8-1.6c-0.2,0-0.3,0-0.3,0s0,0,0-0.1c0-0.2,0.1-0.5,0.1-0.7 c0.1-0.9,0.3-1.9,0.4-2.9c0.3-2,0.6-4.2,0.9-6.4c0.4-2.5,0.7-4.9,0.8-5.9c0.2-1.2,0.2-2.1,0.1-3.1c0.2-0.4,0.5-0.9,0.9-1.4 c0.1-0.2,0.4-0.4,0.7-0.7c0.1-0.1,0.3-0.3,0.5-0.4c0.6-0.4,1.4-0.8,2.3-1c1.8-0.5,3.9-0.5,6.1-0.5c2.2-0.1,4.4-0.1,6.6-0.2 c4.4-0.1,8.6-0.2,11.7-0.3c3.1,0,5.1,0,5.1,0s2,0,5.1,0c1.6,0,3.4-0.1,5.3,0.1c1,0.1,2,0.3,2.9,0.6c0.5,0.2,0.9,0.4,1.2,0.7 c0.2,0.2,0.3,0.3,0.6,0.5c0.1,0.1,0.3,0.2,0.5,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.5,0s0.4-0.1,0.6-0.1 c0.3-0.1,0.6-0.3,0.9-0.5c0.5-0.3,0.8-0.5,1.3-0.6c0.9-0.2,2-0.1,3,0.2c2.1,0.5,4.1,1.1,6,1.6c1.1,0.3,2.1,0.5,2.5,0.7 c0.7,0.2,1.2,0.4,1.6,0.6c0.3,1,0.6,1.8,1.2,3c0.2,0.3,0.4,0.7,1,1.6c0.5,0.7,1.1,1.5,1.9,2.4c0.4,0.4,0.9,0.8,1.4,1.2l0.2,0.1 c0.1,0.1,0.2,0.2,0.3,0.2h0.6c0.3,0,0.5,0,0.8,0c2.2,0,1.9,2.1,2,2.1l0,0c0,0,0,0,0,0.1l0,0v0.1c0,0.3,0,0.7,0,1.1 c0.2,0,0.5-0.1,0.8-0.1h0.2c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.1,0.9,0.2c0.6,0.3,1.1,0.9,1.3,1.6 c0,0.1,0,0.2,0,0.3c-0.1,0.2-0.3,0.4-0.3,0.6l0,0c-0.1,0.4-0.1,0.7,0,1v0.1l0,0c0.5,0-1.1,0,1.1,0.1l0,0l0,0l0,0l0,0l0.1-0.2 c0-0.1,0.1-0.3,0.1-0.4s0-0.3,0.1-0.5h0.1c0.4,0,0.8,0.2,1,0.4c0.2,0.2,0.2,0.5,0.2,0.6c0,0.2,0,0.4,0,0.6 c-0.4,0.8-0.7,1.6-1.1,2.7c-0.2,0.7-0.6,2-1,3.6c-0.7,2.7-1.6,5.9-2.3,9c-1.5,6.2-2.6,11.8-2.6,11.8s-1.1,5.7-2.1,11.9 c-0.5,3.1-0.9,6.5-1.2,9.2c-0.1,1.2-0.2,2.1-0.3,2.6c0,0.4-0.1,0.7-0.1,1l-0.1-0.1c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.4,0,0.6 c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.4-0.6,0.5c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-1.4,0-2.5,0c-4.5,0-9.9,0-15-0.1 c-10.3,0-19.6-0.1-19.6-0.1s-32.2-0.1-38.6-0.2l0,0L177.1,360.3L177.1,360.3z",
    fill: "#202020"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "185.4,292.5 190.4,287.9 194.7,293.2  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "199,292.8 202.6,289.1 205.6,292.4  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "208.9,292.5 212.6,288.5 216.5,292.7  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "219.5,292.2 223.2,288.5 226.2,293.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "230,293.1 234.1,289.2 238.8,293.2  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "242.3,293.3 245.9,290.3 249.1,293.7  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "192,300.6 197.1,295 200.3,298.4  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M203.4,298.8c0,0,3.9-5,4.1-4.8s4.1,4.5,4.1,4.5",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M213.9,299.2c0.3-0.3,4-5.1,4.1-5.2l4.3,4.8",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M224.8,298.8l3.6-3.7c0,0,4.7,5.5,4.8,5.5",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "235.8,300.6 241.2,295 245.7,299.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M246.7,302c-0.3,0.2-4.4,5.2-4.4,5.2",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "239.6,307.2 235.2,302.4 231.5,306.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M228.3,305.6c-0.1-0.1-4.7-5-4.7-5l-3.7,4.2",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M216.6,304.6c-0.2-0.2-3.9-4-3.9-4l-3.9,4.2",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "206,304.8 201.6,300.6 196.4,306  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "193.9,306 190.7,303.1 185.9,307.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm2",
    x1: 184.3,
    y1: 309.7,
    x2: 187.5,
    y2: 313.1,
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "190,313.4 195,308.3 199.2,312.2  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M202.5,311.9c0,0,4.6-4.7,4.9-5.1c0.2-0.2,3.7,3.9,3.7,3.9",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "214.1,310.7 218.1,306.8 222.9,311.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "225.8,311.9 229.8,307.8 234.4,312.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "237.7,313.4 241.1,308.7 244.2,312.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "240.6,319.9 236.2,315.1 232.4,319.3  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "229.4,319.5 224.4,313.8 220.4,318.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "217.7,318.2 212.7,312.9 207.9,317.5  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "204.8,318.2 200.5,313.8 196.1,319.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "193.3,319.5 188.7,315.5 184.7,319.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M187.2,326.4c-0.1-0.2-4.4-4.3-4.4-4.3",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M189.9,327l4.8-5.7c0,0,3.1,3,3.7,3.5",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "201.7,325.4 206,320.5 211.2,325.4  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "213.9,325.7 219.1,319.9 223.7,324.8  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M226.2,325.4c0.2,0,4.2-4.4,4.4-4.4s4.7,5,4.7,5",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M237.7,326.4c0,0,3.8-4.3,3.7-4.1",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "240.6,333.4 236.4,328.2 232.6,332.7  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "229.8,332.1 225.3,327 220.1,332.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M217.2,332.1c-0.1,0-5-5-4.4-4.5c0.1,0.1-4.9,4.8-4.9,4.8",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "205.4,332.5 200,327 196.1,332.5  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "192.6,332.5 188.7,328.3 184.7,333.5  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M182.8,335.3c0.4,0.4,3.6,3.7,3.7,3.8",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M189.9,339.9c0,0,5.1-5.4,4.8-5.2s3.5,4.1,4.2,4.8",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "202.2,339.9 206.8,334.7 210.9,339.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "213.9,339.1 218.4,334 223.2,339.1  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M225.8,339.1c0,0,5.5-5.5,5.6-5.1s4.2,5.1,4.1,5.1",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm2",
    x1: 238.1,
    y1: 339.1,
    x2: 240.6,
    y2: 336.9,
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "239.9,344.7 236.6,341.1 232,345.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "234.1,351.4 230.4,347.5 225.3,352.7  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "227.8,358.8 224.2,355.1 220.1,358.8  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M237.7,355.6c0-0.2-1.8-1.8-1.8-1.8l-4.4,4.5",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "229.1,345.9 224.9,340.8 220.1,345.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "217.2,345.9 212.9,341.1 208.5,345.9  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M222.8,353c0,0-4.1-5.4-4.2-5.2s-4.2,5.2-4.2,5.2",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "216.8,358.8 212.9,355.1 208.5,359.4  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "211.2,353 206.9,347.8 202.5,353  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "205.4,345.9 201.1,341.7 197.1,346  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm2",
    d: "M193.2,346.3c-0.6-0.8-4.5-5.1-4.5-5.1l-3.7,4.3",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "188.3,351.9 183.4,346.6 180.9,349.7  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "199.6,353 195.4,348.4 191.8,352.3  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "194.4,358.8 189.9,354.1 185.7,358.8  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm2",
    points: "205.4,359.4 201.3,354.5 197.7,358.4  ",
    stroke: "#000000",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm2",
    x1: 185,
    y1: 295.9,
    x2: 189,
    y2: 300.6,
    stroke: "#000000",
    fill: "none"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 241,
    y1: 304.8,
    x2: 244.7,
    y2: 300.8,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M245.7,296.5c0,0,2.2-2.6,2.3-2.3",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 237.7,
    y1: 293.9,
    x2: 234.1,
    y2: 297.8,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 225.3,
    y1: 293.7,
    x2: 222.8,
    y2: 296.4,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M231.5,300.8c0.1,0.7-2.6,3-2.6,3",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 227,
    y1: 306.8,
    x2: 224.1,
    y2: 309.7,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 221.3,
    y1: 299.4,
    x2: 218,
    y2: 302.7,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "215.4,293.7 212.6,296.5 210.4,293.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "210.4,299.2 207.4,302.3 205.4,299.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "204.6,293.4 202.2,295.9 199.8,293.6  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M193.2,293.7c-0.1,0.1-3.3,3.4-3.3,3.4l-3.4-4",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 198.9,
    y1: 299.2,
    x2: 195.7,
    y2: 302.7,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "204.2,305.6 200.5,309.2 198.2,307.2  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M215.4,305.5c-0.3,0.1-2.8,2.4-2.8,2.4L211,306",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M209.6,311.1c-0.2,0.4-3.2,4-3.2,4l-2.2-2.2",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M221.3,312.9c-0.4,0-3.2,2.7-3.2,2.7l-2.8-2.9",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "233.1,314.1 230.8,316.3 228,313.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "238.1,307.9 236,310.7 232.6,307.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 242.8,
    y1: 313.4,
    x2: 240.8,
    y2: 315.5,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "239.3,320.5 236.6,323.5 234.1,320.5  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "227.8,319.9 224.6,322.8 221.4,319.1  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M215.4,319.1l-2.8,3.1c0,0-2.9-2.7-3.5-3.1",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "203.4,319.1 200.3,322 198.2,319.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "197.3,313.1 194.2,316.5 192,314.1  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "192,307.2 188.6,310.7 187.2,308.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "191.8,320.7 188.6,324.2 185.9,321.3  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "197.2,326 194.2,329.6 192,327.8  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M209.6,326.4c-0.4,0.5-3.1,3.4-3.1,3.4L204,327",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M222.3,325.7c-0.3,0.2-4.3,3.9-4.3,3.9l-2.7-2.6",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "233.1,327 230.7,329.6 228.3,327  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "228.3,332.7 224.8,336 221.8,333.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "239.3,334 236.6,336.9 234.1,333.5  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "234.4,339.9 230.7,343.3 227.8,339.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6cm3",
    x1: 238.5,
    y1: 346.3,
    x2: 235.5,
    y2: 348.4,
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "232.6,352.3 229.4,355.6 227.1,353.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "227.8,346.6 223.9,349.6 221.8,347.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "221.8,339.6 218.6,343 215.7,339.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "215.7,332.7 212.6,336.3 209.6,333.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "204.2,333.4 200.8,337.2 197.7,333.5  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "191.2,333.5 188.3,336.5 185.9,334.3  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "197.3,340.8 194.7,343.7 192,341.1  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "209.3,341 206.9,343.5 204.2,340.8  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "204.2,346.8 203.7,346.8 200.9,350.4 197.7,347.4  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "191.2,347.4 189.5,349.2 186.5,346.3  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "186.5,353 182.2,357.3 180.9,353.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "193.3,353.9 195.7,356.5 197.7,354.1  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "204.8,354.1 206.8,356.5 209.6,354.1  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "209.6,346.8 212.6,350.4 215.7,346.8  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6cm3",
    points: "216.1,353.9 218.4,356.5 221.3,353.9  ",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M184.4,288.9c0,0,3.7-2.3,5.6-2.5s21.5-0.6,21.5-0.6l15.2,0.1c0,0,4.2,0.5,5.9,1.9s4.3-0.9,5-0.9 s9.2,2,10.9,2.5s1.7,1.4,2,1.9",
    stroke: "#FED5AB",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm3",
    d: "M257.6,298.6c0,0,1.3,0.1,2,2.1",
    stroke: "#FED5AB",
    fill: "none"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M250.4,291.4v-0.1c-0.2-0.4-0.3-0.8-0.4-1.2c-0.5-0.2-1-0.4-1.6-0.6c-0.5-0.1-1.4-0.4-2.5-0.7 c-1.9-0.5-3.9-1-6-1.6c-1-0.2-2.1-0.4-3-0.2c-0.5,0.1-0.8,0.3-1.3,0.6c-0.2,0.2-0.5,0.3-0.9,0.5c-0.2,0.1-0.4,0.1-0.6,0.1 c-0.2,0-0.3,0-0.5,0s-0.4,0-0.6-0.1c-0.2-0.1-0.4-0.2-0.5-0.4c-0.2-0.2-0.4-0.4-0.6-0.5c-0.3-0.3-0.8-0.5-1.2-0.7 c-0.9-0.3-1.9-0.5-2.9-0.6c-1.9-0.2-3.7-0.1-5.3-0.1c-3.1,0-5.1,0-5.1,0s-2,0-5.1,0s-7.3,0.2-11.7,0.3c-2.2,0.1-4.5,0.1-6.6,0.2 c-2.2,0.1-4.3,0-6.1,0.5c-0.9,0.2-1.8,0.6-2.3,1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.3,0.3-0.5,0.5-0.7,0.7c-0.4,0.5-0.7,1-0.9,1.4 c0.1,0.9,0,1.8-0.1,3.1c-0.1,1.1-0.5,3.4-0.8,5.9c-0.3,2.1-0.6,4.3-0.9,6.4c-0.1,1-0.3,2-0.4,2.9c0,0.2-0.1,0.5-0.1,0.7 c0,0,0,0,0,0.1c0,0,0.1,0,0.3,0c0.9,0.2,1.4,0.9,1.8,1.6c0.1,0.4,0.2,0.8,0.2,1.1c0,0.4-0.1,0.7-0.2,1c-0.5,1.2-1.2,2-1.6,2.8 c-0.8,1.7-0.9,3.3-1,4.6c-0.2,2.7-0.3,4-0.3,4s-2,26.5-2.4,31.8c-0.1,1.3-0.3,2.2-0.6,3.2c0,0.1,0,0.2,0,0.4c0,0.1,0,0.2,0,0.3 v0.1l0,0c6.4,0,38.6,0.2,38.6,0.2s9.4,0,19.6,0.1c0.8,0,1.5,0,2.3,0v-69.3L250.4,291.4L250.4,291.4z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm4",
    d: "M258.2,312.9c-0.4,1.8-0.7,3.6-1,5.4s-0.6,3.6-0.9,5.2s-0.7,3.1-0.9,4.4c-0.5,2.5-0.8,4.2-0.8,4.2 s-1.3,6.5-2.1,13.8c-0.2,1.8-0.4,3.7-0.6,5.5s-0.4,3.7-0.9,5.2c-0.3,1.2-0.6,2.1-0.7,2.5s-0.2,0.8-0.2,1.1c0,0.2-0.1,0.3-0.1,0.5 c0,0,0,0,0,0.1c0.1,0,0.3,0,0.5,0c0.7,0,1.4,0,1.8,0c0.2-0.6,0.3-1.2,0.5-2.1c0.1-0.2,0.1-0.6,0.3-1c0.1-0.5,0.3-0.9,0.5-1.5 c0.4-1.4,0.7-3.1,0.9-4.8c0.2-1.7,0.2-3.5,0.3-5.2c0.1-1.8,0.2-3.5,0.4-5.1c0.2-1.6,0.5-3,0.8-4.2c0.5-2.4,0.8-4,0.8-4 s0.3-1.5,0.5-4s0.8-5.8,1.6-9.2c0.4-1.7,0.9-3.4,1.4-5.1s1.1-3.2,1.6-4.7c0.2-0.7,0.4-1.5,0.5-2c0-0.2,0.1-0.5,0.1-0.7 c0-0.4,0.1-0.8,0.1-1c0.1-1,0.2-1.8,0.5-2.6c-0.2-0.6-0.7-1.1-1.2-1.4c-0.3-0.2-0.6-0.2-0.9-0.2c-0.1,0-0.1,0-0.2,0 c0,0-0.1,0-0.2,0h-0.2c-0.1,0-0.1,0-0.2,0c0,0.5,0,1.1-0.1,1.7c0,0.2-0.1,0.6-0.1,1.1c0,0.2-0.1,0.5-0.1,0.7 c-0.1,0.6-0.3,1.5-0.4,2.3C259.1,309.4,258.6,311.1,258.2,312.9L258.2,312.9z",
    fill: "#FFE3A9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6cm4",
    points: "260.7,300.8 260.7,300.8 260.7,300.8  ",
    fill: "#FFE3A9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm4",
    d: "M246.9,317.2L246.9,317.2L246.9,317.2L246.9,317.2z",
    fill: "#FFE3A9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm4",
    d: "M251.2,306.6c-0.4,2.4-0.9,4.9-1.2,7.1c-0.2,1.1-0.5,2.4-1.5,3.1c-0.2,0.2-0.5,0.3-0.8,0.4 c-0.1,0-0.3,0.1-0.4,0.1s-0.1,0-0.2,0H247l0,0l0,0c0,0,0,0.1-0.1,0.3c-0.4,0.9-0.8,1.8-0.9,2.5c-0.1,0.8,0,1.4,0.3,2 s0.6,1.2,0.8,1.9c0.2,0.6,0.3,1.2,0.3,1.7c0,1,0,1.6-0.1,2c0,0.4-0.1,0.6-0.1,0.6s-0.8,7.5-2.2,15.6c-0.7,4-1.6,8.3-2.4,11.8 c-0.3,1.2-0.5,2.1-0.6,2.6c-0.3,1-0.5,1.8-0.9,2.5c1.5,0,3,0,4.4,0c0.1-0.2,0.1-0.4,0.1-0.6c0.1-0.5,0.1-1.1,0.2-1.9 c0-0.5,0-1.4,0.1-2.7c0.2-1.6,0.6-3.5,1-5.4c0.5-1.9,1-3.7,1.4-5.6c0.9-3.7,1.5-7.3,1.9-10s0.7-4.4,0.7-4.4s0.2-1.7,0.6-4.4 c0.4-2.7,0.9-6.3,1.5-10.1c0.3-1.9,0.6-3.8,0.9-5.7c0.3-1.9,0.6-3.8,1.1-5.4c0.2-0.8,0.4-1.6,0.5-2.3c0-0.2,0.1-0.5,0.1-0.7 c0.1-0.4,0.1-0.8,0.1-1c0.1-0.8,0.2-1.4,0.2-2l0,0c-0.1,0-0.2-0.2-0.3-0.2l-0.2-0.1c-0.5-0.4-1-0.8-1.4-1.2 c-0.6-0.6-1-1.2-1.4-1.7c0,1.1,0,2-0.2,3.4C252.3,300,251.8,303.3,251.2,306.6L251.2,306.6z",
    fill: "#FFE3A9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M251.1,362c0.3,0.1,0.7,0.1,1,0c0.4,0,0.8,0,1-0.1c0.5-0.1,1-0.2,1.3-0.5c0.2-0.2,0.4-0.4,0.6-0.6 c0.1,0,0.2,0.1,0.3,0l0.2-0.2c0.3-1,0.5-1.9,0.7-3.2c0.1-0.5,0.2-1.5,0.3-2.6c0.3-2.7,0.8-6,1.2-9.1c0.9-6.2,2.1-11.9,2.1-11.9 s1.1-5.6,2.6-11.8c0.7-3.1,1.6-6.3,2.3-9c0.5-1.6,0.8-3,1-3.6c0.1-0.4,0.2-0.7,0.3-1c0.1-0.1,0.1-0.2,0.2-0.3 c0.3-0.6,0.7-1.3,0.6-2.4c0-0.3-0.1-0.7-0.5-1.2s-1-1-2-0.9l0,0l0,0c-0.1-0.4-0.2-0.7-0.4-1v-0.1l0,0l0,0c0,0,0,0,0-0.1h-0.2 c-0.4-0.5-0.9-1-1.4-1.2c-0.4-0.2-0.9-0.3-1.3-0.3c-0.1,0-0.2,0-0.3,0l0,0c0-0.1,0-0.2,0-0.2s0-0.1,0-0.4c0-0.2-0.1-0.6-0.2-1 c-0.2-0.4-0.5-0.9-1-1.3s-1.2-0.5-1.8-0.5c-0.3,0-0.6,0-0.9,0h-0.2c-0.1,0,0,0,0,0l-0.2-0.1c-0.4-0.3-0.9-0.7-1.2-1.1 c-0.8-0.8-1.4-1.6-1.8-2.2c-0.6-0.8-0.8-1.2-1-1.5c-0.2-0.4-0.4-0.7-0.6-1l0,0c0.1-0.7-0.3-1.4-0.8-1.8c-0.5-0.5-1.2-0.9-2.1-1.2 c-0.5-0.1-1.4-0.4-2.6-0.7c-1.9-0.5-3.9-1-6-1.6c-1.1-0.3-2.3-0.5-3.6-0.2c-0.6,0.1-1.2,0.5-1.7,0.8c-0.2,0.1-0.4,0.3-0.6,0.3 c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0-0.3,0c-0.2,0-0.2,0-0.4-0.2s-0.4-0.4-0.6-0.6c-0.5-0.4-1.1-0.6-1.6-0.9 c-1.1-0.4-2.1-0.6-3.1-0.7c-2-0.2-3.9-0.1-5.4-0.1c-3.1,0-5.1,0-5.1,0s-2,0-5.1,0s-7.3,0.2-11.7,0.3c-2.2,0.1-4.5,0.1-6.6,0.2 c-2.2,0.1-4.4,0-6.4,0.6c-0.5,0.1-1,0.3-1.4,0.5c-0.2,0.1-0.4,0.2-0.7,0.3l-0.3,0.2l-0.2,0.2c-0.2,0.2-0.5,0.3-0.6,0.5 c-0.4,0.3-0.6,0.6-0.8,0.8c-0.9,1.1-1.2,2.3-1,3.3c-0.1,0.5-0.2,1.1-0.3,1.7c-0.1,1.1-0.5,3.4-0.9,5.9c-0.3,2.1-0.6,4.3-0.9,6.4 c-0.1,1-0.3,2-0.4,2.9c-0.1,0.7-0.2,1.3-0.3,1.9c0,0.2-0.1,0.4-0.1,0.6v0.2v0.1c0,0,0,0.1,0,0l0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6 c0.1-0.1,0.2,0,0.2,0h0.1c0.4,0.1,0.8,0.5,0.9,0.9c0.1,0.2,0.1,0.4,0.1,0.6s-0.1,0.5-0.2,0.7c-0.4,0.9-1.1,1.8-1.5,2.8 c-0.9,1.9-1,3.7-1.1,5c-0.2,2.7-0.3,4-0.3,4s-2,26.5-2.4,31.8c0,0.4,0,0.8-0.1,1.1c-0.1,0.3-0.2,0.6-0.2,0.9 c-0.1,0.3-0.1,0.7-0.2,1c0,0.2-0.1,0.4-0.1,0.6c0,0.3-0.1,0.5-0.1,0.8c0,0.2-0.1,0.5-0.1,0.9c0.3,0,0.8,0,1.2,0 c1.1,0,2.5,0,3.9,0c4.6,0,9.9,0,15.1,0.1c10.3,0,19.6,0.1,19.6,0.1s9.4,0,19.6,0.1c0.8,0,1.6,0,2.3,0c4.4,0,8.8,0,12.7,0.1 C250.6,361.9,250.8,361.9,251.1,362L251.1,362z M263.5,308c0-0.3,0.1-0.5,0.1-0.8c0-0.5,0.1-0.8,0.1-1.1c0-0.1,0-0.2,0-0.3 c0.1,0,0.2,0,0.3,0l0,0l0,0l0,0l0,0l0.1-0.2c0-0.1,0.1-0.3,0.1-0.4s0-0.3,0.1-0.5h0.1c0.4,0,0.8,0.2,1,0.4 c0.2,0.2,0.2,0.5,0.2,0.6c0,0.2,0,0.4,0,0.6c-0.4,0.8-0.7,1.6-1.1,2.7c-0.2,0.7-0.6,2-1,3.6c-0.7,2.7-1.6,5.9-2.3,9 c-1.5,6.2-2.6,11.8-2.6,11.8s-1.1,5.7-2.1,11.9c-0.5,3.1-0.9,6.5-1.2,9.2c-0.1,1.2-0.2,2.1-0.3,2.6c0,0.4-0.1,0.7-0.1,1l-0.1-0.1 c0.1,0.1,0.1,0.2,0.1,0.3c0,0.2,0,0.4,0,0.6c-0.1,0.3-0.2,0.5-0.4,0.7c-0.2,0.2-0.4,0.4-0.6,0.5s-0.4,0.1-0.6,0.2 c0.2-0.5,0.4-1,0.6-1.6c0.1-0.2,0.1-0.6,0.3-1c0.1-0.4,0.3-1,0.5-1.5c0.4-1.5,0.7-3.2,0.9-5c0.2-1.8,0.2-3.5,0.3-5.3 c0.1-1.7,0.2-3.4,0.4-5c0.2-1.5,0.5-3,0.7-4.2c0.5-2.4,0.8-4,0.8-4s0.1-0.4,0.2-1.1s0.3-1.7,0.4-3c0.2-2.4,0.8-5.7,1.6-9.1 c0.4-1.7,0.9-3.4,1.4-5s1.1-3.2,1.6-4.7C263.2,309.4,263.4,308.7,263.5,308L263.5,308z M260.7,300.8L260.7,300.8L260.7,300.8 L260.7,300.8L260.7,300.8z M259.9,305.5c0-0.3,0.1-0.5,0.1-0.7c0.1-0.5,0.1-0.8,0.1-1.1c0.1-0.7,0.1-1.2,0.1-1.7 c0.1,0,0.1,0,0.2,0h0.2c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0,0.2,0c0.3,0,0.6,0.1,0.9,0.2c0.5,0.2,1,0.7,1.2,1.4 c-0.3,0.8-0.4,1.6-0.5,2.6c0,0.2-0.1,0.6-0.1,1c0,0.2-0.1,0.5-0.1,0.7c-0.1,0.5-0.3,1.3-0.5,2c-0.5,1.5-1,3-1.6,4.7 c-0.5,1.7-1,3.4-1.4,5.1c-0.9,3.4-1.4,6.8-1.6,9.2c-0.2,2.4-0.5,4-0.5,4s-0.3,1.5-0.8,4c-0.2,1.2-0.5,2.6-0.8,4.2 c-0.2,1.6-0.3,3.3-0.4,5.1c-0.1,1.8-0.2,3.5-0.3,5.2c-0.2,1.7-0.5,3.4-0.9,4.8c-0.1,0.6-0.3,1-0.5,1.5c-0.1,0.5-0.2,0.8-0.3,1 c-0.2,0.9-0.4,1.5-0.5,2.1c-0.5,0-1.1,0-1.8,0c-0.1,0-0.3,0-0.5,0c0,0,0,0,0-0.1c0-0.2,0.1-0.3,0.1-0.5c0.1-0.4,0.2-0.7,0.2-1.1 c0.1-0.5,0.4-1.4,0.7-2.5c0.4-1.5,0.7-3.4,0.9-5.2c0.2-1.8,0.3-3.7,0.6-5.5c0.8-7.3,2.1-13.8,2.1-13.8s0.3-1.6,0.8-4.2 c0.3-1.3,0.6-2.8,0.9-4.4s0.6-3.4,0.9-5.2s0.6-3.6,1-5.4s0.9-3.5,1.2-5.1C259.6,307,259.7,306.2,259.9,305.5L259.9,305.5z M256.3,304.9c0.2-0.8,0.4-1.6,0.6-2.3c0-0.3,0.1-0.5,0.1-0.8c0.1-0.5,0.1-0.8,0.2-1.1c0.1-0.8,0.1-1.5-0.1-2.1 c0.1,0,0.3,0,0.5,0c1.7,0,1.9,1.2,2,1.8c-0.2,1-0.4,1.9-0.6,3.2c0,0.2-0.1,0.6-0.1,1c0,0.2-0.1,0.5-0.1,0.7 c-0.1,0.6-0.3,1.4-0.4,2.2c-0.3,1.6-0.9,3.2-1.2,5.1c-0.4,1.8-0.7,3.7-1,5.5s-0.6,3.6-0.9,5.2s-0.6,3.1-0.9,4.4 c-0.5,2.5-0.8,4.2-0.8,4.2s-1.3,6.6-2.1,13.9c-0.5,3.6-0.6,7.6-1.4,10.5c-0.3,1.1-0.6,2.1-0.7,2.6s-0.2,0.9-0.2,1.3 c0,0.2,0,0.4,0,0.6c0,0.1,0,0.1,0,0.1c-0.3,0-0.5,0-0.8,0c-0.1-0.1-0.3-0.2-0.4-0.3c0,0.1,0.1,0.2,0.1,0.3c-0.5,0-1,0-1.6,0 c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.6,0.4-1.3,0.5-2.1c0-0.5,0-1.5,0.1-2.6c0.2-1.6,0.6-3.4,1-5.3c0.5-1.8,1-3.8,1.4-5.6 c0.9-3.8,1.5-7.4,1.9-10.1s0.7-4.4,0.7-4.4s0.3-1.7,0.6-4.4c0.4-2.7,1-6.3,1.5-10.1c0.3-1.9,0.6-3.8,0.9-5.7 C255.6,308.3,255.9,306.5,256.3,304.9L256.3,304.9z M252.8,295.3c0.4,0.5,0.9,1.1,1.4,1.7c0.4,0.4,0.9,0.8,1.4,1.2l0.2,0.1 c0.1,0.1,0.2,0.2,0.3,0.2l0,0c0,0.5-0.1,1.2-0.2,2c0,0.2-0.1,0.6-0.1,1c0,0.2-0.1,0.5-0.1,0.7c-0.2,0.7-0.4,1.5-0.5,2.3 c-0.4,1.6-0.8,3.5-1.1,5.4c-0.3,1.9-0.6,3.8-0.9,5.7c-0.6,3.8-1.2,7.4-1.5,10.1c-0.4,2.7-0.6,4.4-0.6,4.4s-0.3,1.7-0.7,4.4 c-0.4,2.7-1.1,6.3-1.9,10c-0.4,1.9-0.9,3.7-1.4,5.6s-0.8,3.8-1,5.4c-0.1,1.3-0.1,2.2-0.1,2.7c0,0.8-0.1,1.4-0.2,1.9 c0,0.2-0.1,0.4-0.1,0.6c-1.4,0-2.9,0-4.4,0c0.3-0.7,0.6-1.5,0.9-2.5c0.1-0.5,0.3-1.4,0.6-2.6c0.8-3.5,1.7-7.7,2.4-11.8 c1.5-8.1,2.2-15.6,2.2-15.6s0-0.2,0.1-0.6c0-0.4,0.1-1.1,0.1-2c0-0.5-0.1-1-0.3-1.7c-0.2-0.6-0.6-1.2-0.8-1.9 c-0.3-0.6-0.4-1.3-0.3-2c0.1-0.8,0.4-1.6,0.9-2.5c0.1-0.2,0.1-0.2,0.1-0.3l0,0l0,0l0,0l0,0l0,0h0.1c0.1,0,0.1,0,0.2,0 s0.3,0,0.4-0.1c0.3-0.1,0.5-0.2,0.8-0.4c1-0.7,1.3-2,1.5-3.1c0.4-2.2,0.8-4.6,1.2-7.1c0.6-3.3,1.1-6.5,1.4-7.9 C252.8,297.4,252.8,296.4,252.8,295.3L252.8,295.3z M252.5,294.9c-0.5,1.1-0.8,2.1-1.1,3.6c-0.2,1.4-0.8,4.6-1.4,7.9 c-0.4,2.4-0.9,4.9-1.2,7.1c-0.2,1.1-0.5,2-1,2.3c-0.1,0.1-0.3,0.2-0.4,0.2s-0.1,0-0.2,0h-0.1l0,0H247c-0.2-0.1-0.4-0.1-0.6-0.2 c-0.1,0.2-0.2,0.3-0.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.5,1-0.9,1.9-1,2.9s0.1,2,0.4,2.7s0.6,1.3,0.8,1.8c0.2,0.5,0.2,1,0.3,1.4 c0,0.8,0,1.5-0.1,1.9c0,0.4-0.1,0.6-0.1,0.6s-0.8,7.4-2.2,15.5c-0.7,4-1.6,8.3-2.4,11.7c-0.3,1.1-0.5,2.1-0.6,2.6 c-0.3,1.1-0.4,2-0.4,2.8c-0.6,0-1.3,0-1.9,0c0.2-0.1,0.3-0.3,0.4-0.4c0.2-0.2,0.3-0.5,0.4-0.8s0.1-0.9,0.1-1.5 c-0.1-0.9,0.3-2,0.5-3.2c0.1-0.6,0.2-1.2,0.2-1.8c0-0.6,0.1-1.2,0.1-1.8c0.3-2.4,0.8-4.8,1.6-7c0.8-2.2,1.7-4.5,1.7-6.8 c0.1-2.2-0.2-4.2-0.1-5.9c0-1.6,0.6-2.9,0.9-3.9s0.4-1.5,0.4-1.5s0-0.1,0.1-0.4c0-0.3,0.1-0.7,0-1.2s-0.3-1.1-0.6-1.7 c-0.3-0.6-0.3-1.2-0.2-2.1c0.1-0.9-0.2-1.9-0.4-2.8c-0.2-0.9-0.2-2,0.2-2.8c0.2-0.4,0.6-0.5,1.2-0.5c0.5,0,1.2,0.1,1.9-0.3 c0.3-0.2,0.5-0.5,0.6-0.8s0.2-0.6,0.2-0.9c0.1-0.6,0.2-1.2,0.3-1.8c0.7-4.8,1.4-9.8,2.1-14c0.3-1.7,0.6-3.1,0.7-3.9 c0.1-0.5,0.1-0.9,0.1-1.2c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.3,0.4,0.7,1,1.6C252.4,294.7,252.4,294.8,252.5,294.9L252.5,294.9z M235.4,360.7c-10.3,0-19.6-0.1-19.6-0.1s-32.2-0.1-38.6-0.2l0,0v-0.1c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4 c0.3-1,0.5-1.9,0.6-3.2c0.4-5.3,2.4-31.8,2.4-31.8s0.1-1.4,0.3-4c0.1-1.3,0.2-3,1-4.6c0.4-0.8,1.1-1.6,1.6-2.8 c0.1-0.3,0.2-0.6,0.2-1s0-0.8-0.2-1.1c-0.3-0.7-0.8-1.4-1.8-1.6c-0.2,0-0.3,0-0.3,0s0,0,0-0.1c0-0.2,0.1-0.5,0.1-0.7 c0.1-0.9,0.3-1.9,0.4-2.9c0.3-2,0.6-4.2,0.9-6.4c0.4-2.5,0.7-4.9,0.8-5.9c0.2-1.2,0.2-2.1,0.1-3.1c0.2-0.4,0.5-0.9,0.9-1.4 c0.1-0.2,0.4-0.4,0.7-0.7c0.1-0.1,0.3-0.3,0.5-0.4c0.6-0.4,1.4-0.8,2.3-1c1.8-0.5,3.9-0.5,6.1-0.5c2.2-0.1,4.4-0.1,6.6-0.2 c4.4-0.1,8.6-0.2,11.7-0.3c3.1,0,5.1,0,5.1,0s2,0,5.1,0c1.6,0,3.4-0.1,5.3,0.1c1,0.1,2,0.3,2.9,0.6c0.5,0.2,0.9,0.4,1.2,0.7 c0.2,0.2,0.3,0.3,0.6,0.5c0.1,0.1,0.3,0.2,0.5,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0,0.3,0,0.5,0s0.4-0.1,0.6-0.1 c0.3-0.1,0.6-0.3,0.8-0.5c0.5-0.3,0.8-0.5,1.3-0.6c0.9-0.2,2-0.1,3,0.2c2.1,0.5,4.1,1.1,6,1.6c1.1,0.3,2.1,0.5,2.5,0.7 c0.7,0.2,1.2,0.4,1.6,0.6c0.1,0.4,0.2,0.8,0.4,1.2v0.1c-0.2,0.5-0.4,0.9-0.5,1.6c0,0.1-0.1,0.3-0.1,0.6c-0.2,0.9-0.4,2.1-0.6,3.3 c-0.7,4.2-1.4,9.2-2.1,14c-0.1,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.2,1.1-0.6,1.3c-0.4,0.2-0.9,0.2-1.5,0.2s-1.4,0.2-1.7,0.8 c-0.3,0.6-0.4,1.1-0.4,1.7c0,0.5,0,1.1,0.1,1.6c0.2,1,0.5,1.8,0.4,2.6c0,0.4-0.1,0.8-0.1,1.2c0,0.4,0.2,0.9,0.3,1.2 c0.3,0.6,0.5,1.1,0.6,1.5s0,0.8,0,1s0,0.4,0,0.4s-0.1,0.5-0.4,1.4c-0.1,0.5-0.3,1-0.5,1.7c-0.2,0.6-0.4,1.5-0.4,2.3 c-0.1,1.7,0.2,3.7,0.1,5.9c0,2.1-0.9,4.3-1.7,6.6c-0.8,2.3-1.3,4.7-1.6,7.1c-0.1,0.6-0.1,1.2-0.1,1.8c0,0.6-0.1,1.1-0.2,1.7 s-0.2,1.1-0.3,1.7c-0.1,0.5-0.2,1.2-0.2,1.6c0,0.6,0,1.1-0.1,1.3c-0.1,0.2-0.1,0.4-0.2,0.6s-0.1,0.2-0.2,0.3c0,0-0.3-0.2-0.5-0.5 c0,0.3,0.1,0.5,0.3,0.9c-0.1,0-0.2,0-0.3,0C236.9,360.8,236.1,360.8,235.4,360.7L235.4,360.7z",
    fill: "#202020"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: 15,
    className: "svggeyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 255.4,
    cy: 171.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.7,
    cy: 171.4,
    r: 5.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M254.7,167.2c-2.9,0.3-4.6,3.2-3.2,5.9c0.7,1.3,2.6,0.1,1.9-1.1c-0.6-1,0-2.4,1.2-2.5 C256.2,169.3,256.2,167.1,254.7,167.2L254.7,167.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M183.7,167.6c-2.4-1.4-5.5,0.4-5.2,3.2c0.1,1.4,2.4,1.4,2.2,0c-0.1-1.1,0.9-1.8,1.9-1.2 C183.8,170.3,184.9,168.4,183.7,167.6L183.7,167.6L183.7,167.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.8,171.6c1.9-4,6-6.2,10.4-5.7c1,0.1,1-1.4,0-1.5c-4.9-0.6-9.6,2-11.7,6.4C247.1,171.7,248.4,172.5,248.8,171.6 L248.8,171.6L248.8,171.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.4,178.8c3.3-1.2,6.6-1.8,10.1-1.7c1,0,1-1.5,0-1.5c-3.6-0.1-7.1,0.5-10.5,1.8C250.1,177.6,250.5,179.1,251.4,178.8 L251.4,178.8L251.4,178.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.4,165.9c3.9-0.9,7.4,1.3,8.3,5.1c0.2,0.9,1.7,0.5,1.4-0.4c-1.2-4.6-5.6-7.2-10.2-6.2 C178.1,164.7,178.5,166.1,179.4,165.9L179.4,165.9L179.4,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.4,176.2c3.2,0.2,6.3,1.1,9.1,2.7c0.9,0.5,1.6-0.8,0.8-1.3c-3.1-1.7-6.4-2.6-9.9-2.9 C174.4,174.6,174.4,176.1,175.4,176.2L175.4,176.2L175.4,176.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6cm5",
    d: "M246.6,165.1c-0.1-0.2-0.3-0.8-0.2-1.6c0.1-0.6,0.4-1.4,0.7-2c0.3-0.6,0.6-1.1,0.6-1.1s0.3-0.6,0.7-1.2 c0.4-0.6,1-1.4,1.4-1.8c0.4-0.4,0.6-0.6,0.7-0.7c0.2-0.1,0.4-0.3,0.6-0.3c-0.3,0-0.6,0-0.9,0c-0.1,0.1-0.3,0.1-0.4,0.2 c-0.1,0.1-0.3,0.1-0.4,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.2-0.5,0.5-0.7,0.9c-0.9,1.4-2,3.2-3,4.8c-0.5,0.8-0.9,1.6-0.6,2.3 s1,1.1,1.6,1.2c0.6,0.1,1,0,1.4-0.1C247.4,166.1,246.9,165.7,246.6,165.1L246.6,165.1z",
    fill: "#F9DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm5",
    d: "M184.8,158.2c0.3-0.3,0.6-0.5,0.6-0.5s0.4-0.2,0.8-0.4c0.5-0.2,1.1-0.2,1.4-0.2c0.6,0.1,0.9,0.2,1,0.2 c0,0,0.1,0,0.1,0.1c0,0,0,0-0.1-0.1s-0.2-0.2-0.3-0.3c-0.2-0.2-0.5-0.5-0.8-0.8c-0.6-0.5-1.4-0.8-2.2-0.6s-1.5,0.8-1.8,1.6 c-0.4,0.8-0.4,1.6-0.2,2.4c0.1,0.4,0.2,0.7,0.3,1.1c0-0.3,0-0.7,0.3-1.4C184.2,159,184.5,158.5,184.8,158.2L184.8,158.2z",
    fill: "#F9DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm6",
    d: "M190.6,159.1c-0.1-0.1-0.2-0.3-0.4-0.4c0,0.1,0.1,0.2,0.1,0.3c-0.6-0.6-1.1-0.8-1.9-1.1 c-0.1-0.1-0.4-0.1-0.9-0.2c-0.3,0-0.8,0-1.2,0.1s-0.7,0.3-0.7,0.3s-0.2,0.1-0.5,0.4c-0.2,0.3-0.5,0.7-0.6,1 c-0.2,0.6-0.2,1.1-0.2,1.3c0,0.5,0.1,0.9,0.2,1.2c0.5,0.8,0.9,1.2,0.9,1.2s0.1,0.1,0.4,0.4c0.3,0.2,0.6,0.6,1.2,0.9 c0.5,0.3,1.2,0.6,2,0.7c0.8,0.1,1.6-0.1,2.3-0.6c0.6-0.5,0.9-1.4,0.9-2.2c0-0.9-0.3-1.7-0.8-2.3 C191.2,159.7,190.8,159.3,190.6,159.1L190.6,159.1z",
    fill: "#FF7C9E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm6",
    d: "M252.7,157c-0.3-0.2-0.6-0.2-0.8-0.2c-0.3,0-0.6,0.2-0.9,0.4c-0.1,0.1-0.3,0.2-0.6,0.6 c-0.3,0.4-0.9,1.1-1.3,1.7c-0.4,0.6-0.7,1.2-0.7,1.2s-0.3,0.4-0.5,1.1c-0.3,0.6-0.6,1.3-0.6,1.9c-0.1,0.7,0,1.1,0.1,1.2 c0.2,0.4,0.4,0.6,0.6,0.9c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.1,0,0.1,0s0.8-0.3,2-0.9c1.1-0.7,2.6-1.9,3.2-3.6 c0.3-0.9,0.4-1.8,0.1-2.7C253.7,158,253.2,157.4,252.7,157L252.7,157z",
    fill: "#FF7C9E"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm5",
    d: "M247.2,164.9c-0.1-0.2-0.2-0.6-0.1-1.2c0.1-0.5,0.4-1.3,0.6-1.9c0.3-0.6,0.5-1.1,0.5-1.1s0.3-0.5,0.7-1.2 c0.4-0.6,1-1.3,1.3-1.7c0.4-0.4,0.5-0.6,0.6-0.6c0.3-0.3,0.6-0.4,0.9-0.4s0.5,0,0.8,0.2c-0.1-0.1-0.2-0.1-0.2-0.2 c-0.5-0.3-1-0.4-1.2-0.4c0,0,0,0-0.1,0c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0.1-0.4,0.3-0.7,0.7c-0.4,0.4-0.9,1.1-1.4,1.8 c-0.4,0.6-0.7,1.2-0.7,1.2s-0.3,0.5-0.6,1.1c-0.3,0.6-0.6,1.4-0.7,2c-0.1,0.8,0,1.3,0.2,1.6c0.3,0.6,0.8,1,1.2,1.1h0.1 c0.2-0.1,0.4-0.1,0.5-0.1c-0.2-0.1-0.5-0.2-0.6-0.3C247.6,165.5,247.4,165.3,247.2,164.9L247.2,164.9z",
    fill: "#F9DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6cm5",
    d: "M184.7,159.6c0.1-0.3,0.3-0.7,0.6-1c0.2-0.3,0.5-0.4,0.5-0.4s0.3-0.2,0.7-0.3s0.9-0.2,1.2-0.1 c0.5,0.1,0.7,0.1,0.9,0.2c0.8,0.3,1.3,0.6,1.9,1.1c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.2-0.5-0.4-0.8-0.7 c-0.1-0.1-0.2-0.2-0.3-0.4c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.4-0.2-1-0.2c-0.4,0-0.9,0-1.4,0.2c-0.5,0.1-0.8,0.4-0.8,0.4 s-0.3,0.2-0.6,0.5s-0.6,0.8-0.7,1.2c-0.2,0.6-0.3,1.1-0.3,1.4c0.1,0.3,0.3,0.6,0.5,0.9c0.1,0.2,0.2,0.3,0.3,0.5 c-0.1-0.4-0.1-0.7-0.2-1.2C184.5,160.6,184.5,160.2,184.7,159.6L184.7,159.6z",
    fill: "#F9DAC0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M252.8,156.2c-0.6-0.4-1.2-0.4-1.5-0.5c-0.1,0-0.2,0-0.3,0c-0.4-0.1-0.9,0-1.4,0.2 c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.2-0.6,0.6-0.8,1c-1,1.5-2,3.2-3,4.9c-0.2,0.4-0.5,0.9-0.7,1.4 s-0.2,1.1,0,1.6c0.4,1,1.3,1.4,2.1,1.6c0.8,0.1,1.4,0,1.8-0.1s0.6-0.2,0.6-0.2s0.9-0.3,2.1-1s2.8-2,3.5-3.9 c0.3-1,0.4-2.1,0.2-3.1C254.3,157.6,253.6,156.7,252.8,156.2L252.8,156.2z M253.8,161.5c-0.6,1.8-2.1,2.9-3.2,3.6 c-1.1,0.7-2,0.9-2,0.9s0,0-0.1,0s-0.2,0.1-0.5,0.1h-0.1c-0.4,0.1-0.8,0.2-1.4,0.1c-0.6-0.1-1.3-0.5-1.6-1.2 c-0.3-0.7,0.1-1.5,0.6-2.3c1-1.6,2.1-3.4,3-4.8c0.2-0.3,0.5-0.6,0.7-0.9c0.1-0.1,0.2-0.2,0.3-0.2c0.2-0.1,0.3-0.2,0.4-0.3 s0.3-0.1,0.4-0.2c0.3,0,0.5,0,0.9,0c0,0,0,0,0.1,0c0.2,0,0.7,0.1,1.2,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0.5,0.4,1,1.1,1.2,1.8 C254.1,159.6,254.1,160.6,253.8,161.5L253.8,161.5z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M191.1,158.7c-0.3-0.3-0.6-0.5-0.8-0.7s-0.4-0.4-0.6-0.7c-0.1-0.1-0.2-0.2-0.4-0.4 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2-0.2-0.5-0.6-0.9-0.8c-0.6-0.6-1.7-1-2.7-0.8c-1,0.3-1.8,1-2.2,1.9c-0.5,0.9-0.5,1.9-0.3,2.8 c0.2,0.9,0.6,1.6,0.9,2.2c0.7,1.1,1.3,1.8,1.3,1.8s0.1,0.2,0.4,0.4c0.3,0.3,0.7,0.6,1.3,1s1.3,0.7,2.2,0.8s1.9-0.1,2.7-0.8 s1.2-1.8,1.1-2.7c0-1-0.4-1.9-0.9-2.6C191.6,159.2,191.3,158.9,191.1,158.7L191.1,158.7z M191.3,164.7c-0.6,0.5-1.5,0.7-2.3,0.6 c-0.8-0.1-1.4-0.4-2-0.7s-0.9-0.7-1.2-0.9s-0.4-0.4-0.4-0.4s-0.4-0.4-0.9-1.2c-0.1-0.1-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.6-0.5-0.9 c-0.1-0.3-0.3-0.7-0.3-1.1c-0.2-0.8-0.1-1.6,0.2-2.4c0.4-0.8,1.1-1.4,1.8-1.6c0.8-0.2,1.6,0.1,2.2,0.6c0.3,0.2,0.6,0.5,0.8,0.8 c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0.1,0.1s0.3,0.3,0.3,0.4c0.3,0.3,0.6,0.5,0.8,0.7c0.1,0.1,0.2,0.2,0.3,0.3s0.2,0.2,0.4,0.4 s0.5,0.6,0.9,1.1c0.4,0.6,0.7,1.4,0.8,2.3C192.3,163.3,192,164.1,191.3,164.7L191.3,164.7z",
    fill: "#202020"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: 12,
    className: "svggmouth"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4cm3",
    d: "M212,228.4c3.2,0.7,3.9,3.9,3.9,6.8c0.2-2.7,1.3-5.2,4.5-4.9c2.8,0.3,4.2,2.4,4.8,4.8 c0.1-0.8,0.3-1.5,0.5-2.2v-22.6h28.5c-0.2-1.5-0.5-2.9-0.9-4.4c-0.7-2.5-1.7-4.9-2.8-7c-1.2-2.4-2.6-4.5-3.8-6.2 c-0.9-1.2-1.7-2.2-2.4-2.9c-0.1,3.1-1.4,7.5-5.4,6.5c-3.7-0.9-4.2-6.8-4-10.1c-0.1,0-0.1,0-0.2,0c0.1,4.1-0.3,10.1-5.4,10.9 c-3,0.4-4.5-1.4-5.3-3.7c-0.4,2.8-1.4,5.4-4.3,5.6c-3.2,0.2-4.6-2.1-5.1-4.7c-0.6,2.4-1.9,4.5-4.6,4.3c-4.8-0.5-4.6-6.2-4.1-9.7 c-0.2,0-0.4,0-0.6-0.1c-0.4-0.1-0.7-0.1-1.1-0.1c-0.2,0-0.5-0.1-0.8-0.1c-0.6-0.1-1.1-0.2-1.6-0.3c-0.3-0.1-0.5-0.1-0.7-0.1 c-0.1,0-0.2-0.1-0.4-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6,0.4,0.9c0.3,0.6,0.5,1.3,0.7,2.2c0.1,0.2,0.1,0.6,0.2,1.1 c0,0.2,0.1,0.5,0.1,0.7c0.1,0.5,0.2,1.2,0.3,1.9c0.4,2.7,0.8,6,1.1,9.1s0.2,6.1,0.1,8.3c-0.1,1.1-0.2,2-0.3,2.6s-0.1,1-0.1,1 s0,0.4-0.1,1s-0.1,1.5-0.1,2.6c0,2.1,0.1,5.1,1.1,7.9c0.6,1.9,1.8,3.6,3.1,5l0,0C207.4,230.1,209.2,227.8,212,228.4L212,228.4z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.3,214.4C255.3,214.4,255.3,214.3,255.3,214.4c0-1.4-0.1-2.7-0.2-4c-0.2-1.5-0.5-3-0.9-4.4c-0.7-2.5-1.7-4.9-2.9-7 c-1.3-2.4-2.7-4.6-3.9-6.3c-0.9-1.2-1.8-2.2-2.5-2.9c0-0.3,0-0.6,0-0.8c-0.2-0.2-0.5-0.4-0.7-0.6c-0.1,0.1-0.2,0.2-0.2,0.4 c0,0.1,0,0.2,0,0.2c-0.7-0.6-1.1-0.9-1.1-0.9s-0.5-0.4-1.5-0.9s-2.5-1-4.5-1.1c-0.3,0-0.5,0-0.8,0c0-0.2,0-0.4,0-0.6 c0-0.6-0.9-0.6-0.9,0c0,0.2,0,0.4,0,0.6c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0-0.5c0-0.5-0.6-0.6-0.9-0.2c0,0.1-0.1,0.1-0.1,0.2 c-0.1,0.2-0.1,0.4,0.1,0.5v0.1c-2.9,0.4-6.2,1.3-9.8,2c0-0.2,0-0.3,0-0.5c0-0.4-0.4-0.5-0.7-0.3c-0.2,0-0.4,0.2-0.4,0.4 s0,0.4,0,0.6c-0.5,0.1-0.9,0.1-1.4,0.2c-2.3,0.3-4.6,0.5-6.9,0.6c0-0.1,0-0.1,0-0.2c0-0.4-0.5-0.6-0.8-0.3 c-0.3,0-0.5,0.1-0.5,0.4v0.1c-2.6,0-5.1-0.1-7.5-0.3c0-0.1,0-0.2,0-0.3c0.1-0.6-0.8-0.8-0.9-0.2c0,0.1,0,0.3-0.1,0.4 c-0.2,0-0.4,0-0.6-0.1c-0.4-0.1-0.8-0.1-1.1-0.1c-0.2,0-0.5-0.1-0.8-0.1c-0.6-0.1-1.1-0.2-1.7-0.3c-0.3-0.1-0.5-0.1-0.8-0.1 c-0.1,0-0.3-0.1-0.4-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6,0.5,0.9c0.3,0.6,0.5,1.3,0.7,2.2c0.1,0.2,0.1,0.6,0.2,1.1 c0,0.2,0.1,0.5,0.1,0.7c0.1,0.5,0.2,1.2,0.3,1.9c0.4,2.8,0.9,6,1.1,9.2c0.2,3.1,0.3,6.2,0.1,8.4c-0.1,1.1-0.2,2.1-0.3,2.7 c-0.1,0.6-0.1,1-0.1,1s0,0.4-0.1,1s-0.1,1.5-0.1,2.6c0,2.1,0.1,5.1,1.2,8c0.6,1.9,1.8,3.7,3.2,5.1l0,0c0,0.4,0,0.7,0.1,1.1 c0.2,0.2,0.4,0.4,0.7,0.6c0.2-0.1,0.3-0.3,0.3-0.5c0-0.1,0-0.2-0.1-0.3c0.4,0.3,0.8,0.6,1.2,0.9c1,0.6,1.9,1,2.3,1.2 c1.4,0.6,2.3,0.9,3.4,1.4c0,0.1,0,0.2,0,0.3c-0.1,0-0.1,0-0.2,0c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.2,0,0.4 c-0.1,0.5,0.8,0.6,0.9,0.2c0.1,0.2,0.2,0.4,0.3,0.6c0,0,0,0.1,0.1,0.1s0.2-0.1,0.4,0c0.1,0,0.1,0,0.2,0.1 c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0-0.3,0-0.4c2,0.4,4.1,0.6,6.1,0.7c0.6,0,1.3,0,1.9,0c0,0.1,0,0.3,0,0.4c0,0.4,0.5,0.5,0.8,0.4 c0.2,0.1,0.4,0.1,0.6-0.1c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.1-0.3c2.1-0.1,4-0.3,5.6-0.6c0.8-0.1,1.4-0.2,2-0.4 c0,0.1,0,0.3,0,0.4c0,0.1,0.1,0.2,0.2,0.3l0,0c0.2-0.1,0.5-0.1,0.7-0.1v-0.1c0-0.2,0-0.4,0-0.6c0.7-0.1,1-0.3,1-0.3 s0.4-0.1,1.1-0.3s1.6-0.5,2.8-0.9c0.5-0.2,1.2-0.5,1.8-0.7c0,0.2,0,0.4,0.1,0.7c0,0,0,0,0,0.1c0.1-0.1,0.3-0.1,0.5-0.2 c0.1-0.1,0.3-0.1,0.4-0.2c0-0.2-0.1-0.5-0.1-0.8c1.7-0.8,3.6-1.9,5.3-3.4c0.7-0.6,1.3-1.2,1.9-1.8c0,0.1,0.1,0.2,0.1,0.3 s0.1,0.1,0.1,0.1c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0.1-0.1,0.2-0.2l0,0c0.1-0.2,0.2-0.3,0.3-0.3c0-0.2-0.1-0.4-0.2-0.6 c0.8-1,1.4-2.1,2-3.1c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.3,0.2-0.5v-0.1c0.1-0.3,0.2-0.6,0.4-0.9c0.4-1.1,0.7-2,0.8-2.5 c0.2-1,0.5-1.7,0.7-2.4c0-0.1,0-0.1,0-0.2c0.2-1,0.3-2,0.3-3.1C255.7,215.1,255.7,214.4,255.3,214.4L255.3,214.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.4,210.3c-0.2-1.6-0.5-3.1-0.9-4.7c-1-3.4-2.4-6.5-3.9-9.1c-1-1.7-2-3.2-2.9-4.4c-0.5-0.8-1.1-1.4-1.6-2 c-1-0.9-1.9-1.8-2.9-2.7c-0.1-0.1-0.2-0.1-0.2-0.1s-0.5-0.4-1.6-1c-1-0.6-2.7-1.2-4.8-1.2c-2.1-0.1-4.5,0.3-7,0.9 c-2.5,0.6-5.1,1.2-7.9,1.6c-5.6,0.8-11.4,0.7-16.4,0.1c-0.4-0.1-0.8-0.1-1.2-0.2c-0.2,0-0.4-0.1-0.6-0.1 c-0.6-0.1-1.1-0.2-1.6-0.3c-0.3-0.1-0.5-0.1-0.7-0.1c-0.4-0.1-0.7-0.1-0.9-0.2h-0.1c-1.8-0.4-2.8-0.4-4.3-0.4 c1.4,0.8,2.3,1.2,4.1,1.6c0.1,0,0.2,0,0.3,0.1c0,0.1,0,0.2,0,0.3s0,0.1,0,0.2c0,0.4,0.1,0.7,0.1,1c0.1,0.7,0.2,1.4,0.4,2.2 c0.1,0.2,0.1,0.6,0.2,1c0,0.2,0.1,0.5,0.1,0.7c0.1,0.5,0.2,1.2,0.3,1.9c0.4,2.7,0.8,5.9,1,9s0.2,6,0.1,8.2 c-0.1,1.1-0.2,1.9-0.3,2.6s-0.1,1-0.1,1s0,0.4-0.1,1s-0.1,1.5-0.2,2.7c0,2.2,0.1,5.3,1.2,8.3c0.7,2.3,2.2,4.4,3.9,6 c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.1,0.2,0.2c0,0,0.1,0,0.1,0.1c2,1.7,4.4,2.9,6.9,3.8c0.5,0.1,1,0.3,1.6,0.4 c0.1,0,0.2,0,0.3,0c0.4,0.1,0.9,0.2,1.3,0.3c0.4,0.1,0.7,0.1,1.1,0.2c1.4,0.2,2.8,0.3,4.1,0.3c1,0,2,0,3,0 c1.3-0.1,2.6-0.2,3.7-0.3c0.9-0.1,1.8-0.2,2.6-0.3s1.4-0.3,2-0.4c0.1,0,0.1-0.1,0.2-0.1c0.4-0.1,0.7-0.2,1.1-0.2 c0.4-0.1,0.6-0.2,0.6-0.2s0.4-0.1,1.1-0.3s1.6-0.5,2.8-0.9c0.3-0.1,0.5-0.2,0.8-0.3c0.5-0.2,1-0.4,1.5-0.6 c1.9-0.9,3.9-2.1,5.8-3.7c0.7-0.6,1.3-1.2,1.9-1.9c0.1-0.1,0.2-0.3,0.3-0.4c0-0.1,0.1-0.1,0.2-0.2l0,0c0.1-0.1,0.1-0.2,0.2-0.3 c0.6-0.8,1.1-1.5,1.6-2.3s0.9-1.7,1.3-2.5c0.2-0.5,0.6-1.3,0.9-2.3c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-1 c0.2-0.6,0.3-1.3,0.4-2c0.2-1.4,0.4-2.8,0.4-4.2C255.6,212.9,255.6,211.6,255.4,210.3L255.4,210.3z M254.4,215.1 c0,1-0.1,2.1-0.3,3.1c0,0.1,0,0.1,0,0.2c-0.2,0.7-0.4,1.4-0.7,2.4c-0.1,0.5-0.4,1.4-0.8,2.5c-0.1,0.3-0.2,0.6-0.4,0.9v0.1 c-0.1,0.2-0.2,0.4-0.2,0.5c-0.1,0.2-0.2,0.4-0.3,0.6c-0.5,1-1.2,2.1-1.9,3.1c0.1,0.4,0.2,0.8,0.2,1.2c0,0.6-0.7,0.6-0.9,0.1 l-0.1-0.3c-0.6,0.6-1.2,1.3-1.8,1.8c-1.6,1.4-3.5,2.5-5.1,3.3c0,0.3,0.1,0.5,0.1,0.8c0.1,0.6-0.8,0.8-0.9,0.2 c0-0.2-0.1-0.4-0.1-0.6c-0.6,0.3-1.2,0.5-1.7,0.7c-1.1,0.4-2.1,0.7-2.7,0.9c-0.7,0.2-1,0.3-1,0.3s-0.4,0.1-1,0.2 c0,0.2,0,0.4,0,0.6c0,0.6-0.9,0.6-0.9,0c0-0.1,0-0.3,0-0.4c-0.6,0.1-1.2,0.2-1.9,0.4c-1.5,0.2-3.4,0.5-5.4,0.6 c0,0.1,0,0.2-0.1,0.3s-0.2,0.3-0.3,0.4c-0.2,0.2-0.4,0.2-0.6,0.1c-0.2,0.2-0.7,0.1-0.7-0.3c0-0.1,0-0.3,0-0.4 c-0.6,0-1.2,0-1.9,0c-2,0-4.1-0.3-6-0.6c0,0.1,0,0.3,0,0.4c0.1,0.4-0.6,0.6-0.8,0.2c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.1,0.4-0.9,0.3-0.9-0.2c0-0.1,0-0.2,0-0.4c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2,0-0.3c-1.1-0.4-2-0.8-3.4-1.4 c-0.4-0.2-1.3-0.6-2.2-1.2c-0.4-0.2-0.8-0.6-1.1-0.9c0,0.1,0,0.2,0.1,0.3c0.1,0.6-0.7,0.8-0.9,0.2c-0.1-0.5-0.1-0.9-0.1-1.4l0,0 c-1.4-1.4-2.5-3.1-3.1-5c-1-2.8-1.2-5.8-1.1-7.9c0-1.1,0.1-2,0.1-2.6c0.1-0.6,0.1-1,0.1-1s0-0.4,0.1-1s0.2-1.5,0.3-2.6 c0.2-2.2,0.1-5.2-0.1-8.3s-0.6-6.4-1.1-9.1c-0.1-0.7-0.2-1.4-0.3-1.9c-0.1-0.3-0.1-0.5-0.1-0.7c-0.1-0.4-0.2-0.8-0.2-1.1 c-0.2-0.9-0.4-1.6-0.7-2.2c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.1-0.1-0.2-0.2-0.3c0.1,0,0.2,0.1,0.4,0.1s0.5,0.1,0.7,0.1 c0.5,0.1,1.1,0.2,1.6,0.3c0.2,0,0.5,0.1,0.8,0.1c0.4,0.1,0.7,0.1,1.1,0.1c0.2,0,0.4,0,0.6,0.1c0-0.1,0-0.3,0.1-0.4 c0.1-0.6,1-0.3,0.9,0.2c0,0.1,0,0.2,0,0.3c2.3,0.2,4.7,0.3,7.2,0.3v-0.1c0-0.3,0.2-0.4,0.5-0.4c0.3-0.2,0.8-0.1,0.8,0.3 c0,0.1,0,0.1,0,0.2c2.2-0.1,4.5-0.2,6.7-0.5c0.5-0.1,0.9-0.1,1.4-0.2c0-0.2,0-0.4,0-0.6c0-0.2,0.2-0.4,0.4-0.4 c0.3-0.2,0.7-0.1,0.7,0.3c0,0.1,0,0.3,0,0.5c3.5-0.6,6.7-1.6,9.5-1.9v-0.1c-0.1-0.1-0.2-0.3-0.1-0.5c0-0.1,0.1-0.1,0.1-0.2 c0.2-0.4,0.8-0.2,0.8,0.2c0,0.1,0,0.3,0,0.5c0.1,0,0.1,0,0.2,0c0-0.2,0-0.4,0-0.6c0-0.6,0.9-0.6,0.9,0c0,0.2,0,0.4,0,0.6 c0.3,0,0.5,0,0.8,0c1.9,0.1,3.4,0.6,4.3,1.1c1,0.5,1.5,0.9,1.5,0.9s0.4,0.3,1,0.8c0-0.1,0-0.2,0-0.2c0-0.6,0.9-0.6,0.9,0 c0,0.3,0,0.7,0,1.1c0.7,0.7,1.6,1.7,2.4,2.9c1.2,1.7,2.6,3.8,3.8,6.2c1.1,2.1,2.1,4.5,2.8,7c0.4,1.4,0.7,2.9,0.9,4.4 c0.2,1.3,0.3,2.6,0.2,3.9v0.1C254.9,214.4,254.9,215.1,254.4,215.1L254.4,215.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6cm7",
    d: "M235.6,224.7c-1.4,1.7-2.6,3.6-3.5,5.7c1.9,1.4,2.4,4.4,2.5,6.8c0.7-0.1,1-0.2,1-0.2s0.4-0.1,1-0.3 c0.7-0.2,1.6-0.5,2.7-0.9c0.5-0.2,1.1-0.4,1.7-0.7c-0.3-3.2,0-7,3.3-8.6c2.1-1,4.6,0,5.4,2c0.7-1,1.4-2,1.9-3.1 c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.3,0.2-0.5v-0.1c0.1-0.3,0.2-0.6,0.4-0.9c0.4-1.1,0.6-2,0.8-2.5c0.2-0.9,0.4-1.7,0.7-2.4 c0-0.1,0-0.1,0-0.2c0.2-1,0.3-2,0.3-3.1l0,0C246.9,215.5,240.2,219.1,235.6,224.7L235.6,224.7z",
    fill: "#FFD2AB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M224.9,193.8c1.1,2.2,3.6,3.1,5.7,1.9c3.2-1.8,3.3-6,3.1-9.3c-2.8,0.4-6,1.3-9.5,1.9c0,0.7-0.1,1.6-0.1,2.5 C224.2,191.8,224.4,192.9,224.9,193.8L224.9,193.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M215.4,194.6c0.6,1.9,2.4,4,4.7,3.4c2.9-0.7,3.2-4.7,3.3-7.8c-0.1-0.6-0.1-1.2-0.1-1.7 c-0.5,0.1-0.9,0.1-1.4,0.2c-2.2,0.3-4.5,0.5-6.7,0.5C215,191,214.8,192.8,215.4,194.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M209.6,197.6c4.3,0.9,4.6-5.6,4.4-8.4c-2.5,0-5-0.1-7.2-0.3C206.2,191.8,205.7,196.7,209.6,197.6 L209.6,197.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M237.5,194.2c1.5,2,4.1,1.4,5.2-0.6c0.8-1.4,0.8-3.1,0.7-4.6c-0.6-0.6-1-0.8-1-0.8s-0.5-0.4-1.5-0.9 s-2.4-1-4.3-1.1c-0.2,0-0.5,0-0.8,0C235.6,188.8,235.9,192.1,237.5,194.2L237.5,194.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M249,228.9c-0.6-2.6-4.2-2.2-5.7-0.4c-1.4,1.7-1.5,4-1.2,6.1c1.7-0.8,3.5-1.9,5.1-3.3 c0.6-0.6,1.2-1.2,1.8-1.8c0,0,0-0.1-0.1-0.1C248.9,229.1,248.9,229,249,228.9L249,228.9z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M214.8,237.2c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0-0.1C214.9,237.2,214.8,237.2,214.8,237.2L214.8,237.2z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M215.8,237.1C215.8,237.1,215.9,237.1,215.8,237.1c0.1-0.2,0-0.4,0-0.6 C215.9,236.7,215.8,236.9,215.8,237.1L215.8,237.1z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M213.8,230.6c-2.4-2.9-6.1-0.5-5.6,2.8c0.4,0.3,0.8,0.6,1.1,0.9c0.9,0.6,1.8,1,2.2,1.2 c1.4,0.6,2.2,0.9,3.4,1.4C215.2,234.7,215.3,232.4,213.8,230.6L213.8,230.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M224.7,237.7c-0.1-2.6-0.9-5.6-3.7-6.3c-4.1-1.1-4.4,3.5-4.1,6.3c1.9,0.4,4,0.6,6,0.6c0.6,0,1.2,0,1.9,0 c0-0.1,0-0.3,0-0.4C224.7,237.9,224.7,237.8,224.7,237.7L224.7,237.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M229.2,230.7c-3.2,0.7-3.3,4.5-3.2,7.2c0.2,0,0.4,0.2,0.4,0.4c2-0.1,3.9-0.3,5.4-0.6 c0.8-0.1,1.4-0.2,1.9-0.4C233.7,234.7,233,229.8,229.2,230.7z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.9,198.5c2.7,0.3,4.1-1.8,4.6-4.3c0.6,2.6,2,4.9,5.1,4.7c2.9-0.2,3.9-2.8,4.3-5.6c0.8,2.3,2.3,4.2,5.3,3.7 c5.1-0.8,5.6-6.7,5.4-10.9c0-0.2,0-0.3,0-0.5c0-0.5-0.6-0.6-0.8-0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.1,0.4,0.1,0.5v0.1 c0.1,3.3,0.1,7.5-3.1,9.3c-2.2,1.2-4.6,0.3-5.7-1.9c-0.5-0.9-0.7-2-0.8-3.1c0.1-0.9,0.1-1.8,0.1-2.5c0-0.2,0-0.3,0-0.5 c0-0.4-0.4-0.5-0.7-0.3c-0.2,0-0.3,0.2-0.4,0.4c0,0.2,0,0.4,0,0.6c0,0.6,0,1.1,0.1,1.7c-0.1,3.1-0.4,7.1-3.3,7.8 c-2.3,0.6-4.1-1.5-4.7-3.4c-0.5-1.7-0.4-3.6-0.2-5.4c0-0.1,0-0.1,0-0.2c0-0.4-0.5-0.5-0.8-0.3c-0.2,0-0.5,0.1-0.5,0.4v0.1 c0.2,2.8-0.1,9.3-4.4,8.4c-3.8-0.9-3.4-5.7-2.9-8.7c0-0.1,0-0.2,0-0.3c0.1-0.6-0.8-0.8-0.9-0.2c0,0.1,0,0.3-0.1,0.4 C205.2,192.3,205.1,198,209.9,198.5L209.9,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.9,196.4c4,1,5.3-3.4,5.4-6.5c0-0.4,0-0.7,0-1.1c0-0.6-0.9-0.6-0.9,0c0,0.1,0,0.2,0,0.2c0.1,1.6,0.1,3.2-0.7,4.6 c-1.1,2-3.7,2.6-5.2,0.6c-1.6-2.1-1.8-5.4-1.7-8c0-0.2,0-0.4,0-0.6c0-0.6-0.9-0.6-0.9,0c0,0.2,0,0.4,0,0.6 C234.7,189.6,235.2,195.4,238.9,196.4L238.9,196.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,237.9c-0.2-2.7,0-6.5,3.2-7.2c3.8-0.9,4.5,4,4.6,6.6c0,0.1,0,0.3,0,0.4c0,0.6,0.9,0.6,0.9,0c0-0.2,0-0.4,0-0.6 c-0.1-2.3-0.6-5.4-2.5-6.8c0.9-2.1,2.1-4,3.5-5.7c4.5-5.6,11.2-9.2,18.7-9.6l0,0c0.5-0.1,0.5-0.8,0-0.9h-0.1 c-8,0.4-15.2,4.3-19.9,10.5c-1.2,1.6-2.3,3.4-3.1,5.2c-0.5-0.2-1.1-0.3-1.8-0.2c-2.1,0.1-3.2,1.5-3.8,3.2 c-0.2,0.7-0.4,1.5-0.5,2.2c-0.6-2.4-2-4.5-4.8-4.8c-3.2-0.3-4.3,2.3-4.5,4.9c0-2.9-0.7-6.1-3.9-6.8c-2.8-0.6-4.6,1.7-4.7,4.1 c0,0.5,0,0.9,0.1,1.4c0.1,0.6,1,0.3,0.9-0.2c0-0.1,0-0.2-0.1-0.3c-0.6-3.3,3.1-5.7,5.6-2.8c1.5,1.7,1.4,4.1,1.2,6.3 c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0.1s0,0.2,0,0.4c-0.1,0.5,0.8,0.6,0.9,0.2c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0.4,0.9,0.2,0.8-0.2 c0-0.1,0-0.3,0-0.4c-0.3-2.8,0-7.4,4.1-6.3c2.9,0.8,3.6,3.7,3.7,6.3c-0.1,0.1-0.1,0.1-0.1,0.3c0,0.1,0,0.3,0,0.4 c0,0.1,0,0.3,0,0.4c0,0.4,0.5,0.5,0.7,0.3c0.2,0.1,0.4,0.1,0.6-0.1c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.1-0.3 C226.4,238.1,226.2,238,226.1,237.9L226.1,237.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8,237.1c0-0.2,0-0.4,0.1-0.6C215.9,236.7,215.9,236.9,215.8,237.1C215.9,237.1,215.9,237.1,215.8,237.1L215.8,237.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,226.4c-3.3,1.5-3.6,5.4-3.3,8.6c0,0.2,0,0.4,0.1,0.6c0.1,0.6,1,0.3,0.9-0.2c0-0.3-0.1-0.5-0.1-0.8 c-0.2-2.1-0.2-4.4,1.2-6.1c1.5-1.8,5.1-2.2,5.7,0.4c-0.1,0.1-0.1,0.2-0.1,0.4c0,0,0,0.1,0.1,0.1l0.1,0.3c0.2,0.4,0.9,0.4,0.9-0.1 c0-0.4-0.1-0.8-0.2-1.2C249,226.4,246.5,225.4,244.4,226.4L244.4,226.4z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: 11,
    className: "svgghead"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gummy_bear_helmet_Image"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181789847829888253860000014952587370379039130_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.6154,
    y1: 1873.24,
    x2: 320.6154,
    y2: 1751.38,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,135.5c-2.2,0.8-4.4,1.6-6.6,2.2 c-2.3,0.6-6,1-7.4,3.1c-1.3,2.1,0.3,6.6,0.8,8.9c0.4,2.4,0.9,4.8,1.3,7.2c3.5,21.4,5.4,43.9,4.4,65.6l0,0h0.1 c0.5,0.9-0.3,2.2-0.7,3c-0.3,0.5-0.6,1-1,1.5c0.3-0.1,0.6-0.1,0.9-0.2c0.1-0.2,0.2-0.4,0.5-0.4c2.1-0.4,3.9-2.2,3.9-4.4 c0-0.1,0.2-0.2,0.3,0c0.2,1.1,0,2.2-0.5,3.2c2.7-1.1,5.5-2,8.1-3.4c3.8-2.1,7.3-4.7,10.5-7.7c6.2-5.7,10.8-12.6,14-20.4 c1.6-23.4,0.4-46.8-2-70.2C331.7,128.6,322.2,132.2,313.2,135.5L313.2,135.5z M309.5,218.8c0,0.2-0.3,0.1-0.3,0 c0.3-12.3,0.4-24.4-0.9-36.7c0-0.2,0.3-0.2,0.3,0C310.6,194.1,311.2,206.6,309.5,218.8L309.5,218.8z",
    style: {},
    fill: "url(\"#SVGID_00000181789847829888253860000014952587370379039130_\")"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124853675744649783290000008677896324407568043_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.6624,
    y1: 1843.45,
    x2: 142.6624,
    y2: 1736.1,
    gradientTransform: "matrix(1 0 0 1 0 -1636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138,198c-0.5-5.9,0.6-12.1,1.5-18 c0.9-6.4,2.2-12.7,3.7-19s3.3-12.5,5.4-18.6c1.8-5.2,3.5-10.9,6.2-15.7c0-0.1,0-0.1,0.1-0.2l0,0c0.2-0.4,0.5-0.8,0.7-1.2 c0.1-0.2,0.3-0.2,0.4-0.2c0.8-2.1-0.6-5-1.9-6.5c-1-1.1-2.4-1.8-3.6-2.6c-1.2-0.9-2.5-1.8-3.7-2.7c-2.7-2.1-5.5-4.3-7.7-7 c-5.6,16.2-8.8,33.1-9.7,50.2c-0.4,8-0.6,16.1,0.6,24c0.6,3.9,1.6,7.8,3.3,11.4C134.5,194.6,136.8,198.5,138,198L138,198z",
    style: {},
    fill: "url(\"#SVGID_00000124853675744649783290000008677896324407568043_\")"
  }), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M298.3,141.5l0.5,5.7c0.1,1.7,1.7,3.3,3.5,2.7c6.9-2.4,13.5-5,20-8.5c3.2-1.7,6.4-3.5,9.5-5.4 s5-4.4,7.8-6.4c2.5-1.8,0.2-6-2.5-4.2c-10.7,7.4-23,12.2-35.6,15.2c-3.8,0.9-2.1,6.1,1.6,5.6c1.8-0.2,5.1-1.2,4.6-3.8 c-0.5-2.7-4.3-2.2-6.1-1.9l1.6,5.6c13.2-3.5,25.1-9.4,36.5-16.7l-2.5-4.2c-3,1.9-6.6,3.1-9.7,5c-2.9,1.7-5.7,3.4-8.7,5 c-6.1,3.3-12.3,6.5-18.5,9.5l4.1,1.7c-0.4-1.9-0.8-3.8-1.1-5.6C302.6,138.1,298.1,138.7,298.3,141.5L298.3,141.5L298.3,141.5z",
    fill: "#AE0D35"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M299.4,142.9c1.7,1.7,4.3,0.8,6.4,0.5c2.7-0.4,5.5-0.9,7.8-2.5c0.9-0.6,0.8-2.1-0.3-2.4 c-2.5-0.6-5.3-0.3-7.8,0.2c-2.1,0.4-5.3,0.5-6.3,2.7C299,141.8,299,142.4,299.4,142.9L299.4,142.9L299.4,142.9z",
    fill: "#AE0D35"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M137.7,111.2c1.6,7,6.9,13.3,11.4,18.6c3.2,3.9,9-1.8,5.6-5.6c-4.5-5-7.6-11.1-12.3-15.8 C140.3,106.4,137.1,108.5,137.7,111.2L137.7,111.2L137.7,111.2z",
    fill: "#AE0D35"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M340.9,123.3c0-0.2-0.1-0.3-0.2-0.4c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0-0.3-0.1-0.3c-10.8,4.5-21.1,10-32.3,13.6 c-2.7,0.9-8.3,1.3-10.3,3.6c-1.5,1.7-0.3,4.9,0,6.9c1.9,12.7,3.9,25.2,4.9,37.9c1,13.2,0.9,26.3,1.2,39.5c0,0.2,0.1,0.4,0.2,0.4 c0,0.1-0.1,0.2-0.2,0.3c-0.6,1.1-1.5,2.1-2.6,2.9c-0.5,0.4-0.2,1.1,0.4,1c1.1-0.3,2.3-0.5,3.4-0.8l0,0c0.4-0.1,0.7-0.2,1-0.3 c0.1-0.1,0.3-0.1,0.4-0.1c7.8-1.3,15.9-7.4,21.4-12.5c6-5.6,10.7-12.4,13.8-20c0.2,0,0.5-0.2,0.5-0.5c0-0.4,0-0.7,0-1.1 c0.2-0.6,0.5-1.2,0.7-1.8c0.1-0.4-0.3-0.6-0.5-0.4C344.1,168.3,343.9,145.7,340.9,123.3L340.9,123.3z M341.8,193.5 c-3.2,7.7-7.8,14.7-14,20.4c-3.2,2.9-6.7,5.5-10.5,7.7c-2.6,1.5-5.4,2.4-8.1,3.4c0.5-1,0.7-2.1,0.5-3.2c0-0.1-0.2-0.1-0.3,0 c-0.1,2.2-1.8,4.1-3.9,4.4c-0.3,0-0.4,0.2-0.5,0.4c-0.3,0.1-0.6,0.1-0.9,0.2c0.4-0.4,0.8-0.9,1-1.5c0.4-0.8,1.2-2.2,0.7-3 c0,0-0.1-0.1-0.1,0l0,0c1-21.7-0.9-44.2-4.4-65.6c-0.4-2.4-0.9-4.8-1.3-7.2c-0.4-2.3-2.1-6.8-0.8-8.9c1.3-2.1,5.1-2.4,7.4-3.1 c2.2-0.6,4.4-1.4,6.6-2.2c9-3.2,18.5-6.9,26.6-12.1C342.2,146.7,343.5,170.1,341.8,193.5L341.8,193.5z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M308.2,182c1.3,12.3,1.2,24.4,0.9,36.7c0,0.2,0.3,0.2,0.3,0c1.8-12.2,1.1-24.7-0.9-36.8 C308.5,181.8,308.2,181.8,308.2,182L308.2,182z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M138.2,200c1.2-2,1.6-3.9,1-6.2c0.6-4.4,0.8-9,1.4-13.4c0.9-6.4,2.2-12.7,3.7-19c1.4-6,3.2-11.9,5.1-17.7 c1.9-5.7,4.8-11.3,6.5-17.1c3-1.6,2.3-5.3,0.1-7.8c-2.6-2.8-6.6-4.7-9.6-7.1c-2.7-2.2-5.1-4.7-7.9-6.8c-0.2-0.2-0.5,0.2-0.4,0.4 c0.1,0.1,0.1,0.1,0.1,0.2c-0.1,0.1-0.1,0.1-0.1,0.2c-5.9,17-9.2,34.8-9.9,52.8c-0.6,14.1-0.9,30.5,9.2,41.5 C137.7,200.3,138.1,200.3,138.2,200L138.2,200z M133.3,192.1c-1.7-3.6-2.7-7.5-3.3-11.4c-1.2-7.9-1-16.1-0.6-24 c0.8-17.2,4.1-34,9.7-50.2c2.2,2.6,5,4.9,7.7,7c1.2,0.9,2.4,1.8,3.7,2.7c1.2,0.8,2.6,1.5,3.6,2.6c1.4,1.4,2.8,4.4,1.9,6.5 c-0.1,0-0.3,0-0.4,0.2c-0.3,0.4-0.5,0.8-0.7,1.2l0,0c-0.1,0-0.1,0.1-0.1,0.2c-2.7,4.8-4.4,10.5-6.2,15.7 c-2.1,6.1-3.9,12.3-5.4,18.6s-2.7,12.6-3.7,19c-0.9,5.8-2,12.1-1.5,18C136.8,198.6,134.5,194.6,133.3,192.1L133.3,192.1z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M337.3,184c-0.9,10.2-6.3,20.3-13.2,27.8c-0.5,0.6,0.1,1.5,0.9,1.1c10.8-5.9,16-16.6,15.9-28.9 C340.7,181.7,337.5,181.8,337.3,184L337.3,184L337.3,184z",
    fill: "#FFFFFF"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M338.5,169.7c-0.7,0.8-1.3,1.8-1.4,2.9c-0.1,1,0.1,2.2,0.7,3.1c1.3,1.9,4,0.7,3.7-1.6 c-0.2-0.9-0.4-1.9-0.2-2.9c0.1-0.7-0.1-1.5-0.8-1.9C339.9,169.1,339,169.1,338.5,169.7L338.5,169.7L338.5,169.7z",
    fill: "#FFFFFF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M130.1,152.8c-1.5,12.2-2,26.8,4,37.9c0.4,0.7,1.5,0.4,1.5-0.4c-0.1-6.3-1.4-12.4-2-18.6 s-0.4-12.6,0.2-18.9C134.1,150.3,130.4,150.4,130.1,152.8L130.1,152.8L130.1,152.8z",
    fill: "#FFFFFF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "st4cm1",
    d: "M132.6,137.4c-0.6,2.1-1.5,5.9,0.4,7.6c0.4,0.3,1,0.5,1.4,0.2c2.3-1.5,1.8-5.4,1.4-7.7 C135.6,135.7,133,135.9,132.6,137.4L132.6,137.4z",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127740341217216951560000007047851351309571468_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,23.9 c4.8-6.8,11.7-11.7,19.3-15.1c-2.6,0.3-5.3,0.4-8,0.3c-4.4-0.2-9.3-1.8-13.7-1.4c-11.9,1.1-13,22-3,26.6 C168.3,30.9,169.6,26.9,171.8,23.9L171.8,23.9z",
    style: {},
    fill: "url(\"#SVGID_00000127740341217216951560000007047851351309571468_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139265169868790869420000010554492954939910335_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,56.2c-4.4,1.7-5.4,5.1-7.5,8.6 c5.6-4,12.6-7.2,19.4-8.8C270.1,55.3,266.1,54.8,262.2,56.2z",
    style: {},
    fill: "url(\"#SVGID_00000139265169868790869420000010554492954939910335_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080904464867536717050000002770865723048467874_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,51.8c-0.1-0.5,0.1-0.9,0.5-1.2 c13.8-9.6,3-25-6.7-32.9c-6.5-5.4-12.8-6.1-20.8-3.8c-5.4,1.5-10.4,2.6-16.1,2.4c-11.1-0.5-21.7-4.5-32.3-7.2 c-12.3-3.1-24.9-5.3-37.5-5.7c-16.9-0.5-35.6,1.7-50.3,10.8c-8.4,5.2-12.4,12-16.8,20.5c-0.1,0.3-0.3,0.5-0.5,0.8 c0.1,0.6-0.2,1.2-0.9,1.3c-4.4,6-11.1,5.5-18.3,7.6c-9.2,2.7-17.8,9.4-22.4,17.8c-1.2,2.3-2.1,4.5-2.6,6.7l0,0 c-0.4,2-0.5,3.9-0.5,5.8c0.2,6,2.6,11.8,5.9,17.4c1,1.5,2,3.1,2.9,4.6c1.8,2.3,3.5,4.6,5.4,6.9c3,3.3,6.1,6.6,8.9,10 c1.1,1.3,2.2,2.8,3.3,4.2c1.9,2,3.7,4,5.6,6.1c5.4,5.7,9.1,12.9,14.3,18.8c2.9,2.6,6,5,9.3,7.3c0.1,0.1,0.1,0.3,0,0.4 c8.8,4.8,20.1,5.8,29.6,6.6c10.8,0.9,22.3,1.4,32.5-2.7c5-2,9.5-4.7,14.6-6.4c4.5-1.6,9.2-2.7,13.8-3.7c11-2.4,22.2-3.9,33.2-6.2 c20.2-4.2,39.5-13,52.3-29.8c7.2-9.3,9-20.2,4.8-31.2C356.6,68.4,351.3,60.7,348.6,51.8L348.6,51.8z M142.5,71.5 c-4.4-3.8-6.3-8.6-6.7-14.3c-0.1-0.8,1.1-0.7,1.2,0c0.6,5,3.1,9.9,6,14C143.1,71.5,142.7,71.7,142.5,71.5z M167.4,108.1 c-0.7,0.1-1.3,0.2-2,0.1c-0.4-0.1-0.8-0.3-1.1-0.5c-0.1,0.1-0.2,0.2-0.4,0.1c-0.9-0.2-1.1-1.2-0.5-1.9c0.3-0.3,0.8-0.3,1.1,0 c0.4,0.4,0.8,0.8,1.3,1.1c0.5,0.3,1.1,0.6,1.6,0.8C167.5,107.9,167.5,108.1,167.4,108.1L167.4,108.1z M227,70.5 c0.1,0.2-0.1,0.4-0.3,0.3c-5.4-2.4-9.4-5.8-15.6-6.3c-4.9-0.5-15.8,0.2-17.3,6.5c-0.1,0.3-0.4,0.2-0.5-0.1c-0.6-6,9.8-7.8,14.1-8 C213.9,62.5,223.5,64.5,227,70.5L227,70.5z M224.2,76.9c-2.4,0.8-4.7,1.2-6.9,2.5c-2,1.2-3.3,2.9-5.1,4.3c-0.1,0.1-0.2,0-0.2-0.1 c1.4-4.2,7.9-7.7,12.2-7.1C224.4,76.5,224.4,76.9,224.2,76.9z M186.6,41.5c0-0.1,0.1-0.1,0.1,0c1.1,1.9,1.9,3.8,3.1,5.6 c1.3,1.9,2.9,3.6,4.4,5.5c0.1,0.2,0,0.5-0.2,0.4C189.8,51.4,186.4,46.2,186.6,41.5L186.6,41.5z M177.2,51.3 c0.6,0,1.2,0.1,1.9,0.2l0.1-0.1c5.1-3.6,14,1.5,14.9,7.5c0.4,0.4,0.8,0.7,1.1,1.1c0.1,0.1,0,0.4-0.2,0.3 c-0.3-0.1-0.6-0.2-0.8-0.4c0,0.3,0,0.5-0.1,0.8c0,0.1-0.2,0.1-0.2,0c-0.2-0.4-0.4-0.8-0.5-1.3c-2.2-1.2-4.3-2.7-6.5-3.8 c-3.1-1.5-6.7-2.2-9.8-3.9C176.7,51.8,176.9,51.3,177.2,51.3L177.2,51.3z M195.4,102.2c-3.6,1.8-7.5,2.8-11.4,3.9 c-3.8,1.1-7.7,2.4-11.7,2.8c-0.1,0-0.2-0.2-0.1-0.3c3.6-1.8,7.6-2.8,11.4-3.9c3.9-1.2,7.7-2.4,11.7-2.8 C195.5,101.9,195.5,102.2,195.4,102.2L195.4,102.2z M199.4,81.7c-2-0.7-3.5-1.9-4.6-3.7c-0.8-1.2-2.1-3.7-0.9-5 c0.1-0.1,0.2-0.1,0.3,0c1,0.9,1,2.9,1.7,4.1c0.9,1.7,2.2,3.1,3.8,4.2C199.8,81.4,199.7,81.8,199.4,81.7z M204.6,101.3 c0.1,0.2-0.2,0.3-0.4,0.2c-3.1-4.3-2.9-11.6,0.4-15.7c0.1-0.1,0.2,0,0.2,0.1c-0.6,2.6-1.4,5-1.5,7.7 C203.3,96.2,204,98.8,204.6,101.3z M230.1,114.3c-7.9,1.9-19.9-4.6-24.5-10.9c-0.1-0.2,0.1-0.4,0.3-0.3c4.1,2.5,7.7,5.3,12.1,7.2 c3.9,1.6,8.3,1.9,12.1,3.6C230.4,113.9,230.3,114.2,230.1,114.3z M253.5,56.2c0.8-1.6,3.2-2.6,4.6-3.6c1.9-1.4,3.8-2.8,5.6-4.2 c0.2-0.2,0.5,0.2,0.4,0.4c-1.4,2.1-2.8,3.6-4.9,5.1c-1.5,1.1-3.7,2.9-5.7,2.5C253.4,56.3,253.4,56.2,253.5,56.2L253.5,56.2z M242.8,112.4c-1.5-0.1-2.9-0.4-4.4-0.1c-1.3,0.3-2.5,0.8-3.8,1.2c-0.2,0.1-0.3-0.2-0.2-0.3c1.9-2.1,5.5-3.2,8.3-3.1 C244.3,110.2,244.2,112.6,242.8,112.4L242.8,112.4z M278.1,56c-4.5,1.4-9,2.7-13.3,4.5s-8.3,4.4-12.4,6.5 c-0.1,0.1-0.3-0.1-0.2-0.2c0.6-0.5,1.2-1,1.9-1.5l0,0c-0.3-4.3,3.2-8.4,7-10c5-2.2,10.4-1.1,15.5-0.1c0.2,0,0.3,0.1,0.4,0.2 c0.3-0.1,0.7-0.1,1-0.2C278.4,55.2,278.6,55.9,278.1,56L278.1,56z M333.9,71.1c-6.9,6.7-15.6,11.5-24.6,14.8 c-0.3,0.1-0.4-0.3-0.2-0.4c8.7-4.1,16.6-9.1,24.5-14.6C333.9,70.8,334.1,71,333.9,71.1L333.9,71.1z M342.6,41.8 c0.1,0.2,0,0.4-0.2,0.4c-2.1,0.5-4.6-1.3-6.3-2.4c-2.4-1.5-4.6-3.2-6.4-5.4c-0.1-0.1,0-0.2,0.1-0.2c2.4,1.3,4.7,2.8,7.1,4.2 c0.2,0.1,0.4,0.2,0.6,0.3c0.1,0,0.2,0,0.3,0.1l0.1,0.1c0.6,0.2,1.2,0.5,1.8,0.8c1-0.1,1.7-1.3,2.2-3.6c0.1-1.7-0.2-3.3-0.9-4.9 c-1.6-2.8-4.8-3.6-7.8-3.9c-1.1-0.1-8,0-10.7,1.3c0.1,0.3-0.1,0.6-0.3,0.9c0.2,0.2,0.4,0.5,0.6,0.7c0.3,0.4,0.7,0.9,0.8,1.4 c0,0.2-0.1,0.3-0.3,0.3c-0.5-0.1-1-0.5-1.4-0.8c-0.5-0.4-1-0.8-1.4-1.1c-0.1-0.1-0.2-0.3-0.2-0.5c0,0-0.1,0-0.1-0.1 c-0.4-0.2-0.5-0.9,0-1.1c6.3-3.2,19.9-5.1,22.9,3.6c0.9,2.5,1.1,7.2-1.5,8.9C341.9,41,342.3,41.4,342.6,41.8L342.6,41.8z",
    style: {},
    fill: "url(\"#SVGID_00000080904464867536717050000002770865723048467874_\")"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000097461035905135310180000002777459715441924029_",
    cx: 243.89,
    cy: 1714.3101,
    r: 106.22,
    gradientTransform: "matrix(1 0 0 1 0 -1636)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    style: {
      stopColor: "rgb(249, 50, 116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(213, 51, 69)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,57.6c-0.7-1.5-1.6-3-3.2-4.1 c-2.9-2.1-5.5-1.7-8.6-1.5c1.9,0.6,3.8,1.5,5.6,2.3C188.2,55.2,190.5,56.3,192.4,57.6L192.4,57.6z",
    style: {},
    fill: "url(\"#SVGID_00000097461035905135310180000002777459715441924029_\")"
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M351.8,32.7c1.2,5.4-0.7,11.1-5.2,14.4c-3.1,2.2,0.3,6.7,3.2,4.1c5.5-4.8,7.6-12.5,5.3-19.4 C354.4,29.8,351.4,30.6,351.8,32.7L351.8,32.7z",
    fill: "#AE0D35"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M341.7,27.6c-5.3-3.7-15.5-3.8-19.9,1.5c-1.5,1.8-0.1,5,2.5,4.2c2.8-0.8,5-2.6,8-3.1s5.9-0.5,8.9-0.3 C342.4,30.1,342.6,28.3,341.7,27.6L341.7,27.6L341.7,27.6z",
    fill: "#AE0D35"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M358.7,72.6c-0.7,15.4-10.4,28.7-21.5,38.8c-6.3,5.7-12.3,10.5-19.8,14.6c-3.5,1.9-6.8,4.1-10.3,5.9 c-4,2.1-8.5,3.4-12.6,5.2c-0.6,0.3-1.2,1.2-1.1,1.9c0.1,0.5,0.1,0.7,0.3,1.1c0.5,0.9,1.6,1.3,2.5,1c4.7-1.2,9.2-3.2,13.9-4.4 s9.2-2.3,13.8-4.2c8.8-3.7,17.6-7.8,24.5-14.4c12.2-11.5,18.1-29.5,12.7-45.8C360.6,71,358.7,71.2,358.7,72.6L358.7,72.6 L358.7,72.6z",
    fill: "#AE0D35"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M280.8,143.5c8.4-1.5,17.8-2.6,25.5-6.4c0.8-0.4,0.4-1.7-0.5-1.7c-8.6,0.1-17.6,3.4-25.7,5.9 C278.7,141.7,279.3,143.8,280.8,143.5L280.8,143.5z",
    fill: "#AE0D35"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M214.6,81.7c1.8-0.9,3.8-1.7,5.6-2.4c1.8-0.7,3.8-0.9,5.4-2.1c1.8-1.3,1.1-3.7-1.1-4c-4.5-0.6-8.7,4-11,7.3 C213,81.4,213.9,82.1,214.6,81.7L214.6,81.7z",
    fill: "#AE0D35"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M198.4,77.6l-1.3-3.8c-0.5-1.4-0.9-2.6-2.2-3.4c-1.1-0.7-2.5,0-2.9,1.2c-0.4,1.3,0.1,2.5,0.6,3.7l1.4,3.5 c0.4,1.2,1.5,2,2.8,1.6C197.9,80.1,198.8,78.7,198.4,77.6L198.4,77.6L198.4,77.6z",
    fill: "#AE0D35"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M253.7,62.6c1.7-1.1,2.9-2.9,4.2-4.5c0.6-0.8,1.4-1.6,1.9-2.5c0.5-0.8,0.8-1.8,1.4-2.5 c0.7-0.9,0.1-2.3-1.1-2s-2.5,0.4-3.6,1.1c-1,0.6-2,1.6-2.8,2.5c-1.5,1.9-2.6,4.4-2.2,6.8C251.8,62.6,253,63.1,253.7,62.6 L253.7,62.6z",
    fill: "#AE0D35"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M195.9,57.7c0.5-2.1,0.6-4.1,0-6.2c-0.8-2.8-2.2-5.6-5.5-5.7c-2,0-3.6,1.7-3.6,3.7c0,2.6,1.7,3.5,3.4,5.1 c1.1,1.1,2.3,2.2,3.2,3.5C193.9,59,195.6,59,195.9,57.7L195.9,57.7L195.9,57.7z",
    fill: "#AE0D35"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M158.5,17c-1.1,5,0.6,10.3,2.8,14.8l-0.7-2.5c-0.2,1.6,0.3,2.9,1.2,4.1c2.1,3,6.3,3.9,9,1.2s1.9-7-1.2-9 c-1.3-0.9-2.6-1.3-4.1-1.2l2.5,0.7c-3.4-2.3-5.7-5.3-8.3-8.4C159.4,16.2,158.7,16.5,158.5,17L158.5,17L158.5,17z",
    fill: "#AE0D35"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M182,134c-0.7,4,4.1,7.5,6.9,9.5c4.4,3.3,9.8,5.5,15.2,6.7c11,2.6,22.8,3.4,31-5.4c1.8-1.9,0.4-4.5-2-4.7 c-4-0.4-7.7-1.5-11.8-1.9c-4.9-0.4-9.8-0.2-14.7-0.9c-4.6-0.6-9.1-1.4-13.6-2.3c-3-0.6-7.1-2.9-10.1-2 C182.5,133.2,182.1,133.6,182,134L182,134L182,134z",
    fill: "#AE0D35"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "st5cm5",
    d: "M129,92.2c5.1,9.8,11.4,19,20.2,25.8c0.7,0.5,1.9-0.2,1.3-1c-6.4-8.8-13.7-16.9-20.1-25.6 C129.8,90.5,128.5,91.2,129,92.2L129,92.2z",
    fill: "#AE0D35"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M198,70.2c3.8-1.4,7.8-1.4,11.5-2.9c0.8-0.3,1-1.3,0.2-1.8c-4.1-2.7-8.7-1.6-13,0.2 C194,66.8,195.1,71.2,198,70.2L198,70.2L198,70.2z",
    fill: "#FFFAFC"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M213.5,68.1l1.1,0.3c0.8,0.2,1.6,0,2.1-0.6l0.2-0.2l-0.8,0.4l0.3-0.1c0.9-0.3,1.3-1.2,0.9-2.1l-0.1-0.3 l0.2,0.9v-0.2c-0.1-0.8-0.4-1.5-1.1-1.9l-1-0.5c-1.2-0.6-2.7-0.2-3.3,1.1C211.5,66.3,212.2,67.7,213.5,68.1L213.5,68.1 L213.5,68.1z",
    fill: "#FFFAFC"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M250.6,77.9c5.1,0.5,10.8-1.5,15.5-3.2c5.2-1.9,8.4-4.3,11.3-8.9c0.6-0.9,0.3-2.5-0.8-3 c-5.4-2.3-9.9-2.4-15.4,0.3c-4.9,2.4-10.4,6-12.8,11C247.6,75.9,248.6,77.7,250.6,77.9L250.6,77.9z",
    fill: "#FFFAFC"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M313.2,16.9c5.3,0.5,10.7,0.8,16,0.4c3.2-0.3,6.8-0.7,8.7-3.6c0.4-0.6,0.1-1.6-0.5-1.9 c-3.3-1.8-7.1-0.2-10.5,0.8c-4.6,1.3-9.2,2.2-13.9,2.9C312.1,15.6,312.5,16.9,313.2,16.9L313.2,16.9L313.2,16.9z",
    fill: "#FFFAFC"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M343.8,35.4c-0.9,0.8-1.6,2.5-1.9,3.8c-0.4,1.3,0.4,2.8,1.8,3.2s2.9-0.4,3.1-1.8c0.3-1.2,0.5-3.1,0-4.3 C346.3,34.9,344.8,34.5,343.8,35.4L343.8,35.4z",
    fill: "#FFFAFC"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M169.2,44.7c-4.3-1.2-9.4-2.2-13.9-1.6c-7.3,1.1-17.9,5.1-17.7,14c0.1,2.2,1.2,4.7,3.3,5.7 c6.9,3.5,14.2-1.3,19.8-5.3c3.3-2.4,5.6-6.2,9.1-8.1C171.8,48.3,171.4,45.2,169.2,44.7L169.2,44.7L169.2,44.7z",
    fill: "#FFFAFC"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M176,23.9c9.1-2,17.3-6.9,26.1-9.8s17.8-3.9,26-7.7c1.4-0.6,0.9-2.7-0.4-3.1c-9.6-2.7-20.2,0.5-29.2,4.1 s-17.9,7.9-22.9,16C175.5,23.7,175.8,23.9,176,23.9L176,23.9L176,23.9z",
    fill: "#FFFAFC"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M232.4,5.1c4.3,2.6,10.6,2.3,15.1,0.3c0.7-0.3,0.7-1.5,0-1.9c-4.3-2.3-10.6-2.8-15.1-0.5 C231.5,3.4,231.6,4.6,232.4,5.1L232.4,5.1L232.4,5.1z",
    fill: "#FFFAFC"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M180,8.7c-1.3-1.6-3.8-2.2-5.8-2.5c-1.7-0.3-5,0.1-4.9,2.5s3.1,2.9,4.9,2.7c2-0.2,4.4-0.7,5.8-2.2 C180.2,9.1,180.2,8.9,180,8.7L180,8.7L180,8.7z",
    fill: "#FFFAFC"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "st7cm4",
    d: "M179.4,111.1c2.7,1.6,5.8,3.7,9,3.2c2.6-0.4,2.3-3.8,0.6-4.9c-2.4-1.7-6.2-1.1-8.9-0.9 C178.7,108.5,178.1,110.4,179.4,111.1L179.4,111.1L179.4,111.1z",
    fill: "#FFFAFC"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M212,83.6c0,0.1,0.1,0.2,0.2,0.1c1.8-1.4,3.1-3.1,5.1-4.3c2.2-1.3,4.6-1.7,6.9-2.5c0.2-0.1,0.2-0.4,0-0.4 C219.9,75.9,213.5,79.4,212,83.6z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M195.9,77.1c-0.6-1.2-0.6-3.2-1.7-4.1c-0.1-0.1-0.2-0.1-0.3,0c-1.1,1.3,0.1,3.8,0.9,5c1.1,1.8,2.6,3,4.6,3.7 c0.2,0.1,0.4-0.3,0.2-0.4C198.1,80.2,196.7,78.7,195.9,77.1z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M193.3,70.9c0,0.3,0.4,0.3,0.5,0.1c1.5-6.2,12.4-6.9,17.3-6.5c6.2,0.6,10.3,3.9,15.6,6.3c0.2,0.1,0.4-0.1,0.3-0.3 c-3.5-6-13.2-8-19.6-7.7C203.2,63.1,192.8,64.8,193.3,70.9L193.3,70.9z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M204.6,85.7c-3.3,4.2-3.5,11.4-0.4,15.7c0.1,0.2,0.4,0.1,0.4-0.2c-0.5-2.6-1.3-5.1-1.2-7.7c0-2.7,0.8-5.1,1.5-7.7 C204.9,85.7,204.7,85.6,204.6,85.7z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M230.2,113.8c-3.8-1.7-8.2-1.9-12.1-3.6c-4.5-1.8-8.1-4.7-12.1-7.2c-0.2-0.1-0.5,0.1-0.3,0.3 c4.6,6.3,16.6,12.8,24.5,10.9C230.4,114.2,230.4,113.9,230.2,113.8z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M242.8,110.1c-2.7-0.1-6.4,1-8.3,3.1c-0.1,0.1,0,0.3,0.2,0.3c1.2-0.4,2.5-0.9,3.8-1.2c1.5-0.3,2.9,0,4.4,0.1 C244.3,112.5,244.3,110.2,242.8,110.1L242.8,110.1z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M195.3,101.9c-4,0.4-7.8,1.7-11.7,2.8c-3.8,1.2-7.8,2.1-11.4,3.9c-0.1,0.1-0.1,0.3,0.1,0.3c4-0.4,7.9-1.7,11.7-2.8 c3.9-1.1,7.8-2.1,11.4-3.9C195.6,102.2,195.5,101.9,195.3,101.9L195.3,101.9z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M167.4,107.8c-0.5-0.2-1.1-0.5-1.6-0.8s-0.9-0.7-1.3-1.1c-0.3-0.3-0.8-0.3-1.1,0c-0.7,0.7-0.4,1.7,0.5,1.9 c0.1,0,0.3,0,0.4-0.1c0.3,0.2,0.7,0.4,1.1,0.5c0.8,0.2,1.3,0.1,2-0.1C167.6,108.1,167.5,107.9,167.4,107.8L167.4,107.8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M277.9,55.2c-0.3,0.1-0.7,0.1-1,0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-5.1-1-10.6-2.1-15.5,0.1c-3.8,1.7-7.2,5.8-7,10l0,0 c-0.6,0.5-1.3,1-1.9,1.5c-0.1,0.1,0,0.3,0.2,0.2c4.2-2.2,8.1-4.7,12.4-6.5c4.3-1.9,8.8-3.1,13.3-4.5 C278.6,55.8,278.4,55.1,277.9,55.2L277.9,55.2z M254.7,64.9c2.1-3.6,3.1-7,7.5-8.6c3.9-1.5,7.9-1,11.9-0.2 C267.3,57.7,260.3,60.8,254.7,64.9z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M259.2,53.8c2.1-1.5,3.5-3,4.9-5.1c0.1-0.2-0.1-0.5-0.4-0.4c-1.9,1.4-3.8,2.8-5.6,4.2c-1.4,1-3.8,2-4.6,3.6 c0,0.1,0,0.2,0.1,0.2C255.5,56.6,257.7,54.8,259.2,53.8L259.2,53.8z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M194.1,53c0.2,0.1,0.4-0.2,0.2-0.4c-1.4-1.8-3.1-3.6-4.4-5.5c-1.2-1.8-2.1-3.8-3.1-5.6c0-0.1-0.1,0-0.1,0 C186.4,46.2,189.8,51.4,194.1,53L194.1,53z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M186.8,55.8c2.2,1.1,4.3,2.6,6.5,3.8c0.2,0.4,0.4,0.8,0.5,1.3c0,0.1,0.2,0.1,0.2,0c0-0.3,0.1-0.5,0.1-0.8 c0.3,0.1,0.6,0.3,0.8,0.4c0.2,0.1,0.3-0.2,0.2-0.3c-0.3-0.4-0.7-0.8-1.1-1.1c-0.9-6-9.8-11-14.9-7.5c-0.1,0-0.1,0.1-0.1,0.1 c-0.6-0.1-1.2-0.2-1.9-0.2c-0.3,0-0.4,0.5-0.2,0.6C180.1,53.6,183.6,54.3,186.8,55.8L186.8,55.8z M189.2,53.5 c1.6,1.2,2.5,2.6,3.2,4.1c-1.9-1.4-4.2-2.4-6.2-3.4c-1.8-0.8-3.6-1.7-5.6-2.3C183.7,51.8,186.4,51.4,189.2,53.5L189.2,53.5z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M342.9,31.8c-3-8.8-16.7-6.9-22.9-3.6c-0.5,0.2-0.4,0.9,0,1.1c0,0,0.1,0,0.1,0.1c0,0.2,0.1,0.4,0.2,0.5 c0.5,0.4,0.9,0.8,1.4,1.1c0.4,0.3,0.9,0.7,1.4,0.8c0.2,0,0.3-0.1,0.3-0.3c-0.1-0.5-0.5-1-0.8-1.4c-0.2-0.2-0.4-0.5-0.6-0.7 c0.2-0.3,0.4-0.6,0.3-0.9c2.7-1.2,9.6-1.4,10.7-1.3c3,0.3,6.1,1.1,7.8,3.9c0.7,1.6,1,3.2,0.9,4.9c-0.5,2.3-1.2,3.5-2.2,3.6 c-0.6-0.3-1.2-0.5-1.8-0.8l-0.1-0.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-2.4-1.3-4.7-2.8-7.1-4.2 c-0.1,0-0.2,0.1-0.1,0.2c1.7,2.2,4,4,6.4,5.4c1.8,1.1,4.2,2.9,6.3,2.4c0.2,0,0.3-0.3,0.2-0.4c-0.3-0.5-0.7-0.9-1.2-1.2 C344.1,39,343.8,34.2,342.9,31.8L342.9,31.8z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M333.8,70.9c-7.9,5.5-15.8,10.5-24.5,14.6c-0.2,0.1-0.1,0.5,0.2,0.4c9-3.3,17.6-8.1,24.6-14.8 C334.1,71,333.9,70.7,333.8,70.9L333.8,70.9z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M355.1,62.4c-1.3-2.5-3.1-5.4-3.6-8.2c-0.6-3.3,1.2-3.3,3.2-5.8c5.3-6.8,3.1-15.7-1.4-22.2c-5.1-7.4-14-15.9-23.6-15.8 c-5.4,0-10.4,2.4-15.6,3.4c-7.6,1.3-15.3,0.1-22.6-1.8c-12.8-3.2-25.3-7.1-38.5-9c-18.5-2.7-38.8-2.6-56.7,3.8 c-0.2-0.2-0.5-0.4-0.9-0.3c-4.7,0.7-9.4,1-14.2,0.6c-3.4-0.3-6.8-1.2-10.3-1.4c-4.9-0.2-8.8,1.7-11.2,6.1 c-4.1,7.8-3.2,20.3,5.3,24.5c-1.3,1.7-2.8,3.1-4.9,3.8c-4.9,1.8-10.3,1.7-15.2,3.7c-9.1,3.8-17.4,11.2-21.2,20.4 c-1.7,4.1-2.1,8-1.8,11.8c-0.8,13.8,12,26.3,20.4,35.7c6.7,7.4,11.8,16,17.9,23.8c3.1,4,6.6,8.2,10.9,11.2 c0.8,0.8,1.7,1.6,2.6,2.3c8.1,6.4,19.2,7.9,29.2,9.2c11.5,1.4,24.4,2.6,35.6-1c5.3-1.7,10-4.6,15.2-6.6 c5.8-2.2,11.8-3.6,17.8-4.9c12.9-2.7,26-4.3,38.8-7.5c19.5-5,41.3-16.8,50.5-35.6c4.4-9.1,4.1-18.4,0.2-27.6 C359.6,70.7,357.2,66.6,355.1,62.4L355.1,62.4z M169.4,7.7c4.4-0.4,9.2,1.2,13.7,1.4c2.7,0.1,5.3,0,8-0.3 c-7.6,3.4-14.5,8.3-19.3,15.1c-2.1,3-3.4,7-5.4,10.4C156.4,29.8,157.5,8.8,169.4,7.7L169.4,7.7z M355.2,108.2 C342.4,125,323,133.7,302.9,138c-11,2.3-22.2,3.8-33.2,6.2c-4.7,1-9.3,2.2-13.8,3.7c-5,1.7-9.6,4.4-14.6,6.4 c-10.3,4.1-21.7,3.6-32.6,2.7c-9.6-0.8-20.9-1.9-29.6-6.6c0.1-0.1,0.1-0.3,0-0.4c-3.3-2.4-6.4-4.7-9.3-7.3 c-5.1-5.9-8.9-13.1-14.3-18.8c-1.9-2-3.8-4-5.6-6.1c-1.1-1.4-2.2-2.8-3.3-4.2c-2.9-3.4-6-6.7-8.9-10c-1.8-2.2-3.6-4.5-5.4-6.9 c-1-1.5-2-3.1-2.9-4.6c-3.4-5.6-5.7-11.4-5.9-17.4c0-1.9,0.2-3.8,0.5-5.8l0,0c0.5-2.2,1.3-4.5,2.6-6.7 c4.6-8.5,13.2-15.1,22.4-17.8c7.2-2.1,13.9-1.6,18.3-7.6c0.6-0.1,0.9-0.7,0.9-1.3c0.2-0.3,0.3-0.5,0.5-0.8 c4.3-8.5,8.4-15.3,16.8-20.5C199.9,5.1,218.7,3,235.6,3.4c12.7,0.4,25.2,2.6,37.5,5.7c10.7,2.7,21.2,6.7,32.3,7.2 c5.7,0.2,10.7-0.9,16.1-2.4c8-2.2,14.3-1.5,20.8,3.8c9.7,7.9,20.5,23.3,6.7,32.9c-0.4,0.3-0.6,0.7-0.5,1.2 c2.7,8.9,8,16.6,11.4,25.2C364.2,88,362.4,98.8,355.2,108.2L355.2,108.2z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M136.9,57.2c-0.1-0.7-1.2-0.8-1.2,0c0.4,5.7,2.3,10.5,6.7,14.4c0.2,0.2,0.6-0.1,0.4-0.3C140,67.1,137.6,62.2,136.9,57.2z "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: 14,
    className: "svggshield"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7cm5",
    d: "M364.3,354.6c-0.1-0.5-0.3-1.1-0.4-1.6c-0.2-0.6-0.3-1.2-0.5-1.8c-0.4-1.2-0.7-2.4-1.1-3.6 c-0.8-2.5-1.6-4.9-2.7-7.4c-2-5-4.6-9.8-7.9-14.1c-3.3-4.2-7.2-7.7-11.3-10.4c-4-2.6-8.2-4.4-11.8-5.5c-0.9-0.3-1.8-0.5-2.6-0.7 c-0.8-0.2-1.6-0.4-2.4-0.5c-1.5-0.2-2.8-0.5-3.9-0.6c-2.1-0.2-3.4-0.3-3.4-0.3s-0.3,0-0.9,0s-1.4,0-2.5,0s-2.4,0.1-3.9,0.2 c-0.8,0-1.5,0.2-2.4,0.3c-0.8,0.1-1.7,0.2-2.7,0.5c-3.7,0.7-8,2.1-12.3,4.3c-4.3,2.2-8.7,5.1-12.6,8.8c-3.9,3.7-7.3,8-10.1,12.6 c-2.7,4.6-4.8,9.4-6.1,13.9c-0.4,1.1-0.6,2.3-0.9,3.4c-0.1,0.5-0.3,1.1-0.4,1.6s-0.2,1-0.2,1.4c0,0.3-0.1,0.5-0.1,0.7 c-0.1,0.4-0.1,0.8-0.2,1c-0.2,1.3-0.4,2.2-0.7,3.2c0,0,0,0,0.1,0c0.5,0.1,1.2,0,2.1,0c2.7,0,8.8,0,15.8,0c0-0.2-0.1-0.5-0.1-0.7 c-0.1-0.7,0-1.4,0.1-2.3c0-0.2,0.1-0.6,0.2-1.1c0-0.2,0.1-0.5,0.1-0.7l0.1-0.4c0-0.2,0.1-0.4,0.1-0.6c0.1-0.4,0.2-0.8,0.3-1.1 c0.2-0.8,0.4-1.6,0.7-2.4c2-6.4,6.5-13.3,12.5-18.1c5.9-4.9,12.9-7.5,18.1-8.4c2.6-0.5,4.8-0.6,6.4-0.6c0.8,0,1.4,0,1.8,0 s0.6,0,0.6,0s0.9,0,2.4,0.2c1.5,0.1,3.7,0.5,6.3,1.2c5.1,1.4,11.8,4.8,17.2,10.2c2.7,2.7,5.1,5.8,7,9c0.4,0.8,0.9,1.6,1.3,2.5 c0.4,0.8,0.8,1.7,1.1,2.5c0.3,0.9,0.6,1.7,0.9,2.5c0.2,0.4,0.3,0.8,0.4,1.2c0.1,0.4,0.2,0.8,0.3,1.1c0.4,1.1,0.5,2.1,0.6,2.6 s0.2,0.9,0.2,1.2c0,0.4,0,0.7,0,1.1c0,0.3,0,0.6,0,0.8c3,0,5.4,0,6.8,0c0.8,0,1.4,0,2,0.1c-0.4-0.8-0.7-1.6-1-2.8 C364.8,356.6,364.6,355.7,364.3,354.6L364.3,354.6z",
    fill: "#FFD9D6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm5",
    d: "M343.2,354.1c-1.4-3-3.8-6.4-6.9-8.7c-3-2.3-6.5-3.6-9.2-4c-1.3-0.2-2.4-0.3-3.2-0.3c-0.8,0-1.2,0-1.2,0 s-0.4,0-1.2,0.1c-0.8,0.1-1.9,0.2-3.2,0.5c-2.6,0.5-6.1,1.9-9.2,4.1s-5.8,5.3-7.3,8.4c-0.2,0.4-0.4,0.8-0.5,1.1 c-0.1,0.4-0.4,0.8-0.4,1c-0.1,0.2-0.2,0.5-0.2,0.7c-0.2,0.4-0.2,0.8-0.3,1c-0.2,0.8-0.4,1.5-0.6,2.1c6.4,0,11.8,0,14.1,0 c0-1.1,0.2-2.1,1.1-3.3c0.2-0.3,0.5-0.7,1.4-1.4c1-0.9,3-1.9,4.9-2.3c0.9-0.2,1.8-0.3,2.4-0.4c0.6,0,1,0,1,0s0.3,0,0.9,0 c0.5,0,1.3,0.1,2.1,0.2c1.6,0.3,3.5,1.1,4.7,2s1.7,1.7,2,2.1c0.7,1.1,0.9,2.1,0.9,3c3.5,0,7,0,10.5,0c-0.5-1.1-0.8-2-1.3-3.3 C344,356.1,343.7,355.2,343.2,354.1L343.2,354.1z",
    fill: "#FFD9D6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm5",
    d: "M356,358.1c-0.1-0.4-0.2-0.7-0.3-1.2c-0.1-0.5-0.3-1.4-0.6-2.5c-0.1-0.4-0.2-0.7-0.3-1.1 c-0.1-0.4-0.2-0.8-0.4-1.2c-0.3-0.8-0.6-1.6-0.9-2.4c-0.4-0.8-0.7-1.6-1.1-2.4s-0.9-1.6-1.3-2.4c-1.8-3.2-4.1-6.2-6.8-8.8 c-5.2-5.2-11.7-8.6-16.7-9.9c-2.5-0.7-4.6-1.1-6.1-1.2c-1.5-0.2-2.3-0.2-2.3-0.2s-0.2,0-0.6,0s-1,0-1.7,0c-1.5,0-3.6,0.2-6.2,0.6 c-5.1,0.9-11.9,3.4-17.6,8.2c-5.8,4.6-10.2,11.3-12.1,17.5c-0.2,0.8-0.5,1.5-0.7,2.3c-0.1,0.4-0.2,0.8-0.3,1.1 c0,0.2-0.1,0.4-0.1,0.5l-0.1,0.4c0,0.3-0.1,0.5-0.1,0.7c-0.1,0.4-0.1,0.8-0.2,1c-0.1,0.9-0.3,1.6-0.4,2.2c0,0.2-0.1,0.4-0.2,0.7 c6.4,0,13.5,0,19.7,0c0-0.7,0.1-1.5,0.4-2.4c0.1-0.2,0.2-0.6,0.3-1c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.3,0.3-0.7,0.5-1.1 s0.3-0.8,0.6-1.2c1.6-3.2,4.4-6.5,7.7-8.8c3.3-2.3,6.9-3.7,9.7-4.3c1.4-0.3,2.5-0.4,3.3-0.5s1.3-0.1,1.3-0.1s0.5,0,1.3,0 s2,0.1,3.4,0.3c2.8,0.4,6.5,1.8,9.7,4.3c3.2,2.4,5.8,5.9,7.2,9.1c0.5,1.1,0.9,2,1,2.5c0.5,1.5,0.6,2.5,0.5,3.7c3.9,0,7.6,0,10.7,0 c-0.1-0.2-0.2-0.5-0.2-0.7C356.2,358.8,356.1,358.5,356,358.1L356,358.1z",
    fill: "#FFD9D6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm5",
    d: "M331.4,355.7c-1-0.8-2.7-1.5-4.2-1.8c-0.8-0.1-1.4-0.2-1.9-0.2s-0.8,0-0.8,0s-0.4,0-0.9,0 c-0.6,0-1.4,0.1-2.2,0.3c-1.7,0.4-3.5,1.3-4.4,2.1c-0.7,0.6-1,1-1.2,1.2c-0.7,1-1.1,1.7-1.5,2.6c0.5,0,0.7,0,0.7,0s9,0,19.3,0 c-0.3-0.8-0.7-1.5-1.2-2.4C332.9,357.2,332.4,356.5,331.4,355.7L331.4,355.7z",
    fill: "#FFD9D6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M315,358.5c2.4-1.8,4.7-3.3,7.8-2.2c2.5,0.9,3.8,3,5.9,4.4c0.3,0.2,0.7-0.1,0.6-0.5 c-2.1-5.9-11.3-7.9-14.7-2.2C314.4,358.4,314.7,358.8,315,358.5L315,358.5L315,358.5z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M327.6,354c2.3,1.2,3.8,3.4,4.5,5.9c0,0.1,0.3,0.1,0.3,0c-0.4-2.8-2.1-5-4.6-6.1 C327.6,353.7,327.4,353.9,327.6,354L327.6,354L327.6,354z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M320.2,352.6c-5.9-1.9-19.9-2.5-21.2,6.2c-0.1,0.7,0.7,1.4,1.3,0.8c2.6-2.7,4.2-5,8-6.1s7.8-0.4,11.8-0.5 C320.3,353,320.4,352.7,320.2,352.6L320.2,352.6L320.2,352.6z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M330.6,354.2c-2.2-5.1-8.2-8.3-13.5-8.9c-4.3-0.5-10.6,0.2-13.4,3.9c-0.3,0.4,0.2,0.9,0.6,0.8 c4.4-1.1,7.6-3.7,12.5-3.2c5.8,0.5,9.4,3.9,13.5,7.5C330.6,354.5,330.7,354.3,330.6,354.2L330.6,354.2L330.6,354.2z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M334.7,358.2c5-6.9,0.4-18.6-8.9-17.5c-0.4,0-0.7,0.6-0.2,0.9c6.5,3.6,10.5,8.8,8.7,16.5 C334.2,358.3,334.5,358.4,334.7,358.2L334.7,358.2z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M343.2,354.6c-0.1,2.2-1.3,3.8-2.7,5.4c-0.1,0.2,0,0.4,0.2,0.4c2.5-0.6,3.7-3.4,3.4-5.8 C344.1,354,343.2,354,343.2,354.6L343.2,354.6L343.2,354.6z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M310.2,344.2c-7-7.6-25.4-5.8-29.2,4.6c-0.2,0.5,0.4,1.1,0.9,0.9c4.3-1.8,7.3-5.4,11.9-6.7 c5.6-1.5,10.6,0.8,16,1.9C310.2,344.9,310.5,344.5,310.2,344.2L310.2,344.2L310.2,344.2z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M301.2,354.2c-2.5-2.9-8.5-1.4-11.6-0.6c-3.3,0.9-9.2,2.5-10.9,5.9c-0.4,0.8,0.3,1.8,1.2,1.5 c3.4-0.9,6.4-3.5,9.8-4.6c2.1-0.7,4.4-1.2,6.6-1.4c1.6-0.1,3.3,0.1,4.8-0.5C301.2,354.5,301.3,354.3,301.2,354.2L301.2,354.2 L301.2,354.2z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M321.2,340.5c-3.2-9.3-17.7-13.5-26.1-10.1c-0.3,0.1-0.3,0.5,0.1,0.5c4.9-0.3,9.6-0.6,14.3,1.2 s7.5,5.5,11.3,8.6C321,340.9,321.3,340.8,321.2,340.5L321.2,340.5L321.2,340.5z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M328.8,326.6c3.7,2.8,6.1,6.7,7.6,11c1.2,3.4,1.2,7.8,3.4,10.6c0.2,0.2,0.6,0.3,0.7-0.1 c1.1-4.1-1.3-9.6-3.1-13.3s-4.5-6.9-8.1-9.1C328.8,325.3,328.3,326.2,328.8,326.6L328.8,326.6L328.8,326.6z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M349.9,342.5c0.1,2.9,0.8,5.5,0.4,8.4c-0.4,3.2-1.7,5.9-3.5,8.6c-0.8,1.1,1,2.2,1.8,1.1 c3.3-4.6,5.3-13.2,1.9-18.2C350.4,342,349.9,342.1,349.9,342.5L349.9,342.5z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M287.2,337.7c-11.3-3.7-26.3,8.7-26.2,20.1c0,0.3,0.5,0.5,0.6,0.2c2.5-4.7,4.4-9.5,8.6-13.1 c5.1-4.4,10.8-4.7,17-6.4C287.6,338.4,287.6,337.8,287.2,337.7L287.2,337.7L287.2,337.7z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M271.6,330.5c6.1-3.7,12.2-7.4,19.5-8.1c3.5-0.3,7.1,0,10.6,0.9c2.7,0.7,5.1,2,7.9,1.8 c0.6,0,0.9-0.6,0.6-1.1c-3.2-6-13.9-6.4-19.7-5.7c-7.8,1-15.5,4.6-19.5,11.6C270.8,330.2,271.3,330.7,271.6,330.5L271.6,330.5 L271.6,330.5z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M314.6,307.8c2.4,2.4,4.8,4.5,6.8,7.3s3.1,5.9,4.4,9c0.1,0.2,0.6,0.3,0.5-0.1c-0.6-6.5-5.4-13.9-11.4-16.6 C314.7,307.3,314.5,307.6,314.6,307.8L314.6,307.8L314.6,307.8z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M334.4,312.4c2.6,4,5.2,7.6,6.5,12.4c0.9,3.2-0.4,7.5,2.4,9.6c0.1,0.1,0.4,0,0.5-0.1 c3.2-2.5,0.9-9.2-0.4-12.4c-1.6-4-4.5-8-8.3-10.1C334.6,311.5,334.1,312,334.4,312.4L334.4,312.4L334.4,312.4z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M359.1,338c0.1,3.4,0.6,6.6,0,10c-0.6,3.1-2.1,5.6-3.2,8.5c-0.2,0.6,0.6,0.9,1,0.6 c4.4-4.2,5.6-13.9,2.5-19.1C359.3,337.8,359.1,337.8,359.1,338L359.1,338L359.1,338z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm6",
    d: "M365.3,357.4c-0.2,0.6-0.9,1.1-1.3,1.5s-1.2,1-1,1.6c0.1,0.2,0.3,0.4,0.5,0.4c0.7,0,1.4-1.1,1.8-1.6 c0.4-0.6,0.6-1.3,0.4-2C365.7,357.2,365.3,357.2,365.3,357.4L365.3,357.4L365.3,357.4z",
    fill: "#C02C23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1cm2",
    d: "M366.8,360.7l-0.1-0.5l-0.1-0.2l0,0l0,0c0-1-0.1-1.9-0.5-3.2c-0.1-0.5-0.4-1.4-0.7-2.6 c-0.1-0.5-0.3-1.1-0.4-1.6c-0.2-0.6-0.3-1.2-0.5-1.8c-0.4-1.2-0.7-2.4-1.1-3.7c-0.8-2.5-1.7-5-2.7-7.5c-2-5-4.7-10-8-14.3 c-3.4-4.3-7.4-8-11.6-10.6c-4.2-2.7-8.4-4.5-12.1-5.6c-0.9-0.3-1.8-0.5-2.7-0.7c-0.9-0.2-1.6-0.4-2.4-0.6 c-0.8-0.1-1.5-0.2-2.1-0.4c-0.7-0.1-1.3-0.2-1.8-0.3c-2.2-0.2-3.4-0.3-3.4-0.3s-0.3,0-0.9,0s-1.5,0-2.5,0c-1.1,0-2.4,0.1-4,0.2 c-0.8,0-1.6,0.2-2.5,0.3c-0.1,0-0.1,0-0.2,0c-0.8,0.1-1.6,0.2-2.5,0.4c-3.8,0.7-8.1,2.2-12.6,4.4c-4.4,2.2-8.9,5.3-12.9,9 s-7.5,8.1-10.3,12.8c-2.8,4.7-4.9,9.6-6.2,14.2c-0.4,1.1-0.6,2.3-0.9,3.4c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.5-0.2,1-0.3,1.4 c0,0.3-0.1,0.5-0.1,0.7c-0.1,0.5-0.1,0.8-0.2,1.1c-0.1,0.9-0.2,1.6-0.1,2.4c-0.2,0.2-0.4,0.4-0.4,0.7c0,0.2,0,0.4,0.2,0.6 c0.1,0.1,0.2,0.3,0.4,0.4c0,0.1,0,0.2,0,0.3c0-0.1,0.1-0.1,0.1-0.2l0,0c0.4,0.2,0.8,0.3,1.2,0.3c0.4,0,0.8,0,1.2,0 c2.7,0,8.9,0,16,0c0,0.1,0,0.1,0,0.2c0-0.1,0-0.1,0-0.2c6.5,0,13.8,0,20.1,0c0,0.3,0.1,0.5,0.1,0.8c0.1-0.3,0.2-0.6,0.3-0.8 c8.8,0,15.7,0,15.7,0s9.2,0,19.7,0c0,0.1,0,0.1,0.1,0.2c0-0.1,0-0.1,0-0.2c7.7,0,16.1,0,22.1,0v0.1v-0.1c3,0,5.5,0,6.9,0 c0.6,0,1.1,0,1.6-0.1c-0.1,0.1-0.3,0.3-0.4,0.4c0.4-0.2,0.8-0.3,1.2-0.5c0,0.1,0.1,0.2,0.2,0.3c0-0.1,0-0.2,0-0.4c0,0,0,0,0.1,0 C366.6,360.8,366.7,360.8,366.8,360.7L366.8,360.7L366.8,360.7z M315,359.9c0,0-0.3,0-0.7,0c0.4-0.9,0.8-1.6,1.5-2.6 c0.2-0.2,0.5-0.6,1.2-1.2c0.9-0.8,2.7-1.7,4.4-2.1c0.8-0.2,1.6-0.3,2.2-0.3s0.9,0,0.9,0s0.3,0,0.8,0s1.2,0.1,1.9,0.2 c1.5,0.3,3.2,1,4.2,1.8s1.5,1.4,1.7,1.8c0.6,0.9,0.9,1.6,1.2,2.4C324,359.9,315.1,359.9,315,359.9L315,359.9z M335,359.9 c0-1-0.2-1.9-0.9-3c-0.2-0.4-0.8-1.2-2-2.1s-3.1-1.7-4.7-2c-0.8-0.1-1.5-0.2-2.1-0.2c-0.5,0-0.9,0-0.9,0s-0.4,0-1,0 s-1.5,0.1-2.4,0.4c-1.8,0.4-3.9,1.4-4.9,2.3c-0.8,0.7-1.1,1.2-1.4,1.4c-0.8,1.2-1.1,2.2-1.1,3.3c-2.3,0-7.6,0-14.1,0 c0.2-0.6,0.4-1.2,0.6-2.1c0.1-0.2,0.1-0.6,0.3-1c0.1-0.2,0.1-0.4,0.2-0.7c0.1-0.3,0.3-0.7,0.4-1c0.1-0.4,0.3-0.8,0.5-1.1 c1.5-3,4.1-6.2,7.3-8.4c3.1-2.2,6.6-3.5,9.2-4.1c1.3-0.3,2.4-0.4,3.2-0.5s1.2-0.1,1.2-0.1s0.4,0,1.2,0c0.8,0,1.9,0.1,3.2,0.3 c2.6,0.4,6.1,1.7,9.2,4c3,2.3,5.5,5.6,6.9,8.7c0.5,1.1,0.8,2,1,2.4c0.5,1.4,0.8,2.3,1.3,3.3C342.1,359.9,338.5,359.9,335,359.9 L335,359.9z M345.8,359.9c0.1-1.2,0-2.2-0.5-3.7c-0.1-0.5-0.5-1.4-1-2.5c-1.4-3.2-4-6.7-7.2-9.1c-3.2-2.5-6.9-3.8-9.7-4.3 c-1.4-0.3-2.6-0.3-3.4-0.3s-1.3,0-1.3,0s-0.5,0-1.3,0.1s-2,0.2-3.3,0.5c-2.8,0.6-6.4,1.9-9.7,4.3c-3.3,2.3-6.1,5.6-7.7,8.8 c-0.2,0.4-0.4,0.8-0.6,1.2c-0.1,0.4-0.4,0.8-0.5,1.1c-0.1,0.3-0.2,0.5-0.2,0.7c-0.2,0.4-0.3,0.8-0.3,1c-0.3,0.9-0.4,1.7-0.4,2.4 c-6.2,0-13.3,0-19.7,0c0.1-0.2,0.1-0.4,0.2-0.7c0.1-0.6,0.3-1.3,0.4-2.2c0-0.2,0.1-0.6,0.2-1c0-0.2,0.1-0.5,0.1-0.7l0.1-0.4 c0-0.2,0.1-0.4,0.1-0.5c0.1-0.4,0.2-0.7,0.3-1.1c0.2-0.8,0.4-1.5,0.7-2.3c1.9-6.2,6.3-12.9,12.1-17.5c5.7-4.7,12.5-7.3,17.6-8.2 c2.6-0.5,4.7-0.6,6.2-0.6c0.7,0,1.3,0,1.7,0c0.4,0,0.6,0,0.6,0s0.8,0,2.3,0.2c1.5,0.1,3.6,0.5,6.1,1.2c5,1.4,11.4,4.7,16.7,9.9 c2.6,2.6,4.9,5.6,6.8,8.8c0.4,0.8,0.9,1.6,1.3,2.4s0.7,1.6,1.1,2.4c0.3,0.8,0.6,1.6,0.9,2.4c0.2,0.4,0.3,0.8,0.4,1.2 c0.1,0.4,0.2,0.7,0.3,1.1c0.4,1.1,0.5,2.1,0.6,2.5s0.2,0.8,0.3,1.2c0.1,0.4,0.2,0.7,0.3,1c0.1,0.2,0.1,0.5,0.2,0.7 C353.4,359.9,349.7,359.9,345.8,359.9L345.8,359.9z M363.9,359.8c-1.4,0-3.8,0-6.8,0c0-0.3,0-0.6,0-0.8c0-0.3,0-0.7,0-1.1 s-0.1-0.8-0.2-1.2c-0.1-0.5-0.3-1.5-0.6-2.6c-0.1-0.4-0.2-0.8-0.3-1.1c-0.1-0.4-0.2-0.8-0.4-1.2c-0.3-0.8-0.6-1.6-0.9-2.5 c-0.4-0.8-0.8-1.7-1.1-2.5c-0.4-0.8-0.9-1.6-1.3-2.5c-1.9-3.3-4.2-6.4-7-9c-5.4-5.4-12-8.8-17.2-10.2c-2.6-0.7-4.8-1.1-6.3-1.2 c-1.5-0.2-2.4-0.2-2.4-0.2s-0.2,0-0.6,0s-1,0-1.8,0c-1.5,0-3.7,0.2-6.4,0.6c-5.2,0.9-12.2,3.5-18.1,8.4 c-6,4.8-10.5,11.6-12.5,18.1c-0.2,0.8-0.5,1.6-0.7,2.4c-0.1,0.4-0.2,0.8-0.3,1.1c0,0.2-0.1,0.4-0.1,0.6l-0.1,0.4 c0,0.3-0.1,0.5-0.1,0.7c-0.1,0.5-0.1,0.8-0.2,1.1c-0.1,0.9-0.1,1.6-0.1,2.3c0,0.2,0.1,0.5,0.1,0.7c-7.1,0-13.1,0-15.8,0 c-0.9,0-1.6,0.1-2.1,0c0,0,0,0-0.1,0c0.3-1,0.5-1.9,0.7-3.2c0-0.2,0.1-0.6,0.2-1c0-0.2,0.1-0.5,0.1-0.7c0.1-0.5,0.2-0.9,0.2-1.4 c0.1-0.5,0.3-1.1,0.4-1.6c0.3-1.1,0.5-2.2,0.9-3.4c1.3-4.5,3.4-9.4,6.1-13.9c2.7-4.6,6.2-8.9,10.1-12.6s8.2-6.7,12.6-8.8 s8.6-3.6,12.3-4.3c0.9-0.2,1.8-0.3,2.7-0.5c0.9-0.1,1.6-0.3,2.4-0.3c1.5-0.1,2.8-0.2,3.9-0.2s1.9,0,2.5,0s0.9,0,0.9,0 s1.2,0.1,3.4,0.3c1.1,0.1,2.4,0.4,3.9,0.6c0.7,0.1,1.5,0.4,2.4,0.5c0.8,0.2,1.7,0.4,2.6,0.7c3.6,1,7.7,2.8,11.8,5.5 c4.1,2.6,8,6.1,11.3,10.4c3.3,4.2,5.9,9.1,7.9,14.1c1,2.5,1.9,5,2.7,7.4c0.4,1.2,0.7,2.4,1.1,3.6c0.2,0.6,0.3,1.2,0.5,1.8 c0.1,0.5,0.3,1.1,0.4,1.6c0.3,1.1,0.5,2.1,0.7,2.6c0.3,1.2,0.6,2,1,2.8C365.3,359.9,364.7,359.9,363.9,359.8L363.9,359.8z",
    fill: "#202020"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M296.9,313c-8.6,3.2-16.3,8.3-22.4,15.2c-5.2,6-11.4,15.1-11.1,23.4c0.1,1.9,2.9,2,3.2,0.4 c1.8-3.2,2.7-6.9,4.4-10.1c1.9-3.7,4.2-7.2,6.9-10.3c5.5-6.3,12.4-11.1,20.2-14C301,316.5,299.8,311.9,296.9,313L296.9,313z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M305.8,314c4.8,0.6,9.7,0.1,14.5,0.6c3.2,0.4,3.3-4.9,0-5c-4.7-0.3-10.5-0.4-14.9,1.4 C303.7,311.6,304,313.8,305.8,314L305.8,314z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M317.2,325.2c-8.1-0.6-17,3.9-23.2,8.7c-4.6,3.6-14.2,12.8-12.4,19.5c0.2,0.7,1.1,1.2,1.8,0.7 c2.6-1.7,3.5-4.9,5.2-7.5c2.2-3.3,4.9-6.2,8-8.6c6.5-5.2,13.3-6.7,21.1-8.6C320.3,328.9,319.6,325.4,317.2,325.2L317.2,325.2z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M313.6,344.7c-4.4,0.9-10,6.6-9.8,11.3c0,1.4,1.9,2.5,2.9,1.2c1.3-1.6,2.1-3.4,3.5-4.9 c1.5-1.6,3.3-2.3,5.1-3.4C317.6,347.5,316.1,344.3,313.6,344.7L313.6,344.7z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M324.6,341.5c-1.6-0.3-3.8,0-5.2,0.9c-0.9,0.5-2.2,2.2-1,3.1c0.7,0.5,1.8,0.5,2.6,0.4c1-0.1,2,0.1,3,0.1 C326.5,345.9,327.2,342,324.6,341.5L324.6,341.5z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M318.7,356.7c-0.3,0.2,0,0.6,0.3,0.6c1.2-0.3,2.6-0.5,3.9-0.6c1.1-0.1,2-0.5,2.9-0.9c0.2-0.1,0.2-0.4,0-0.5 C323.3,353.9,320.7,354.9,318.7,356.7L318.7,356.7z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M362.1,355.7c-0.9-2.3-0.2-4.5-0.6-6.8c-0.3-2-0.8-3.9-1.3-5.8c-1-3.6-2-7.3-4.3-10.3 c-0.3-0.4-1-0.3-0.9,0.2c0.3,3.5,1.5,6.7,2.3,10c0.4,1.6,0.8,3.3,1.2,4.9c0.5,2,2.2,6.2,2,8C360.4,357.1,362.6,356.8,362.1,355.7 L362.1,355.7z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M350.6,346.2c-0.4-0.3-0.9,0.2-0.8,0.6c0.7,3.3,1.5,6.4,1.8,9.7c0.1,0.8,0.5,1.4,1.3,1.7 c0.3,0.1,0.6,0.1,0.9,0c0.7-0.3,1.3-0.9,1.3-1.7C355.1,352.6,353.7,348.6,350.6,346.2z",
    fill: "#FFF8F8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7cm7",
    d: "M342.9,354.4c-0.2-0.3-0.5-0.6-0.7-0.9c-0.3-0.5-1.1-0.3-1.1,0.3c0,0.4-0.1,0.8-0.1,1.2c0,0.3,0.1,0.7,0.2,1 c0.1,0.8,0.3,1.3,1,1.9c0.5,0.4,1.2,0.2,1.4-0.4c0.2-0.8,0.2-1.4-0.1-2.1C343.2,355.1,343.1,354.7,342.9,354.4L342.9,354.4z",
    fill: "#FFF8F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties2);
export default __webpack_public_path__ + "static/media/properties2.bb69dae8cd245ae31d38b4bbeed38fd0.svg";
export { ForwardRef as ReactComponent };